import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import * as React from 'react';
import React__default, { useMemo, useContext, createContext, useRef, Children, useEffect, useState, useLayoutEffect as useLayoutEffect$1, useCallback, useReducer, forwardRef, createElement, cloneElement, lazy, Suspense, memo, isValidElement } from 'react';
import { css, ThemeProvider as ThemeProvider$1, useTheme, Global as Global$1, keyframes } from '@emotion/react';
export { css } from '@emotion/react';
import ReactDOM, { createPortal } from 'react-dom';
import create from 'zustand/vanilla';
import create$1 from 'zustand';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var theme = {
    colors: {
        common: {
            black: '#000',
            white: '#fff',
        },
        primary: {
            100: '#E6EAF7',
            200: '#BFCBEC',
            300: '#8098D8',
            400: '#4064C5',
            500: '#0031B2',
            600: '#002A97',
            700: '#00227D',
            800: '#001B62',
            900: '#001447',
        },
        secondary: {
            100: '#FCE6E6',
            200: '#FACCCC',
            300: '#F7B3B3',
            400: '#F59999',
            500: '#F28080',
            600: '#CE6D6D',
            700: '#A95A5A',
            800: '#854646',
            900: '#613333',
        },
        success: {
            100: '#D9F7E7 ',
            200: '#BBF1D4',
            300: '#8CE7B6',
            400: '#5DDE98',
            500: '#2ED47A',
            600: '#27B468',
            700: '#209455',
            800: '#197543',
            900: '#125531',
        },
        danger: {
            100: '#FEE6E6',
            200: '#FDC6C6',
            300: '#FA8C8C',
            400: '#F86666',
            500: '#F64040',
            600: '#D13636',
            700: '#AC2D2D',
            800: '#872323',
            900: '#621A1A',
        },
        warning: {
            100: '#FFE9C6 ',
            200: '#FFDA9C',
            300: '#FFC76B',
            400: '#FFB539',
            500: '#FFA208',
            600: '#D98A07',
            700: '#B37106',
            800: '#8C5904',
            900: '#664103',
        },
        info: {
            100: '#DBF0FD ',
            200: '#B1DFFA',
            300: '#7CC9F7',
            400: '#46B2F4',
            500: '#109CF1',
            600: '#0E85CD',
            700: '#0B6DA9',
            800: '#095685',
            900: '#063E60',
        },
        neutral: {
            100: '#EDEDEF',
            200: '#D1D3D7',
            300: '#B0B4BB',
            400: '#90959F',
            500: '#707683',
            600: '#5F646F',
            700: '#4E535C',
            800: '#3E4148',
            900: '#2D2F34',
        },
        extra: {
            background: '#FFFFFA',
            disabled_bg: '#DADEE2',
            disabled_font: '#BDBCBC',
            gray_style: '#FAFAFC',
            gray_icon: '#90A0B7',
        },
    },
    shadows: [
        '0px 2px 6px rgba(0, 0, 0, 0.1)',
        '6px 6px 12px rgba(0, 0, 0, 0.08)',
        '0px 12px 18px rgba(0, 0, 0, 0.1)',
        '0px 10px 24px rgba(0, 0, 0, 0.1)',
    ],
    borderRadius: {
        none: '0px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        pill: '500px',
        circular: '50%',
    },
    borderWidths: {
        none: '0px',
        hairline: '1px',
        thin: '2px',
        thick: '4px',
        heavy: '8px',
    },
    spacing: function (value) { return value * 8; },
    typography: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeighSemiBold: 600,
        fontWeightBold: 700,
        fontWeightExtraBold: 800,
        fontWeightBlack: 900,
        h0: {
            fontFamily: '"Lato", "Nunito", sans-serif',
            fontSize: '48px',
            fontWeight: 900,
            letterSpacing: '0',
            lineHeight: '64px',
        },
        h1: {
            fontFamily: '"Lato", "Nunito", sans-serif',
            fontSize: '32px',
            fontWeight: 800,
            letterSpacing: '0',
            lineHeight: '48px',
        },
        h2: {
            fontFamily: '"Lato", "Nunito", sans-serif',
            fontSize: '24px',
            fontWeight: 700,
            letterSpacing: '0',
            lineHeight: '40px',
        },
        h3: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '20px',
            fontWeight: 700,
            letterSpacing: '0',
            lineHeight: '28px',
        },
        h4: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '18px',
            fontWeight: 600,
            letterSpacing: '0',
            lineHeight: '26px',
        },
        h5: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '16px',
            fontWeight: 600,
            letterSpacing: '0',
            lineHeight: '24px',
        },
        body1: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '24px',
        },
        body2: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '22px',
        },
        button1: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 700,
            letterSpacing: '0.1rem',
            lineHeight: '24px',
        },
        button2: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '16px',
            fontWeight: 700,
            letterSpacing: '0.01rem',
            lineHeight: '24px',
        },
        button3: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 700,
            letterSpacing: '0.01rem',
            lineHeight: '24px',
        },
        link: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0.01rem',
            lineHeight: '24px',
        },
        label: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '22px',
        },
        microCopy: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '20px',
        },
    },
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var objIsEmpty = function (obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};

// TODO: adicionar um segundo contexto e provider envolvendo o EmotionThemeProvider para passar um setter para o theme via context api
var ThemeProvider = function (_a) {
    var children = _a.children, theme$1 = _a.theme;
    return (jsx(ThemeProvider$1, __assign$1({ theme: theme$1 || theme }, { children: children })));
};
var useThemeContext = function () {
    var contextTheme = useTheme();
    var theme$1 = useMemo(function () { return (!objIsEmpty(contextTheme) ? contextTheme : theme); }, [contextTheme]);
    return theme$1;
};

var toString = Object.prototype.toString;

var kindOf = function kindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';

  var type = typeof val;
  if (type === 'boolean') return 'boolean';
  if (type === 'string') return 'string';
  if (type === 'number') return 'number';
  if (type === 'symbol') return 'symbol';
  if (type === 'function') {
    return isGeneratorFn(val) ? 'generatorfunction' : 'function';
  }

  if (isArray(val)) return 'array';
  if (isBuffer(val)) return 'buffer';
  if (isArguments(val)) return 'arguments';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  if (isRegexp(val)) return 'regexp';

  switch (ctorName(val)) {
    case 'Symbol': return 'symbol';
    case 'Promise': return 'promise';

    // Set, Map, WeakSet, WeakMap
    case 'WeakMap': return 'weakmap';
    case 'WeakSet': return 'weakset';
    case 'Map': return 'map';
    case 'Set': return 'set';

    // 8-bit typed arrays
    case 'Int8Array': return 'int8array';
    case 'Uint8Array': return 'uint8array';
    case 'Uint8ClampedArray': return 'uint8clampedarray';

    // 16-bit typed arrays
    case 'Int16Array': return 'int16array';
    case 'Uint16Array': return 'uint16array';

    // 32-bit typed arrays
    case 'Int32Array': return 'int32array';
    case 'Uint32Array': return 'uint32array';
    case 'Float32Array': return 'float32array';
    case 'Float64Array': return 'float64array';
  }

  if (isGeneratorObj(val)) {
    return 'generator';
  }

  // Non-plain objects
  type = toString.call(val);
  switch (type) {
    case '[object Object]': return 'object';
    // iterators
    case '[object Map Iterator]': return 'mapiterator';
    case '[object Set Iterator]': return 'setiterator';
    case '[object String Iterator]': return 'stringiterator';
    case '[object Array Iterator]': return 'arrayiterator';
  }

  // other
  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
};

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isArray(val) {
  if (Array.isArray) return Array.isArray(val);
  return val instanceof Array;
}

function isError(val) {
  return val instanceof Error || (typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number');
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function'
    && typeof val.getDate === 'function'
    && typeof val.setDate === 'function';
}

function isRegexp(val) {
  if (val instanceof RegExp) return true;
  return typeof val.flags === 'string'
    && typeof val.ignoreCase === 'boolean'
    && typeof val.multiline === 'boolean'
    && typeof val.global === 'boolean';
}

function isGeneratorFn(name, val) {
  return ctorName(name) === 'GeneratorFunction';
}

function isGeneratorObj(val) {
  return typeof val.throw === 'function'
    && typeof val.return === 'function'
    && typeof val.next === 'function';
}

function isArguments(val) {
  try {
    if (typeof val.length === 'number' && typeof val.callee === 'function') {
      return true;
    }
  } catch (err) {
    if (err.message.indexOf('callee') !== -1) {
      return true;
    }
  }
  return false;
}

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  if (val.constructor && typeof val.constructor.isBuffer === 'function') {
    return val.constructor.isBuffer(val);
  }
  return false;
}

/*!
 * shallow-clone <https://github.com/jonschlinkert/shallow-clone>
 *
 * Copyright (c) 2015-present, Jon Schlinkert.
 * Released under the MIT License.
 */

const valueOf = Symbol.prototype.valueOf;


function clone(val, deep) {
  switch (kindOf(val)) {
    case 'array':
      return val.slice();
    case 'object':
      return Object.assign({}, val);
    case 'date':
      return new val.constructor(Number(val));
    case 'map':
      return new Map(val);
    case 'set':
      return new Set(val);
    case 'buffer':
      return cloneBuffer(val);
    case 'symbol':
      return cloneSymbol(val);
    case 'arraybuffer':
      return cloneArrayBuffer(val);
    case 'float32array':
    case 'float64array':
    case 'int16array':
    case 'int32array':
    case 'int8array':
    case 'uint16array':
    case 'uint32array':
    case 'uint8clampedarray':
    case 'uint8array':
      return cloneTypedArray(val);
    case 'regexp':
      return cloneRegExp(val);
    case 'error':
      return Object.create(val);
    default: {
      return val;
    }
  }
}

function cloneRegExp(val) {
  const flags = val.flags !== void 0 ? val.flags : (/\w+$/.exec(val) || void 0);
  const re = new val.constructor(val.source, flags);
  re.lastIndex = val.lastIndex;
  return re;
}

function cloneArrayBuffer(val) {
  const res = new val.constructor(val.byteLength);
  new Uint8Array(res).set(new Uint8Array(val));
  return res;
}

function cloneTypedArray(val, deep) {
  return new val.constructor(val.buffer, val.byteOffset, val.length);
}

function cloneBuffer(val) {
  const len = val.length;
  const buf = Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : Buffer.from(len);
  val.copy(buf);
  return buf;
}

function cloneSymbol(val) {
  return valueOf ? Object(valueOf.call(val)) : {};
}

/**
 * Expose `clone`
 */

var shallowClone = clone;

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

var isobject = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



function isObjectObject(o) {
  return isobject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

var isPlainObject = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

/**
 * Module dependenices
 */





function cloneDeep(val, instanceClone) {
  switch (kindOf(val)) {
    case 'object':
      return cloneObjectDeep(val, instanceClone);
    case 'array':
      return cloneArrayDeep(val, instanceClone);
    default: {
      return shallowClone(val);
    }
  }
}

function cloneObjectDeep(val, instanceClone) {
  if (typeof instanceClone === 'function') {
    return instanceClone(val);
  }
  if (instanceClone || isPlainObject(val)) {
    const res = new val.constructor();
    for (let key in val) {
      res[key] = cloneDeep(val[key], instanceClone);
    }
    return res;
  }
  return val;
}

function cloneArrayDeep(val, instanceClone) {
  const res = new val.constructor(val.length);
  for (let i = 0; i < val.length; i++) {
    res[i] = cloneDeep(val[i], instanceClone);
  }
  return res;
}

/**
 * Expose `cloneDeep`
 */

var cloneDeep_1 = cloneDeep;

function makeStyles(styles) {
    var useStyles = function (styleProps) {
        var theme = useThemeContext();
        var currStyles = useMemo(function () {
            var _a;
            var stylesClone = cloneDeep_1(styles);
            var processedStyles = {};
            for (var _i = 0, _b = Object.entries(stylesClone); _i < _b.length; _i++) {
                var _c = _b[_i], key = _c[0], styleOrCreator = _c[1];
                Object.assign(processedStyles, (_a = {},
                    _a[key] = typeof styleOrCreator === 'function'
                        ? styleOrCreator(theme, styleProps)
                        : styleOrCreator,
                    _a));
            }
            return processedStyles;
        }, [styleProps, theme]);
        return currStyles;
    };
    return useStyles;
}

var reset = css(templateObject_1$3$1 || (templateObject_1$3$1 = __makeTemplateObject(["\n  html,\n  body,\n  div,\n  span,\n  applet,\n  object,\n  iframe,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  blockquote,\n  pre,\n  a,\n  abbr,\n  acronym,\n  address,\n  big,\n  cite,\n  code,\n  del,\n  dfn,\n  em,\n  img,\n  ins,\n  kbd,\n  q,\n  s,\n  samp,\n  small,\n  strike,\n  strong,\n  sub,\n  sup,\n  tt,\n  var,\n  b,\n  u,\n  i,\n  center,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  article,\n  aside,\n  canvas,\n  details,\n  embed,\n  figure,\n  figcaption,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  output,\n  ruby,\n  section,\n  summary,\n  time,\n  mark,\n  audio,\n  video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  section {\n    display: block;\n  }\n  body {\n    line-height: 1;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n"], ["\n  html,\n  body,\n  div,\n  span,\n  applet,\n  object,\n  iframe,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  blockquote,\n  pre,\n  a,\n  abbr,\n  acronym,\n  address,\n  big,\n  cite,\n  code,\n  del,\n  dfn,\n  em,\n  img,\n  ins,\n  kbd,\n  q,\n  s,\n  samp,\n  small,\n  strike,\n  strong,\n  sub,\n  sup,\n  tt,\n  var,\n  b,\n  u,\n  i,\n  center,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  article,\n  aside,\n  canvas,\n  details,\n  embed,\n  figure,\n  figcaption,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  output,\n  ruby,\n  section,\n  summary,\n  time,\n  mark,\n  audio,\n  video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  section {\n    display: block;\n  }\n  body {\n    line-height: 1;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n"])));
var templateObject_1$3$1;

var normalize = css(templateObject_1$2$1 || (templateObject_1$2$1 = __makeTemplateObject(["\n  html {\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n  }\n  body {\n    margin: 0;\n  }\n  main {\n    display: block;\n  }\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n  hr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n  }\n  pre {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  a {\n    background-color: transparent;\n  }\n  abbr[title] {\n    border-bottom: none;\n    text-decoration: underline;\n    text-decoration: underline dotted;\n  }\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  img {\n    border-style: none;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n  }\n  button,\n  input {\n    overflow: visible;\n  }\n  button,\n  select {\n    text-transform: none;\n  }\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n  button::-moz-focus-inner,\n  [type='button']::-moz-focus-inner,\n  [type='reset']::-moz-focus-inner,\n  [type='submit']::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  button:-moz-focusring,\n  [type='button']:-moz-focusring,\n  [type='reset']:-moz-focusring,\n  [type='submit']:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  legend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  textarea {\n    overflow: auto;\n  }\n  [type='checkbox'],\n  [type='radio'] {\n    box-sizing: border-box;\n    padding: 0;\n  }\n  [type='number']::-webkit-inner-spin-button,\n  [type='number']::-webkit-outer-spin-button {\n    height: auto;\n  }\n  [type='search'] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n  [type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n  details {\n    display: block;\n  }\n  summary {\n    display: list-item;\n  }\n  template {\n    display: none;\n  }\n  [hidden] {\n    display: none;\n  }\n"], ["\n  html {\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n  }\n  body {\n    margin: 0;\n  }\n  main {\n    display: block;\n  }\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n  hr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n  }\n  pre {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  a {\n    background-color: transparent;\n  }\n  abbr[title] {\n    border-bottom: none;\n    text-decoration: underline;\n    text-decoration: underline dotted;\n  }\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  img {\n    border-style: none;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n  }\n  button,\n  input {\n    overflow: visible;\n  }\n  button,\n  select {\n    text-transform: none;\n  }\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n  button::-moz-focus-inner,\n  [type='button']::-moz-focus-inner,\n  [type='reset']::-moz-focus-inner,\n  [type='submit']::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  button:-moz-focusring,\n  [type='button']:-moz-focusring,\n  [type='reset']:-moz-focusring,\n  [type='submit']:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  legend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  textarea {\n    overflow: auto;\n  }\n  [type='checkbox'],\n  [type='radio'] {\n    box-sizing: border-box;\n    padding: 0;\n  }\n  [type='number']::-webkit-inner-spin-button,\n  [type='number']::-webkit-outer-spin-button {\n    height: auto;\n  }\n  [type='search'] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n  [type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n  details {\n    display: block;\n  }\n  summary {\n    display: list-item;\n  }\n  template {\n    display: none;\n  }\n  [hidden] {\n    display: none;\n  }\n"])));
var templateObject_1$2$1;

var boxSizingReset = css(templateObject_1$1$1 || (templateObject_1$1$1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  &:before,\n  &:after,\n  & *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n"], ["\n  box-sizing: border-box;\n  &:before,\n  &:after,\n  & *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n"])));
var templateObject_1$1$1;

var ResetStyles = function () {
    return (jsx(Global$1, { styles: css(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n        ", ";\n        ", ";\n        body {\n          ", ";\n        }\n      "], ["\n        ", ";\n        ", ";\n        body {\n          ", ";\n        }\n      "])), reset, normalize, boxSizingReset) }));
};
var templateObject_1$C;

var useStyles$1W = makeStyles({
    root: function (theme) { return css(templateObject_1$B || (templateObject_1$B = __makeTemplateObject$1(["\n    border-radius: ", ";\n\n    svg {\n      width: 60%;\n      height: 60%;\n    }\n  "], ["\n    border-radius: ", ";\n\n    svg {\n      width: 60%;\n      height: 60%;\n    }\n  "])), theme.borderRadius.circular); },
    placeholderIcon: function () { return css(templateObject_2$k || (templateObject_2$k = __makeTemplateObject$1(["\n    width: 100%;\n    height: 100%;\n  "], ["\n    width: 100%;\n    height: 100%;\n  "]))); },
    placeholder: function () { return css(templateObject_3$h || (templateObject_3$h = __makeTemplateObject$1(["\n    width: 100%;\n    height: 100%;\n  "], ["\n    width: 100%;\n    height: 100%;\n  "]))); },
});
var templateObject_1$B, templateObject_2$k, templateObject_3$h;

const DEFAULT_COLORS = {
  dark: [
    "#C1C2C5",
    "#A6A7AB",
    "#909296",
    "#5c5f66",
    "#373A40",
    "#2C2E33",
    "#25262b",
    "#1A1B1E",
    "#141517",
    "#101113"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
};

function fontStyles(theme) {
  return () => ({ fontFamily: theme.fontFamily || "sans-serif" });
}

function focusStyles(theme) {
  return () => ({
    WebkitTapHighlightColor: "transparent",
    "&:focus": {
      outlineOffset: 2,
      outline: theme.focusRing === "always" || theme.focusRing === "auto" ? `2px solid ${theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]}` : "none"
    },
    "&:focus:not(:focus-visible)": {
      outline: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
    }
  });
}

function themeColor(theme) {
  return (color, shade, primaryFallback = true) => {
    const primaryShades = theme.colors[theme.primaryColor];
    return color in theme.colors ? theme.colors[color][shade] : primaryFallback ? primaryShades[shade] : color;
  };
}

function getGradientColorStops(colors) {
  let stops = "";
  for (let i = 1; i < colors.length - 1; i += 1) {
    stops += `${colors[i]} ${i / (colors.length - 1) * 100}%, `;
  }
  return `${colors[0]} 0%, ${stops}${colors[colors.length - 1]} 100%`;
}

function linearGradient(deg, ...colors) {
  return `linear-gradient(${deg}deg, ${getGradientColorStops(colors)})`;
}
function radialGradient(...colors) {
  return `radial-gradient(circle, ${getGradientColorStops(colors)})`;
}

function size(props) {
  if (typeof props.size === "number") {
    return props.size;
  }
  return props.sizes[props.size] || props.size || props.sizes.md;
}

function largerThan(theme) {
  return (breakpoint) => `@media (min-width: ${size({ size: breakpoint, sizes: theme.breakpoints }) + 1}px)`;
}
function smallerThan(theme) {
  return (breakpoint) => `@media (max-width: ${size({ size: breakpoint, sizes: theme.breakpoints })}px)`;
}

function isHexColor(hex) {
  const HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}$/i;
  return HEX_REGEXP.test(hex);
}
function hexToRgba(color) {
  let hexString = color.replace("#", "");
  if (hexString.length === 3) {
    const shorthandHex = hexString.split("");
    hexString = [
      shorthandHex[0],
      shorthandHex[0],
      shorthandHex[1],
      shorthandHex[1],
      shorthandHex[2],
      shorthandHex[2]
    ].join("");
  }
  const parsed = parseInt(hexString, 16);
  const r = parsed >> 16 & 255;
  const g = parsed >> 8 & 255;
  const b = parsed & 255;
  return {
    r,
    g,
    b,
    a: 1
  };
}
function rgbStringToRgba(color) {
  const [r, g, b, a] = color.replace(/[^0-9,.]/g, "").split(",").map(Number);
  return { r, g, b, a: a || 1 };
}
function toRgba(color) {
  if (isHexColor(color)) {
    return hexToRgba(color);
  }
  if (color.startsWith("rgb")) {
    return rgbStringToRgba(color);
  }
  return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}

function rgba(color, alpha) {
  if (typeof color !== "string" || alpha > 1 || alpha < 0) {
    return "rgba(0, 0, 0, 1)";
  }
  const { r, g, b } = toRgba(color);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function cover(offset = 0) {
  return {
    position: "absolute",
    top: offset,
    right: offset,
    left: offset,
    bottom: offset
  };
}

function darken(color, alpha) {
  const { r, g, b, a } = toRgba(color);
  const f = 1 - alpha;
  const dark = (input) => Math.round(input * f);
  return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}

function lighten(color, alpha) {
  const { r, g, b, a } = toRgba(color);
  const light = (input) => Math.round(input + (255 - input) * alpha);
  return `rgba(${light(r)}, ${light(g)}, ${light(b)}, ${a})`;
}

function radius(theme) {
  return (size) => {
    if (typeof size === "number") {
      return size;
    }
    const defaultRadius = typeof theme.defaultRadius === "number" ? theme.defaultRadius : theme.radius[theme.defaultRadius] || theme.defaultRadius;
    return theme.radius[size] || size || defaultRadius;
  };
}

function primaryShade(theme) {
  return (colorScheme) => {
    if (typeof theme.primaryShade === "number") {
      return theme.primaryShade;
    }
    return theme.primaryShade[colorScheme || theme.colorScheme];
  };
}

const DEFAULT_GRADIENT = {
  from: "indigo",
  to: "cyan",
  deg: 45
};
function variant(theme) {
  const getThemeColor = themeColor(theme);
  const getPrimaryShade = primaryShade(theme);
  return ({ variant: variant2, color, gradient }) => {
    if (variant2 === "light") {
      return {
        border: "transparent",
        background: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0), theme.colorScheme === "dark" ? 0.35 : 1),
        color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
        hover: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 7 : 1), theme.colorScheme === "dark" ? 0.45 : 0.65)
      };
    }
    if (variant2 === "default") {
      return {
        border: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[4],
        background: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white,
        color: theme.colorScheme === "dark" ? theme.white : theme.black,
        hover: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[0]
      };
    }
    if (variant2 === "white") {
      return {
        border: "transparent",
        background: theme.white,
        color: getThemeColor(color, getPrimaryShade()),
        hover: null
      };
    }
    if (variant2 === "outline") {
      return {
        border: getThemeColor(color, theme.colorScheme === "dark" ? 4 : getPrimaryShade("light")),
        background: "transparent",
        color: getThemeColor(color, theme.colorScheme === "dark" ? 4 : getPrimaryShade("light")),
        hover: theme.colorScheme === "dark" ? rgba(getThemeColor(color, 4), 0.05) : rgba(getThemeColor(color, 0), 0.35)
      };
    }
    if (variant2 === "gradient") {
      const merged = {
        from: (gradient == null ? void 0 : gradient.from) || DEFAULT_GRADIENT.from,
        to: (gradient == null ? void 0 : gradient.to) || DEFAULT_GRADIENT.to,
        deg: (gradient == null ? void 0 : gradient.deg) || DEFAULT_GRADIENT.deg
      };
      return {
        background: `linear-gradient(${merged.deg}deg, ${getThemeColor(merged.from, getPrimaryShade(), false)} 0%, ${getThemeColor(merged.to, getPrimaryShade(), false)} 100%)`,
        color: theme.white,
        border: "transparent",
        hover: null
      };
    }
    if (variant2 === "subtle") {
      return {
        border: "transparent",
        background: "transparent",
        color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
        hover: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0), theme.colorScheme === "dark" ? 0.35 : 1)
      };
    }
    return {
      border: "transparent",
      background: getThemeColor(color, getPrimaryShade()),
      color: theme.white,
      hover: getThemeColor(color, getPrimaryShade() === 9 ? 8 : getPrimaryShade() + 1)
    };
  };
}

function hover(hoverStyle) {
  return {
    "@media (hover: hover)": {
      "&:hover": hoverStyle
    },
    "@media (hover: none)": {
      "&:active": hoverStyle
    }
  };
}

const fns = {
  fontStyles,
  themeColor,
  focusStyles,
  linearGradient,
  radialGradient,
  smallerThan,
  largerThan,
  rgba,
  size,
  cover,
  darken,
  lighten,
  radius,
  variant,
  primaryShade,
  hover
};

var __defProp$1N = Object.defineProperty;
var __defProps$M = Object.defineProperties;
var __getOwnPropDescs$M = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1O = Object.getOwnPropertySymbols;
var __hasOwnProp$1O = Object.prototype.hasOwnProperty;
var __propIsEnum$1O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1N = (obj, key, value) => key in obj ? __defProp$1N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1O.call(b, prop))
      __defNormalProp$1N(a, prop, b[prop]);
  if (__getOwnPropSymbols$1O)
    for (var prop of __getOwnPropSymbols$1O(b)) {
      if (__propIsEnum$1O.call(b, prop))
        __defNormalProp$1N(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$M = (a, b) => __defProps$M(a, __getOwnPropDescs$M(b));
function attachFunctions(themeBase) {
  return __spreadProps$M(__spreadValues$1N({}, themeBase), {
    fn: {
      fontStyles: fns.fontStyles(themeBase),
      themeColor: fns.themeColor(themeBase),
      focusStyles: fns.focusStyles(themeBase),
      largerThan: fns.largerThan(themeBase),
      smallerThan: fns.smallerThan(themeBase),
      radialGradient: fns.radialGradient,
      linearGradient: fns.linearGradient,
      rgba: fns.rgba,
      size: fns.size,
      cover: fns.cover,
      lighten: fns.lighten,
      darken: fns.darken,
      primaryShade: fns.primaryShade(themeBase),
      radius: fns.radius(themeBase),
      variant: fns.variant(themeBase),
      hover: fns.hover
    }
  });
}

Object.keys(DEFAULT_COLORS);
const MANTINE_SIZES = ["xs", "sm", "md", "lg", "xl"];
const _DEFAULT_THEME = {
  dir: "ltr",
  primaryShade: {
    light: 6,
    dark: 8
  },
  focusRing: "auto",
  loader: "oval",
  dateFormat: "MMMM D, YYYY",
  colorScheme: "light",
  white: "#fff",
  black: "#000",
  defaultRadius: "sm",
  transitionTimingFunction: "ease",
  colors: DEFAULT_COLORS,
  lineHeight: 1.55,
  fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  primaryColor: "blue",
  shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)",
    sm: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px",
    md: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
    lg: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 28px 23px -7px, rgba(0, 0, 0, 0.04) 0px 12px 12px -7px",
    xl: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 36px 28px -7px, rgba(0, 0, 0, 0.04) 0px 17px 17px -7px"
  },
  fontSizes: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20
  },
  radius: {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 32
  },
  spacing: {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24
  },
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400
  },
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontWeight: 700,
    sizes: {
      h1: { fontSize: 34, lineHeight: 1.3 },
      h2: { fontSize: 26, lineHeight: 1.35 },
      h3: { fontSize: 22, lineHeight: 1.4 },
      h4: { fontSize: 18, lineHeight: 1.45 },
      h5: { fontSize: 16, lineHeight: 1.5 },
      h6: { fontSize: 14, lineHeight: 1.5 }
    }
  },
  other: {},
  datesLocale: "en"
};
const DEFAULT_THEME = attachFunctions(_DEFAULT_THEME);

function filterProps(props) {
  return Object.keys(props).reduce((acc, key) => {
    if (props[key] !== void 0) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
}

var __defProp$1M = Object.defineProperty;
var __getOwnPropSymbols$1N = Object.getOwnPropertySymbols;
var __hasOwnProp$1N = Object.prototype.hasOwnProperty;
var __propIsEnum$1N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1M = (obj, key, value) => key in obj ? __defProp$1M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1N.call(b, prop))
      __defNormalProp$1M(a, prop, b[prop]);
  if (__getOwnPropSymbols$1N)
    for (var prop of __getOwnPropSymbols$1N(b)) {
      if (__propIsEnum$1N.call(b, prop))
        __defNormalProp$1M(a, prop, b[prop]);
    }
  return a;
};
const MantineProviderContext = createContext({
  theme: DEFAULT_THEME,
  styles: {},
  classNames: {},
  emotionOptions: { key: "mantine", prepend: true },
  defaultProps: {}
});
function useMantineTheme() {
  var _a;
  return ((_a = useContext(MantineProviderContext)) == null ? void 0 : _a.theme) || DEFAULT_THEME;
}
function useMantineThemeStyles(component) {
  const ctx = useContext(MantineProviderContext);
  return { styles: ctx.styles[component] || {}, classNames: ctx.classNames[component] || {} };
}
function useMantineEmotionOptions() {
  var _a;
  return ((_a = useContext(MantineProviderContext)) == null ? void 0 : _a.emotionOptions) || { key: "mantine", prepend: true };
}
function useMantineDefaultProps(component, defaultProps, props) {
  var _a, _b;
  const contextProps = ((_b = (_a = useContext(MantineProviderContext)) == null ? void 0 : _a.defaultProps) == null ? void 0 : _b[component]) || {};
  return __spreadValues$1M(__spreadValues$1M(__spreadValues$1M({}, defaultProps), contextProps), filterProps(props));
}

const elevations = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400
};
function getDefaultZIndex(level) {
  return elevations[level];
}

var __getOwnPropSymbols$1M = Object.getOwnPropertySymbols;
var __hasOwnProp$1M = Object.prototype.hasOwnProperty;
var __propIsEnum$1M = Object.prototype.propertyIsEnumerable;
var __objRest$14 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function extractSystemStyles(others) {
  const _a = others, { m, mx, my, mt, mb, ml, mr, p, px, py, pt, pb, pl, pr } = _a, rest = __objRest$14(_a, ["m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr"]);
  const systemStyles = { m, mx, my, mt, mb, ml, mr, p, px, py, pt, pb, pl, pr };
  Object.keys(systemStyles).forEach((key) => {
    if (systemStyles[key] === void 0) {
      delete systemStyles[key];
    }
  });
  return { systemStyles, rest };
}

function fromEntries$1(entries) {
  const o = {};
  Object.keys(entries).forEach((key) => {
    const [k, v] = entries[key];
    o[k] = v;
  });
  return o;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

function useGuaranteedMemo(fn, deps) {
  const ref = useRef();
  if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map((v, i) => v === deps[i]).indexOf(false) >= 0) {
    ref.current = {
      v: fn(),
      prevDeps: [...deps]
    };
  }
  return ref.current.v;
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$2 (value, length) {
	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash$2(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify$1 (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length);
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [stringify$1, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify$1];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

const defaultCacheOptions = {
  key: "mantine",
  prepend: true
};
const { getCache } = (() => {
  let cache;
  let _key = defaultCacheOptions.key;
  function _getCache(options) {
    if (cache === void 0 || _key !== (options == null ? void 0 : options.key)) {
      _key = (options == null ? void 0 : options.key) || "mantine";
      cache = createCache((options == null ? void 0 : options.key) ? options : defaultCacheOptions);
    }
    return cache;
  }
  return { getCache: _getCache };
})();
function useEmotionCache() {
  const options = useMantineEmotionOptions();
  return getCache(options);
}

var __defProp$1L = Object.defineProperty;
var __getOwnPropSymbols$1L = Object.getOwnPropertySymbols;
var __hasOwnProp$1L = Object.prototype.hasOwnProperty;
var __propIsEnum$1L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1L = (obj, key, value) => key in obj ? __defProp$1L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1L.call(b, prop))
      __defNormalProp$1L(a, prop, b[prop]);
  if (__getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(b)) {
      if (__propIsEnum$1L.call(b, prop))
        __defNormalProp$1L(a, prop, b[prop]);
    }
  return a;
};
const refPropertyName = "ref";
function getRef(args) {
  let ref;
  if (args.length !== 1) {
    return { args, ref };
  }
  const [arg] = args;
  if (!(arg instanceof Object)) {
    return { args, ref };
  }
  if (!(refPropertyName in arg)) {
    return { args, ref };
  }
  ref = arg[refPropertyName];
  const argCopy = __spreadValues$1L({}, arg);
  delete argCopy[refPropertyName];
  return { args: [argCopy], ref };
}
const { cssFactory } = (() => {
  function merge(registered, css, className) {
    const registeredStyles = [];
    const rawClassName = getRegisteredStyles(registered, registeredStyles, className);
    if (registeredStyles.length < 2) {
      return className;
    }
    return rawClassName + css(registeredStyles);
  }
  function _cssFactory(params) {
    const { cache } = params;
    const css = (...styles) => {
      const { ref, args } = getRef(styles);
      const serialized = serializeStyles(args, cache.registered);
      insertStyles(cache, serialized, false);
      return `${cache.key}-${serialized.name}${ref === void 0 ? "" : ` ${ref}`}`;
    };
    const cx = (...args) => merge(cache.registered, css, clsx(args));
    return { css, cx };
  }
  return { cssFactory: _cssFactory };
})();
function useCss() {
  const cache = useEmotionCache();
  return useGuaranteedMemo(() => cssFactory({ cache }), [cache]);
}

function mergeClassNames(cx, classes, themeClassNames, classNames, name) {
  return Object.keys(classes).reduce((acc, className) => {
    acc[className] = cx(classes[className], themeClassNames !== null && themeClassNames[className], classNames != null && classNames[className], name ? `mantine-${name}-${className}` : null);
    return acc;
  }, {});
}

function createStyles(getCssObjectOrCssObject) {
  const getCssObject = typeof getCssObjectOrCssObject === "function" ? getCssObjectOrCssObject : () => getCssObjectOrCssObject;
  function useStyles(params, options) {
    const theme = useMantineTheme();
    const { styles: themeStyles, classNames: themeClassNames } = useMantineThemeStyles(options == null ? void 0 : options.name);
    const { css, cx } = useCss();
    function createRef(refName) {
      return `__mantine-ref-${refName || ""}`;
    }
    const cssObject = getCssObject(theme, params, createRef);
    const _styles = typeof (options == null ? void 0 : options.styles) === "function" ? options == null ? void 0 : options.styles(theme) : (options == null ? void 0 : options.styles) || {};
    const _themeStyles = typeof themeStyles === "function" ? themeStyles(theme, params || {}) : themeStyles || {};
    const classes = fromEntries$1(Object.keys(cssObject).map((key) => {
      const mergedStyles = cx(css(cssObject[key]), css(_themeStyles[key]), css(_styles[key]));
      return [key, mergedStyles];
    }));
    return {
      classes: mergeClassNames(cx, classes, themeClassNames, options == null ? void 0 : options.classNames, options == null ? void 0 : options.name),
      cx,
      theme
    };
  }
  return useStyles;
}

function Global({ styles }) {
  const theme = useMantineTheme();
  return /* @__PURE__ */ React__default.createElement(Global$1, {
    styles: css(typeof styles === "function" ? styles(theme) : styles)
  });
}

var __defProp$1K = Object.defineProperty;
var __defProps$L = Object.defineProperties;
var __getOwnPropDescs$L = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1K = Object.getOwnPropertySymbols;
var __hasOwnProp$1K = Object.prototype.hasOwnProperty;
var __propIsEnum$1K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1K = (obj, key, value) => key in obj ? __defProp$1K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1K.call(b, prop))
      __defNormalProp$1K(a, prop, b[prop]);
  if (__getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(b)) {
      if (__propIsEnum$1K.call(b, prop))
        __defNormalProp$1K(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$L = (a, b) => __defProps$L(a, __getOwnPropDescs$L(b));
const popIn = {
  in: { opacity: 1, transform: "scale(1)" },
  out: { opacity: 0, transform: "scale(.9) translateY(10px)" },
  transitionProperty: "transform, opacity"
};
const transitions = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  scale: {
    in: { opacity: 1, transform: "scale(1)" },
    out: { opacity: 0, transform: "scale(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: { opacity: 1, transform: "scaleY(1)" },
    out: { opacity: 0, transform: "scaleY(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: { opacity: 1, transform: "scaleX(1)" },
    out: { opacity: 0, transform: "scaleX(0)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(-20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(-5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-100%)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(100%)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(100%)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-100%)" },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: __spreadProps$L(__spreadValues$1K({}, popIn), {
    common: { transformOrigin: "center center" }
  }),
  "pop-bottom-left": __spreadProps$L(__spreadValues$1K({}, popIn), {
    common: { transformOrigin: "bottom left" }
  }),
  "pop-bottom-right": __spreadProps$L(__spreadValues$1K({}, popIn), {
    common: { transformOrigin: "bottom right" }
  }),
  "pop-top-left": __spreadProps$L(__spreadValues$1K({}, popIn), {
    common: { transformOrigin: "top left" }
  }),
  "pop-top-right": __spreadProps$L(__spreadValues$1K({}, popIn), {
    common: { transformOrigin: "top right" }
  })
};

function filterFalsyChildren(children) {
  return Children.toArray(children).filter(Boolean);
}

function groupOptions({ data }) {
  const sortedData = [];
  const unGroupedData = [];
  const groupedData = data.reduce((acc, item, index) => {
    if (item.group) {
      if (acc[item.group])
        acc[item.group].push(index);
      else
        acc[item.group] = [index];
    } else {
      unGroupedData.push(index);
    }
    return acc;
  }, {});
  Object.keys(groupedData).forEach((groupName) => {
    sortedData.push(...groupedData[groupName].map((index) => data[index]));
  });
  sortedData.push(...unGroupedData.map((itemIndex) => data[itemIndex]));
  return sortedData;
}

function findAncestor(element, className) {
  let _element = element;
  while ((_element = _element.parentElement) && !_element.classList.contains(className))
    ;
  return _element;
}
function getContextItemIndex(options, node) {
  if (!node) {
    return -1;
  }
  return Array.from(findAncestor(node, options.parentClassName).querySelectorAll(options.elementSelector)).findIndex((element) => element === node);
}

function createUseContext(defaultValue) {
  const Context = createContext(defaultValue);
  function useContextConsumer(component) {
    const ctx = useContext(Context);
    const [parentName] = component.split(".");
    if (!ctx) {
      throw new Error(`${component} component was rendered outside of ${parentName} component context`);
    }
    return ctx;
  }
  return [Context.Provider, useContextConsumer];
}

const DEFAULT_EVENTS$1 = ["mousedown", "touchstart"];
function useClickOutside(handler, events, nodes) {
  const ref = useRef();
  useEffect(() => {
    const listener = (event) => {
      var _a;
      if (Array.isArray(nodes)) {
        const shouldIgnore = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.hasAttribute("data-ignore-outside-clicks");
        const shouldTrigger = nodes.every((node) => !!node && !node.contains(event.target));
        shouldTrigger && !shouldIgnore && handler();
      } else if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };
    (events || DEFAULT_EVENTS$1).forEach((fn) => document.addEventListener(fn, listener));
    return () => {
      (events || DEFAULT_EVENTS$1).forEach((fn) => document.removeEventListener(fn, listener));
    };
  }, [ref, handler, nodes]);
  return ref;
}

function useClipboard({ timeout = 2e3 } = {}) {
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [copyTimeout, setCopyTimeout] = useState(null);
  const handleCopyResult = (value) => {
    clearTimeout(copyTimeout);
    setCopyTimeout(setTimeout(() => setCopied(false), timeout));
    setCopied(value);
  };
  const copy = (valueToCopy) => {
    if ("clipboard" in navigator) {
      navigator.clipboard.writeText(valueToCopy).then(() => handleCopyResult(true)).catch((err) => setError(err));
    } else {
      setError(new Error("useClipboard: navigator.clipboard is not supported"));
    }
  };
  const reset = () => {
    setCopied(false);
    setError(null);
    clearTimeout(copyTimeout);
  };
  return { copy, reset, error, copied };
}

function attachMediaListener(query, callback) {
  try {
    query.addEventListener("change", callback);
    return () => query.removeEventListener("change", callback);
  } catch (e) {
    query.addListener(callback);
    return () => query.removeListener(callback);
  }
}
function getInitialValue(query, initialValue) {
  if (initialValue !== void 0) {
    return initialValue;
  }
  if (typeof window !== "undefined" && "matchMedia" in window) {
    return window.matchMedia(query).matches;
  }
  return false;
}
function useMediaQuery(query, initialValue) {
  const [matches, setMatches] = useState(getInitialValue(query, initialValue));
  const queryRef = useRef();
  useEffect(() => {
    if ("matchMedia" in window) {
      queryRef.current = window.matchMedia(query);
      setMatches(queryRef.current.matches);
      return attachMediaListener(queryRef.current, (event) => setMatches(event.matches));
    }
    return void 0;
  }, [query]);
  return matches;
}

function useColorScheme(initialValue) {
  return useMediaQuery("(prefers-color-scheme: dark)", initialValue === "dark") ? "dark" : "light";
}

function useDebouncedValue(value, wait, options = { leading: false }) {
  const [_value, setValue] = useState(value);
  const mountedRef = useRef(false);
  const timeoutRef = useRef(null);
  const cooldownRef = useRef(false);
  const cancel = () => window.clearTimeout(timeoutRef.current);
  useEffect(() => {
    if (mountedRef.current) {
      if (!cooldownRef.current && options.leading) {
        cooldownRef.current = true;
        setValue(value);
      } else {
        cancel();
        timeoutRef.current = window.setTimeout(() => {
          cooldownRef.current = false;
          setValue(value);
        }, wait);
      }
    }
  }, [value, options.leading]);
  useEffect(() => {
    mountedRef.current = true;
    return cancel;
  }, []);
  return [_value, cancel];
}

const useIsomorphicEffect = typeof document !== "undefined" ? useLayoutEffect$1 : useEffect;

function useDocumentTitle(title) {
  useIsomorphicEffect(() => {
    if (typeof title === "string" && title.trim().length > 0) {
      document.title = title.trim();
    }
  }, [title]);
}

function useDidUpdate(fn, dependencies) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      fn();
    } else {
      mounted.current = true;
    }
  }, dependencies);
}

function useFocusReturn({
  opened,
  transitionDuration,
  shouldReturnFocus = true
}) {
  const lastActiveElement = useRef();
  const returnFocus = () => {
    var _a;
    if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") {
      (_a = lastActiveElement.current) == null ? void 0 : _a.focus();
    }
  };
  useDidUpdate(() => {
    let timeout = -1;
    const clearFocusTimeout = (event) => {
      if (event.code === "Tab") {
        window.clearTimeout(timeout);
      }
    };
    document.addEventListener("keydown", clearFocusTimeout);
    if (opened) {
      lastActiveElement.current = document.activeElement;
    } else if (shouldReturnFocus) {
      timeout = window.setTimeout(returnFocus, transitionDuration + 10);
    }
    return () => {
      window.clearTimeout(timeout);
      document.removeEventListener("keydown", clearFocusTimeout);
    };
  }, [opened]);
  return returnFocus;
}

const TABBABLE_NODES = /input|select|textarea|button|object/;
const FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function hidden(element) {
  if (process.env.NODE_ENV === "test") {
    return false;
  }
  return element.style.display === "none";
}
function visible(element) {
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) {
      break;
    }
    if (hidden(parentElement)) {
      return false;
    }
    parentElement = parentElement.parentNode;
  }
  return true;
}
function getElementTabIndex(element) {
  let tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) {
    tabIndex = void 0;
  }
  return parseInt(tabIndex, 10);
}
function focusable(element) {
  const nodeName = element.nodeName.toLowerCase();
  const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
  const res = TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}
function tabbable(element) {
  const tabIndex = getElementTabIndex(element);
  const isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
  return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}

function scopeTab(node, event) {
  const tabbable = findTabbableDescendants(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  const leavingFinalTabbable = finalTabbable === document.activeElement || node === document.activeElement;
  if (!leavingFinalTabbable) {
    return;
  }
  event.preventDefault();
  const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  if (target) {
    target.focus();
  }
}

function createAriaHider(containerNode, selector = "body > :not(script)") {
  const rootNodes = Array.from(document.querySelectorAll(selector)).map((node) => {
    if (node.contains(containerNode)) {
      return void 0;
    }
    const ariaHidden = node.getAttribute("aria-hidden");
    if (ariaHidden === null || ariaHidden === "false") {
      node.setAttribute("aria-hidden", "true");
    }
    return { node, ariaHidden };
  });
  return () => {
    rootNodes.forEach((item) => {
      if (!item) {
        return;
      }
      if (item.ariaHidden === null) {
        item.node.removeAttribute("aria-hidden");
      } else {
        item.node.setAttribute("aria-hidden", item.ariaHidden);
      }
    });
  };
}

function useFocusTrap(active = true) {
  const ref = useRef();
  const restoreAria = useRef(null);
  const setRef = useCallback((node) => {
    if (!active) {
      return;
    }
    if (restoreAria.current) {
      restoreAria.current();
    }
    if (node) {
      const processNode = (_node) => {
        restoreAria.current = createAriaHider(_node);
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
          const children = Array.from(node.querySelectorAll(FOCUS_SELECTOR));
          focusElement = children.find(tabbable) || children.find(focusable) || null;
          if (!focusElement && focusable(node))
            focusElement = node;
        }
        if (focusElement) {
          focusElement.focus();
        } else if (process.env.NODE_ENV === "development") {
          console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", node);
        }
      };
      setTimeout(() => {
        if (node.ownerDocument) {
          processNode(node);
        } else if (process.env.NODE_ENV === "development") {
          console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", node);
        }
      });
      ref.current = node;
    } else {
      ref.current = null;
    }
  }, [active]);
  useEffect(() => {
    if (!active) {
      return void 0;
    }
    const handleKeyDown = (event) => {
      if (event.key === "Tab" && ref.current) {
        scopeTab(ref.current, event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [active]);
  return setRef;
}

const reducer = (value) => (value + 1) % 1e6;
function useForceUpdate() {
  const [, update] = useReducer(reducer, 0);
  return update;
}

function getInputOnChange$1(setValue) {
  return (val) => {
    if (!val) {
      setValue(val);
    } else if (typeof val === "function") {
      setValue(val);
    } else if (typeof val === "object" && "nativeEvent" in val) {
      const { currentTarget } = val;
      if (currentTarget.type === "checkbox") {
        setValue(currentTarget.checked);
      } else {
        setValue(currentTarget.value);
      }
    } else {
      setValue(val);
    }
  };
}
function useInputState(initialState) {
  const [value, setValue] = useState(initialState);
  return [value, getInputOnChange$1(setValue)];
}

function randomId() {
  return `mantine-${Math.random().toString(36).slice(2, 11)}`;
}

function useId(id, generateId = randomId) {
  const generatedId = useRef(generateId());
  return id || generatedId.current;
}

var __defProp$1J = Object.defineProperty;
var __getOwnPropSymbols$1J = Object.getOwnPropertySymbols;
var __hasOwnProp$1J = Object.prototype.hasOwnProperty;
var __propIsEnum$1J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1J = (obj, key, value) => key in obj ? __defProp$1J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1J.call(b, prop))
      __defNormalProp$1J(a, prop, b[prop]);
  if (__getOwnPropSymbols$1J)
    for (var prop of __getOwnPropSymbols$1J(b)) {
      if (__propIsEnum$1J.call(b, prop))
        __defNormalProp$1J(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_EVENTS = ["keypress", "mousemove", "touchmove", "click", "scroll"];
const DEFAULT_OPTIONS$1 = {
  events: DEFAULT_EVENTS,
  initialState: true
};
function useIdle(timeout, options) {
  const { events, initialState } = __spreadValues$1J(__spreadValues$1J({}, DEFAULT_OPTIONS$1), options);
  const [idle, setIdle] = useState(initialState);
  const timer = useRef();
  useEffect(() => {
    const handleEvents = () => {
      setIdle(false);
      if (timer.current) {
        window.clearTimeout(timer.current);
      }
      timer.current = window.setTimeout(() => {
        setIdle(true);
      }, timeout);
    };
    events.forEach((event) => document.addEventListener(event, handleEvents));
    return () => {
      events.forEach((event) => document.removeEventListener(event, handleEvents));
    };
  }, [timeout]);
  return idle;
}

function useInterval(fn, interval) {
  const [active, setActive] = useState(false);
  const intervalRef = useRef();
  const start = () => {
    if (!active) {
      setActive(true);
      intervalRef.current = window.setInterval(fn, interval);
    }
  };
  const stop = () => {
    setActive(false);
    window.clearInterval(intervalRef.current);
  };
  const toggle = () => {
    if (active) {
      stop();
    } else {
      start();
    }
  };
  return { start, stop, toggle, active };
}

var __defProp$1I = Object.defineProperty;
var __defProps$K = Object.defineProperties;
var __getOwnPropDescs$K = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1I = Object.getOwnPropertySymbols;
var __hasOwnProp$1I = Object.prototype.hasOwnProperty;
var __propIsEnum$1I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1I = (obj, key, value) => key in obj ? __defProp$1I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1I.call(b, prop))
      __defNormalProp$1I(a, prop, b[prop]);
  if (__getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(b)) {
      if (__propIsEnum$1I.call(b, prop))
        __defNormalProp$1I(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$K = (a, b) => __defProps$K(a, __getOwnPropDescs$K(b));
function useListState(initialValue = []) {
  const [state, setState] = useState(initialValue);
  const append = (...items) => setState((current) => [...current, ...items]);
  const prepend = (...items) => setState((current) => [...items, ...current]);
  const insert = (index, ...items) => setState((current) => [...current.slice(0, index), ...items, ...current.slice(index)]);
  const apply = (fn) => setState((current) => current.map((item, index) => fn(item, index)));
  const remove = (...indices) => setState((current) => current.filter((_, index) => !indices.includes(index)));
  const pop = () => setState((current) => {
    const cloned = [...current];
    cloned.pop();
    return cloned;
  });
  const shift = () => setState((current) => {
    const cloned = [...current];
    cloned.shift();
    return cloned;
  });
  const reorder = ({ from, to }) => setState((current) => {
    const cloned = [...current];
    const item = current[from];
    cloned.splice(from, 1);
    cloned.splice(to, 0, item);
    return cloned;
  });
  const setItem = (index, item) => setState((current) => {
    const cloned = [...current];
    cloned[index] = item;
    return cloned;
  });
  const setItemProp = (index, prop, value) => setState((current) => {
    const cloned = [...current];
    cloned[index] = __spreadProps$K(__spreadValues$1I({}, cloned[index]), { [prop]: value });
    return cloned;
  });
  const applyWhere = (condition, fn) => setState((current) => current.map((item, index) => condition(item, index) ? fn(item, index) : item));
  return [
    state,
    {
      setState,
      append,
      prepend,
      insert,
      pop,
      shift,
      apply,
      applyWhere,
      remove,
      reorder,
      setItem,
      setItemProp
    }
  ];
}

function useWindowEvent(type, listener, options) {
  useEffect(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, []);
}

function serializeJSON(value) {
  try {
    return JSON.stringify(value);
  } catch (error) {
    throw new Error("@mantine/hooks use-local-storage: Failed to serialize the value");
  }
}
function deserializeJSON(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}
function useLocalStorage({
  key,
  defaultValue = void 0,
  getInitialValueInEffect = false,
  deserialize = deserializeJSON,
  serialize = serializeJSON
}) {
  var _a;
  const [value, setValue] = useState(typeof window !== "undefined" && "localStorage" in window && !getInitialValueInEffect ? deserialize((_a = window.localStorage.getItem(key)) != null ? _a : void 0) : defaultValue != null ? defaultValue : "");
  const setLocalStorageValue = useCallback((val) => {
    if (val instanceof Function) {
      setValue((current) => {
        const result = val(current);
        window.localStorage.setItem(key, serialize(result));
        window.dispatchEvent(new CustomEvent("mantine-local-storage", { detail: { key, value: val(current) } }));
        return result;
      });
    } else {
      window.localStorage.setItem(key, serialize(val));
      window.dispatchEvent(new CustomEvent("mantine-local-storage", { detail: { key, value: val } }));
      setValue(val);
    }
  }, [key]);
  useWindowEvent("storage", (event) => {
    var _a2;
    if (event.storageArea === window.localStorage && event.key === key) {
      setValue(deserialize((_a2 = event.newValue) != null ? _a2 : void 0));
    }
  });
  useWindowEvent("mantine-local-storage", (event) => {
    if (event.detail.key === key) {
      setValue(event.detail.value);
    }
  });
  useEffect(() => {
    if (defaultValue !== void 0 && value === void 0) {
      setLocalStorageValue(defaultValue);
    }
  }, [defaultValue, value, setLocalStorageValue]);
  useEffect(() => {
    var _a2;
    if (getInitialValueInEffect) {
      setValue(deserialize((_a2 = window.localStorage.getItem(key)) != null ? _a2 : void 0) || (defaultValue != null ? defaultValue : ""));
    }
  }, []);
  return [value === void 0 ? defaultValue : value, setLocalStorageValue];
}
const useLocalStorageValue = useLocalStorage;

function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (typeof ref === "object" && ref !== null && "current" in ref) {
    ref.current = value;
  }
}

function useMergedRef(...refs) {
  return useCallback((node) => {
    refs.forEach((ref) => assignRef(ref, node));
  }, refs);
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => assignRef(ref, node));
  };
}

var __defProp$1H = Object.defineProperty;
var __getOwnPropSymbols$1H = Object.getOwnPropertySymbols;
var __hasOwnProp$1H = Object.prototype.hasOwnProperty;
var __propIsEnum$1H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1H = (obj, key, value) => key in obj ? __defProp$1H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1H.call(b, prop))
      __defNormalProp$1H(a, prop, b[prop]);
  if (__getOwnPropSymbols$1H)
    for (var prop of __getOwnPropSymbols$1H(b)) {
      if (__propIsEnum$1H.call(b, prop))
        __defNormalProp$1H(a, prop, b[prop]);
    }
  return a;
};
function useMouse() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const ref = useRef();
  const setMousePosition = (event) => {
    if (ref.current) {
      const rect = event.currentTarget.getBoundingClientRect();
      const x = Math.max(0, Math.round(event.pageX - rect.left - (window.pageXOffset || window.scrollX)));
      const y = Math.max(0, Math.round(event.pageY - rect.top - (window.pageYOffset || window.scrollY)));
      setPosition({ x, y });
    } else {
      setPosition({ x: event.clientX, y: event.clientY });
    }
  };
  useEffect(() => {
    const element = (ref == null ? void 0 : ref.current) ? ref.current : document;
    element.addEventListener("mousemove", setMousePosition);
    return () => element.removeEventListener("mousemove", setMousePosition);
  }, [ref.current]);
  return __spreadValues$1H({ ref }, position);
}

function clamp$1({ value, min, max }) {
  return Math.min(Math.max(value, min), max);
}

const clampUseMovePosition = (position) => ({
  x: clamp$1({ min: 0, max: 1, value: position.x }),
  y: clamp$1({ min: 0, max: 1, value: position.y })
});
function useMove(onChange, handlers, dir = "ltr") {
  const ref = useRef();
  const mounted = useRef(false);
  const isSliding = useRef(false);
  const frame = useRef(0);
  const [active, setActive] = useState(false);
  useEffect(() => {
    mounted.current = true;
  }, []);
  useEffect(() => {
    const onScrub = ({ x, y }) => {
      cancelAnimationFrame(frame.current);
      frame.current = requestAnimationFrame(() => {
        if (mounted.current && ref.current) {
          ref.current.style.userSelect = "none";
          const rect = ref.current.getBoundingClientRect();
          if (rect.width && rect.height) {
            const _x = clamp$1({ value: (x - rect.left) / rect.width, min: 0, max: 1 });
            onChange({
              x: dir === "ltr" ? _x : 1 - _x,
              y: clamp$1({ value: (y - rect.top) / rect.height, min: 0, max: 1 })
            });
          }
        }
      });
    };
    const bindEvents = () => {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", stopScrubbing);
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", stopScrubbing);
    };
    const unbindEvents = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", stopScrubbing);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", stopScrubbing);
    };
    const startScrubbing = () => {
      if (!isSliding.current && mounted.current) {
        isSliding.current = true;
        typeof (handlers == null ? void 0 : handlers.onScrubStart) === "function" && handlers.onScrubStart();
        setActive(true);
        bindEvents();
      }
    };
    const stopScrubbing = () => {
      if (isSliding.current && mounted.current) {
        isSliding.current = false;
        setActive(false);
        unbindEvents();
        setTimeout(() => {
          typeof (handlers == null ? void 0 : handlers.onScrubEnd) === "function" && handlers.onScrubEnd();
        }, 0);
      }
    };
    const onMouseDown = (event) => {
      startScrubbing();
      onMouseMove(event);
    };
    const onMouseMove = (event) => onScrub({ x: event.clientX, y: event.clientY });
    const onTouchStart = (event) => {
      startScrubbing();
      event == null ? void 0 : event.preventDefault();
      onTouchMove(event);
    };
    const onTouchMove = (event) => {
      event == null ? void 0 : event.preventDefault();
      onScrub({ x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY });
    };
    ref.current.addEventListener("mousedown", onMouseDown);
    ref.current.addEventListener("touchstart", onTouchStart);
    return () => {
      if (ref.current) {
        ref.current.removeEventListener("mousedown", onMouseDown);
        ref.current.removeEventListener("touchstart", onTouchStart);
      }
    };
  }, [dir, onChange]);
  return { ref, active };
}

function useUncontrolled({
  value,
  defaultValue,
  finalValue,
  rule,
  onChange,
  onValueUpdate
}) {
  const shouldBeControlled = rule(value);
  const modeRef = useRef("initial");
  const initialValue = rule(defaultValue) ? defaultValue : finalValue;
  const [uncontrolledValue, setUncontrolledValue] = useState(initialValue);
  let effectiveValue = shouldBeControlled ? value : uncontrolledValue;
  if (!shouldBeControlled && modeRef.current === "controlled") {
    effectiveValue = finalValue;
  }
  modeRef.current = shouldBeControlled ? "controlled" : "uncontrolled";
  const mode = modeRef.current;
  const handleChange = (nextValue) => {
    typeof onChange === "function" && onChange(nextValue);
    if (mode === "uncontrolled") {
      setUncontrolledValue(nextValue);
    }
  };
  useEffect(() => {
    if (mode === "uncontrolled") {
      setUncontrolledValue(effectiveValue);
    }
    typeof onValueUpdate === "function" && onValueUpdate(effectiveValue);
  }, [mode, effectiveValue]);
  return [effectiveValue, handleChange, modeRef.current];
}

function range(start, end) {
  const length = end - start + 1;
  return Array.from({ length }, (_, index) => index + start);
}

const DOTS = "dots";
function usePagination({
  total,
  siblings = 1,
  boundaries = 1,
  page,
  initialPage = 1,
  onChange
}) {
  const [activePage, setActivePage] = useUncontrolled({
    value: page,
    onChange,
    defaultValue: initialPage,
    finalValue: initialPage,
    rule: (_page) => typeof _page === "number" && _page <= total
  });
  const setPage = (pageNumber) => {
    if (pageNumber <= 0) {
      setActivePage(1);
    } else if (pageNumber > total) {
      setActivePage(total);
    } else {
      setActivePage(pageNumber);
    }
  };
  const next = () => setPage(activePage + 1);
  const previous = () => setPage(activePage - 1);
  const first = () => setPage(1);
  const last = () => setPage(total);
  const paginationRange = useMemo(() => {
    const totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
    if (totalPageNumbers >= total) {
      return range(1, total);
    }
    const leftSiblingIndex = Math.max(activePage - siblings, boundaries);
    const rightSiblingIndex = Math.min(activePage + siblings, total - boundaries);
    const shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
    const shouldShowRightDots = rightSiblingIndex < total - (boundaries + 1);
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = siblings * 2 + boundaries + 2;
      return [...range(1, leftItemCount), DOTS, ...range(total - (boundaries - 1), total)];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = boundaries + 1 + 2 * siblings;
      return [...range(1, boundaries), DOTS, ...range(total - rightItemCount, total)];
    }
    return [
      ...range(1, boundaries),
      DOTS,
      ...range(leftSiblingIndex, rightSiblingIndex),
      DOTS,
      ...range(total - boundaries + 1, total)
    ];
  }, [total, siblings, activePage]);
  return {
    range: paginationRange,
    active: activePage,
    setPage,
    next,
    previous,
    first,
    last
  };
}

function useQueue({ initialValues = [], limit }) {
  const [{ state, queue }, setState] = useState({
    state: initialValues.slice(0, limit),
    queue: initialValues.slice(limit)
  });
  const add = (...items) => setState((current) => {
    const results = [...current.state, ...current.queue, ...items];
    return {
      state: results.slice(0, limit),
      queue: results.slice(limit)
    };
  });
  const update = (fn) => setState((current) => {
    const results = fn([...current.state, ...current.queue]);
    return {
      state: results.slice(0, limit),
      queue: results.slice(limit)
    };
  });
  const cleanQueue = () => setState((current) => ({ state: current.state, queue: [] }));
  return {
    state,
    queue,
    add,
    update,
    cleanQueue
  };
}

function usePageLeave(onPageLeave) {
  useEffect(() => {
    document.documentElement.addEventListener("mouseleave", onPageLeave);
    return () => document.documentElement.removeEventListener("mouseleave", onPageLeave);
  }, []);
}

function useReducedMotion(initialValue) {
  return useMediaQuery("(prefers-reduced-motion: reduce)", initialValue);
}

const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

const getRelativePosition = ({
  axis,
  target,
  parent,
  alignment,
  offset,
  isList
}) => {
  if (!target || !parent && typeof document === "undefined") {
    return 0;
  }
  const isCustomParent = !!parent;
  const parentElement = parent || document.body;
  const parentPosition = parentElement.getBoundingClientRect();
  const targetPosition = target.getBoundingClientRect();
  const getDiff = (property) => targetPosition[property] - parentPosition[property];
  if (axis === "y") {
    const diff = getDiff("top");
    if (diff === 0)
      return 0;
    if (alignment === "start") {
      const distance = diff - offset;
      const shouldScroll = distance <= targetPosition.height * (isList ? 0 : 1) || !isList;
      return shouldScroll ? distance : 0;
    }
    const parentHeight = isCustomParent ? parentPosition.height : window.innerHeight;
    if (alignment === "end") {
      const distance = diff + offset - parentHeight + targetPosition.height;
      const shouldScroll = distance >= -targetPosition.height * (isList ? 0 : 1) || !isList;
      return shouldScroll ? distance : 0;
    }
    if (alignment === "center") {
      return diff - parentHeight / 2 + targetPosition.height / 2;
    }
    return 0;
  }
  if (axis === "x") {
    const diff = getDiff("left");
    if (diff === 0)
      return 0;
    if (alignment === "start") {
      const distance = diff - offset;
      const shouldScroll = distance <= targetPosition.width || !isList;
      return shouldScroll ? distance : 0;
    }
    const parentWidth = isCustomParent ? parentPosition.width : window.innerWidth;
    if (alignment === "end") {
      const distance = diff + offset - parentWidth + targetPosition.width;
      const shouldScroll = distance >= -targetPosition.width || !isList;
      return shouldScroll ? distance : 0;
    }
    if (alignment === "center") {
      return diff - parentWidth / 2 + targetPosition.width / 2;
    }
    return 0;
  }
  return 0;
};

const getScrollStart = ({ axis, parent }) => {
  if (!parent && typeof document === "undefined") {
    return 0;
  }
  const method = axis === "y" ? "scrollTop" : "scrollLeft";
  if (parent) {
    return parent[method];
  }
  const { body, documentElement } = document;
  return body[method] + documentElement[method];
};

const setScrollParam = ({ axis, parent, distance }) => {
  if (!parent && typeof document === "undefined") {
    return;
  }
  const method = axis === "y" ? "scrollTop" : "scrollLeft";
  if (parent) {
    parent[method] = distance;
  } else {
    const { body, documentElement } = document;
    body[method] = distance;
    documentElement[method] = distance;
  }
};

function useScrollIntoView({
  duration = 1250,
  axis = "y",
  onScrollFinish,
  easing = easeInOutQuad,
  offset = 0,
  cancelable = true,
  isList = false
} = {}) {
  const frameID = useRef(0);
  const startTime = useRef(0);
  const shouldStop = useRef(false);
  const scrollableRef = useRef(null);
  const targetRef = useRef(null);
  const reducedMotion = useReducedMotion();
  const cancel = () => {
    if (frameID.current) {
      cancelAnimationFrame(frameID.current);
    }
  };
  const scrollIntoView = useCallback(({ alignment = "start" } = {}) => {
    var _a;
    shouldStop.current = false;
    if (frameID.current) {
      cancel();
    }
    const start = (_a = getScrollStart({ parent: scrollableRef.current, axis })) != null ? _a : 0;
    const change = getRelativePosition({
      parent: scrollableRef.current,
      target: targetRef.current,
      axis,
      alignment,
      offset,
      isList
    }) - (scrollableRef.current ? 0 : start);
    function animateScroll() {
      if (startTime.current === 0) {
        startTime.current = performance.now();
      }
      const now = performance.now();
      const elapsed = now - startTime.current;
      const t = reducedMotion || duration === 0 ? 1 : elapsed / duration;
      const distance = start + change * easing(t);
      setScrollParam({
        parent: scrollableRef.current,
        axis,
        distance
      });
      if (!shouldStop.current && t < 1) {
        frameID.current = requestAnimationFrame(animateScroll);
      } else {
        typeof onScrollFinish === "function" && onScrollFinish();
        startTime.current = 0;
        frameID.current = 0;
        cancel();
      }
    }
    animateScroll();
  }, [scrollableRef.current]);
  const handleStop = () => {
    if (cancelable) {
      shouldStop.current = true;
    }
  };
  useWindowEvent("wheel", handleStop, {
    passive: true
  });
  useWindowEvent("touchmove", handleStop, {
    passive: true
  });
  useEffect(() => cancel, []);
  return {
    scrollableRef,
    targetRef,
    scrollIntoView,
    cancel
  };
}

const defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
const browser$1 = typeof window !== "undefined";
function useResizeObserver() {
  const frameID = useRef(0);
  const ref = useRef(null);
  const [rect, setRect] = useState(defaultState);
  const observer = useMemo(() => browser$1 ? new ResizeObserver((entries) => {
    const entry = entries[0];
    if (entry) {
      cancelAnimationFrame(frameID.current);
      frameID.current = requestAnimationFrame(() => {
        if (ref.current) {
          setRect(entry.contentRect);
        }
      });
    }
  }) : null, []);
  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
      if (frameID.current) {
        cancelAnimationFrame(frameID.current);
      }
    };
  }, [ref.current]);
  return [ref, rect];
}
function useElementSize() {
  const [ref, { width, height }] = useResizeObserver();
  return { ref, width, height };
}

function getScrollWidth() {
  if (typeof window === "undefined" || typeof document === "undefined")
    return 0;
  const paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  return paddingRight + scrollbarWidth;
}

const getLockStyles = ({ disableBodyPadding }) => {
  const scrollWidth = disableBodyPadding ? null : getScrollWidth();
  const styles = `body {
        --removed-scroll-width: ${scrollWidth}px;
        touch-action: none;
        overflow: hidden !important;
        position: relative !important;
        ${scrollWidth ? "padding-right: var(--removed-scroll-width) !important;" : ""}
        `;
  return styles;
};

function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}

function insertStyleTag(tag) {
  const head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}

function makeStyleTag() {
  const tag = document.createElement("style");
  tag.type = "text/css";
  tag.setAttribute("mantine-scroll-lock", "");
  return tag;
}

function useScrollLock(lock, options = {
  disableBodyPadding: false
}) {
  const [scrollLocked, setScrollLocked] = useState(lock || false);
  const scrollTop = useRef(0);
  const { disableBodyPadding } = options;
  const stylesheet = useRef(null);
  const lockScroll = () => {
    scrollTop.current = window.scrollY;
    const styles = getLockStyles({ disableBodyPadding });
    const sheet = makeStyleTag();
    injectStyles(sheet, styles);
    insertStyleTag(sheet);
    stylesheet.current = sheet;
  };
  const unlockScroll = () => {
    if (!(stylesheet == null ? void 0 : stylesheet.current))
      return;
    stylesheet.current.parentNode.removeChild(stylesheet.current);
    stylesheet.current = null;
  };
  useEffect(() => {
    if (scrollLocked) {
      lockScroll();
    } else {
      unlockScroll();
    }
    return unlockScroll;
  }, [scrollLocked]);
  useEffect(() => {
    if (lock !== void 0) {
      setScrollLocked(lock);
    }
  }, [lock]);
  useEffect(() => {
    if (lock === void 0 && typeof window !== "undefined") {
      window.document.body.style.overflow === "hidden" && setScrollLocked(true);
    }
  }, [setScrollLocked]);
  return [scrollLocked, setScrollLocked];
}

function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (!(a instanceof Object) || !(b instanceof Object)) {
    return false;
  }
  const keys = Object.keys(a);
  const { length } = keys;
  for (let i = 0; i < length; i += 1) {
    if (!(keys[i] in b)) {
      return false;
    }
  }
  for (let i = 0; i < length; i += 1) {
    if (a[keys[i]] !== b[keys[i]]) {
      return false;
    }
  }
  return length === Object.keys(b).length;
}

function shallowCompare(prevValue, currValue) {
  if (!prevValue || !currValue) {
    return false;
  }
  if (prevValue === currValue) {
    return true;
  }
  if (prevValue.length !== currValue.length) {
    return false;
  }
  for (let i = 0; i < prevValue.length; i += 1) {
    if (!shallowEqual(prevValue[i], currValue[i])) {
      return false;
    }
  }
  return true;
}
function useShallowCompare(dependencies) {
  const ref = useRef([]);
  const updateRef = useRef(0);
  if (!shallowCompare(ref.current, dependencies)) {
    ref.current = dependencies;
    updateRef.current += 1;
  }
  return [updateRef.current];
}
function useShallowEffect(cb, dependencies) {
  useEffect(cb, useShallowCompare(dependencies));
}

function useToggle(initialValue, options) {
  const [state, setState] = useState(initialValue);
  const toggle = (value) => {
    if (typeof value !== "undefined") {
      setState(value);
    } else {
      setState((current) => {
        if (current === options[0]) {
          return options[1];
        }
        return options[0];
      });
    }
  };
  return [state, toggle];
}
function useBooleanToggle(initialValue = false) {
  return useToggle(initialValue, [true, false]);
}

const eventListerOptions = {
  passive: true
};
const browser = typeof window !== "undefined";
function useViewportSize() {
  const [windowSize, setWindowSize] = useState({
    width: browser ? window.innerWidth : 0,
    height: browser ? window.innerHeight : 0
  });
  const setSize = useCallback(() => {
    setWindowSize({
      width: window.innerWidth || 0,
      height: window.innerHeight || 0
    });
  }, []);
  useWindowEvent("resize", setSize, eventListerOptions);
  useWindowEvent("orientationchange", setSize, eventListerOptions);
  return windowSize;
}

function getScrollPosition() {
  return typeof window !== "undefined" ? { x: window.pageXOffset, y: window.pageYOffset } : { x: 0, y: 0 };
}
function scrollTo({ x, y }) {
  if (typeof window !== "undefined") {
    const scrollOptions = { behavior: "smooth" };
    if (typeof x === "number") {
      scrollOptions.left = x;
    }
    if (typeof y === "number") {
      scrollOptions.top = y;
    }
    window.scrollTo(scrollOptions);
  }
}
function useWindowScroll() {
  const [position, setPosition] = useState(getScrollPosition());
  useWindowEvent("scroll", () => setPosition(getScrollPosition()));
  useWindowEvent("resize", () => setPosition(getScrollPosition()));
  return [position, scrollTo];
}

function useIntersection(options) {
  const [entry, setEntry] = useState(null);
  const observer = useRef();
  const ref = useCallback((element) => {
    if (observer.current) {
      observer.current.disconnect();
      observer.current = null;
    }
    if (element === null) {
      setEntry(null);
      return;
    }
    observer.current = new IntersectionObserver(([_entry]) => {
      setEntry(_entry);
    }, options);
    observer.current.observe(element);
  }, [options == null ? void 0 : options.rootMargin, options == null ? void 0 : options.root, options == null ? void 0 : options.threshold]);
  return [ref, entry];
}

function useHash() {
  const [hash, setHashValue] = useState(typeof window !== "undefined" ? window.location.hash : "");
  const setHash = (value) => {
    window.location.hash = value;
    setHashValue(value);
  };
  useWindowEvent("hashchange", () => {
    setHashValue(window.location.hash);
  });
  return [hash, setHash];
}

var __defProp$1G = Object.defineProperty;
var __defProps$J = Object.defineProperties;
var __getOwnPropDescs$J = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1G = Object.getOwnPropertySymbols;
var __hasOwnProp$1G = Object.prototype.hasOwnProperty;
var __propIsEnum$1G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1G = (obj, key, value) => key in obj ? __defProp$1G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1G.call(b, prop))
      __defNormalProp$1G(a, prop, b[prop]);
  if (__getOwnPropSymbols$1G)
    for (var prop of __getOwnPropSymbols$1G(b)) {
      if (__propIsEnum$1G.call(b, prop))
        __defNormalProp$1G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$J = (a, b) => __defProps$J(a, __getOwnPropDescs$J(b));
function parseHotkey(hotkey) {
  const keys = hotkey.toLowerCase().split("+").map((part) => part.trim());
  const modifiers = {
    alt: keys.includes("alt"),
    ctrl: keys.includes("ctrl"),
    meta: keys.includes("meta"),
    mod: keys.includes("mod"),
    shift: keys.includes("shift")
  };
  const reservedKeys = ["alt", "ctrl", "meta", "shift", "mod"];
  const freeKey = keys.find((key) => !reservedKeys.includes(key));
  return __spreadProps$J(__spreadValues$1G({}, modifiers), {
    key: freeKey
  });
}
function isExactHotkey(hotkey, event) {
  const { alt, ctrl, meta, mod, shift, key } = hotkey;
  const { altKey, ctrlKey, metaKey, shiftKey, key: pressedKey } = event;
  if (alt !== altKey) {
    return false;
  }
  if (mod) {
    if (!ctrlKey && !metaKey) {
      return false;
    }
  } else {
    if (ctrl !== ctrlKey) {
      return false;
    }
    if (meta !== metaKey) {
      return false;
    }
  }
  if (shift !== shiftKey) {
    return false;
  }
  if (key && (pressedKey.toLowerCase() === key.toLowerCase() || event.code.replace("Key", "").toLowerCase() === key.toLowerCase())) {
    return true;
  }
  return false;
}
function getHotkeyMatcher(hotkey) {
  return (event) => isExactHotkey(parseHotkey(hotkey), event);
}
function getHotkeyHandler(hotkeys) {
  return (event) => {
    hotkeys.forEach(([hotkey, handler]) => {
      if (getHotkeyMatcher(hotkey)(event.nativeEvent)) {
        event.preventDefault();
        handler(event);
      }
    });
  };
}

function shouldFireEvent(event) {
  if (event.target instanceof HTMLElement) {
    return !["INPUT", "TEXTAREA", "SELECT"].includes(event.target.tagName);
  }
  return true;
}
function useHotkeys(hotkeys) {
  useEffect(() => {
    const keydownListener = (event) => {
      hotkeys.forEach(([hotkey, handler]) => {
        if (getHotkeyMatcher(hotkey)(event) && shouldFireEvent(event)) {
          event.preventDefault();
          handler(event);
        }
      });
    };
    document.documentElement.addEventListener("keydown", keydownListener);
    return () => document.documentElement.removeEventListener("keydown", keydownListener);
  }, [hotkeys]);
}

function getFullscreenElement() {
  const _document = window.document;
  const fullscreenElement = _document.fullscreenElement || _document.webkitFullscreenElement || _document.mozFullScreenElement || _document.msFullscreenElement;
  return fullscreenElement;
}
async function exitFullscreen() {
  const _document = window.document;
  if (typeof _document.exitFullscreen === "function")
    return _document.exitFullscreen();
  if (typeof _document.msExitFullscreen === "function")
    return _document.msExitFullscreen();
  if (typeof _document.webkitExitFullscreen === "function")
    return _document.webkitExitFullscreen();
  if (typeof _document.mozCancelFullScreen === "function")
    return _document.mozCancelFullScreen();
  return null;
}
async function enterFullScreen(element) {
  var _a, _b, _c, _d;
  const _element = element;
  return ((_a = _element.requestFullscreen) == null ? void 0 : _a.call(_element)) || ((_b = _element.msRequestFullscreen) == null ? void 0 : _b.call(_element)) || ((_c = _element.webkitRequestFullscreen) == null ? void 0 : _c.call(_element)) || ((_d = _element.mozRequestFullscreen) == null ? void 0 : _d.call(_element));
}
const prefixes = ["", "webkit", "moz", "ms"];
function addEvents(element, {
  onFullScreen,
  onError
}) {
  prefixes.forEach((prefix) => {
    element.addEventListener(`${prefix}fullscreenchange`, onFullScreen);
    element.addEventListener(`${prefix}fullscreenerror`, onError);
  });
  return () => {
    prefixes.forEach((prefix) => {
      element.removeEventListener(`${prefix}fullscreenchange`, onFullScreen);
      element.removeEventListener(`${prefix}fullscreenerror`, onError);
    });
  };
}
function useFullscreen() {
  const [fullscreen, setFullscreen] = useState(false);
  const _ref = useRef();
  const handleFullscreenChange = useCallback((event) => {
    setFullscreen(event.target === getFullscreenElement());
  }, [setFullscreen]);
  const handleFullscreenError = useCallback((event) => {
    setFullscreen(false);
    console.error(`[@mantine/hooks] use-fullscreen: Error attempting full-screen mode method: ${event} (${event.target})`);
  }, [setFullscreen]);
  const toggle = useCallback(async () => {
    if (!getFullscreenElement()) {
      await enterFullScreen(_ref.current);
    } else {
      await exitFullscreen();
    }
  }, []);
  const ref = useCallback((element) => {
    if (element === null) {
      _ref.current = window.document.documentElement;
    } else {
      _ref.current = element;
    }
  }, []);
  useEffect(() => {
    if (!_ref.current && window.document) {
      _ref.current = window.document.documentElement;
      return addEvents(_ref.current, {
        onFullScreen: handleFullscreenChange,
        onError: handleFullscreenError
      });
    }
    if (_ref.current) {
      return addEvents(_ref.current, {
        onFullScreen: handleFullscreenChange,
        onError: handleFullscreenError
      });
    }
    return void 0;
  }, []);
  return { ref, toggle, fullscreen };
}

function useLogger(componentName, props) {
  useEffect(() => {
    console.log(`${componentName} mounted`, ...props);
    return () => console.log(`${componentName} unmounted`);
  }, []);
  useDidUpdate(() => {
    console.log(`${componentName} updated`, ...props);
  }, props);
  return null;
}

function useHover() {
  const [hovered, setHovered] = useState(false);
  const ref = useRef(null);
  const onMouseEnter = useCallback(() => setHovered(true), []);
  const onMouseLeave = useCallback(() => setHovered(false), []);
  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener("mouseenter", onMouseEnter);
      ref.current.addEventListener("mouseleave", onMouseLeave);
      return () => {
        var _a, _b;
        (_a = ref.current) == null ? void 0 : _a.removeEventListener("mouseenter", onMouseEnter);
        (_b = ref.current) == null ? void 0 : _b.removeEventListener("mouseleave", onMouseLeave);
      };
    }
    return void 0;
  }, []);
  return { ref, hovered };
}

function useUuid(staticId) {
  const [uuid, setUuid] = useState("");
  useIsomorphicEffect(() => {
    setUuid(randomId());
  }, []);
  return staticId || uuid;
}

function useValidatedState(initialValue, validation) {
  const [value, setValue] = useState(initialValue);
  const [lastValidValue, setLastValidValue] = useState(validation(initialValue) ? initialValue : void 0);
  const [valid, setValid] = useState(validation(initialValue));
  const onChange = (val) => {
    if (validation(val)) {
      setLastValidValue(val);
      setValid(true);
    } else {
      setValid(false);
    }
    setValue(val);
  };
  return [{ value, lastValidValue, valid }, onChange];
}

function getOS() {
  const { userAgent } = window.navigator;
  const macosPlatforms = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
  const windowsPlatforms = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
  const iosPlatforms = /(iPhone)|(iPad)|(iPod)/i;
  if (macosPlatforms.test(userAgent)) {
    return "macos";
  }
  if (iosPlatforms.test(userAgent)) {
    return "ios";
  }
  if (windowsPlatforms.test(userAgent)) {
    return "windows";
  }
  if (/Android/i.test(userAgent)) {
    return "android";
  }
  if (/Linux/i.test(userAgent)) {
    return "linux";
  }
  return "undetermined";
}
function useOs() {
  if (typeof window !== "undefined") {
    return getOS();
  }
  return "undetermined";
}

var __defProp$1F = Object.defineProperty;
var __getOwnPropSymbols$1F = Object.getOwnPropertySymbols;
var __hasOwnProp$1F = Object.prototype.hasOwnProperty;
var __propIsEnum$1F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1F = (obj, key, value) => key in obj ? __defProp$1F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1F.call(b, prop))
      __defNormalProp$1F(a, prop, b[prop]);
  if (__getOwnPropSymbols$1F)
    for (var prop of __getOwnPropSymbols$1F(b)) {
      if (__propIsEnum$1F.call(b, prop))
        __defNormalProp$1F(a, prop, b[prop]);
    }
  return a;
};
function useSetState(initialState) {
  const [state, _setState] = useState(initialState);
  const setState = (statePartial) => _setState((current) => __spreadValues$1F(__spreadValues$1F({}, current), typeof statePartial === "function" ? statePartial(current) : statePartial));
  return [state, setState];
}

function useEventListener(type, listener, options) {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener(type, listener, options);
      return () => {
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.removeEventListener(type, listener, options);
      };
    }
    return void 0;
  }, [listener, options]);
  return ref;
}

function useDisclosure(initialState, callbacks) {
  const [opened, setOpened] = useState(initialState);
  const open = () => {
    var _a;
    if (!opened) {
      setOpened(true);
      (_a = callbacks == null ? void 0 : callbacks.onOpen) == null ? void 0 : _a.call(callbacks);
    }
  };
  const close = () => {
    var _a;
    if (opened) {
      setOpened(false);
      (_a = callbacks == null ? void 0 : callbacks.onClose) == null ? void 0 : _a.call(callbacks);
    }
  };
  const toggle = () => {
    opened ? close() : open();
  };
  return [opened, { open, close, toggle }];
}

function containsRelatedTarget(event) {
  if (event.currentTarget instanceof HTMLElement && event.relatedTarget instanceof HTMLElement) {
    return event.currentTarget.contains(event.relatedTarget);
  }
  return false;
}
function useFocusWithin({
  onBlur,
  onFocus
} = {}) {
  const ref = useRef();
  const [focused, _setFocused] = useState(false);
  const focusedRef = useRef(false);
  const setFocused = (value) => {
    _setFocused(value);
    focusedRef.current = value;
  };
  const handleFocusIn = (event) => {
    if (!focusedRef.current) {
      setFocused(true);
      onFocus == null ? void 0 : onFocus(event);
    }
  };
  const handleFocusOut = (event) => {
    if (focusedRef.current && !containsRelatedTarget(event)) {
      setFocused(false);
      onBlur == null ? void 0 : onBlur(event);
    }
  };
  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener("focusin", handleFocusIn);
      ref.current.addEventListener("focusout", handleFocusOut);
      return () => {
        var _a, _b;
        (_a = ref.current) == null ? void 0 : _a.removeEventListener("focusin", handleFocusIn);
        (_b = ref.current) == null ? void 0 : _b.removeEventListener("focusout", handleFocusOut);
      };
    }
    return void 0;
  }, []);
  return { ref, focused };
}

var __defProp$1E = Object.defineProperty;
var __getOwnPropSymbols$1E = Object.getOwnPropertySymbols;
var __hasOwnProp$1E = Object.prototype.hasOwnProperty;
var __propIsEnum$1E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1E = (obj, key, value) => key in obj ? __defProp$1E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1E.call(b, prop))
      __defNormalProp$1E(a, prop, b[prop]);
  if (__getOwnPropSymbols$1E)
    for (var prop of __getOwnPropSymbols$1E(b)) {
      if (__propIsEnum$1E.call(b, prop))
        __defNormalProp$1E(a, prop, b[prop]);
    }
  return a;
};
const defaultValue = {
  downlink: 10,
  effectiveType: "4g",
  saveData: false,
  rtt: 50
};
function getConnection() {
  if (typeof navigator === "undefined") {
    return defaultValue;
  }
  const _navigator = navigator;
  const connection = _navigator.connection || _navigator.mozConnection || _navigator.webkitConnection;
  if (!connection) {
    return defaultValue;
  }
  return {
    downlink: connection == null ? void 0 : connection.downlink,
    effectiveType: connection == null ? void 0 : connection.effectiveType,
    saveData: connection == null ? void 0 : connection.saveData,
    rtt: connection == null ? void 0 : connection.rtt
  };
}
function useNetwork() {
  const [status, setStatus] = useState(__spreadValues$1E({ online: true }, getConnection()));
  const handleConnectionChange = useCallback(() => setStatus((current) => __spreadValues$1E(__spreadValues$1E({}, current), getConnection())), []);
  useWindowEvent("online", () => setStatus(__spreadValues$1E({ online: true }, getConnection())));
  useWindowEvent("offline", () => setStatus(__spreadValues$1E({ online: false }, getConnection())));
  useEffect(() => {
    if (navigator.connection) {
      navigator.connection.addEventListener("change", handleConnectionChange);
      return () => navigator.connection.removeEventListener("change", handleConnectionChange);
    }
    return void 0;
  }, []);
  return status;
}

function upperFirst(value) {
  return typeof value !== "string" ? "" : value.charAt(0).toUpperCase() + value.slice(1);
}

const SYSTEM_PROPS = {
  mt: "marginTop",
  mb: "marginBottom",
  ml: "marginLeft",
  mr: "marginRight",
  pt: "paddingTop",
  pb: "paddingBottom",
  pl: "paddingLeft",
  pr: "paddingRight"
};
const NEGATIVE_VALUES = ["-xs", "-sm", "-md", "-lg", "-xl"];
function isValidSizeValue(margin) {
  return typeof margin === "string" || typeof margin === "number";
}
function getSizeValue(margin, theme) {
  if (NEGATIVE_VALUES.includes(margin)) {
    return theme.fn.size({ size: margin.replace("-", ""), sizes: theme.spacing }) * -1;
  }
  return theme.fn.size({ size: margin, sizes: theme.spacing });
}
function getSystemStyles(systemStyles, theme) {
  const styles = {};
  if (isValidSizeValue(systemStyles.p)) {
    const value = getSizeValue(systemStyles.p, theme);
    styles.padding = value;
  }
  if (isValidSizeValue(systemStyles.m)) {
    const value = getSizeValue(systemStyles.m, theme);
    styles.margin = value;
  }
  if (isValidSizeValue(systemStyles.py)) {
    const value = getSizeValue(systemStyles.py, theme);
    styles.paddingTop = value;
    styles.paddingBottom = value;
  }
  if (isValidSizeValue(systemStyles.px)) {
    const value = getSizeValue(systemStyles.px, theme);
    styles.paddingLeft = value;
    styles.paddingRight = value;
  }
  if (isValidSizeValue(systemStyles.my)) {
    const value = getSizeValue(systemStyles.my, theme);
    styles.marginTop = value;
    styles.marginBottom = value;
  }
  if (isValidSizeValue(systemStyles.mx)) {
    const value = getSizeValue(systemStyles.mx, theme);
    styles.marginLeft = value;
    styles.marginRight = value;
  }
  Object.keys(SYSTEM_PROPS).forEach((property) => {
    if (isValidSizeValue(systemStyles[property])) {
      styles[SYSTEM_PROPS[property]] = theme.fn.size({
        size: getSizeValue(systemStyles[property], theme),
        sizes: theme.spacing
      });
    }
  });
  return styles;
}

function extractSx(sx, theme) {
  return typeof sx === "function" ? sx(theme) : sx;
}
function useSx(sx, systemProps, className) {
  const theme = useMantineTheme();
  const { css, cx } = useCss();
  if (Array.isArray(sx)) {
    return cx(className, css(getSystemStyles(systemProps, theme)), sx.map((partial) => css(extractSx(partial, theme))));
  }
  return cx(className, css(extractSx(sx, theme)), css(getSystemStyles(systemProps, theme)));
}

var __defProp$1D = Object.defineProperty;
var __getOwnPropSymbols$1D = Object.getOwnPropertySymbols;
var __hasOwnProp$1D = Object.prototype.hasOwnProperty;
var __propIsEnum$1D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1D = (obj, key, value) => key in obj ? __defProp$1D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1D.call(b, prop))
      __defNormalProp$1D(a, prop, b[prop]);
  if (__getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(b)) {
      if (__propIsEnum$1D.call(b, prop))
        __defNormalProp$1D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$13 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Box = forwardRef((_a, ref) => {
  var _b = _a, { className, component, style, sx } = _b, others = __objRest$13(_b, ["className", "component", "style", "sx"]);
  const { systemStyles, rest } = extractSystemStyles(others);
  const Element = component || "div";
  return /* @__PURE__ */ React__default.createElement(Element, __spreadValues$1D({
    ref,
    className: useSx(sx, systemStyles, className),
    style
  }, rest));
});
Box.displayName = "@mantine/core/Box";

var __defProp$1C = Object.defineProperty;
var __defProps$I = Object.defineProperties;
var __getOwnPropDescs$I = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1C = Object.getOwnPropertySymbols;
var __hasOwnProp$1C = Object.prototype.hasOwnProperty;
var __propIsEnum$1C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1C = (obj, key, value) => key in obj ? __defProp$1C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1C.call(b, prop))
      __defNormalProp$1C(a, prop, b[prop]);
  if (__getOwnPropSymbols$1C)
    for (var prop of __getOwnPropSymbols$1C(b)) {
      if (__propIsEnum$1C.call(b, prop))
        __defNormalProp$1C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$I = (a, b) => __defProps$I(a, __getOwnPropDescs$I(b));
var useStyles$1U = createStyles((theme) => ({
  root: __spreadProps$I(__spreadValues$1C(__spreadValues$1C({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
    cursor: "pointer",
    border: 0,
    padding: 0,
    appearance: "none",
    fontSize: theme.fontSizes.md,
    backgroundColor: "transparent",
    textAlign: "left",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    textDecoration: "none"
  })
}));

var useStyles$1V = useStyles$1U;

var __defProp$1B = Object.defineProperty;
var __getOwnPropSymbols$1B = Object.getOwnPropertySymbols;
var __hasOwnProp$1B = Object.prototype.hasOwnProperty;
var __propIsEnum$1B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1B = (obj, key, value) => key in obj ? __defProp$1B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1B.call(b, prop))
      __defNormalProp$1B(a, prop, b[prop]);
  if (__getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(b)) {
      if (__propIsEnum$1B.call(b, prop))
        __defNormalProp$1B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$12 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const UnstyledButton = forwardRef((_a, ref) => {
  var _b = _a, { className, component = "button" } = _b, others = __objRest$12(_b, ["className", "component"]);
  const { classes, cx } = useStyles$1V(null, { name: "UnstyledButton" });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1B({
    component,
    ref,
    className: cx(classes.root, className),
    type: component === "button" ? "button" : void 0
  }, others));
});
UnstyledButton.displayName = "@mantine/core/UnstyledButton";

var __defProp$1A = Object.defineProperty;
var __getOwnPropSymbols$1A = Object.getOwnPropertySymbols;
var __hasOwnProp$1A = Object.prototype.hasOwnProperty;
var __propIsEnum$1A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1A = (obj, key, value) => key in obj ? __defProp$1A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1A.call(b, prop))
      __defNormalProp$1A(a, prop, b[prop]);
  if (__getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(b)) {
      if (__propIsEnum$1A.call(b, prop))
        __defNormalProp$1A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$11 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Center = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Center", {}, props), { inline, sx } = _a, others = __objRest$11(_a, ["inline", "sx"]);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1A({
    ref,
    sx: [
      {
        display: inline ? "inline-flex" : "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      ...Array.isArray(sx) ? sx : [sx]
    ]
  }, others));
});
Center.displayName = "@mantine/core/Center";

var __defProp$1z = Object.defineProperty;
var __defProps$H = Object.defineProperties;
var __getOwnPropDescs$H = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1z = Object.getOwnPropertySymbols;
var __hasOwnProp$1z = Object.prototype.hasOwnProperty;
var __propIsEnum$1z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1z = (obj, key, value) => key in obj ? __defProp$1z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1z.call(b, prop))
      __defNormalProp$1z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(b)) {
      if (__propIsEnum$1z.call(b, prop))
        __defNormalProp$1z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$H = (a, b) => __defProps$H(a, __getOwnPropDescs$H(b));
const sizes$d = {
  xs: 18,
  sm: 22,
  md: 28,
  lg: 34,
  xl: 44
};
function getVariantStyles$1({ variant, theme, color }) {
  if (variant === "hover" || variant === "transparent") {
    return __spreadValues$1z({
      border: "1px solid transparent",
      color: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : 7),
      backgroundColor: "transparent"
    }, theme.fn.hover(variant === "transparent" ? {} : {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.fn.themeColor(color, 0)
    }));
  }
  const colors = theme.fn.variant({ color, variant });
  return __spreadValues$1z({
    backgroundColor: colors.background,
    color: colors.color,
    border: `1px solid ${colors.border}`
  }, theme.fn.hover({ backgroundColor: colors.hover }));
}
var useStyles$1S = createStyles((theme, { color, size, radius }) => ({
  root: __spreadProps$H(__spreadValues$1z(__spreadValues$1z({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
    position: "relative",
    appearance: "none",
    WebkitAppearance: "none",
    WebkitTapHighlightColor: "transparent",
    boxSizing: "border-box",
    height: theme.fn.size({ size, sizes: sizes$d }),
    minHeight: theme.fn.size({ size, sizes: sizes$d }),
    width: theme.fn.size({ size, sizes: sizes$d }),
    minWidth: theme.fn.size({ size, sizes: sizes$d }),
    borderRadius: theme.fn.radius(radius),
    padding: 0,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:disabled": {
      color: theme.colors.gray[theme.colorScheme === "dark" ? 6 : 4],
      cursor: "not-allowed",
      backgroundColor: theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
      borderColor: theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1)
    },
    "&:not(:disabled):active": {
      transform: "translateY(1px)"
    }
  }),
  outline: getVariantStyles$1({ theme, color, variant: "outline" }),
  filled: getVariantStyles$1({ theme, color, variant: "filled" }),
  default: getVariantStyles$1({ theme, color, variant: "default" }),
  light: getVariantStyles$1({ theme, color, variant: "light" }),
  hover: getVariantStyles$1({ theme, color, variant: "hover" }),
  transparent: getVariantStyles$1({ theme, color, variant: "transparent" }),
  loading: {
    "&::before": {
      content: '""',
      position: "absolute",
      top: -1,
      left: -1,
      right: -1,
      bottom: -1,
      backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
      borderRadius: theme.fn.radius(radius),
      cursor: "not-allowed"
    }
  }
}));

var useStyles$1T = useStyles$1S;

var __defProp$1y = Object.defineProperty;
var __getOwnPropSymbols$1y = Object.getOwnPropertySymbols;
var __hasOwnProp$1y = Object.prototype.hasOwnProperty;
var __propIsEnum$1y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1y = (obj, key, value) => key in obj ? __defProp$1y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1y.call(b, prop))
      __defNormalProp$1y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(b)) {
      if (__propIsEnum$1y.call(b, prop))
        __defNormalProp$1y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$10 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Bars(_a) {
  var _b = _a, { size, color } = _b, others = __objRest$10(_b, ["size", "color"]);
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$1y({
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    width: `${size}px`
  }, others), /* @__PURE__ */ React__default.createElement("rect", {
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ React__default.createElement("rect", {
    x: "30",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ React__default.createElement("rect", {
    x: "60",
    width: "15",
    height: "140",
    rx: "6"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ React__default.createElement("rect", {
    x: "90",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ React__default.createElement("rect", {
    x: "120",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}

var __defProp$1x = Object.defineProperty;
var __getOwnPropSymbols$1x = Object.getOwnPropertySymbols;
var __hasOwnProp$1x = Object.prototype.hasOwnProperty;
var __propIsEnum$1x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1x = (obj, key, value) => key in obj ? __defProp$1x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1x.call(b, prop))
      __defNormalProp$1x(a, prop, b[prop]);
  if (__getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(b)) {
      if (__propIsEnum$1x.call(b, prop))
        __defNormalProp$1x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Oval(_a) {
  var _b = _a, { size, color } = _b, others = __objRest$$(_b, ["size", "color"]);
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$1x({
    width: `${size}px`,
    height: `${size}px`,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: color
  }, others), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React__default.createElement("g", {
    transform: "translate(2.5 2.5)",
    strokeWidth: "5"
  }, /* @__PURE__ */ React__default.createElement("circle", {
    strokeOpacity: ".5",
    cx: "16",
    cy: "16",
    r: "16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M32 16c0-9.94-8.06-16-16-16"
  }, /* @__PURE__ */ React__default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}

var __defProp$1w = Object.defineProperty;
var __getOwnPropSymbols$1w = Object.getOwnPropertySymbols;
var __hasOwnProp$1w = Object.prototype.hasOwnProperty;
var __propIsEnum$1w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1w = (obj, key, value) => key in obj ? __defProp$1w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1w.call(b, prop))
      __defNormalProp$1w(a, prop, b[prop]);
  if (__getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(b)) {
      if (__propIsEnum$1w.call(b, prop))
        __defNormalProp$1w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Dots(_a) {
  var _b = _a, { size, color } = _b, others = __objRest$_(_b, ["size", "color"]);
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$1w({
    width: `${size}px`,
    height: `${size / 4}px`,
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color
  }, others), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "60",
    cy: "15",
    r: "9",
    fillOpacity: "0.3"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "fill-opacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ React__default.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}

var __defProp$1v = Object.defineProperty;
var __getOwnPropSymbols$1v = Object.getOwnPropertySymbols;
var __hasOwnProp$1v = Object.prototype.hasOwnProperty;
var __propIsEnum$1v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1v = (obj, key, value) => key in obj ? __defProp$1v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1v.call(b, prop))
      __defNormalProp$1v(a, prop, b[prop]);
  if (__getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(b)) {
      if (__propIsEnum$1v.call(b, prop))
        __defNormalProp$1v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LOADERS = {
  bars: Bars,
  oval: Oval,
  dots: Dots
};
const LOADER_SIZES$1 = {
  xs: 18,
  sm: 22,
  md: 36,
  lg: 44,
  xl: 58
};
const defaultProps$G = {
  size: "md"
};
function Loader$1(props) {
  const _a = useMantineDefaultProps("Loader", defaultProps$G, props), {
    size = "md",
    color,
    variant
  } = _a, others = __objRest$Z(_a, [
    "size",
    "color",
    "variant"
  ]);
  const theme = useMantineTheme();
  const defaultLoader = variant in LOADERS ? variant : theme.loader;
  const _color = color || theme.primaryColor;
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1v({
    role: "presentation",
    component: LOADERS[defaultLoader] || LOADERS.bars,
    size: theme.fn.size({ size, sizes: LOADER_SIZES$1 }),
    color: _color in theme.colors ? theme.fn.themeColor(_color, theme.colorScheme === "dark" ? 4 : theme.fn.primaryShade("light")) : color
  }, others));
}
Loader$1.displayName = "@mantine/core/Loader";

var __defProp$1u = Object.defineProperty;
var __getOwnPropSymbols$1u = Object.getOwnPropertySymbols;
var __hasOwnProp$1u = Object.prototype.hasOwnProperty;
var __propIsEnum$1u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1u = (obj, key, value) => key in obj ? __defProp$1u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1u.call(b, prop))
      __defNormalProp$1u(a, prop, b[prop]);
  if (__getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(b)) {
      if (__propIsEnum$1u.call(b, prop))
        __defNormalProp$1u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$F = {
  color: "gray",
  size: "md",
  variant: "hover",
  disabled: false,
  loading: false
};
const ActionIcon = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("ActionIcon", defaultProps$F, props), {
    className,
    color,
    children,
    radius,
    size,
    variant,
    disabled,
    loaderProps,
    loading,
    component,
    styles,
    classNames
  } = _a, others = __objRest$Y(_a, [
    "className",
    "color",
    "children",
    "radius",
    "size",
    "variant",
    "disabled",
    "loaderProps",
    "loading",
    "component",
    "styles",
    "classNames"
  ]);
  const { classes, cx, theme } = useStyles$1T({ size, radius, color }, { name: "ActionIcon", classNames, styles });
  const colors = theme.fn.variant({ color, variant: "light" });
  const loader = /* @__PURE__ */ React__default.createElement(Loader$1, __spreadValues$1u({
    color: colors.color,
    size: theme.fn.size({ size, sizes: sizes$d }) - 12
  }, loaderProps));
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1u({
    component: component || "button",
    className: cx(classes[variant], classes.root, { [classes.loading]: loading }, className),
    type: "button",
    ref,
    disabled: disabled || loading
  }, others), loading ? loader : children);
});
ActionIcon.displayName = "@mantine/core/ActionIcon";

var __defProp$1t = Object.defineProperty;
var __getOwnPropSymbols$1t = Object.getOwnPropertySymbols;
var __hasOwnProp$1t = Object.prototype.hasOwnProperty;
var __propIsEnum$1t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1t = (obj, key, value) => key in obj ? __defProp$1t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1t.call(b, prop))
      __defNormalProp$1t(a, prop, b[prop]);
  if (__getOwnPropSymbols$1t)
    for (var prop of __getOwnPropSymbols$1t(b)) {
      if (__propIsEnum$1t.call(b, prop))
        __defNormalProp$1t(a, prop, b[prop]);
    }
  return a;
};
function CloseIcon(props) {
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$1t({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React__default.createElement("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
CloseIcon.displayName = "@mantine/core/CloseIcon";

var __defProp$1s = Object.defineProperty;
var __getOwnPropSymbols$1s = Object.getOwnPropertySymbols;
var __hasOwnProp$1s = Object.prototype.hasOwnProperty;
var __propIsEnum$1s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1s = (obj, key, value) => key in obj ? __defProp$1s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1s.call(b, prop))
      __defNormalProp$1s(a, prop, b[prop]);
  if (__getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(b)) {
      if (__propIsEnum$1s.call(b, prop))
        __defNormalProp$1s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const iconSizes$4 = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24
};
const CloseButton = forwardRef((_a, ref) => {
  var _b = _a, { iconSize, size = "md" } = _b, others = __objRest$X(_b, ["iconSize", "size"]);
  const theme = useMantineTheme();
  const _iconSize = iconSize || theme.fn.size({ size, sizes: iconSizes$4 });
  return /* @__PURE__ */ React__default.createElement(ActionIcon, __spreadValues$1s({
    size,
    ref
  }, others), /* @__PURE__ */ React__default.createElement(CloseIcon, {
    width: _iconSize,
    height: _iconSize
  }));
});
CloseButton.displayName = "@mantine/core/CloseButton";

const defaultProps$E = {
  zIndex: 1,
  position: "relative"
};
function Portal(props) {
  const { children, zIndex, target, className, position } = useMantineDefaultProps("Portal", defaultProps$E, props);
  const theme = useMantineTheme();
  const [mounted, setMounted] = useState(false);
  const ref = useRef();
  useIsomorphicEffect(() => {
    setMounted(true);
    ref.current = !target ? document.createElement("div") : typeof target === "string" ? document.querySelector(target) : target;
    if (!target) {
      document.body.appendChild(ref.current);
    }
    return () => {
      !target && document.body.removeChild(ref.current);
    };
  }, [target]);
  if (!mounted) {
    return null;
  }
  return createPortal(/* @__PURE__ */ React__default.createElement("div", {
    className,
    dir: theme.dir,
    style: { position, zIndex }
  }, children), ref.current);
}
Portal.displayName = "@mantine/core/Portal";

var __defProp$1r = Object.defineProperty;
var __defProps$G = Object.defineProperties;
var __getOwnPropDescs$G = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1r = Object.getOwnPropertySymbols;
var __hasOwnProp$1r = Object.prototype.hasOwnProperty;
var __propIsEnum$1r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1r = (obj, key, value) => key in obj ? __defProp$1r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1r.call(b, prop))
      __defNormalProp$1r(a, prop, b[prop]);
  if (__getOwnPropSymbols$1r)
    for (var prop of __getOwnPropSymbols$1r(b)) {
      if (__propIsEnum$1r.call(b, prop))
        __defNormalProp$1r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$G = (a, b) => __defProps$G(a, __getOwnPropDescs$G(b));
function getTextColor({ theme, color, variant }) {
  if (color === "dimmed") {
    return theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6];
  }
  return color in theme.colors ? theme.colors[color][theme.colorScheme === "dark" ? 5 : 7] : variant === "link" ? theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 7] : color || "inherit";
}
function getLineClamp(lineClamp) {
  if (typeof lineClamp === "number") {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: lineClamp,
      WebkitBoxOrient: "vertical"
    };
  }
  return null;
}
var useStyles$1Q = createStyles((theme, {
  color,
  variant,
  size,
  lineClamp,
  inline,
  inherit,
  underline,
  gradientDeg,
  gradientTo,
  gradientFrom,
  weight,
  transform,
  align
}) => {
  const colors = theme.fn.variant({
    variant: "gradient",
    gradient: { from: gradientFrom, to: gradientTo, deg: gradientDeg }
  });
  return {
    root: __spreadValues$1r(__spreadProps$G(__spreadValues$1r(__spreadValues$1r(__spreadValues$1r({}, theme.fn.fontStyles()), theme.fn.focusStyles()), getLineClamp(lineClamp)), {
      color: getTextColor({ color, theme, variant }),
      fontFamily: inherit ? "inherit" : theme.fontFamily,
      fontSize: inherit ? "inherit" : theme.fontSizes[size],
      lineHeight: inherit ? "inherit" : inline ? 1 : theme.lineHeight,
      textDecoration: underline ? "underline" : "none",
      WebkitTapHighlightColor: "transparent",
      fontWeight: inherit ? "inherit" : weight,
      textTransform: transform,
      textAlign: align
    }), theme.fn.hover(variant === "link" && underline === void 0 ? {
      textDecoration: "underline"
    } : void 0)),
    gradient: {
      backgroundImage: colors.background,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    }
  };
});

var useStyles$1R = useStyles$1Q;

var __defProp$1q = Object.defineProperty;
var __getOwnPropSymbols$1q = Object.getOwnPropertySymbols;
var __hasOwnProp$1q = Object.prototype.hasOwnProperty;
var __propIsEnum$1q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1q = (obj, key, value) => key in obj ? __defProp$1q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1q.call(b, prop))
      __defNormalProp$1q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(b)) {
      if (__propIsEnum$1q.call(b, prop))
        __defNormalProp$1q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$D = {
  size: "md",
  variant: "text",
  gradient: { from: "blue", to: "cyan", deg: 45 },
  inline: false,
  inherit: false
};
const Text$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Text", defaultProps$D, props), {
    className,
    component,
    size = "md",
    weight,
    transform,
    color,
    align,
    variant = "text",
    lineClamp,
    gradient = { from: "blue", to: "cyan", deg: 45 },
    inline = false,
    inherit = false,
    underline,
    classNames,
    styles
  } = _a, others = __objRest$W(_a, [
    "className",
    "component",
    "size",
    "weight",
    "transform",
    "color",
    "align",
    "variant",
    "lineClamp",
    "gradient",
    "inline",
    "inherit",
    "underline",
    "classNames",
    "styles"
  ]);
  const { classes, cx } = useStyles$1R({
    variant,
    color,
    size,
    lineClamp,
    inline,
    inherit,
    underline,
    weight,
    transform,
    align,
    gradientFrom: gradient.from,
    gradientTo: gradient.to,
    gradientDeg: gradient.deg
  }, { classNames, styles, name: "Text" });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1q({
    ref,
    component: component || "div",
    className: cx(classes.root, { [classes.gradient]: variant === "gradient" }, className)
  }, others));
});
Text$1.displayName = "@mantine/core/Text";

var useStyles$1O = createStyles(() => ({
  root: {
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: 0,
    border: 0
  }
}));

var useStyles$1P = useStyles$1O;

var __defProp$1p = Object.defineProperty;
var __getOwnPropSymbols$1p = Object.getOwnPropertySymbols;
var __hasOwnProp$1p = Object.prototype.hasOwnProperty;
var __propIsEnum$1p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1p = (obj, key, value) => key in obj ? __defProp$1p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1p.call(b, prop))
      __defNormalProp$1p(a, prop, b[prop]);
  if (__getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(b)) {
      if (__propIsEnum$1p.call(b, prop))
        __defNormalProp$1p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$C = {};
const Anchor = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Anchor", defaultProps$C, props), { component, className, classNames, styles } = _a, others = __objRest$V(_a, ["component", "className", "classNames", "styles"]);
  const { classes, cx } = useStyles$1P(null, { name: "Anchor", classNames, styles });
  const buttonProps = component === "button" ? { type: "button" } : null;
  return /* @__PURE__ */ React__default.createElement(Text$1, __spreadValues$1p(__spreadValues$1p({
    component: component || "a",
    variant: "link",
    ref,
    className: cx(classes.root, className)
  }, buttonProps), others));
});
Anchor.displayName = "@mantine/core/Anchor";

const AppShellContext = createContext({});
const AppShellProvider = AppShellContext.Provider;
function useAppShellContext() {
  return useContext(AppShellContext);
}

var __defProp$1o = Object.defineProperty;
var __defProps$F = Object.defineProperties;
var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1o = Object.getOwnPropertySymbols;
var __hasOwnProp$1o = Object.prototype.hasOwnProperty;
var __propIsEnum$1o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1o = (obj, key, value) => key in obj ? __defProp$1o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1o.call(b, prop))
      __defNormalProp$1o(a, prop, b[prop]);
  if (__getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(b)) {
      if (__propIsEnum$1o.call(b, prop))
        __defNormalProp$1o(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$F = (a, b) => __defProps$F(a, __getOwnPropDescs$F(b));
var useStyles$1M = createStyles((theme, { height, fixed, position, zIndex, borderPosition }) => ({
  root: __spreadProps$F(__spreadValues$1o(__spreadValues$1o({}, theme.fn.fontStyles()), position), {
    zIndex,
    height,
    maxHeight: height,
    position: fixed ? "fixed" : "static",
    boxSizing: "border-box",
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    borderBottom: borderPosition === "bottom" ? `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}` : void 0,
    borderTop: borderPosition === "top" ? `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}` : void 0
  })
}));

var useStyles$1N = useStyles$1M;

var __defProp$1n = Object.defineProperty;
var __getOwnPropSymbols$1n = Object.getOwnPropertySymbols;
var __hasOwnProp$1n = Object.prototype.hasOwnProperty;
var __propIsEnum$1n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1n = (obj, key, value) => key in obj ? __defProp$1n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1n.call(b, prop))
      __defNormalProp$1n(a, prop, b[prop]);
  if (__getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(b)) {
      if (__propIsEnum$1n.call(b, prop))
        __defNormalProp$1n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VerticalSection = forwardRef((_a, ref) => {
  var _b = _a, {
    children,
    className,
    classNames,
    styles,
    height,
    fixed = false,
    position,
    zIndex = getDefaultZIndex("app"),
    section,
    __staticSelector
  } = _b, others = __objRest$U(_b, [
    "children",
    "className",
    "classNames",
    "styles",
    "height",
    "fixed",
    "position",
    "zIndex",
    "section",
    "__staticSelector"
  ]);
  const ctx = useAppShellContext();
  const { classes, cx } = useStyles$1N({
    height,
    fixed: ctx.fixed || fixed,
    position,
    zIndex: ctx.zIndex || zIndex,
    borderPosition: section === "header" ? "bottom" : "top"
  }, { name: __staticSelector, classNames, styles });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1n({
    component: section === "header" ? "nav" : "footer",
    className: cx(classes.root, className),
    ref
  }, others), children, /* @__PURE__ */ React__default.createElement(Global, {
    styles: () => ({
      ":root": {
        [`--mantine-${section}-height`]: `${height}px`
      }
    })
  }));
});
VerticalSection.displayName = "@mantine/core/VerticalSection";

var __defProp$1m = Object.defineProperty;
var __defProps$E = Object.defineProperties;
var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1m = Object.getOwnPropertySymbols;
var __hasOwnProp$1m = Object.prototype.hasOwnProperty;
var __propIsEnum$1m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1m = (obj, key, value) => key in obj ? __defProp$1m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1m.call(b, prop))
      __defNormalProp$1m(a, prop, b[prop]);
  if (__getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(b)) {
      if (__propIsEnum$1m.call(b, prop))
        __defNormalProp$1m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$E = (a, b) => __defProps$E(a, __getOwnPropDescs$E(b));
const defaultProps$B = {
  fixed: false,
  position: { top: 0, left: 0, right: 0 },
  zIndex: getDefaultZIndex("app")
};
const Header = forwardRef((props, ref) => {
  const _props = useMantineDefaultProps("Header", defaultProps$B, props);
  return /* @__PURE__ */ React__default.createElement(VerticalSection, __spreadProps$E(__spreadValues$1m({
    section: "header",
    __staticSelector: "Header"
  }, _props), {
    ref
  }));
});
Header.displayName = "@mantine/core/Header";

var __defProp$1l = Object.defineProperty;
var __getOwnPropSymbols$1l = Object.getOwnPropertySymbols;
var __hasOwnProp$1l = Object.prototype.hasOwnProperty;
var __propIsEnum$1l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1l = (obj, key, value) => key in obj ? __defProp$1l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1l.call(b, prop))
      __defNormalProp$1l(a, prop, b[prop]);
  if (__getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(b)) {
      if (__propIsEnum$1l.call(b, prop))
        __defNormalProp$1l(a, prop, b[prop]);
    }
  return a;
};
function getPositionStyles$1(props, theme) {
  const padding = theme.fn.size({ size: props.padding, sizes: theme.spacing });
  const navbarOffset = props.navbarOffsetBreakpoint ? theme.fn.size({ size: props.navbarOffsetBreakpoint, sizes: theme.breakpoints }) : null;
  const asideOffset = props.asideOffsetBreakpoint ? theme.fn.size({ size: props.asideOffsetBreakpoint, sizes: theme.breakpoints }) : null;
  if (!props.fixed) {
    return { padding };
  }
  return {
    minHeight: "100vh",
    paddingTop: `calc(var(--mantine-header-height, 0px) + ${padding}px)`,
    paddingBottom: `calc(var(--mantine-footer-height, 0px) + ${padding}px)`,
    paddingLeft: `calc(var(--mantine-navbar-width, 0px) + ${padding}px)`,
    paddingRight: `calc(var(--mantine-aside-width, 0px) + ${padding}px)`,
    [`@media (max-width: ${navbarOffset}px)`]: {
      paddingLeft: padding
    },
    [`@media (max-width: ${asideOffset}px)`]: {
      paddingRight: padding
    }
  };
}
var useStyles$1K = createStyles((theme, props) => ({
  root: {
    boxSizing: "border-box"
  },
  body: {
    display: "flex",
    boxSizing: "border-box"
  },
  main: __spreadValues$1l({
    flex: 1,
    width: "100vw",
    boxSizing: "border-box"
  }, getPositionStyles$1(props, theme))
}));

var useStyles$1L = useStyles$1K;

var __defProp$1k = Object.defineProperty;
var __getOwnPropSymbols$1k = Object.getOwnPropertySymbols;
var __hasOwnProp$1k = Object.prototype.hasOwnProperty;
var __propIsEnum$1k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1k = (obj, key, value) => key in obj ? __defProp$1k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1k.call(b, prop))
      __defNormalProp$1k(a, prop, b[prop]);
  if (__getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(b)) {
      if (__propIsEnum$1k.call(b, prop))
        __defNormalProp$1k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$A = {
  fixed: false,
  zIndex: getDefaultZIndex("app"),
  padding: "md"
};
const AppShell = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("AppShell", defaultProps$A, props), {
    children,
    navbar,
    header,
    footer,
    aside,
    fixed,
    zIndex,
    padding,
    navbarOffsetBreakpoint,
    asideOffsetBreakpoint,
    className,
    styles,
    classNames
  } = _a, others = __objRest$T(_a, [
    "children",
    "navbar",
    "header",
    "footer",
    "aside",
    "fixed",
    "zIndex",
    "padding",
    "navbarOffsetBreakpoint",
    "asideOffsetBreakpoint",
    "className",
    "styles",
    "classNames"
  ]);
  const { classes, cx } = useStyles$1L({ padding, fixed, navbarOffsetBreakpoint, asideOffsetBreakpoint }, { styles, classNames, name: "AppShell" });
  return /* @__PURE__ */ React__default.createElement(AppShellProvider, {
    value: { fixed, zIndex }
  }, /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1k({
    className: cx(classes.root, className),
    ref
  }, others), header, /* @__PURE__ */ React__default.createElement("div", {
    className: classes.body
  }, navbar, /* @__PURE__ */ React__default.createElement("main", {
    className: classes.main
  }, children), aside), footer));
});
AppShell.displayName = "@mantine/core/AppShell";

var useStyles$1I = createStyles((theme, { ratio }) => ({
  root: {
    position: "relative",
    maxWidth: "100%",
    "&::before": {
      content: '""',
      height: 0,
      display: "block",
      paddingBottom: `${1 / ratio * 100}%`
    },
    "&::after": {
      content: '""',
      display: "table",
      clear: "both"
    },
    "& > *:not(style)": {
      overflow: "hidden",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%"
    },
    "& > img, & > video": {
      objectFit: "cover"
    }
  }
}));

var useStyles$1J = useStyles$1I;

var __defProp$1j = Object.defineProperty;
var __getOwnPropSymbols$1j = Object.getOwnPropertySymbols;
var __hasOwnProp$1j = Object.prototype.hasOwnProperty;
var __propIsEnum$1j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1j = (obj, key, value) => key in obj ? __defProp$1j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1j.call(b, prop))
      __defNormalProp$1j(a, prop, b[prop]);
  if (__getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(b)) {
      if (__propIsEnum$1j.call(b, prop))
        __defNormalProp$1j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AspectRatio = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("AspectRatio", {}, props), { className, ratio, children, classNames, styles } = _a, others = __objRest$S(_a, ["className", "ratio", "children", "classNames", "styles"]);
  const { classes, cx } = useStyles$1J({ ratio }, { name: "AspectRatio", classNames, styles });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1j({
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
AspectRatio.displayName = "@mantine/core/AspectRatio";

function composeEventHandlers(e,n,{checkForDefaultPrevented:t=!0}={}){return function(r){if(null==e||e(r),!1===t||!r.defaultPrevented)return null==n?void 0:n(r)}}

function clamp(t,[a,n]){return Math.min(n,Math.max(a,t))}

const useLayoutEffect=Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)?React.useLayoutEffect:()=>{};

function useDirection(t,n){const[r,o]=React.useState("ltr"),[i,u]=React.useState(),c=React.useRef(0);return React.useEffect((()=>{if(void 0===n&&null!=t&&t.parentElement){const e=getComputedStyle(t.parentElement);u(e);}}),[t,n]),React.useEffect((()=>(void 0===n&&function e(){c.current=requestAnimationFrame((()=>{const t=null==i?void 0:i.direction;t&&o(t),e();}));}(),()=>cancelAnimationFrame(c.current))),[i,n,o]),n||r}

function useCallbackRef(r){const t=React.useRef(r);return React.useEffect((()=>{t.current=r;})),React.useMemo((()=>(...e)=>{var r;return null===(r=t.current)||void 0===r?void 0:r.call(t,...e)}),[])}

function composeRefs(...o){return e=>o.forEach((o=>function(o,e){"function"==typeof o?o(e):null!=o&&(o.current=e);}(o,e)))}function useComposedRefs(...e){return React.useCallback(composeRefs(...e),e)}

function createContextScope(n,o=[]){let r=[];const c=()=>{const t=r.map((t=>/*#__PURE__*/React.createContext(t)));return function(o){const r=(null==o?void 0:o[n])||t;return React.useMemo((()=>({[`__scope${n}`]:{...o,[n]:r}})),[o,r])}};return c.scopeName=n,[function(t,o){const c=/*#__PURE__*/React.createContext(o),u=r.length;function s(t){const{scope:o,children:r,...s}=t,i=(null==o?void 0:o[n][u])||c,a=React.useMemo((()=>s),Object.values(s));return React.createElement(i.Provider,{value:a},r)}return r=[...r,o],s.displayName=t+"Provider",[s,function(r,s){const i=(null==s?void 0:s[n][u])||c,a=React.useContext(i);if(a)return a;if(void 0!==o)return o;throw new Error(`\`${r}\` must be used within \`${t}\``)}]},t(c,...o)]}function t(...t){const n=t[0];if(1===t.length)return n;const o=()=>{const o=t.map((e=>({useScope:e(),scopeName:e.scopeName})));return function(t){const r=o.reduce(((e,{useScope:n,scopeName:o})=>({...e,...n(t)[`__scope${o}`]})),{});return React.useMemo((()=>({[`__scope${n.scopeName}`]:r})),[r])}};return o.scopeName=n.scopeName,o}

const Presence=u=>{const{present:o,children:i}=u,s=function(n){const[u,o]=React.useState(),i=React.useRef({}),s=React.useRef(n),c=React.useRef("none"),a=n?"mounted":"unmounted",[d,m]=function(e,n){return React.useReducer(((e,t)=>{const r=n[e][t];return null!=r?r:e}),e)}(a,{mounted:{UNMOUNT:"unmounted",ANIMATION_OUT:"unmountSuspended"},unmountSuspended:{MOUNT:"mounted",ANIMATION_END:"unmounted"},unmounted:{MOUNT:"mounted"}});return React.useEffect((()=>{const e=r$1(i.current);c.current="mounted"===d?e:"none";}),[d]),useLayoutEffect((()=>{const e=i.current,t=s.current;if(t!==n){const u=c.current,o=r$1(e);if(n)m("MOUNT");else if("none"===o||"none"===(null==e?void 0:e.display))m("UNMOUNT");else {const e=u!==o;m(t&&e?"ANIMATION_OUT":"UNMOUNT");}s.current=n;}}),[n,m]),useLayoutEffect((()=>{if(u){const e=e=>{const n=r$1(i.current).includes(e.animationName);e.target===u&&n&&m("ANIMATION_END");},n=e=>{e.target===u&&(c.current=r$1(i.current));};return u.addEventListener("animationstart",n),u.addEventListener("animationcancel",e),u.addEventListener("animationend",e),()=>{u.removeEventListener("animationstart",n),u.removeEventListener("animationcancel",e),u.removeEventListener("animationend",e);}}m("ANIMATION_END");}),[u,m]),{isPresent:["mounted","unmountSuspended"].includes(d),ref:React.useCallback((e=>{e&&(i.current=getComputedStyle(e)),o(e);}),[])}}(o),c="function"==typeof i?i({present:s.isPresent}):React.Children.only(i),a=useComposedRefs(s.ref,c.ref);return "function"==typeof i||s.isPresent?/*#__PURE__*/React.cloneElement(c,{ref:a}):null};function r$1(e){return (null==e?void 0:e.animationName)||"none"}Presence.displayName="Presence";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const Slot=/*#__PURE__*/React.forwardRef(((e,o)=>{const{children:a,...s}=e;return React.Children.toArray(a).some(l)?/*#__PURE__*/React.createElement(React.Fragment,null,React.Children.map(a,(e=>l(e)?/*#__PURE__*/React.createElement(n,_extends({},s,{ref:o}),e.props.children):e))):/*#__PURE__*/React.createElement(n,_extends({},s,{ref:o}),a)}));Slot.displayName="Slot";const n=/*#__PURE__*/React.forwardRef(((r,n)=>{const{children:l,...a}=r;return React.isValidElement(l)?/*#__PURE__*/React.cloneElement(l,{...o(a,l.props),ref:composeRefs(n,l.ref)}):React.Children.count(l)>1?React.Children.only(null):null}));n.displayName="SlotClone";const Slottable=({children:e})=>/*#__PURE__*/React.createElement(React.Fragment,null,e);function l(e){return React.isValidElement(e)&&e.type===Slottable}function o(e,t){const r={...t};for(const n in t){const l=e[n],o=t[n];/^on[A-Z]/.test(n)?r[n]=(...e)=>{null==o||o(...e),null==l||l(...e);}:"style"===n?r[n]={...l,...o}:"className"===n&&(r[n]=[l,o].filter(Boolean).join(" "));}return {...e,...r}}

const Primitive=["a","button","div","h2","h3","img","li","nav","ol","p","span","svg","ul"].reduce(((o,i)=>({...o,[i]:/*#__PURE__*/React.forwardRef(((o,m)=>{const{asChild:a,...s}=o,n=a?Slot:i;return React.useEffect((()=>{window[Symbol.for("radix-ui")]=!0;}),[]),/*#__PURE__*/React.createElement(n,_extends({},s,{ref:m}))}))})),{});

const[d,p]=createContextScope("ScrollArea");const[f,h]=d("ScrollArea");const ScrollArea$1=/*#__PURE__*/React.forwardRef(((e,r)=>{const{__scopeScrollArea:t,type:n="hover",scrollHideDelay:i=600,...a}=e,[d,p]=React.useState(null),[h,m]=React.useState(null),[w,b]=React.useState(null),[v,S]=React.useState(null),[g,E]=React.useState(null),[C,T]=React.useState(0),[y,A]=React.useState(0),[x,R]=React.useState(!1),[P,L]=React.useState(!1),_=useComposedRefs(r,(e=>p(e))),D=useDirection(d,a.dir);return React.createElement(f,{scope:t,type:n,dir:D,scrollHideDelay:i,scrollArea:d,viewport:h,onViewportChange:m,content:w,onContentChange:b,scrollbarX:v,onScrollbarXChange:S,scrollbarXEnabled:x,onScrollbarXEnabledChange:R,scrollbarY:g,onScrollbarYChange:E,scrollbarYEnabled:P,onScrollbarYEnabledChange:L,onCornerWidthChange:T,onCornerHeightChange:A},/*#__PURE__*/React.createElement(Primitive.div,_extends({},a,{ref:_,style:{position:"relative","--radix-scroll-area-corner-width":C+"px","--radix-scroll-area-corner-height":y+"px",...e.style}})))}));const ScrollAreaViewport=/*#__PURE__*/React.forwardRef(((e,r)=>{const{__scopeScrollArea:t,children:o,...n}=e,i=h("ScrollAreaViewport",t),a=React.useRef(null),d=useComposedRefs(r,a,i.onViewportChange);return React.createElement(React.Fragment,null,/*#__PURE__*/React.createElement("style",{dangerouslySetInnerHTML:{__html:"[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"}}),/*#__PURE__*/React.createElement(Primitive.div,_extends({"data-radix-scroll-area-viewport":""},n,{ref:d,style:{overflowX:i.scrollbarXEnabled?"scroll":"hidden",overflowY:i.scrollbarYEnabled?"scroll":"hidden",...e.style}}),/*#__PURE__*/React.createElement("div",{ref:i.onContentChange,style:{minWidth:"100%",display:"table"}},o)))}));const ScrollAreaScrollbar=/*#__PURE__*/React.forwardRef(((e,r)=>{const{forceMount:t,...o}=e,n=h("ScrollAreaScrollbar",e.__scopeScrollArea),{onScrollbarXEnabledChange:l,onScrollbarYEnabledChange:i}=n,a="horizontal"===e.orientation;return React.useEffect((()=>(a?l(!0):i(!0),()=>{a?l(!1):i(!1);})),[a,l,i]),"hover"===n.type?/*#__PURE__*/React.createElement(m,_extends({},o,{ref:r,forceMount:t})):"scroll"===n.type?/*#__PURE__*/React.createElement(w,_extends({},o,{ref:r,forceMount:t})):"auto"===n.type?/*#__PURE__*/React.createElement(b,_extends({},o,{ref:r,forceMount:t})):"always"===n.type?/*#__PURE__*/React.createElement(v,_extends({},o,{ref:r})):null}));const m=/*#__PURE__*/React.forwardRef(((e,r)=>{const{forceMount:t,...o}=e,n=h("ScrollAreaScrollbar",e.__scopeScrollArea),[l,i]=React.useState(!1);return React.useEffect((()=>{const e=n.scrollArea;let r=0;if(e){const t=()=>{window.clearTimeout(r),i(!0);},o=()=>{r=window.setTimeout((()=>i(!1)),n.scrollHideDelay);};return e.addEventListener("pointerenter",t),e.addEventListener("pointerleave",o),()=>{e.removeEventListener("pointerenter",t),e.removeEventListener("pointerleave",o);}}}),[n.scrollArea,n.scrollHideDelay]),/*#__PURE__*/React.createElement(Presence,{present:t||l},/*#__PURE__*/React.createElement(b,_extends({"data-state":l?"visible":"hidden"},o,{ref:r})))})),w=/*#__PURE__*/React.forwardRef(((r,t)=>{const{forceMount:o,...n}=r,l=h("ScrollAreaScrollbar",r.__scopeScrollArea),i="horizontal"===r.orientation,c=z((()=>p("SCROLL_END")),100),[d,p]=(f="hidden",m={hidden:{SCROLL:"scrolling"},scrolling:{SCROLL_END:"idle",POINTER_ENTER:"interacting"},interacting:{SCROLL:"interacting",POINTER_LEAVE:"idle"},idle:{HIDE:"hidden",SCROLL:"scrolling",POINTER_ENTER:"interacting"}},React.useReducer(((e,r)=>{const t=m[e][r];return null!=t?t:e}),f));var f,m;return React.useEffect((()=>{if("idle"===d){const e=window.setTimeout((()=>p("HIDE")),l.scrollHideDelay);return ()=>window.clearTimeout(e)}}),[d,l.scrollHideDelay,p]),React.useEffect((()=>{const e=l.viewport,r=i?"scrollLeft":"scrollTop";if(e){let t=e[r];const o=()=>{const o=e[r];t!==o&&(p("SCROLL"),c()),t=o;};return e.addEventListener("scroll",o),()=>e.removeEventListener("scroll",o)}}),[l.viewport,i,p,c]),/*#__PURE__*/React.createElement(Presence,{present:o||"hidden"!==d},/*#__PURE__*/React.createElement(v,_extends({"data-state":"hidden"===d?"hidden":"visible"},n,{ref:t,onPointerEnter:composeEventHandlers(r.onPointerEnter,(()=>p("POINTER_ENTER"))),onPointerLeave:composeEventHandlers(r.onPointerLeave,(()=>p("POINTER_LEAVE")))})))})),b=/*#__PURE__*/React.forwardRef(((e,r)=>{const t=h("ScrollAreaScrollbar",e.__scopeScrollArea),{forceMount:o,...n}=e,[l,i]=React.useState(!1),c="horizontal"===e.orientation,d=z((()=>{if(t.viewport){const e=t.viewport.offsetWidth<t.viewport.scrollWidth,r=t.viewport.offsetHeight<t.viewport.scrollHeight;i(c?e:r);}}),10);return H(t.viewport,d),H(t.content,d),/*#__PURE__*/React.createElement(Presence,{present:o||l},/*#__PURE__*/React.createElement(v,_extends({"data-state":l?"visible":"hidden"},n,{ref:r})))})),v=/*#__PURE__*/React.forwardRef(((e,r)=>{const{orientation:t="vertical",...o}=e,n=h("ScrollAreaScrollbar",e.__scopeScrollArea),l=React.useRef(null),i=React.useRef(0),[a,c]=React.useState({content:0,viewport:0,scrollbar:{size:0,paddingStart:0,paddingEnd:0}}),d=x(a.viewport,a.content),p={...o,sizes:a,onSizesChange:c,hasThumb:Boolean(d>0&&d<1),onThumbChange:e=>l.current=e,onThumbPointerUp:()=>i.current=0,onThumbPointerDown:e=>i.current=e};function f(e,r){return function(e,r,t,o="ltr"){const n=R(t),l=n/2,i=r||l,a=n-i,c=t.scrollbar.paddingStart+i,s=t.scrollbar.size-t.scrollbar.paddingEnd-a,u=t.content-t.viewport;return L([c,s],"ltr"===o?[0,u]:[-1*u,0])(e)}(e,i.current,a,r)}return "horizontal"===t?/*#__PURE__*/React.createElement(S,_extends({},p,{ref:r,onThumbPositionChange:()=>{if(n.viewport&&l.current){const e=P(n.viewport.scrollLeft,a,n.dir);l.current.style.transform=`translate3d(${e}px, 0, 0)`;}},onWheelScroll:e=>{n.viewport&&(n.viewport.scrollLeft=e);},onDragScroll:e=>{n.viewport&&(n.viewport.scrollLeft=f(e,n.dir));}})):"vertical"===t?/*#__PURE__*/React.createElement(g,_extends({},p,{ref:r,onThumbPositionChange:()=>{if(n.viewport&&l.current){const e=P(n.viewport.scrollTop,a);l.current.style.transform=`translate3d(0, ${e}px, 0)`;}},onWheelScroll:e=>{n.viewport&&(n.viewport.scrollTop=e);},onDragScroll:e=>{n.viewport&&(n.viewport.scrollTop=f(e));}})):null})),S=/*#__PURE__*/React.forwardRef(((e,r)=>{const{sizes:t,onSizesChange:o,...n}=e,i=h("ScrollAreaScrollbar",e.__scopeScrollArea),[a,c]=React.useState(),d=React.useRef(null),p=useComposedRefs(r,d,i.onScrollbarXChange);return React.useEffect((()=>{d.current&&c(getComputedStyle(d.current));}),[d]),/*#__PURE__*/React.createElement(T,_extends({"data-orientation":"horizontal"},n,{ref:p,sizes:t,style:{bottom:0,left:"rtl"===i.dir?"var(--radix-scroll-area-corner-width)":0,right:"ltr"===i.dir?"var(--radix-scroll-area-corner-width)":0,"--radix-scroll-area-thumb-width":R(t)+"px",...e.style},onThumbPointerDown:r=>e.onThumbPointerDown(r.x),onDragScroll:r=>e.onDragScroll(r.x),onWheelScroll:(r,t)=>{if(i.viewport){const o=i.viewport.scrollLeft+r.deltaX;e.onWheelScroll(o),_(o,t)&&r.preventDefault();}},onResize:()=>{d.current&&i.viewport&&a&&o({content:i.viewport.scrollWidth,viewport:i.viewport.offsetWidth,scrollbar:{size:d.current.clientWidth,paddingStart:A(a.paddingLeft),paddingEnd:A(a.paddingRight)}});}}))})),g=/*#__PURE__*/React.forwardRef(((e,r)=>{const{sizes:t,onSizesChange:o,...n}=e,i=h("ScrollAreaScrollbar",e.__scopeScrollArea),[a,c]=React.useState(),d=React.useRef(null),p=useComposedRefs(r,d,i.onScrollbarYChange);return React.useEffect((()=>{d.current&&c(getComputedStyle(d.current));}),[d]),/*#__PURE__*/React.createElement(T,_extends({"data-orientation":"vertical"},n,{ref:p,sizes:t,style:{top:0,right:"ltr"===i.dir?0:void 0,left:"rtl"===i.dir?0:void 0,bottom:"var(--radix-scroll-area-corner-height)","--radix-scroll-area-thumb-height":R(t)+"px",...e.style},onThumbPointerDown:r=>e.onThumbPointerDown(r.y),onDragScroll:r=>e.onDragScroll(r.y),onWheelScroll:(r,t)=>{if(i.viewport){const o=i.viewport.scrollTop+r.deltaY;e.onWheelScroll(o),_(o,t)&&r.preventDefault();}},onResize:()=>{d.current&&i.viewport&&a&&o({content:i.viewport.scrollHeight,viewport:i.viewport.offsetHeight,scrollbar:{size:d.current.clientHeight,paddingStart:A(a.paddingTop),paddingEnd:A(a.paddingBottom)}});}}))})),[E,C]=d("ScrollAreaScrollbar"),T=/*#__PURE__*/React.forwardRef(((r,t)=>{const{__scopeScrollArea:o,sizes:i,hasThumb:a,onThumbChange:d,onThumbPointerUp:p,onThumbPointerDown:f,onThumbPositionChange:m,onDragScroll:w,onWheelScroll:b,onResize:v,...S}=r,g=h("ScrollAreaScrollbar",o),[C,T]=React.useState(null),y=useComposedRefs(t,(e=>T(e))),A=React.useRef(null),x=React.useRef(""),R=g.viewport,P=i.content-i.viewport,L=useCallbackRef(b),_=useCallbackRef(m),D=z(v,10);function W(e){if(A.current){const r=e.clientX-A.current.left,t=e.clientY-A.current.top;w({x:r,y:t});}}return React.useEffect((()=>{const e=e=>{const r=e.target;(null==C?void 0:C.contains(r))&&L(e,P);};return document.addEventListener("wheel",e,{passive:!1}),()=>document.removeEventListener("wheel",e,{passive:!1})}),[R,C,P,L]),React.useEffect(_,[i,_]),H(C,D),H(g.content,D),/*#__PURE__*/React.createElement(E,{scope:o,scrollbar:C,hasThumb:a,onThumbChange:useCallbackRef(d),onThumbPointerUp:useCallbackRef(p),onThumbPositionChange:_,onThumbPointerDown:useCallbackRef(f)},/*#__PURE__*/React.createElement(Primitive.div,_extends({},S,{ref:y,style:{position:"absolute",...S.style},onPointerDown:composeEventHandlers(r.onPointerDown,(e=>{if(0===e.button){e.target.setPointerCapture(e.pointerId),A.current=C.getBoundingClientRect(),x.current=document.body.style.webkitUserSelect,document.body.style.webkitUserSelect="none",W(e);}})),onPointerMove:composeEventHandlers(r.onPointerMove,W),onPointerUp:composeEventHandlers(r.onPointerUp,(e=>{e.target.releasePointerCapture(e.pointerId),document.body.style.webkitUserSelect=x.current,A.current=null;}))})))}));const ScrollAreaThumb=/*#__PURE__*/React.forwardRef(((r,t)=>{const{__scopeScrollArea:o,style:n,...i}=r,a=h("ScrollbarThumb",o),d=C("ScrollbarThumb",o),{onThumbPositionChange:p}=d,f=useComposedRefs(t,(e=>d.onThumbChange(e))),m=React.useRef(),w=z((()=>{m.current&&(m.current(),m.current=void 0);}),100);return React.useEffect((()=>{const e=a.viewport;if(e){const r=()=>{if(w(),!m.current){const r=D(e,p);m.current=r,p();}};return p(),e.addEventListener("scroll",r),()=>e.removeEventListener("scroll",r)}}),[a.viewport,w,p]),d.hasThumb?/*#__PURE__*/React.createElement(Primitive.div,_extends({},i,{ref:f,style:{width:"var(--radix-scroll-area-thumb-width)",height:"var(--radix-scroll-area-thumb-height)",...n},onPointerDownCapture:composeEventHandlers(r.onPointerDownCapture,(e=>{const r=e.target.getBoundingClientRect(),t=e.clientX-r.left,o=e.clientY-r.top;d.onThumbPointerDown({x:t,y:o});})),onPointerUp:composeEventHandlers(r.onPointerUp,d.onThumbPointerUp)})):null}));const ScrollAreaCorner=/*#__PURE__*/React.forwardRef(((e,r)=>{const t=h("ScrollAreaCorner",e.__scopeScrollArea),o=Boolean(t.scrollbarX&&t.scrollbarY);return "scroll"!==t.type&&o?/*#__PURE__*/React.createElement(y,_extends({},e,{ref:r})):null}));const y=/*#__PURE__*/React.forwardRef(((e,r)=>{const{__scopeScrollArea:t,...o}=e,n=h("ScrollAreaCorner",t),[l,i]=React.useState(0),[a,d]=React.useState(0),p=Boolean(l&&a);return H(n.scrollbarX,(()=>{var e;const r=(null===(e=n.scrollbarX)||void 0===e?void 0:e.offsetHeight)||0;n.onCornerHeightChange(r),d(r);})),H(n.scrollbarY,(()=>{var e;const r=(null===(e=n.scrollbarY)||void 0===e?void 0:e.offsetWidth)||0;n.onCornerWidthChange(r),i(r);})),p?/*#__PURE__*/React.createElement(Primitive.div,_extends({},o,{ref:r,style:{width:l,height:a,position:"absolute",right:"ltr"===n.dir?0:void 0,left:"rtl"===n.dir?0:void 0,bottom:0,...e.style}})):null}));function A(e){return e?parseInt(e,10):0}function x(e,r){const t=e/r;return isNaN(t)?0:t}function R(e){const r=x(e.viewport,e.content),t=e.scrollbar.paddingStart+e.scrollbar.paddingEnd,o=(e.scrollbar.size-t)*r;return Math.max(o,18)}function P(e,t,o="ltr"){const n=R(t),l=t.scrollbar.paddingStart+t.scrollbar.paddingEnd,i=t.scrollbar.size-l,a=t.content-t.viewport,c=i-n,s=clamp(e,"ltr"===o?[0,a]:[-1*a,0]);return L([0,a],[0,c])(s)}function L(e,r){return t=>{if(e[0]===e[1]||r[0]===r[1])return r[0];const o=(r[1]-r[0])/(e[1]-e[0]);return r[0]+o*(t-e[0])}}function _(e,r){return e>0&&e<r}const D=(e,r=(()=>{}))=>{let t={left:e.scrollLeft,top:e.scrollTop},o=0;return function n(){const l={left:e.scrollLeft,top:e.scrollTop},i=t.left!==l.left,a=t.top!==l.top;(i||a)&&r(),t=l,o=window.requestAnimationFrame(n);}(),()=>window.cancelAnimationFrame(o)};function z(e,r){const t=useCallbackRef(e),o=React.useRef(0);return React.useEffect((()=>()=>window.clearTimeout(o.current)),[]),React.useCallback((()=>{window.clearTimeout(o.current),o.current=window.setTimeout(t,r);}),[t,r])}function H(e,r){const o=useCallbackRef(r);useLayoutEffect((()=>{let r=0;if(e){const t=new ResizeObserver((()=>{cancelAnimationFrame(r),r=window.requestAnimationFrame(o);}));return t.observe(e),()=>{window.cancelAnimationFrame(r),t.unobserve(e);}}}),[e,o]);}const Root=ScrollArea$1;const Viewport=ScrollAreaViewport;const Scrollbar=ScrollAreaScrollbar;const Thumb=ScrollAreaThumb;const Corner=ScrollAreaCorner;

var useStyles$1G = createStyles((theme, { scrollbarSize, offsetScrollbars, scrollbarHovered }, getRef) => ({
  root: {
    overflow: "hidden"
  },
  viewport: {
    width: "100%",
    height: "100%",
    paddingRight: offsetScrollbars ? scrollbarSize : void 0
  },
  scrollbar: {
    display: "flex",
    userSelect: "none",
    touchAction: "none",
    boxSizing: "border-box",
    padding: scrollbarSize / 5,
    transition: "background-color 150ms ease, opacity 150ms ease",
    "&:hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
      [`& .${getRef("thumb")}`]: {
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba("#ffffff", 0.5) : theme.fn.rgba(theme.black, 0.5)
      }
    },
    '&[data-orientation="vertical"]': {
      width: scrollbarSize
    },
    '&[data-orientation="horizontal"]': {
      flexDirection: "column",
      height: scrollbarSize
    },
    '&[data-state="hidden"]': {
      opacity: 0
    }
  },
  thumb: {
    ref: getRef("thumb"),
    flex: 1,
    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba("#ffffff", 0.4) : theme.fn.rgba(theme.black, 0.4),
    borderRadius: scrollbarSize,
    position: "relative",
    transition: "background-color 150ms ease",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      minWidth: 44,
      minHeight: 44
    }
  },
  corner: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
    transition: "opacity 150ms ease",
    opacity: scrollbarHovered ? 1 : 0
  }
}));

var useStyles$1H = useStyles$1G;

var __defProp$1i = Object.defineProperty;
var __getOwnPropSymbols$1i = Object.getOwnPropertySymbols;
var __hasOwnProp$1i = Object.prototype.hasOwnProperty;
var __propIsEnum$1i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1i = (obj, key, value) => key in obj ? __defProp$1i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1i.call(b, prop))
      __defNormalProp$1i(a, prop, b[prop]);
  if (__getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(b)) {
      if (__propIsEnum$1i.call(b, prop))
        __defNormalProp$1i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$z = {
  scrollbarSize: 12,
  scrollHideDelay: 1e3,
  type: "hover",
  offsetScrollbars: false
};
const ScrollArea = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("ScrollArea", defaultProps$z, props), {
    children,
    className,
    classNames,
    styles,
    scrollbarSize,
    scrollHideDelay,
    type,
    dir,
    offsetScrollbars,
    viewportRef,
    onScrollPositionChange
  } = _a, others = __objRest$R(_a, [
    "children",
    "className",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange"
  ]);
  const [scrollbarHovered, setScrollbarHovered] = useState(false);
  const theme = useMantineTheme();
  const { classes, cx } = useStyles$1H({ scrollbarSize, offsetScrollbars, scrollbarHovered }, { name: "ScrollArea", classNames, styles });
  return /* @__PURE__ */ React__default.createElement(Root, {
    type,
    scrollHideDelay,
    dir: dir || theme.dir,
    ref,
    asChild: true
  }, /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1i({
    className: cx(classes.root, className)
  }, others), /* @__PURE__ */ React__default.createElement(Viewport, {
    className: classes.viewport,
    ref: viewportRef,
    onScroll: typeof onScrollPositionChange === "function" ? ({ currentTarget }) => onScrollPositionChange({
      x: currentTarget.scrollLeft,
      y: currentTarget.scrollTop
    }) : void 0
  }, children), /* @__PURE__ */ React__default.createElement(Scrollbar, {
    orientation: "horizontal",
    className: classes.scrollbar,
    forceMount: true,
    onMouseEnter: () => setScrollbarHovered(true),
    onMouseLeave: () => setScrollbarHovered(false)
  }, /* @__PURE__ */ React__default.createElement(Thumb, {
    className: classes.thumb
  })), /* @__PURE__ */ React__default.createElement(Scrollbar, {
    orientation: "vertical",
    className: classes.scrollbar,
    forceMount: true,
    onMouseEnter: () => setScrollbarHovered(true),
    onMouseLeave: () => setScrollbarHovered(false)
  }, /* @__PURE__ */ React__default.createElement(Thumb, {
    className: classes.thumb
  })), /* @__PURE__ */ React__default.createElement(Corner, {
    className: classes.corner
  })));
});
ScrollArea.displayName = "@mantine/core/ScrollArea";

var __defProp$1h = Object.defineProperty;
var __defProps$D = Object.defineProperties;
var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1h = (obj, key, value) => key in obj ? __defProp$1h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1h.call(b, prop))
      __defNormalProp$1h(a, prop, b[prop]);
  if (__getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(b)) {
      if (__propIsEnum$1h.call(b, prop))
        __defNormalProp$1h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$D = (a, b) => __defProps$D(a, __getOwnPropDescs$D(b));
var __objRest$Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SelectScrollArea = forwardRef((_a, ref) => {
  var _b = _a, { style } = _b, others = __objRest$Q(_b, ["style"]);
  return /* @__PURE__ */ React__default.createElement(ScrollArea, __spreadProps$D(__spreadValues$1h({}, others), {
    style: __spreadValues$1h({ width: "100%" }, style),
    viewportRef: ref
  }), others.children);
});
SelectScrollArea.displayName = "@mantine/core/SelectScrollArea";

var __defProp$1g = Object.defineProperty;
var __defProps$C = Object.defineProperties;
var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1g = (obj, key, value) => key in obj ? __defProp$1g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1g.call(b, prop))
      __defNormalProp$1g(a, prop, b[prop]);
  if (__getOwnPropSymbols$1g)
    for (var prop of __getOwnPropSymbols$1g(b)) {
      if (__propIsEnum$1g.call(b, prop))
        __defNormalProp$1g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$C = (a, b) => __defProps$C(a, __getOwnPropDescs$C(b));
var useStyles$1E = createStyles((theme, { native }) => ({
  dropdown: __spreadProps$C(__spreadValues$1g({}, theme.fn.fontStyles()), {
    boxSizing: "border-box",
    pointerEvents: "auto",
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]}`,
    padding: 4,
    overflowY: native ? "auto" : "hidden",
    overscrollBehaviorY: "contain",
    width: "100%"
  })
}));

var useStyles$1F = useStyles$1E;

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function parsePopperPosition(position) {
  if (typeof position !== "string") {
    return { position: "top", placement: "center" };
  }
  const splitted = position.split("-");
  if (splitted.length === 1) {
    return { position, placement: "center" };
  }
  return { position: splitted[0], placement: splitted[1] };
}

function PopperContainer({
  children,
  zIndex = getDefaultZIndex("popover"),
  className,
  withinPortal = true
}) {
  if (withinPortal) {
    return /* @__PURE__ */ React__default.createElement(Portal, {
      className,
      zIndex
    }, children);
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className,
    style: { position: "relative", zIndex }
  }, children);
}
PopperContainer.displayName = "@mantine/core/PopperContainer";

var __defProp$1f = Object.defineProperty;
var __defProps$B = Object.defineProperties;
var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1f = (obj, key, value) => key in obj ? __defProp$1f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1f.call(b, prop))
      __defNormalProp$1f(a, prop, b[prop]);
  if (__getOwnPropSymbols$1f)
    for (var prop of __getOwnPropSymbols$1f(b)) {
      if (__propIsEnum$1f.call(b, prop))
        __defNormalProp$1f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$B = (a, b) => __defProps$B(a, __getOwnPropDescs$B(b));
const horizontalPlacement = (arrowSize, distance, classes) => ({
  [`&.${classes.center}`]: {
    top: `calc(50% - ${arrowSize}px)`
  },
  [`&.${classes.end}`]: {
    bottom: arrowSize * distance
  },
  [`&.${classes.start}`]: {
    top: arrowSize * distance
  }
});
const verticalPlacement = (arrowSize, distance, classes, theme) => ({
  [`&.${classes.center}`]: {
    left: `calc(50% - ${arrowSize}px)`
  },
  [`&.${classes.end}`]: {
    right: theme.dir === "ltr" ? arrowSize * distance : void 0,
    left: theme.dir === "rtl" ? arrowSize * distance : void 0
  },
  [`&.${classes.start}`]: {
    left: theme.dir === "ltr" ? arrowSize * distance : void 0,
    right: theme.dir === "rtl" ? arrowSize * distance : void 0
  }
});
var useStyles$1C = createStyles((theme, { arrowSize, arrowDistance }, getRef) => {
  const center = { ref: getRef("center") };
  const start = { ref: getRef("start") };
  const end = { ref: getRef("end") };
  const placementClasses = {
    center: center.ref,
    start: start.ref,
    end: end.ref
  };
  return {
    center,
    start,
    end,
    arrow: {
      width: arrowSize * 2,
      height: arrowSize * 2,
      position: "absolute",
      transform: "rotate(45deg)",
      border: "1px solid transparent",
      zIndex: 1
    },
    left: __spreadProps$B(__spreadValues$1f({}, horizontalPlacement(arrowSize, arrowDistance, placementClasses)), {
      right: theme.dir === "ltr" ? -arrowSize : "unset",
      left: theme.dir === "rtl" ? -arrowSize : "unset",
      borderLeft: theme.dir === "ltr" ? 0 : void 0,
      borderRight: theme.dir === "rtl" ? 0 : void 0,
      borderBottom: 0
    }),
    right: __spreadProps$B(__spreadValues$1f({}, horizontalPlacement(arrowSize, arrowDistance, placementClasses)), {
      left: theme.dir === "ltr" ? -arrowSize : "unset",
      right: theme.dir === "rtl" ? -arrowSize : "unset",
      borderRight: theme.dir === "ltr" ? 0 : void 0,
      borderLeft: theme.dir === "rtl" ? 0 : void 0,
      borderTop: 0
    }),
    top: __spreadProps$B(__spreadValues$1f({}, verticalPlacement(arrowSize, arrowDistance, placementClasses, theme)), {
      bottom: -arrowSize,
      borderLeft: theme.dir === "ltr" ? 0 : void 0,
      borderRight: theme.dir === "rtl" ? 0 : void 0,
      borderTop: 0
    }),
    bottom: __spreadProps$B(__spreadValues$1f({}, verticalPlacement(arrowSize, arrowDistance, placementClasses, theme)), {
      top: -arrowSize,
      borderRight: theme.dir === "ltr" ? 0 : void 0,
      borderLeft: theme.dir === "rtl" ? 0 : void 0,
      borderBottom: 0
    })
  };
});

var useStyles$1D = useStyles$1C;

var __defProp$1e = Object.defineProperty;
var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1e = (obj, key, value) => key in obj ? __defProp$1e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1e.call(b, prop))
      __defNormalProp$1e(a, prop, b[prop]);
  if (__getOwnPropSymbols$1e)
    for (var prop of __getOwnPropSymbols$1e(b)) {
      if (__propIsEnum$1e.call(b, prop))
        __defNormalProp$1e(a, prop, b[prop]);
    }
  return a;
};
const transitionStatuses = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function getTransitionStyles({
  transition,
  state,
  duration,
  timingFunction
}) {
  const shared = {
    transitionDuration: `${duration}ms`,
    transitionTimingFunction: timingFunction
  };
  if (typeof transition === "string") {
    if (!(transition in transitions)) {
      return null;
    }
    return __spreadValues$1e(__spreadValues$1e(__spreadValues$1e({
      transitionProperty: transitions[transition].transitionProperty
    }, shared), transitions[transition].common), transitions[transition][transitionStatuses[state]]);
  }
  return __spreadValues$1e(__spreadValues$1e(__spreadValues$1e({
    transitionProperty: transition.transitionProperty
  }, shared), transition.common), transition[transitionStatuses[state]]);
}

function useTransition({
  duration,
  exitDuration,
  timingFunction,
  mounted,
  onEnter,
  onExit,
  onEntered,
  onExited
}) {
  const theme = useMantineTheme();
  const reduceMotion = useReducedMotion();
  const [transitionStatus, setStatus] = useState(mounted ? "entered" : "exited");
  const [transitionDuration, setTransitionDuration] = useState(reduceMotion ? 0 : duration);
  const timeoutRef = useRef(-1);
  const handleStateChange = (shouldMount) => {
    const preHandler = shouldMount ? onEnter : onExit;
    const handler = shouldMount ? onEntered : onExited;
    setStatus(shouldMount ? "pre-entering" : "pre-exiting");
    window.clearTimeout(timeoutRef.current);
    const _duration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
    setTransitionDuration(_duration);
    if (_duration === 0) {
      typeof preHandler === "function" && preHandler();
      typeof handler === "function" && handler();
      setStatus(shouldMount ? "entered" : "exited");
    } else {
      const preStateTimeout = window.setTimeout(() => {
        typeof preHandler === "function" && preHandler();
        setStatus(shouldMount ? "entering" : "exiting");
      }, 10);
      timeoutRef.current = window.setTimeout(() => {
        window.clearTimeout(preStateTimeout);
        typeof handler === "function" && handler();
        setStatus(shouldMount ? "entered" : "exited");
      }, _duration);
    }
  };
  useDidUpdate(() => {
    handleStateChange(mounted);
  }, [mounted]);
  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);
  return {
    transitionDuration,
    transitionStatus,
    transitionTimingFunction: timingFunction || theme.transitionTimingFunction
  };
}

function Transition({
  transition,
  duration = 250,
  exitDuration = duration,
  mounted,
  children,
  timingFunction,
  onExit,
  onEntered,
  onEnter,
  onExited
}) {
  const { transitionDuration, transitionStatus, transitionTimingFunction } = useTransition({
    mounted,
    exitDuration,
    duration,
    timingFunction,
    onExit,
    onEntered,
    onEnter,
    onExited
  });
  if (transitionDuration === 0) {
    return mounted ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children({})) : null;
  }
  return transitionStatus === "exited" ? null : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children(getTransitionStyles({
    transition,
    duration: transitionDuration,
    state: transitionStatus,
    timingFunction: transitionTimingFunction
  })));
}
Transition.displayName = "@mantine/core/Transition";

var __defProp$1d = Object.defineProperty;
var __defProps$A = Object.defineProperties;
var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1d = (obj, key, value) => key in obj ? __defProp$1d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1d.call(b, prop))
      __defNormalProp$1d(a, prop, b[prop]);
  if (__getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(b)) {
      if (__propIsEnum$1d.call(b, prop))
        __defNormalProp$1d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$A = (a, b) => __defProps$A(a, __getOwnPropDescs$A(b));
function flipPlacement(placement, dir) {
  if (placement === "center") {
    return placement;
  }
  if (dir === "rtl") {
    if (placement === "end") {
      return "start";
    }
    return "end";
  }
  return placement;
}
function flipPosition(position, dir) {
  if (position === "top" || position === "bottom") {
    return position;
  }
  if (dir === "rtl") {
    if (position === "left") {
      return "right";
    }
    return "left";
  }
  return position;
}
function Popper({
  position = "top",
  placement = "center",
  gutter = 5,
  arrowSize = 2,
  arrowDistance = 2,
  withArrow = false,
  referenceElement,
  children,
  mounted,
  transition = "pop-top-left",
  transitionDuration,
  exitTransitionDuration = transitionDuration,
  transitionTimingFunction,
  arrowClassName,
  arrowStyle,
  zIndex = getDefaultZIndex("popover"),
  forceUpdateDependencies = [],
  modifiers = [],
  onTransitionEnd,
  withinPortal = true
}) {
  var _a;
  const padding = withArrow ? gutter + arrowSize : gutter;
  const { classes, cx, theme } = useStyles$1D({ arrowSize, arrowDistance }, { name: "Popper" });
  const [popperElement, setPopperElement] = useState(null);
  const _placement = flipPlacement(placement, theme.dir);
  const _position = flipPosition(position, theme.dir);
  const initialPlacement = _placement === "center" ? _position : `${_position}-${_placement}`;
  const { styles, attributes, forceUpdate } = usePopper(referenceElement, popperElement, {
    placement: initialPlacement,
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, padding]
        }
      },
      ...modifiers
    ]
  });
  const parsedAttributes = parsePopperPosition((_a = attributes.popper) == null ? void 0 : _a["data-popper-placement"]);
  useDidUpdate(() => {
    typeof forceUpdate === "function" && forceUpdate();
  }, forceUpdateDependencies);
  return /* @__PURE__ */ React__default.createElement(Transition, {
    mounted: mounted && !!referenceElement,
    duration: transitionDuration,
    exitDuration: exitTransitionDuration,
    transition,
    timingFunction: transitionTimingFunction,
    onExited: onTransitionEnd
  }, (transitionStyles) => /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(PopperContainer, {
    withinPortal,
    zIndex
  }, /* @__PURE__ */ React__default.createElement("div", __spreadValues$1d({
    ref: setPopperElement,
    style: __spreadProps$A(__spreadValues$1d({}, styles.popper), {
      pointerEvents: "none"
    })
  }, attributes.popper), /* @__PURE__ */ React__default.createElement("div", {
    style: transitionStyles
  }, children, withArrow && /* @__PURE__ */ React__default.createElement("div", {
    style: arrowStyle,
    className: cx(classes.arrow, classes[parsedAttributes.placement], classes[parsedAttributes.position], arrowClassName)
  }))))));
}
Popper.displayName = "@mantine/core/Popper";

var useStyles$1A = createStyles((theme, { radius, shadow, withBorder }) => ({
  root: {
    outline: 0,
    WebkitTapHighlightColor: "transparent",
    display: "block",
    textDecoration: "none",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    boxSizing: "border-box",
    borderRadius: theme.fn.radius(radius),
    boxShadow: theme.shadows[shadow] || shadow || "none",
    border: withBorder ? `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]}` : void 0
  }
}));

var useStyles$1B = useStyles$1A;

var __defProp$1c = Object.defineProperty;
var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1c = (obj, key, value) => key in obj ? __defProp$1c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1c.call(b, prop))
      __defNormalProp$1c(a, prop, b[prop]);
  if (__getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(b)) {
      if (__propIsEnum$1c.call(b, prop))
        __defNormalProp$1c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$y = {};
const Paper = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Paper", defaultProps$y, props), { component, className, children, radius, withBorder, shadow } = _a, others = __objRest$P(_a, ["component", "className", "children", "radius", "withBorder", "shadow"]);
  const { classes, cx } = useStyles$1B({ radius, shadow, withBorder }, { name: "Paper" });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1c({
    component: component || "div",
    className: cx(classes.root, className),
    ref
  }, others), children);
});
Paper.displayName = "@mantine/core/Paper";

const SelectDropdown = forwardRef(({
  mounted,
  transition,
  transitionDuration,
  transitionTimingFunction,
  uuid,
  shadow,
  maxDropdownHeight,
  withinPortal = true,
  children,
  classNames,
  styles,
  dropdownComponent,
  referenceElement,
  direction = "column",
  onDirectionChange,
  switchDirectionOnFlip = false,
  zIndex = getDefaultZIndex("popover"),
  dropdownPosition = "flip",
  __staticSelector,
  positionDependencies = []
}, ref) => {
  const { classes } = useStyles$1F({ native: dropdownComponent !== SelectScrollArea }, { classNames, styles, name: __staticSelector });
  const previousPlacement = useRef("bottom");
  return /* @__PURE__ */ React__default.createElement(Popper, {
    referenceElement,
    mounted,
    transition,
    transitionDuration,
    exitTransitionDuration: 0,
    transitionTimingFunction,
    position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
    withinPortal,
    forceUpdateDependencies: positionDependencies,
    zIndex,
    modifiers: [
      {
        name: "preventOverflow",
        enabled: false
      },
      {
        name: "flip",
        enabled: dropdownPosition === "flip"
      },
      {
        name: "sameWidth",
        enabled: true,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: ({ state }) => {
          state.styles.popper.width = `${state.rects.reference.width}px`;
        },
        effect: ({ state }) => {
          state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
        }
      },
      {
        name: "directionControl",
        enabled: true,
        phase: "main",
        fn: ({ state }) => {
          if (previousPlacement.current !== state.placement) {
            previousPlacement.current = state.placement;
            const nextDirection = state.placement === "top" ? "column-reverse" : "column";
            if (direction !== nextDirection && switchDirectionOnFlip) {
              onDirectionChange && onDirectionChange(nextDirection);
            }
          }
        }
      }
    ]
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: { maxHeight: maxDropdownHeight, display: "flex" }
  }, /* @__PURE__ */ React__default.createElement(Paper, {
    radius: "sm",
    component: dropdownComponent || "div",
    id: `${uuid}-items`,
    "aria-labelledby": `${uuid}-label`,
    role: "listbox",
    className: classes.dropdown,
    shadow,
    ref,
    onMouseDown: (event) => event.preventDefault()
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: { display: "flex", flexDirection: direction, width: "100%" }
  }, children))));
});
SelectDropdown.displayName = "@mantine/core/SelectDropdown";

const sizes$c = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};
var useStyles$1y = createStyles((theme, { size, variant, color }) => ({
  root: {},
  withLabel: {
    borderTop: "0 !important"
  },
  left: {
    "&::before": {
      display: "none"
    }
  },
  right: {
    "&::after": {
      display: "none"
    }
  },
  label: {
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: '""',
      flex: 1,
      height: 1,
      borderTop: `${theme.fn.size({ size, sizes: sizes$c })}px ${variant} ${theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 4, false)}`,
      marginRight: theme.spacing.xs
    },
    "&::after": {
      content: '""',
      flex: 1,
      borderTop: `${theme.fn.size({ size, sizes: sizes$c })}px ${variant} ${theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 4, false)}`,
      marginLeft: theme.spacing.xs
    }
  },
  labelDefaultStyles: {
    color: color === "dark" ? theme.colors.dark[1] : theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : theme.fn.primaryShade(), false)
  },
  horizontal: {
    border: 0,
    borderTopWidth: theme.fn.size({ size, sizes: sizes$c }),
    borderTopColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 4, false),
    borderTopStyle: variant,
    margin: 0
  },
  vertical: {
    border: 0,
    alignSelf: "stretch",
    height: "100%",
    borderLeftWidth: theme.fn.size({ size, sizes: sizes$c }),
    borderLeftColor: theme.fn.themeColor(color, 4, false),
    borderLeftStyle: variant
  }
}));

var useStyles$1z = useStyles$1y;

var __defProp$1b = Object.defineProperty;
var __defProps$z = Object.defineProperties;
var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1b = (obj, key, value) => key in obj ? __defProp$1b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1b.call(b, prop))
      __defNormalProp$1b(a, prop, b[prop]);
  if (__getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(b)) {
      if (__propIsEnum$1b.call(b, prop))
        __defNormalProp$1b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$z = (a, b) => __defProps$z(a, __getOwnPropDescs$z(b));
var __objRest$O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$x = {
  orientation: "horizontal",
  size: "xs",
  labelPosition: "left",
  variant: "solid"
};
const Divider = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Divider", defaultProps$x, props), {
    className,
    color,
    orientation,
    size,
    label,
    labelPosition,
    labelProps,
    variant,
    styles,
    classNames
  } = _a, others = __objRest$O(_a, [
    "className",
    "color",
    "orientation",
    "size",
    "label",
    "labelPosition",
    "labelProps",
    "variant",
    "styles",
    "classNames"
  ]);
  const theme = useMantineTheme();
  const _color = color || (theme.colorScheme === "dark" ? "dark" : "gray");
  const { classes, cx } = useStyles$1z({ color: _color, size, variant }, { classNames, styles, name: "Divider" });
  const vertical = orientation === "vertical";
  const horizontal = orientation === "horizontal";
  const withLabel = !!label && horizontal;
  const useLabelDefaultStyles = !(labelProps == null ? void 0 : labelProps.color);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$1b({
    ref,
    className: cx(classes.root, {
      [classes.vertical]: vertical,
      [classes.horizontal]: horizontal,
      [classes.withLabel]: withLabel
    }, className)
  }, others), withLabel && /* @__PURE__ */ React__default.createElement(Text$1, __spreadProps$z(__spreadValues$1b({}, labelProps), {
    size: (labelProps == null ? void 0 : labelProps.size) || "xs",
    sx: { marginTop: 2 },
    className: cx(classes.label, classes[labelPosition], {
      [classes.labelDefaultStyles]: useLabelDefaultStyles
    })
  }), label));
});
Divider.displayName = "@mantine/core/Divider";

var useStyles$1w = createStyles((theme, { size }) => ({
  item: {
    boxSizing: "border-box",
    textAlign: "left",
    width: "100%",
    padding: `${theme.fn.size({ size, sizes: theme.spacing }) / 1.5}px ${theme.fn.size({
      size,
      sizes: theme.spacing
    })}px`,
    cursor: "pointer",
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    borderRadius: theme.radius.sm
  },
  selected: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors[theme.primaryColor][0],
    color: theme.colorScheme === "dark" ? theme.white : theme.colors[theme.primaryColor][9]
  },
  hovered: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
  },
  nothingFound: {
    boxSizing: "border-box",
    color: theme.colors.gray[6],
    paddingTop: theme.fn.size({ size, sizes: theme.spacing }) / 2,
    paddingBottom: theme.fn.size({ size, sizes: theme.spacing }) / 2,
    textAlign: "center"
  },
  disabled: {
    cursor: "default",
    color: theme.colors.dark[2]
  },
  separator: {
    boxSizing: "border-box",
    textAlign: "left",
    width: "100%",
    padding: `${theme.fn.size({ size, sizes: theme.spacing }) / 1.5}px ${theme.fn.size({
      size,
      sizes: theme.spacing
    })}px`
  },
  separatorLabel: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
  }
}));

var useStyles$1x = useStyles$1w;

var __defProp$1a = Object.defineProperty;
var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1a = (obj, key, value) => key in obj ? __defProp$1a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1a.call(b, prop))
      __defNormalProp$1a(a, prop, b[prop]);
  if (__getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(b)) {
      if (__propIsEnum$1a.call(b, prop))
        __defNormalProp$1a(a, prop, b[prop]);
    }
  return a;
};
function SelectItems({
  data,
  hovered,
  classNames,
  styles,
  isItemSelected,
  uuid,
  __staticSelector,
  onItemHover,
  onItemSelect,
  itemsRefs,
  itemComponent: Item,
  size,
  nothingFound,
  creatable,
  createLabel
}) {
  const { classes, cx } = useStyles$1x({ size }, { classNames, styles, name: __staticSelector });
  const unGroupedItems = [];
  const groupedItems = [];
  let creatableDataIndex = null;
  const constructItemComponent = (item, index) => {
    const selected = typeof isItemSelected === "function" ? isItemSelected(item.value) : false;
    return /* @__PURE__ */ React__default.createElement(Item, __spreadValues$1a({
      key: item.value,
      className: cx(classes.item, {
        [classes.hovered]: !item.disabled && hovered === index,
        [classes.selected]: !item.disabled && selected,
        [classes.disabled]: item.disabled
      }),
      onMouseEnter: () => onItemHover(index),
      id: `${uuid}-${index}`,
      role: "option",
      "data-ignore-outside-clicks": true,
      tabIndex: -1,
      "aria-selected": hovered === index,
      ref: (node) => {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[item.value] = node;
        }
      },
      onMouseDown: !item.disabled ? (event) => {
        event.preventDefault();
        onItemSelect(item);
      } : null,
      disabled: item.disabled
    }, item));
  };
  let groupName = null;
  data.forEach((item, index) => {
    if (item.creatable) {
      creatableDataIndex = index;
    } else if (!item.group) {
      unGroupedItems.push(constructItemComponent(item, index));
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        groupedItems.push(/* @__PURE__ */ React__default.createElement("div", {
          className: classes.separator,
          key: `__mantine-divider-${index}`
        }, /* @__PURE__ */ React__default.createElement(Divider, {
          classNames: { label: classes.separatorLabel },
          label: item.group
        })));
      }
      groupedItems.push(constructItemComponent(item, index));
    }
  });
  if (creatable) {
    const creatableDataItem = data[creatableDataIndex];
    const selected = typeof isItemSelected === "function" ? isItemSelected(data[creatableDataIndex].value) : false;
    unGroupedItems.push(/* @__PURE__ */ React__default.createElement("div", {
      key: creatableDataItem.value,
      className: cx(classes.item, {
        [classes.hovered]: hovered === creatableDataIndex,
        [classes.selected]: selected
      }),
      onMouseEnter: () => onItemHover(creatableDataIndex),
      onMouseDown: (event) => {
        event.preventDefault();
        onItemSelect(creatableDataItem);
      },
      tabIndex: -1,
      ref: (node) => {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[creatableDataItem.value] = node;
        }
      }
    }, createLabel));
  }
  if (groupedItems.length > 0 && unGroupedItems.length > 0) {
    unGroupedItems.unshift(/* @__PURE__ */ React__default.createElement("div", {
      className: classes.separator
    }, /* @__PURE__ */ React__default.createElement(Divider, null)));
  }
  return groupedItems.length > 0 || unGroupedItems.length > 0 ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, groupedItems, unGroupedItems) : /* @__PURE__ */ React__default.createElement(Text$1, {
    size,
    className: classes.nothingFound
  }, nothingFound);
}
SelectItems.displayName = "@mantine/core/SelectItems";

var __defProp$19 = Object.defineProperty;
var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$19 = (obj, key, value) => key in obj ? __defProp$19(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$19 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$19.call(b, prop))
      __defNormalProp$19(a, prop, b[prop]);
  if (__getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(b)) {
      if (__propIsEnum$19.call(b, prop))
        __defNormalProp$19(a, prop, b[prop]);
    }
  return a;
};
var __objRest$N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DefaultItem = forwardRef((_a, ref) => {
  var _b = _a, { label, value } = _b, others = __objRest$N(_b, ["label", "value"]);
  return /* @__PURE__ */ React__default.createElement("div", __spreadValues$19({
    ref
  }, others), label || value);
});
DefaultItem.displayName = "@mantine/core/DefaultItem";

function filterData$1({ data, limit, value, filter }) {
  const result = [];
  for (let i = 0; i < data.length; i += 1) {
    if (filter(value, data[i])) {
      result.push(data[i]);
    }
    if (result.length >= limit) {
      break;
    }
  }
  return result;
}

var useStyles$1u = createStyles((theme, { size }) => {
  const spacing = theme.fn.size({ size, sizes: theme.spacing });
  return {
    wrapper: {
      position: "relative"
    },
    item: {
      textAlign: "left",
      width: "100%",
      padding: `${spacing / 1.5}px ${spacing}`,
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    },
    hovered: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
    },
    nothingFound: {
      boxSizing: "border-box",
      color: theme.colors.gray[6],
      paddingTop: spacing / 2,
      paddingBottom: spacing / 2,
      textAlign: "center"
    }
  };
});

var useStyles$1v = useStyles$1u;

var __defProp$18 = Object.defineProperty;
var __defProps$y = Object.defineProperties;
var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$18 = (obj, key, value) => key in obj ? __defProp$18(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$18 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$18.call(b, prop))
      __defNormalProp$18(a, prop, b[prop]);
  if (__getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(b)) {
      if (__propIsEnum$18.call(b, prop))
        __defNormalProp$18(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$y = (a, b) => __defProps$y(a, __getOwnPropDescs$y(b));
var useStyles$1s = createStyles((theme, { size }) => ({
  root: __spreadProps$y(__spreadValues$18({}, theme.fn.fontStyles()), {
    lineHeight: theme.lineHeight
  }),
  label: {
    display: "inline-block",
    marginBottom: 4,
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    fontWeight: 500,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
    wordBreak: "break-word",
    cursor: "default",
    WebkitTapHighlightColor: "transparent"
  },
  error: {
    marginTop: theme.spacing.xs / 2,
    wordBreak: "break-word",
    color: theme.colors.red[theme.colorScheme === "dark" ? 6 : 7]
  },
  description: {
    marginTop: -3,
    marginBottom: 7,
    wordBreak: "break-word",
    color: `${theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6]} !important`,
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }) - 2,
    lineHeight: 1.2
  },
  required: {
    color: theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7]
  }
}));

var useStyles$1t = useStyles$1s;

var __defProp$17 = Object.defineProperty;
var __defProps$x = Object.defineProperties;
var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$17 = (obj, key, value) => key in obj ? __defProp$17(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$17 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$17.call(b, prop))
      __defNormalProp$17(a, prop, b[prop]);
  if (__getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(b)) {
      if (__propIsEnum$17.call(b, prop))
        __defNormalProp$17(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$x = (a, b) => __defProps$x(a, __getOwnPropDescs$x(b));
var __objRest$M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$17.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$17.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$w = {
  labelElement: "label",
  size: "sm",
  __staticSelector: "InputWrapper"
};
const InputWrapper = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("InputWrapper", defaultProps$w, props), {
    className,
    label,
    children,
    required,
    id,
    error,
    description,
    labelElement,
    labelProps,
    descriptionProps,
    errorProps,
    classNames,
    styles,
    size,
    __staticSelector
  } = _a, others = __objRest$M(_a, [
    "className",
    "label",
    "children",
    "required",
    "id",
    "error",
    "description",
    "labelElement",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "classNames",
    "styles",
    "size",
    "__staticSelector"
  ]);
  const { classes, cx } = useStyles$1t({ size }, { classNames, styles, name: __staticSelector });
  const _labelProps = labelElement === "label" ? { htmlFor: id } : {};
  const inputLabel = createElement(labelElement, __spreadProps$x(__spreadValues$17(__spreadValues$17({}, _labelProps), labelProps), {
    id: id ? `${id}-label` : void 0,
    className: classes.label
  }), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, label, required && /* @__PURE__ */ React__default.createElement("span", {
    className: classes.required,
    "aria-hidden": true
  }, " *")));
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$17({
    className: cx(classes.root, className),
    ref
  }, others), label && inputLabel, description && /* @__PURE__ */ React__default.createElement(Text$1, __spreadProps$x(__spreadValues$17({}, descriptionProps), {
    color: "gray",
    className: classes.description
  }), description), children, typeof error !== "boolean" && error && /* @__PURE__ */ React__default.createElement(Text$1, __spreadProps$x(__spreadValues$17({}, errorProps), {
    size,
    className: classes.error
  }), error));
});
InputWrapper.displayName = "@mantine/core/InputWrapper";

var __defProp$16 = Object.defineProperty;
var __defProps$w = Object.defineProperties;
var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$16 = (obj, key, value) => key in obj ? __defProp$16(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$16 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$16.call(b, prop))
      __defNormalProp$16(a, prop, b[prop]);
  if (__getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(b)) {
      if (__propIsEnum$16.call(b, prop))
        __defNormalProp$16(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$w = (a, b) => __defProps$w(a, __getOwnPropDescs$w(b));
const sizes$b = {
  xs: 30,
  sm: 36,
  md: 42,
  lg: 50,
  xl: 60
};
var useStyles$1q = createStyles((theme, {
  size,
  multiline,
  radius,
  variant,
  invalid,
  rightSectionWidth,
  withRightSection,
  iconWidth
}) => {
  const invalidColor = theme.colors.red[theme.colorScheme === "dark" ? 6 : 7];
  const sizeStyles = variant === "default" || variant === "filled" ? {
    minHeight: theme.fn.size({ size, sizes: sizes$b }),
    paddingLeft: theme.fn.size({ size, sizes: sizes$b }) / 3,
    paddingRight: withRightSection ? rightSectionWidth : theme.fn.size({ size, sizes: sizes$b }) / 3,
    borderRadius: theme.fn.radius(radius)
  } : null;
  return {
    wrapper: {
      position: "relative"
    },
    input: variant === "headless" ? {} : __spreadProps$w(__spreadValues$16(__spreadProps$w(__spreadValues$16({}, theme.fn.fontStyles()), {
      height: multiline ? variant === "unstyled" ? void 0 : "auto" : theme.fn.size({ size, sizes: sizes$b }),
      WebkitTapHighlightColor: "transparent",
      lineHeight: multiline ? theme.lineHeight : `${theme.fn.size({ size, sizes: sizes$b }) - 2}px`,
      appearance: "none",
      resize: "none",
      boxSizing: "border-box",
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      width: "100%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      display: "block",
      textAlign: "left"
    }), sizeStyles), {
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
        color: theme.colors.dark[2],
        opacity: 0.6,
        cursor: "not-allowed",
        "&::placeholder": {
          color: theme.colors.dark[2]
        }
      },
      "&::placeholder": {
        opacity: 1,
        userSelect: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      },
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
        appearance: "none"
      },
      "&[type=number]": {
        MozAppearance: "textfield"
      }
    }),
    defaultVariant: {
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[4]}`,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
      transition: "border-color 100ms ease",
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 8 : 5]
      }
    },
    filledVariant: {
      border: "1px solid transparent",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: `${theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 8 : 5]} !important`
      }
    },
    unstyledVariant: {
      borderWidth: 0,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      backgroundColor: "transparent",
      minHeight: 28,
      outline: 0,
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: "transparent"
      },
      "&:disabled": {
        backgroundColor: "transparent",
        "&:focus, &:focus-within": {
          outline: "none",
          borderColor: "transparent"
        }
      }
    },
    withIcon: {
      paddingLeft: typeof iconWidth === "number" ? iconWidth : theme.fn.size({ size, sizes: sizes$b })
    },
    invalid: {
      color: invalidColor,
      borderColor: invalidColor,
      "&::placeholder": {
        opacity: 1,
        color: invalidColor
      }
    },
    disabled: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
      color: theme.colors.dark[2],
      opacity: 0.6,
      cursor: "not-allowed",
      "&::placeholder": {
        color: theme.colors.dark[2]
      }
    },
    icon: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 1,
      left: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: theme.fn.size({ size, sizes: sizes$b }),
      color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
    },
    rightSection: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: rightSectionWidth
    }
  };
});

var useStyles$1r = useStyles$1q;

var __defProp$15 = Object.defineProperty;
var __defProps$v = Object.defineProperties;
var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$15 = (obj, key, value) => key in obj ? __defProp$15(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$15 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$15.call(b, prop))
      __defNormalProp$15(a, prop, b[prop]);
  if (__getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(b)) {
      if (__propIsEnum$15.call(b, prop))
        __defNormalProp$15(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$v = (a, b) => __defProps$v(a, __getOwnPropDescs$v(b));
var __objRest$L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$v = {
  rightSectionWidth: 36,
  size: "sm",
  __staticSelector: "Input"
};
const Input$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Input", defaultProps$v, props), {
    component,
    className,
    invalid,
    required,
    disabled,
    variant,
    icon,
    style,
    rightSectionWidth,
    iconWidth,
    rightSection,
    rightSectionProps,
    radius,
    size,
    wrapperProps,
    classNames,
    styles,
    __staticSelector,
    multiline,
    sx
  } = _a, others = __objRest$L(_a, [
    "component",
    "className",
    "invalid",
    "required",
    "disabled",
    "variant",
    "icon",
    "style",
    "rightSectionWidth",
    "iconWidth",
    "rightSection",
    "rightSectionProps",
    "radius",
    "size",
    "wrapperProps",
    "classNames",
    "styles",
    "__staticSelector",
    "multiline",
    "sx"
  ]);
  const theme = useMantineTheme();
  const _variant = variant || (theme.colorScheme === "dark" ? "filled" : "default");
  const { classes, cx } = useStyles$1r({
    radius,
    size,
    multiline,
    variant: _variant,
    invalid,
    rightSectionWidth,
    iconWidth,
    withRightSection: !!rightSection
  }, { classNames, styles, name: __staticSelector });
  const { systemStyles, rest } = extractSystemStyles(others);
  const Element = component || "input";
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$15(__spreadValues$15({
    className: cx(classes.wrapper, className),
    sx,
    style
  }, systemStyles), wrapperProps), icon && /* @__PURE__ */ React__default.createElement("div", {
    className: classes.icon
  }, icon), /* @__PURE__ */ React__default.createElement(Element, __spreadProps$v(__spreadValues$15({}, rest), {
    ref,
    required,
    "aria-invalid": invalid,
    disabled,
    className: cx(classes[`${_variant}Variant`], classes.input, {
      [classes.withIcon]: icon,
      [classes.invalid]: invalid,
      [classes.disabled]: disabled
    })
  })), rightSection && /* @__PURE__ */ React__default.createElement("div", __spreadProps$v(__spreadValues$15({}, rightSectionProps), {
    className: classes.rightSection
  }), rightSection));
});
Input$1.displayName = "@mantine/core/Input";

var __defProp$14 = Object.defineProperty;
var __defProps$u = Object.defineProperties;
var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$14 = (obj, key, value) => key in obj ? __defProp$14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$14 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$14.call(b, prop))
      __defNormalProp$14(a, prop, b[prop]);
  if (__getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(b)) {
      if (__propIsEnum$14.call(b, prop))
        __defNormalProp$14(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$u = (a, b) => __defProps$u(a, __getOwnPropDescs$u(b));
var __objRest$K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$14.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$14.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function defaultFilter$1(value, item) {
  return item.value.toLowerCase().trim().includes(value.toLowerCase().trim());
}
const defaultProps$u = {
  required: false,
  size: "sm",
  shadow: "sm",
  limit: 5,
  itemComponent: DefaultItem,
  transition: "pop",
  transitionDuration: 0,
  initiallyOpened: false,
  filter: defaultFilter$1,
  switchDirectionOnFlip: false,
  zIndex: getDefaultZIndex("popover"),
  dropdownPosition: "flip",
  maxDropdownHeight: "auto",
  positionDependencies: []
};
const Autocomplete = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Autocomplete", defaultProps$u, props), {
    className,
    style,
    sx,
    required = false,
    label,
    id,
    error,
    description,
    size = "sm",
    shadow = "sm",
    data,
    limit = 5,
    value,
    defaultValue,
    onChange,
    itemComponent = DefaultItem,
    onItemSubmit,
    onKeyDown,
    onFocus,
    onBlur,
    onClick,
    transition = "skew-up",
    transitionDuration = 0,
    initiallyOpened = false,
    transitionTimingFunction,
    wrapperProps,
    classNames,
    styles,
    filter = defaultFilter$1,
    nothingFound,
    onDropdownClose,
    onDropdownOpen,
    withinPortal,
    switchDirectionOnFlip = false,
    zIndex = getDefaultZIndex("popover"),
    dropdownPosition,
    maxDropdownHeight,
    dropdownComponent,
    errorProps,
    labelProps,
    descriptionProps,
    positionDependencies
  } = _a, others = __objRest$K(_a, [
    "className",
    "style",
    "sx",
    "required",
    "label",
    "id",
    "error",
    "description",
    "size",
    "shadow",
    "data",
    "limit",
    "value",
    "defaultValue",
    "onChange",
    "itemComponent",
    "onItemSubmit",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "transition",
    "transitionDuration",
    "initiallyOpened",
    "transitionTimingFunction",
    "wrapperProps",
    "classNames",
    "styles",
    "filter",
    "nothingFound",
    "onDropdownClose",
    "onDropdownOpen",
    "withinPortal",
    "switchDirectionOnFlip",
    "zIndex",
    "dropdownPosition",
    "maxDropdownHeight",
    "dropdownComponent",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "positionDependencies"
  ]);
  const { classes } = useStyles$1v({ size }, { classNames, styles, name: "Autocomplete" });
  const { systemStyles, rest } = extractSystemStyles(others);
  const [dropdownOpened, _setDropdownOpened] = useState(initiallyOpened);
  const [hovered, setHovered] = useState(-1);
  const [direction, setDirection] = useState("column");
  const inputRef = useRef(null);
  const uuid = useUuid(id);
  const [_value, handleChange] = useUncontrolled({
    value,
    defaultValue,
    finalValue: "",
    onChange,
    rule: (val) => typeof val === "string"
  });
  const setDropdownOpened = (opened) => {
    _setDropdownOpened(opened);
    const handler = opened ? onDropdownOpen : onDropdownClose;
    typeof handler === "function" && handler();
  };
  useDidUpdate(() => {
    setHovered(0);
  }, [_value]);
  const handleItemClick = (item) => {
    handleChange(item.value);
    typeof onItemSubmit === "function" && onItemSubmit(item);
    setDropdownOpened(false);
  };
  const formattedData = data.map((item) => typeof item === "string" ? { value: item } : item);
  const filteredData = filterData$1({ data: formattedData, value: _value, limit, filter });
  const handleInputKeydown = (event) => {
    typeof onKeyDown === "function" && onKeyDown(event);
    const isColumn = direction === "column";
    const handleNext = () => {
      setHovered((current) => current < filteredData.length - 1 ? current + 1 : current);
    };
    const handlePrevious = () => {
      setHovered((current) => current > 0 ? current - 1 : current);
    };
    switch (event.nativeEvent.code) {
      case "ArrowUp": {
        event.preventDefault();
        isColumn ? handlePrevious() : handleNext();
        break;
      }
      case "ArrowDown": {
        event.preventDefault();
        isColumn ? handleNext() : handlePrevious();
        break;
      }
      case "Enter": {
        if (filteredData[hovered] && dropdownOpened) {
          event.preventDefault();
          handleChange(filteredData[hovered].value);
          typeof onItemSubmit === "function" && onItemSubmit(filteredData[hovered]);
          setDropdownOpened(false);
        }
        break;
      }
      case "Escape": {
        if (dropdownOpened) {
          event.preventDefault();
          setDropdownOpened(false);
        }
      }
    }
  };
  const handleInputFocus = (event) => {
    typeof onFocus === "function" && onFocus(event);
    setDropdownOpened(true);
  };
  const handleInputBlur = (event) => {
    typeof onBlur === "function" && onBlur(event);
    setDropdownOpened(false);
  };
  const handleInputClick = (event) => {
    typeof onClick === "function" && onClick(event);
    setDropdownOpened(true);
  };
  const shouldRenderDropdown = dropdownOpened && (filteredData.length > 0 || filteredData.length === 0 && !!nothingFound);
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$14(__spreadValues$14({
    required,
    id: uuid,
    label,
    error,
    description,
    size,
    className,
    classNames,
    styles,
    __staticSelector: "Autocomplete",
    sx,
    style,
    errorProps,
    descriptionProps,
    labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.wrapper,
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": shouldRenderDropdown ? `${uuid}-items` : null,
    "aria-controls": uuid,
    "aria-expanded": shouldRenderDropdown,
    onMouseLeave: () => setHovered(-1),
    tabIndex: -1
  }, /* @__PURE__ */ React__default.createElement(Input$1, __spreadProps$u(__spreadValues$14({}, rest), {
    "data-mantine-stop-propagation": dropdownOpened,
    required,
    ref: useMergedRef(ref, inputRef),
    id: uuid,
    type: "string",
    invalid: !!error,
    size,
    onKeyDown: handleInputKeydown,
    classNames,
    styles,
    __staticSelector: "Autocomplete",
    value: _value,
    onChange: (event) => {
      handleChange(event.currentTarget.value);
      setDropdownOpened(true);
    },
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onClick: handleInputClick,
    autoComplete: "nope",
    "aria-autocomplete": "list",
    "aria-controls": shouldRenderDropdown ? `${uuid}-items` : null,
    "aria-activedescendant": hovered !== -1 ? `${uuid}-${hovered}` : null
  })), /* @__PURE__ */ React__default.createElement(SelectDropdown, {
    mounted: shouldRenderDropdown,
    transition,
    transitionDuration,
    transitionTimingFunction,
    uuid,
    shadow,
    maxDropdownHeight,
    dropdownComponent: dropdownComponent || SelectScrollArea,
    classNames,
    styles,
    __staticSelector: "Autocomplete",
    direction,
    onDirectionChange: setDirection,
    switchDirectionOnFlip,
    referenceElement: inputRef.current,
    withinPortal,
    zIndex,
    dropdownPosition,
    positionDependencies
  }, /* @__PURE__ */ React__default.createElement(SelectItems, {
    data: filteredData,
    hovered,
    classNames,
    styles,
    uuid,
    __staticSelector: "Autocomplete",
    onItemHover: setHovered,
    onItemSelect: handleItemClick,
    itemComponent,
    size,
    nothingFound
  }))));
});
Autocomplete.displayName = "@mantine/core/Autocomplete";

var __defProp$13 = Object.defineProperty;
var __defProps$t = Object.defineProperties;
var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$13 = (obj, key, value) => key in obj ? __defProp$13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$13 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$13.call(b, prop))
      __defNormalProp$13(a, prop, b[prop]);
  if (__getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(b)) {
      if (__propIsEnum$13.call(b, prop))
        __defNormalProp$13(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$t = (a, b) => __defProps$t(a, __getOwnPropDescs$t(b));
const sizes$a = {
  xs: 16,
  sm: 26,
  md: 38,
  lg: 56,
  xl: 84
};
var useStyles$1o = createStyles((theme, { size, radius, color }) => {
  const colors = theme.fn.variant({ variant: "light", color });
  return {
    root: __spreadProps$t(__spreadValues$13({}, theme.fn.focusStyles()), {
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      position: "relative",
      display: "block",
      userSelect: "none",
      overflow: "hidden",
      width: theme.fn.size({ size, sizes: sizes$a }),
      minWidth: theme.fn.size({ size, sizes: sizes$a }),
      height: theme.fn.size({ size, sizes: sizes$a }),
      borderRadius: theme.fn.radius(radius)
    }),
    image: {
      objectFit: "cover",
      width: "100%",
      height: "100%",
      display: "block"
    },
    placeholder: __spreadProps$t(__spreadValues$13({}, theme.fn.fontStyles()), {
      fontSize: theme.fn.size({ size, sizes: sizes$a }) / 2.5,
      color: colors.color,
      fontWeight: 700,
      backgroundColor: colors.background,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      userSelect: "none"
    }),
    placeholderIcon: {
      width: "70%",
      height: "70%",
      color: colors.color
    }
  };
});

var useStyles$1p = useStyles$1o;

var __defProp$12 = Object.defineProperty;
var __defProps$s = Object.defineProperties;
var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$12 = (obj, key, value) => key in obj ? __defProp$12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$12 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$12.call(b, prop))
      __defNormalProp$12(a, prop, b[prop]);
  if (__getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(b)) {
      if (__propIsEnum$12.call(b, prop))
        __defNormalProp$12(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$s = (a, b) => __defProps$s(a, __getOwnPropDescs$s(b));
function AvatarPlaceholderIcon(props) {
  return /* @__PURE__ */ React__default.createElement("svg", __spreadProps$s(__spreadValues$12({}, props), {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}

var __defProp$11 = Object.defineProperty;
var __defProps$r = Object.defineProperties;
var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$11 = (obj, key, value) => key in obj ? __defProp$11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$11 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$11.call(b, prop))
      __defNormalProp$11(a, prop, b[prop]);
  if (__getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(b)) {
      if (__propIsEnum$11.call(b, prop))
        __defNormalProp$11(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$r = (a, b) => __defProps$r(a, __getOwnPropDescs$r(b));
var __objRest$J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$11.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$11.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$t = {
  size: "md",
  color: "gray"
};
const Avatar$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Avatar", defaultProps$t, props), {
    component,
    className,
    size,
    src,
    alt,
    radius,
    children,
    color,
    classNames,
    styles,
    imageProps
  } = _a, others = __objRest$J(_a, [
    "component",
    "className",
    "size",
    "src",
    "alt",
    "radius",
    "children",
    "color",
    "classNames",
    "styles",
    "imageProps"
  ]);
  const { classes, cx } = useStyles$1p({ color, radius, size }, { classNames, styles, name: "Avatar" });
  const [error, setError] = useState(!src);
  useEffect(() => {
    !src ? setError(true) : setError(false);
  }, [src]);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$11({
    component: component || "div",
    className: cx(classes.root, className),
    ref
  }, others), error ? /* @__PURE__ */ React__default.createElement("div", {
    className: classes.placeholder,
    title: alt
  }, children || /* @__PURE__ */ React__default.createElement(AvatarPlaceholderIcon, {
    className: classes.placeholderIcon
  })) : /* @__PURE__ */ React__default.createElement("img", __spreadProps$r(__spreadValues$11({}, imageProps), {
    className: classes.image,
    src,
    alt,
    onError: () => setError(true)
  })));
});
Avatar$1.displayName = "@mantine/core/Avatar";

var __defProp$10 = Object.defineProperty;
var __defProps$q = Object.defineProperties;
var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$10 = (obj, key, value) => key in obj ? __defProp$10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$10 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$10.call(b, prop))
      __defNormalProp$10(a, prop, b[prop]);
  if (__getOwnPropSymbols$10)
    for (var prop of __getOwnPropSymbols$10(b)) {
      if (__propIsEnum$10.call(b, prop))
        __defNormalProp$10(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$q = (a, b) => __defProps$q(a, __getOwnPropDescs$q(b));
const sizes$9 = {
  xs: {
    fontSize: 9,
    height: 16
  },
  sm: {
    fontSize: 10,
    height: 18
  },
  md: {
    fontSize: 11,
    height: 20
  },
  lg: {
    fontSize: 13,
    height: 26
  },
  xl: {
    fontSize: 16,
    height: 32
  }
};
const dotSizes = {
  xs: 4,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 10
};
Object.keys(sizes$9).reduce((acc, key) => {
  acc[key] = sizes$9[key].height;
  return acc;
}, {});
var useStyles$1m = createStyles((theme, { color, size, radius, gradientFrom, gradientTo, gradientDeg, fullWidth }) => {
  const dotSize = theme.fn.size({ size, sizes: dotSizes });
  const { fontSize, height } = size in sizes$9 ? sizes$9[size] : sizes$9.md;
  const lightColors = theme.fn.variant({ color, variant: "light" });
  const filledColors = theme.fn.variant({ color, variant: "filled" });
  const outlineColors = theme.fn.variant({ color, variant: "outline" });
  const gradientColors = theme.fn.variant({
    variant: "gradient",
    gradient: { from: gradientFrom, to: gradientTo, deg: gradientDeg }
  });
  return {
    leftSection: {
      marginRight: theme.spacing.xs / 2
    },
    rightSection: {
      marginLeft: theme.spacing.xs / 2
    },
    inner: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    root: __spreadProps$q(__spreadValues$10(__spreadValues$10({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      fontSize,
      height,
      WebkitTapHighlightColor: "transparent",
      lineHeight: `${height - 2}px`,
      textDecoration: "none",
      padding: `0 ${theme.fn.size({ size, sizes: theme.spacing }) / 1.5}px`,
      boxSizing: "border-box",
      display: fullWidth ? "flex" : "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: fullWidth ? "100%" : "auto",
      textTransform: "uppercase",
      borderRadius: theme.fn.radius(radius),
      fontWeight: 700,
      letterSpacing: 0.25,
      cursor: "default",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }),
    light: {
      backgroundColor: lightColors.background,
      color: lightColors.color,
      border: "1px solid transparent"
    },
    filled: {
      backgroundColor: filledColors.background,
      color: filledColors.color,
      border: "1px solid transparent"
    },
    outline: {
      backgroundColor: outlineColors.background,
      color: outlineColors.color,
      border: `1px solid ${outlineColors.border}`
    },
    gradient: {
      backgroundImage: gradientColors.background,
      color: gradientColors.color,
      border: 0
    },
    dot: {
      backgroundColor: "transparent",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[3]}`,
      paddingLeft: theme.fn.size({ size, sizes: theme.spacing }) / 1.5 - dotSize / 2,
      "&::before": {
        content: '""',
        display: "block",
        width: dotSize,
        height: dotSize,
        borderRadius: dotSize,
        backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : theme.fn.primaryShade("light")),
        marginRight: dotSize
      }
    }
  };
});

var useStyles$1n = useStyles$1m;

var __defProp$$ = Object.defineProperty;
var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$$ = (obj, key, value) => key in obj ? __defProp$$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$$.call(b, prop))
      __defNormalProp$$(a, prop, b[prop]);
  if (__getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(b)) {
      if (__propIsEnum$$.call(b, prop))
        __defNormalProp$$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$s = {
  variant: "light",
  size: "md",
  radius: "xl",
  gradient: { from: "blue", to: "cyan", deg: 45 }
};
const Badge = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Badge", defaultProps$s, props), {
    component,
    className,
    color,
    variant,
    fullWidth,
    children,
    size,
    leftSection,
    rightSection,
    radius,
    gradient,
    classNames,
    styles
  } = _a, others = __objRest$I(_a, [
    "component",
    "className",
    "color",
    "variant",
    "fullWidth",
    "children",
    "size",
    "leftSection",
    "rightSection",
    "radius",
    "gradient",
    "classNames",
    "styles"
  ]);
  const { classes, cx } = useStyles$1n({
    size,
    fullWidth,
    color,
    radius,
    gradientFrom: gradient.from,
    gradientTo: gradient.to,
    gradientDeg: gradient.deg
  }, { classNames, styles, name: "Badge" });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$$({
    component: component || "div",
    className: cx(classes[variant], classes.root, className),
    ref
  }, others), leftSection && /* @__PURE__ */ React__default.createElement("span", {
    className: classes.leftSection
  }, leftSection), /* @__PURE__ */ React__default.createElement("span", {
    className: classes.inner
  }, children), rightSection && /* @__PURE__ */ React__default.createElement("span", {
    className: classes.rightSection
  }, rightSection));
});
Badge.displayName = "@mantine/core/Badge";

var useStyles$1k = createStyles((theme) => ({
  root: {
    display: "flex"
  },
  breadcrumb: {
    lineHeight: 1,
    whiteSpace: "nowrap",
    WebkitTapHighlightColor: "transparent"
  },
  separator: {
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

var useStyles$1l = useStyles$1k;

var __defProp$_ = Object.defineProperty;
var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$_ = (obj, key, value) => key in obj ? __defProp$_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$_.call(b, prop))
      __defNormalProp$_(a, prop, b[prop]);
  if (__getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(b)) {
      if (__propIsEnum$_.call(b, prop))
        __defNormalProp$_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$r = {
  separator: "/"
};
const Breadcrumbs$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Breadcrumbs", defaultProps$r, props), { className, children, separator, classNames, styles } = _a, others = __objRest$H(_a, ["className", "children", "separator", "classNames", "styles"]);
  const { classes, cx } = useStyles$1l(null, { classNames, styles, name: "Breadcrumbs" });
  const items = React__default.Children.toArray(children).reduce((acc, child, index, array) => {
    acc.push(React__default.cloneElement(child, { className: classes.breadcrumb, key: index }));
    if (index !== array.length - 1) {
      acc.push(/* @__PURE__ */ React__default.createElement(Text$1, {
        size: "sm",
        className: classes.separator,
        key: `separator-${index}`
      }, separator));
    }
    return acc;
  }, []);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$_({
    className: cx(classes.root, className),
    ref
  }, others), items);
});
Breadcrumbs$1.displayName = "@mantine/core/Breadcrumbs";

var __defProp$Z = Object.defineProperty;
var __defProps$p = Object.defineProperties;
var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Z = (obj, key, value) => key in obj ? __defProp$Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Z.call(b, prop))
      __defNormalProp$Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$Z)
    for (var prop of __getOwnPropSymbols$Z(b)) {
      if (__propIsEnum$Z.call(b, prop))
        __defNormalProp$Z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$p = (a, b) => __defProps$p(a, __getOwnPropDescs$p(b));
const sizes$8 = {
  xs: {
    height: sizes$b.xs,
    padding: "0 14px"
  },
  sm: {
    height: sizes$b.sm,
    padding: "0 18px"
  },
  md: {
    height: sizes$b.md,
    padding: "0 22px"
  },
  lg: {
    height: sizes$b.lg,
    padding: "0 26px"
  },
  xl: {
    height: sizes$b.xl,
    padding: "0 32px"
  },
  "compact-xs": {
    height: 22,
    padding: "0 7px"
  },
  "compact-sm": {
    height: 26,
    padding: "0 8px"
  },
  "compact-md": {
    height: 30,
    padding: "0 10px"
  },
  "compact-lg": {
    height: 34,
    padding: "0 12px"
  },
  "compact-xl": {
    height: 40,
    padding: "0 14px"
  }
};
const heights = Object.keys(sizes$8).reduce((acc, size) => {
  acc[size] = sizes$8[size].height;
  return acc;
}, {});
const getSizeStyles = ({ compact, size }) => {
  if (!compact) {
    return sizes$8[size];
  }
  return sizes$8[`compact-${size}`];
};
const getWidthStyles = (fullWidth) => ({
  display: fullWidth ? "block" : "inline-block",
  width: fullWidth ? "100%" : "auto"
});
function getVariantStyles({ variant, theme, color }) {
  const colors = theme.fn.variant({ color, variant });
  return __spreadValues$Z({
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.background,
    backgroundImage: colors.background,
    color: colors.color
  }, theme.fn.hover({
    backgroundColor: colors.hover
  }));
}
var useStyles$1i = createStyles((theme, {
  color,
  size,
  radius,
  fullWidth,
  compact,
  gradientFrom,
  gradientTo,
  gradientDeg
}, getRef) => {
  const gradient = theme.fn.variant({
    color,
    variant: "gradient",
    gradient: { from: gradientFrom, to: gradientTo, deg: gradientDeg }
  });
  return {
    loading: {
      ref: getRef("loading"),
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: theme.fn.radius(radius),
        cursor: "not-allowed"
      }
    },
    outline: getVariantStyles({ variant: "outline", theme, color }),
    filled: getVariantStyles({ variant: "filled", theme, color }),
    light: getVariantStyles({ variant: "light", theme, color }),
    default: getVariantStyles({ variant: "default", theme, color }),
    white: getVariantStyles({ variant: "white", theme, color }),
    subtle: getVariantStyles({ variant: "subtle", theme, color }),
    gradient: {
      border: 0,
      backgroundImage: gradient.background,
      color: gradient.color,
      "&:hover": theme.fn.hover({
        backgroundSize: "200%"
      })
    },
    root: __spreadProps$p(__spreadValues$Z(__spreadValues$Z(__spreadValues$Z(__spreadValues$Z({}, getSizeStyles({ compact, size })), theme.fn.fontStyles()), theme.fn.focusStyles()), getWidthStyles(fullWidth)), {
      borderRadius: theme.fn.radius(radius),
      fontWeight: 600,
      position: "relative",
      lineHeight: 1,
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      WebkitTapHighlightColor: "transparent",
      userSelect: "none",
      boxSizing: "border-box",
      textDecoration: "none",
      cursor: "pointer",
      appearance: "none",
      WebkitAppearance: "none",
      "&:not(:disabled):active": {
        transform: "translateY(1px)"
      },
      [`&:not(.${getRef("loading")}):disabled`]: {
        borderColor: "transparent",
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5],
        cursor: "not-allowed"
      }
    }),
    icon: {
      display: "flex",
      alignItems: "center"
    },
    leftIcon: {
      marginRight: 10
    },
    rightIcon: {
      marginLeft: 10
    },
    inner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      overflow: "visible"
    },
    label: {
      whiteSpace: "nowrap",
      height: "100%",
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    }
  };
});

var useStyles$1j = useStyles$1i;

var __defProp$Y = Object.defineProperty;
var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Y = (obj, key, value) => key in obj ? __defProp$Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Y.call(b, prop))
      __defNormalProp$Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(b)) {
      if (__propIsEnum$Y.call(b, prop))
        __defNormalProp$Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$q = {
  size: "sm",
  type: "button",
  variant: "filled",
  loaderPosition: "left",
  gradient: { from: "blue", to: "cyan", deg: 45 }
};
const Button$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Button", defaultProps$q, props), {
    className,
    size,
    color,
    type,
    disabled,
    children,
    leftIcon,
    rightIcon,
    fullWidth,
    variant,
    radius,
    component,
    uppercase,
    compact,
    loading,
    loaderPosition,
    loaderProps,
    gradient,
    classNames,
    styles
  } = _a, others = __objRest$G(_a, [
    "className",
    "size",
    "color",
    "type",
    "disabled",
    "children",
    "leftIcon",
    "rightIcon",
    "fullWidth",
    "variant",
    "radius",
    "component",
    "uppercase",
    "compact",
    "loading",
    "loaderPosition",
    "loaderProps",
    "gradient",
    "classNames",
    "styles"
  ]);
  const { classes, cx, theme } = useStyles$1j({
    radius,
    color,
    size,
    fullWidth,
    compact,
    gradientFrom: gradient.from,
    gradientTo: gradient.to,
    gradientDeg: gradient.deg
  }, { classNames, styles, name: "Button" });
  const colors = theme.fn.variant({ color, variant });
  const loader = /* @__PURE__ */ React__default.createElement(Loader$1, __spreadValues$Y({
    color: colors.color,
    size: theme.fn.size({ size, sizes: heights }) / 2
  }, loaderProps));
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$Y({
    component: component || "button",
    className: cx(classes[variant], { [classes.loading]: loading }, classes.root, className),
    type,
    disabled: disabled || loading,
    ref,
    onTouchStart: () => {
    }
  }, others), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.inner
  }, (leftIcon || loading && loaderPosition === "left") && /* @__PURE__ */ React__default.createElement("span", {
    className: cx(classes.icon, classes.leftIcon)
  }, loading && loaderPosition === "left" ? loader : leftIcon), /* @__PURE__ */ React__default.createElement("span", {
    className: classes.label,
    style: { textTransform: uppercase ? "uppercase" : void 0 }
  }, children), (rightIcon || loading && loaderPosition === "right") && /* @__PURE__ */ React__default.createElement("span", {
    className: cx(classes.icon, classes.rightIcon)
  }, loading && loaderPosition === "right" ? loader : rightIcon)));
});
Button$1.displayName = "@mantine/core/Button";

var __defProp$X = Object.defineProperty;
var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
var __hasOwnProp$X = Object.prototype.hasOwnProperty;
var __propIsEnum$X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$X = (obj, key, value) => key in obj ? __defProp$X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$X.call(b, prop))
      __defNormalProp$X(a, prop, b[prop]);
  if (__getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(b)) {
      if (__propIsEnum$X.call(b, prop))
        __defNormalProp$X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function CheckboxIcon(_a) {
  var _b = _a, { indeterminate } = _b, others = __objRest$F(_b, ["indeterminate"]);
  if (indeterminate) {
    return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$X({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 6"
    }, others), /* @__PURE__ */ React__default.createElement("rect", {
      width: "32",
      height: "6",
      fill: "currentColor",
      rx: "3"
    }));
  }
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$X({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, others), /* @__PURE__ */ React__default.createElement("path", {
    d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}

var __defProp$W = Object.defineProperty;
var __defProps$o = Object.defineProperties;
var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
var __hasOwnProp$W = Object.prototype.hasOwnProperty;
var __propIsEnum$W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$W = (obj, key, value) => key in obj ? __defProp$W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$W.call(b, prop))
      __defNormalProp$W(a, prop, b[prop]);
  if (__getOwnPropSymbols$W)
    for (var prop of __getOwnPropSymbols$W(b)) {
      if (__propIsEnum$W.call(b, prop))
        __defNormalProp$W(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$o = (a, b) => __defProps$o(a, __getOwnPropDescs$o(b));
const sizes$7 = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 30,
  xl: 36
};
const iconSizes$3 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 16,
  xl: 20
};
var useStyles$1g = createStyles((theme, { size, radius, color, transitionDuration }, getRef) => {
  const _size = theme.fn.size({ size, sizes: sizes$7 });
  const colors = theme.fn.variant({ variant: "filled", color });
  return {
    icon: {
      ref: getRef("icon"),
      color: theme.white,
      transform: "translateY(5px) scale(0.5)",
      opacity: 0,
      transitionProperty: "opacity, transform",
      transitionTimingFunction: "ease",
      transitionDuration: `${transitionDuration}ms`,
      pointerEvents: "none",
      width: theme.fn.size({ size, sizes: iconSizes$3 }),
      position: "absolute",
      zIndex: 1,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      "@media (prefers-reduced-motion)": {
        transitionDuration: "0ms"
      }
    },
    root: {
      display: "flex",
      alignItems: "center"
    },
    inner: {
      position: "relative",
      width: _size,
      height: _size
    },
    label: __spreadProps$o(__spreadValues$W({}, theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      paddingLeft: theme.spacing.sm,
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      lineHeight: `${_size}px`,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    }),
    input: __spreadProps$o(__spreadValues$W({}, theme.fn.focusStyles()), {
      appearance: "none",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.white,
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
      width: _size,
      height: _size,
      borderRadius: theme.fn.radius(radius),
      padding: 0,
      display: "block",
      margin: 0,
      transition: `border-color ${transitionDuration}ms ease, background-color ${transitionDuration}ms ease`,
      "&:checked": {
        backgroundColor: colors.background,
        borderColor: colors.background,
        [`& + .${getRef("icon")}`]: {
          opacity: 1,
          transform: "translateY(0) scale(1)"
        }
      },
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[3],
        cursor: "not-allowed",
        [`& + .${getRef("icon")}`]: {
          color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5]
        }
      }
    })
  };
});

var useStyles$1h = useStyles$1g;

var __defProp$V = Object.defineProperty;
var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
var __hasOwnProp$V = Object.prototype.hasOwnProperty;
var __propIsEnum$V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$V = (obj, key, value) => key in obj ? __defProp$V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$V.call(b, prop))
      __defNormalProp$V(a, prop, b[prop]);
  if (__getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(b)) {
      if (__propIsEnum$V.call(b, prop))
        __defNormalProp$V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$p = {
  size: "sm",
  __staticSelector: "Checkbox",
  transitionDuration: 100,
  icon: CheckboxIcon
};
const Checkbox$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Checkbox", defaultProps$p, props), {
    className,
    style,
    sx,
    checked,
    color,
    label,
    indeterminate,
    id,
    size,
    radius,
    wrapperProps,
    children,
    classNames,
    styles,
    transitionDuration,
    icon: Icon,
    __staticSelector
  } = _a, others = __objRest$E(_a, [
    "className",
    "style",
    "sx",
    "checked",
    "color",
    "label",
    "indeterminate",
    "id",
    "size",
    "radius",
    "wrapperProps",
    "children",
    "classNames",
    "styles",
    "transitionDuration",
    "icon",
    "__staticSelector"
  ]);
  const uuid = useUuid(id);
  const { systemStyles, rest } = extractSystemStyles(others);
  const { classes, cx } = useStyles$1h({ size, radius, color, transitionDuration }, { classNames, styles, name: __staticSelector });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$V(__spreadValues$V({
    className: cx(classes.root, className),
    style,
    sx
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.inner
  }, /* @__PURE__ */ React__default.createElement("input", __spreadValues$V({
    id: uuid,
    ref,
    type: "checkbox",
    className: classes.input,
    checked: indeterminate || checked
  }, rest)), /* @__PURE__ */ React__default.createElement(Icon, {
    indeterminate,
    className: classes.icon
  })), label && /* @__PURE__ */ React__default.createElement("label", {
    className: classes.label,
    htmlFor: uuid
  }, label));
});
Checkbox$1.displayName = "@mantine/core/Checkbox";

const POSITIONS = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  apart: "space-between"
};
var useStyles$1e = createStyles((theme, { spacing, position, noWrap, direction, grow, align, count }) => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: direction,
    alignItems: align || (direction === "row" ? "center" : grow ? "stretch" : position === "apart" ? "flex-start" : POSITIONS[position]),
    flexWrap: noWrap ? "nowrap" : "wrap",
    justifyContent: direction === "row" ? POSITIONS[position] : void 0,
    gap: theme.fn.size({ size: spacing, sizes: theme.spacing })
  },
  child: {
    boxSizing: "border-box",
    maxWidth: grow && direction === "row" ? `calc(${100 / count}% - ${theme.fn.size({ size: spacing, sizes: theme.spacing }) - theme.fn.size({ size: spacing, sizes: theme.spacing }) / count}px)` : void 0,
    flexGrow: grow ? 1 : 0
  }
}));

var useStyles$1f = useStyles$1e;

var __defProp$U = Object.defineProperty;
var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
var __hasOwnProp$U = Object.prototype.hasOwnProperty;
var __propIsEnum$U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$U = (obj, key, value) => key in obj ? __defProp$U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$U.call(b, prop))
      __defNormalProp$U(a, prop, b[prop]);
  if (__getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(b)) {
      if (__propIsEnum$U.call(b, prop))
        __defNormalProp$U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$o = {
  position: "left",
  spacing: "md",
  direction: "row"
};
const Group = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Group", defaultProps$o, props), {
    className,
    position,
    align,
    children,
    noWrap,
    grow,
    spacing,
    direction,
    classNames,
    styles
  } = _a, others = __objRest$D(_a, [
    "className",
    "position",
    "align",
    "children",
    "noWrap",
    "grow",
    "spacing",
    "direction",
    "classNames",
    "styles"
  ]);
  const filteredChildren = filterFalsyChildren(children);
  const { classes, cx } = useStyles$1f({
    align,
    grow,
    noWrap,
    spacing,
    position,
    direction,
    count: filteredChildren.length
  }, { classNames, styles, name: "Group" });
  const items = filteredChildren.map((child) => {
    var _a2;
    if (typeof child === "object" && child !== null && "props" in child) {
      return React__default.cloneElement(child, {
        className: cx(classes.child, (_a2 = child.props) == null ? void 0 : _a2.className)
      });
    }
    return child;
  });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$U({
    className: cx(classes.root, className),
    ref
  }, others), items);
});
Group.displayName = "@mantine/core/Group";

var useStyles$1c = createStyles((theme, { fluid, size, sizes }) => ({
  root: {
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    maxWidth: fluid ? "100%" : theme.fn.size({ size, sizes }),
    marginLeft: "auto",
    marginRight: "auto"
  }
}));

var useStyles$1d = useStyles$1c;

var __defProp$T = Object.defineProperty;
var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
var __hasOwnProp$T = Object.prototype.hasOwnProperty;
var __propIsEnum$T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$T = (obj, key, value) => key in obj ? __defProp$T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$T.call(b, prop))
      __defNormalProp$T(a, prop, b[prop]);
  if (__getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(b)) {
      if (__propIsEnum$T.call(b, prop))
        __defNormalProp$T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$n = {
  sizes: {
    xs: 540,
    sm: 720,
    md: 960,
    lg: 1140,
    xl: 1320
  }
};
const Container = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Container", defaultProps$n, props), { className, fluid, size, styles, classNames, sizes } = _a, others = __objRest$C(_a, ["className", "fluid", "size", "styles", "classNames", "sizes"]);
  const { classes, cx } = useStyles$1d({ fluid, size, sizes }, { styles, classNames, name: "Container" });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$T({
    className: cx(classes.root, className),
    ref
  }, others));
});
Container.displayName = "@mantine/core/Container";

var __defProp$S = Object.defineProperty;
var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
var __hasOwnProp$S = Object.prototype.hasOwnProperty;
var __propIsEnum$S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$S = (obj, key, value) => key in obj ? __defProp$S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$S.call(b, prop))
      __defNormalProp$S(a, prop, b[prop]);
  if (__getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(b)) {
      if (__propIsEnum$S.call(b, prop))
        __defNormalProp$S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function OptionalPortal(_a) {
  var _b = _a, { withinPortal = true, children } = _b, others = __objRest$B(_b, ["withinPortal", "children"]);
  if (withinPortal) {
    return /* @__PURE__ */ React__default.createElement(Portal, __spreadValues$S({}, others), children);
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
}
OptionalPortal.displayName = "@mantine/core/OptionalPortal";

function GroupedTransition({
  transitions,
  duration = 250,
  exitDuration = duration,
  mounted,
  children,
  timingFunction,
  onExit,
  onEntered,
  onEnter,
  onExited
}) {
  const { transitionDuration, transitionStatus, transitionTimingFunction } = useTransition({
    mounted,
    duration,
    exitDuration,
    timingFunction,
    onExit,
    onEntered,
    onEnter,
    onExited
  });
  if (transitionDuration === 0) {
    return mounted ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children({})) : null;
  }
  if (transitionStatus === "exited") {
    return null;
  }
  const transitionsStyles = Object.keys(transitions).reduce((acc, transition) => {
    acc[transition] = getTransitionStyles({
      duration: transitions[transition].duration,
      transition: transitions[transition].transition,
      timingFunction: transitions[transition].timingFunction || transitionTimingFunction,
      state: transitionStatus
    });
    return acc;
  }, {});
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children(transitionsStyles));
}
GroupedTransition.displayName = "@mantine/core/GroupedTransition";

var __defProp$R = Object.defineProperty;
var __defProps$n = Object.defineProperties;
var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
var __hasOwnProp$R = Object.prototype.hasOwnProperty;
var __propIsEnum$R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$R = (obj, key, value) => key in obj ? __defProp$R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$R.call(b, prop))
      __defNormalProp$R(a, prop, b[prop]);
  if (__getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(b)) {
      if (__propIsEnum$R.call(b, prop))
        __defNormalProp$R(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$n = (a, b) => __defProps$n(a, __getOwnPropDescs$n(b));
var __objRest$A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$m = {
  opacity: 0.6,
  color: "#fff",
  zIndex: getDefaultZIndex("modal"),
  radius: 0,
  blur: 0
};
const Overlay = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Overlay", defaultProps$m, props), { opacity, blur, color, gradient, zIndex, component, radius, sx } = _a, others = __objRest$A(_a, ["opacity", "blur", "color", "gradient", "zIndex", "component", "radius", "sx"]);
  const background = gradient ? { backgroundImage: gradient } : { backgroundColor: color };
  const baseStyles = {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex
  };
  const innerOverlay = (otherProps) => /* @__PURE__ */ React__default.createElement(Box, __spreadValues$R({
    component: component || "div",
    ref,
    sx: [
      (theme) => __spreadProps$n(__spreadValues$R(__spreadValues$R({}, background), baseStyles), {
        opacity,
        borderRadius: theme.fn.size({ size: radius, sizes: theme.radius })
      }),
      ...Array.isArray(sx) ? sx : [sx]
    ]
  }, otherProps));
  if (blur) {
    return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$R({
      sx: [
        () => __spreadProps$n(__spreadValues$R({}, baseStyles), {
          backdropFilter: `blur(${blur}px)`
        }),
        ...Array.isArray(sx) ? sx : [sx]
      ]
    }, others), innerOverlay());
  }
  return innerOverlay(others);
});
Overlay.displayName = "@mantine/core/Overlay";

const [GridProvider, useGridContext] = createUseContext(null);

var __defProp$Q = Object.defineProperty;
var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Q = (obj, key, value) => key in obj ? __defProp$Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Q.call(b, prop))
      __defNormalProp$Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(b)) {
      if (__propIsEnum$Q.call(b, prop))
        __defNormalProp$Q(a, prop, b[prop]);
    }
  return a;
};
const getColumnWidth = (colSpan, columns) => `${100 / (columns / colSpan)}%`;
const getColumnOffset = (offset, columns) => offset ? `${100 / (columns / offset)}%` : void 0;
function getBreakpointsStyles({
  sizes,
  offsets,
  theme,
  columns,
  grow
}) {
  return MANTINE_SIZES.reduce((acc, size) => {
    if (typeof sizes[size] === "number") {
      acc[`@media (min-width: ${theme.breakpoints[size] + 1}px)`] = {
        flexBasis: getColumnWidth(sizes[size], columns),
        flexShrink: 0,
        maxWidth: grow ? "unset" : getColumnWidth(sizes[size], columns),
        marginLeft: getColumnOffset(offsets[size], columns)
      };
    }
    return acc;
  }, {});
}
var useStyles$1a = createStyles((theme, {
  gutter,
  grow,
  offset,
  offsetXs,
  offsetSm,
  offsetMd,
  offsetLg,
  offsetXl,
  columns,
  span,
  xs,
  sm,
  md,
  lg,
  xl
}) => ({
  root: __spreadValues$Q({
    boxSizing: "border-box",
    flexGrow: grow ? 1 : 0,
    padding: theme.fn.size({ size: gutter, sizes: theme.spacing }) / 2,
    marginLeft: getColumnOffset(offset, columns),
    flexBasis: getColumnWidth(span, columns),
    flexShrink: 0,
    maxWidth: grow ? "unset" : getColumnWidth(span, columns)
  }, getBreakpointsStyles({
    sizes: { xs, sm, md, lg, xl },
    offsets: { xs: offsetXs, sm: offsetSm, md: offsetMd, lg: offsetLg, xl: offsetXl },
    theme,
    columns,
    grow
  }))
}));

var useStyles$1b = useStyles$1a;

var __defProp$P = Object.defineProperty;
var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
var __hasOwnProp$P = Object.prototype.hasOwnProperty;
var __propIsEnum$P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$P = (obj, key, value) => key in obj ? __defProp$P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$P.call(b, prop))
      __defNormalProp$P(a, prop, b[prop]);
  if (__getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(b)) {
      if (__propIsEnum$P.call(b, prop))
        __defNormalProp$P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$l = {
  offset: 0,
  offsetXs: 0,
  offsetSm: 0,
  offsetMd: 0,
  offsetLg: 0,
  offsetXl: 0
};
function isValidSpan(span) {
  return typeof span === "number" && span > 0 && span % 1 === 0;
}
const Col = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Col", defaultProps$l, props), {
    children,
    span,
    offset,
    offsetXs,
    offsetSm,
    offsetMd,
    offsetLg,
    offsetXl,
    xs,
    sm,
    md,
    lg,
    xl,
    className,
    classNames,
    styles,
    id
  } = _a, others = __objRest$z(_a, [
    "children",
    "span",
    "offset",
    "offsetXs",
    "offsetSm",
    "offsetMd",
    "offsetLg",
    "offsetXl",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "className",
    "classNames",
    "styles",
    "id"
  ]);
  const { columns, gutter, grow } = useGridContext("Grid.Col");
  const colSpan = span || columns;
  const { classes, cx } = useStyles$1b({
    gutter,
    offset,
    offsetXs,
    offsetSm,
    offsetMd,
    offsetLg,
    offsetXl,
    xs,
    sm,
    md,
    lg,
    xl,
    grow,
    columns,
    span: colSpan
  }, { classNames, styles, name: "Col" });
  if (!isValidSpan(colSpan) || colSpan > columns) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$P({
    className: cx(classes.root, className),
    ref
  }, others), children);
});
Col.displayName = "@mantine/core/Col";

var useStyles$18 = createStyles((theme, { justify, align, gutter }) => ({
  root: {
    margin: -theme.fn.size({ size: gutter, sizes: theme.spacing }) / 2,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: justify,
    alignItems: align
  }
}));

var useStyles$19 = useStyles$18;

var __defProp$O = Object.defineProperty;
var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
var __hasOwnProp$O = Object.prototype.hasOwnProperty;
var __propIsEnum$O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$O = (obj, key, value) => key in obj ? __defProp$O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$O.call(b, prop))
      __defNormalProp$O(a, prop, b[prop]);
  if (__getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(b)) {
      if (__propIsEnum$O.call(b, prop))
        __defNormalProp$O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$k = {
  gutter: "md",
  justify: "flex-start",
  align: "stretch",
  columns: 12
};
const Grid = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Grid", defaultProps$k, props), {
    gutter,
    children,
    grow,
    justify,
    align,
    columns,
    className,
    classNames,
    styles,
    id
  } = _a, others = __objRest$y(_a, [
    "gutter",
    "children",
    "grow",
    "justify",
    "align",
    "columns",
    "className",
    "classNames",
    "styles",
    "id"
  ]);
  const { classes, cx } = useStyles$19({ gutter, justify, align }, { classNames, styles, name: "Grid" });
  return /* @__PURE__ */ React__default.createElement(GridProvider, {
    value: { gutter, grow, columns }
  }, /* @__PURE__ */ React__default.createElement(Box, __spreadValues$O({
    className: cx(classes.root, className),
    ref
  }, others), children));
});
Grid.Col = Col;
Grid.displayName = "@mantine/core/Grid";

var __defProp$N = Object.defineProperty;
var __defProps$m = Object.defineProperties;
var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
var __hasOwnProp$N = Object.prototype.hasOwnProperty;
var __propIsEnum$N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$N = (obj, key, value) => key in obj ? __defProp$N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$N.call(b, prop))
      __defNormalProp$N(a, prop, b[prop]);
  if (__getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(b)) {
      if (__propIsEnum$N.call(b, prop))
        __defNormalProp$N(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$m = (a, b) => __defProps$m(a, __getOwnPropDescs$m(b));
function getPositionStyles(_position, offset = 0) {
  const styles = {};
  const [position, placement] = _position.split("-");
  let translateX = "";
  let translateY = "";
  if (position === "top") {
    styles.top = offset;
    translateY = "-50%";
  }
  if (position === "middle") {
    styles.top = "50%";
    translateY = "-50%";
  }
  if (position === "bottom") {
    styles.bottom = offset;
    translateY = "50%";
  }
  if (placement === "start") {
    styles.left = offset;
    translateX = "-50%";
  }
  if (placement === "center") {
    styles.left = "50%";
    translateX = "-50%";
  }
  if (placement === "end") {
    styles.right = offset;
    translateX = "50%";
  }
  styles.transform = `translate(${translateX}, ${translateY})`;
  return styles;
}
var useStyles$16 = createStyles((theme, {
  radius,
  size,
  color,
  position,
  offset,
  inline,
  withBorder,
  withLabel,
  zIndex
}) => ({
  root: {
    position: "relative",
    display: inline ? "inline-block" : "block"
  },
  indicator: __spreadProps$m(__spreadValues$N({}, getPositionStyles(position, offset)), {
    zIndex,
    position: "absolute",
    [withLabel ? "minWidth" : "width"]: size,
    height: size,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: theme.fontSizes.xs,
    paddingLeft: withLabel ? theme.spacing.xs / 2 : 0,
    paddingRight: withLabel ? theme.spacing.xs / 2 : 0,
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
    backgroundColor: theme.fn.themeColor(color || theme.primaryColor, theme.fn.primaryShade(), false),
    border: withBorder ? `2px solid ${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white}` : void 0,
    color: theme.white,
    whiteSpace: "nowrap"
  })
}));

var useStyles$17 = useStyles$16;

var __defProp$M = Object.defineProperty;
var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
var __hasOwnProp$M = Object.prototype.hasOwnProperty;
var __propIsEnum$M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$M = (obj, key, value) => key in obj ? __defProp$M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$M.call(b, prop))
      __defNormalProp$M(a, prop, b[prop]);
  if (__getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(b)) {
      if (__propIsEnum$M.call(b, prop))
        __defNormalProp$M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$j = {
  position: "top-end",
  offset: 0,
  inline: false,
  withBorder: false,
  disabled: false,
  size: 10,
  radius: 1e3,
  zIndex: getDefaultZIndex("app")
};
const Indicator = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Indicator", defaultProps$j, props), {
    children,
    position,
    offset,
    size,
    radius,
    inline,
    withBorder,
    className,
    color,
    styles,
    label,
    classNames,
    disabled,
    zIndex
  } = _a, others = __objRest$x(_a, [
    "children",
    "position",
    "offset",
    "size",
    "radius",
    "inline",
    "withBorder",
    "className",
    "color",
    "styles",
    "label",
    "classNames",
    "disabled",
    "zIndex"
  ]);
  const { classes, cx } = useStyles$17({ position, offset, size, radius, inline, color, withBorder, zIndex, withLabel: !!label }, { name: "Indicator", classNames, styles });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$M({
    ref,
    className: cx(classes.root, className)
  }, others), !disabled && /* @__PURE__ */ React__default.createElement("div", {
    className: classes.indicator
  }, label), children);
});
Indicator.displayName = "@mantine/core/Indicator";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var index$1 = typeof document !== 'undefined' ? useLayoutEffect$1 : useEffect;

var useLatest = function useLatest(value) {
  var ref = React.useRef(value);
  index$1(function () {
    ref.current = value;
  });
  return ref;
};

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  ref.current = value;
};

var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = useRef();
  return useCallback(function (instance) {
    libRef.current = instance;

    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }

    prevUserRef.current = userRef;

    if (!userRef) {
      return;
    }

    updateRef(userRef, instance);
  }, [userRef]);
};

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259

var hiddenTextarea = null;

var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;

  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  } // remove padding, since height = content


  return height - sizingData.paddingSize;
};

function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }

  if (maxRows === void 0) {
    maxRows = Infinity;
  }

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  var paddingSize = sizingData.paddingSize,
      borderSize = sizingData.borderSize,
      sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData); // measure height of a textarea with a single row

  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;

  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }

  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;

  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }

  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}

var noop = function noop() {};
var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};

var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', // non-standard
'tabSize', 'textIndent', // non-standard
'textRendering', 'textTransform', 'width', 'wordBreak'];
var isIE = typeof document !== 'undefined' ? !!document.documentElement.currentStyle : false;

var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};

var useWindowResizeListener = function useWindowResizeListener(listener) {
  var latestListener = useLatest(listener);
  useLayoutEffect$1(function () {
    var handler = function handler(event) {
      latestListener.current(event);
    };

    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, []);
};

var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
      maxRows = _ref.maxRows,
      minRows = _ref.minRows,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onHeightChange = _ref.onHeightChange,
      onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange,
      props = _objectWithoutPropertiesLoose(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);

  if (process.env.NODE_ENV !== 'production' && props.style) {
    if ('maxHeight' in props.style) {
      throw new Error('Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.');
    }

    if ('minHeight' in props.style) {
      throw new Error('Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.');
    }
  }

  var isControlled = props.value !== undefined;
  var libRef = useRef(null);
  var ref = useComposedRef(libRef, userRef);
  var heightRef = useRef(0);
  var measurementsCacheRef = useRef();

  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);

    if (!nodeSizingData) {
      return;
    }

    measurementsCacheRef.current = nodeSizingData;

    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
        height = _calculateNodeHeight[0],
        rowHeight = _calculateNodeHeight[1];

    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }

    onChange(event);
  };

  if (typeof document !== 'undefined') {
    useLayoutEffect$1(resizeTextarea);
    useWindowResizeListener(resizeTextarea);
  }

  return /*#__PURE__*/createElement("textarea", _extends({}, props, {
    onChange: handleChange,
    ref: ref
  }));
};

var index = /* #__PURE__ */forwardRef(TextareaAutosize);

var TextareaAutosize$1 = index;

var useStyles$14 = createStyles((theme) => ({
  input: {
    paddingTop: theme.spacing.xs,
    paddingBottom: theme.spacing.xs
  }
}));

var useStyles$15 = useStyles$14;

var __defProp$L = Object.defineProperty;
var __defProps$l = Object.defineProperties;
var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
var __hasOwnProp$L = Object.prototype.hasOwnProperty;
var __propIsEnum$L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$L = (obj, key, value) => key in obj ? __defProp$L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$L.call(b, prop))
      __defNormalProp$L(a, prop, b[prop]);
  if (__getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(b)) {
      if (__propIsEnum$L.call(b, prop))
        __defNormalProp$L(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$l = (a, b) => __defProps$l(a, __getOwnPropDescs$l(b));
var __objRest$w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$i = {
  autosize: false,
  size: "sm",
  __staticSelector: "Textarea"
};
const Textarea = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Textarea", defaultProps$i, props), {
    autosize,
    maxRows,
    minRows,
    label,
    error,
    description,
    id,
    className,
    required,
    style,
    wrapperProps,
    classNames,
    styles,
    size,
    __staticSelector,
    sx,
    errorProps,
    descriptionProps,
    labelProps
  } = _a, others = __objRest$w(_a, [
    "autosize",
    "maxRows",
    "minRows",
    "label",
    "error",
    "description",
    "id",
    "className",
    "required",
    "style",
    "wrapperProps",
    "classNames",
    "styles",
    "size",
    "__staticSelector",
    "sx",
    "errorProps",
    "descriptionProps",
    "labelProps"
  ]);
  const uuid = useUuid(id);
  const { classes, cx } = useStyles$15();
  const { systemStyles, rest } = extractSystemStyles(others);
  const sharedProps = __spreadValues$L({
    required,
    ref,
    invalid: !!error,
    id: uuid,
    classNames: __spreadProps$l(__spreadValues$L({}, classNames), { input: cx(classes.input, classNames == null ? void 0 : classNames.input) }),
    styles,
    __staticSelector,
    size,
    multiline: true
  }, rest);
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$L(__spreadValues$L({
    label,
    error,
    id: uuid,
    description,
    required,
    style,
    className,
    classNames,
    styles,
    size,
    __staticSelector,
    sx,
    errorProps,
    labelProps,
    descriptionProps
  }, systemStyles), wrapperProps), autosize ? /* @__PURE__ */ React__default.createElement(Input$1, __spreadProps$l(__spreadValues$L({}, sharedProps), {
    component: TextareaAutosize$1,
    maxRows,
    minRows
  })) : /* @__PURE__ */ React__default.createElement(Input$1, __spreadProps$l(__spreadValues$L({}, sharedProps), {
    component: "textarea",
    rows: minRows
  })));
});
Textarea.displayName = "@mantine/core/Textarea";

var useStyles$12 = createStyles((theme, { smallerThan, largerThan, query, styles }) => {
  const media = {};
  const minWidth = theme.fn.size({ size: largerThan, sizes: theme.breakpoints }) + 1;
  const maxWidth = theme.fn.size({ size: smallerThan, sizes: theme.breakpoints });
  if (largerThan !== void 0 && smallerThan !== void 0) {
    media[`@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`] = styles;
  } else {
    if (largerThan !== void 0) {
      media[`@media (min-width: ${theme.fn.size({ size: largerThan, sizes: theme.breakpoints }) + 1}px)`] = styles;
    }
    if (smallerThan !== void 0) {
      media[`@media (max-width: ${theme.fn.size({ size: smallerThan, sizes: theme.breakpoints })}px)`] = styles;
    }
  }
  if (query) {
    media[`@media ${query}`] = styles;
  }
  return { media };
});

var useStyles$13 = useStyles$12;

function MediaQuery(props) {
  var _a;
  const { children, smallerThan, largerThan, query, styles, className } = useMantineDefaultProps("MediaQuery", {}, props);
  const { classes, cx } = useStyles$13({ smallerThan, largerThan, query, styles }, { name: "MediaQuery" });
  const child = Children.only(children);
  if (typeof child === "object" && child !== null && "props" in child) {
    return React__default.cloneElement(child, {
      className: cx(classes.media, (_a = child.props) == null ? void 0 : _a.className, className)
    });
  }
  return child;
}
MediaQuery.displayName = "@mantine/core/MediaQuery";

var __defProp$K = Object.defineProperty;
var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
var __hasOwnProp$K = Object.prototype.hasOwnProperty;
var __propIsEnum$K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$K = (obj, key, value) => key in obj ? __defProp$K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$K.call(b, prop))
      __defNormalProp$K(a, prop, b[prop]);
  if (__getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(b)) {
      if (__propIsEnum$K.call(b, prop))
        __defNormalProp$K(a, prop, b[prop]);
    }
  return a;
};
function MenuIcon(props) {
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$K({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React__default.createElement("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}

const [MenuProvider, useMenuContext] = createUseContext(null);

var __defProp$J = Object.defineProperty;
var __defProps$k = Object.defineProperties;
var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
var __hasOwnProp$J = Object.prototype.hasOwnProperty;
var __propIsEnum$J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$J = (obj, key, value) => key in obj ? __defProp$J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$J.call(b, prop))
      __defNormalProp$J(a, prop, b[prop]);
  if (__getOwnPropSymbols$J)
    for (var prop of __getOwnPropSymbols$J(b)) {
      if (__propIsEnum$J.call(b, prop))
        __defNormalProp$J(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$k = (a, b) => __defProps$k(a, __getOwnPropDescs$k(b));
var useStyles$10 = createStyles((theme, { radius, color }) => ({
  item: __spreadProps$k(__spreadValues$J({}, theme.fn.fontStyles()), {
    WebkitTapHighlightColor: "transparent",
    fontSize: theme.fontSizes.sm,
    border: 0,
    backgroundColor: "transparent",
    outline: 0,
    width: "100%",
    textAlign: "left",
    display: "inline-block",
    textDecoration: "none",
    boxSizing: "border-box",
    padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
    cursor: "pointer",
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
    color: color ? theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : 7) : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    "&:disabled": {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
      pointerEvents: "none"
    }
  }),
  itemHovered: theme.fn.hover({
    backgroundColor: color ? theme.fn.variant({ variant: "light", color }).background : theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[3], 0.35) : theme.colors.gray[0]
  }),
  itemInner: {
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  itemBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flex: 1
  },
  itemIcon: {
    marginRight: theme.spacing.xs,
    "& *": {
      display: "block"
    }
  },
  itemLabel: {
    lineHeight: 1
  }
}));

var useStyles$11 = useStyles$10;

var __defProp$I = Object.defineProperty;
var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
var __hasOwnProp$I = Object.prototype.hasOwnProperty;
var __propIsEnum$I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$I = (obj, key, value) => key in obj ? __defProp$I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$I.call(b, prop))
      __defNormalProp$I(a, prop, b[prop]);
  if (__getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(b)) {
      if (__propIsEnum$I.call(b, prop))
        __defNormalProp$I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const _MenuItem = forwardRef((_a, ref) => {
  var _b = _a, {
    className,
    children,
    icon,
    color,
    disabled,
    rightSection,
    component,
    onClick
  } = _b, others = __objRest$v(_b, [
    "className",
    "children",
    "icon",
    "color",
    "disabled",
    "rightSection",
    "component",
    "onClick"
  ]);
  const itemRef = useRef();
  const { hovered, onItemHover, radius, onItemKeyDown, classNames, styles, onItemClick } = useMenuContext("Menu.Item");
  const { classes, cx } = useStyles$11({ color, radius }, { classNames, styles, name: "Menu" });
  const itemIndex = getContextItemIndex({ elementSelector: ".mantine-Menu-item", parentClassName: "mantine-Menu-body" }, itemRef.current);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$I({
    component: component || "button",
    type: "button",
    role: "menuitem",
    className: cx(classes.item, { [classes.itemHovered]: hovered === itemIndex }, className),
    onMouseEnter: () => !disabled && onItemHover(itemIndex),
    onMouseLeave: () => onItemHover(-1),
    onKeyDown: onItemKeyDown,
    ref: mergeRefs(ref, itemRef),
    disabled,
    onClick: (event) => {
      typeof onClick === "function" && onClick(event);
      onItemClick();
    }
  }, others), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.itemInner
  }, icon && /* @__PURE__ */ React__default.createElement("div", {
    className: classes.itemIcon
  }, icon), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.itemBody
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classes.itemLabel
  }, children), rightSection)));
});
const MenuItem = _MenuItem;
MenuItem.displayName = "@mantine/core/MenuItem";

var useStyles$_ = createStyles((theme) => ({
  label: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
    fontWeight: 500,
    fontSize: theme.fontSizes.xs,
    padding: `${theme.spacing.xs / 2}px ${theme.spacing.sm}px`,
    cursor: "default"
  }
}));

var useStyles$$ = useStyles$_;

var __defProp$H = Object.defineProperty;
var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
var __hasOwnProp$H = Object.prototype.hasOwnProperty;
var __propIsEnum$H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$H = (obj, key, value) => key in obj ? __defProp$H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$H.call(b, prop))
      __defNormalProp$H(a, prop, b[prop]);
  if (__getOwnPropSymbols$H)
    for (var prop of __getOwnPropSymbols$H(b)) {
      if (__propIsEnum$H.call(b, prop))
        __defNormalProp$H(a, prop, b[prop]);
    }
  return a;
};
function MenuLabel(props) {
  const { classNames, styles } = useMenuContext("Menu.Label");
  const { classes } = useStyles$$(null, { name: "Menu", classNames, styles });
  return /* @__PURE__ */ React__default.createElement(Text$1, __spreadValues$H({
    className: classes.label
  }, props));
}
MenuLabel.displayName = "@mantine/core/MenuLabel";

const sizes$6 = {
  xs: 120,
  sm: 160,
  md: 200,
  lg: 240,
  xl: 300
};
const MENU_PADDING = 4;
var useStyles$Y = createStyles((theme, { size }) => ({
  root: {
    display: "inline-block",
    position: "relative"
  },
  arrow: {
    borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2],
    background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
  },
  body: {
    width: theme.fn.size({ size, sizes: sizes$6 }),
    overflow: "hidden",
    pointerEvents: "all",
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]}`,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    padding: MENU_PADDING,
    "& .mantine-Divider-horizontal": {
      margin: `${theme.spacing.xs / 2}px -${MENU_PADDING}px`,
      borderTopColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[2]
    }
  },
  label: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
    fontWeight: 500,
    fontSize: theme.fontSizes.xs,
    padding: `${theme.spacing.xs / 2}px ${theme.spacing.sm}px`,
    cursor: "default"
  }
}));

var useStyles$Z = useStyles$Y;

var __defProp$G = Object.defineProperty;
var __defProps$j = Object.defineProperties;
var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
var __hasOwnProp$G = Object.prototype.hasOwnProperty;
var __propIsEnum$G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$G = (obj, key, value) => key in obj ? __defProp$G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$G.call(b, prop))
      __defNormalProp$G(a, prop, b[prop]);
  if (__getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(b)) {
      if (__propIsEnum$G.call(b, prop))
        __defNormalProp$G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$j = (a, b) => __defProps$j(a, __getOwnPropDescs$j(b));
var __objRest$u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultControl = /* @__PURE__ */ React__default.createElement(ActionIcon, null, /* @__PURE__ */ React__default.createElement(MenuIcon, null));
function getNextItem(active, items) {
  for (let i = active + 1; i < items.length; i += 1) {
    if (!items[i].disabled) {
      return i;
    }
  }
  return active;
}
function findInitialItem(items) {
  for (let i = 0; i < items.length; i += 1) {
    if (!items[i].disabled) {
      return i;
    }
  }
  return -1;
}
function getPreviousItem(active, items) {
  for (let i = active - 1; i >= 0; i -= 1) {
    if (!items[i].disabled) {
      return i;
    }
  }
  if (!items[active]) {
    return findInitialItem(items);
  }
  return active;
}
const defaultProps$h = {
  control: defaultControl,
  closeOnItemClick: true,
  transitionDuration: 150,
  size: "md",
  shadow: "md",
  position: "bottom",
  placement: "start",
  gutter: 5,
  withArrow: false,
  transition: "pop-top-left",
  controlRefProp: "ref",
  trigger: "click",
  radius: "sm",
  delay: 100,
  zIndex: getDefaultZIndex("popover"),
  withinPortal: true,
  trapFocus: true,
  closeOnScroll: false,
  clickOutsideEvents: ["mousedown", "touchstart"]
};
const Menu$2 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Menu", defaultProps$h, props), {
    control,
    children,
    onClose,
    onOpen,
    opened,
    menuId,
    closeOnItemClick,
    transitionDuration,
    size,
    shadow,
    position,
    placement,
    gutter,
    withArrow,
    transition,
    transitionTimingFunction,
    menuButtonLabel,
    controlRefProp,
    trigger,
    radius,
    delay,
    zIndex,
    withinPortal,
    trapFocus,
    classNames,
    styles,
    closeOnScroll,
    onMouseLeave,
    onMouseEnter,
    onChange,
    className,
    sx,
    clickOutsideEvents
  } = _a, others = __objRest$u(_a, [
    "control",
    "children",
    "onClose",
    "onOpen",
    "opened",
    "menuId",
    "closeOnItemClick",
    "transitionDuration",
    "size",
    "shadow",
    "position",
    "placement",
    "gutter",
    "withArrow",
    "transition",
    "transitionTimingFunction",
    "menuButtonLabel",
    "controlRefProp",
    "trigger",
    "radius",
    "delay",
    "zIndex",
    "withinPortal",
    "trapFocus",
    "classNames",
    "styles",
    "closeOnScroll",
    "onMouseLeave",
    "onMouseEnter",
    "onChange",
    "className",
    "sx",
    "clickOutsideEvents"
  ]);
  const [hovered, setHovered] = useState(-1);
  const { classes, cx } = useStyles$Z({ size }, { classNames, styles, name: "Menu" });
  const delayTimeout = useRef();
  const [referenceElement, setReferenceElement] = useState(null);
  const [wrapperElement, setWrapperElement] = useState(null);
  const [dropdownElement, setDropdownElement] = useState(null);
  const uuid = useUuid(menuId);
  const focusReference = () => window.setTimeout(() => referenceElement == null ? void 0 : referenceElement.focus(), 0);
  const [_opened, setOpened] = useUncontrolled({
    value: opened,
    defaultValue: false,
    finalValue: false,
    rule: (val) => typeof val === "boolean",
    onChange: (value) => value ? typeof onOpen === "function" && onOpen() : typeof onClose === "function" && onClose()
  });
  const openedRef = useRef(_opened);
  const handleClose = () => {
    if (openedRef.current) {
      openedRef.current = false;
      setOpened(false);
    }
  };
  const handleOpen = () => {
    openedRef.current = true;
    setOpened(true);
  };
  useWindowEvent("scroll", () => closeOnScroll && handleClose());
  useClickOutside(() => _opened && handleClose(), clickOutsideEvents, [
    dropdownElement,
    wrapperElement
  ]);
  const toggleMenu = () => {
    _opened ? handleClose() : handleOpen();
  };
  const controlEventHandlers = trigger === "click" ? { onClick: toggleMenu } : { onMouseEnter: handleOpen, onClick: toggleMenu };
  const handleMouseLeave = (event) => {
    typeof onMouseLeave === "function" && onMouseLeave(event);
    if (trigger === "hover") {
      if (delay > 0) {
        delayTimeout.current = window.setTimeout(() => handleClose(), delay);
      } else {
        handleClose();
      }
    }
  };
  const handleMouseEnter = (event) => {
    typeof onMouseEnter === "function" && onMouseEnter(event);
    window.clearTimeout(delayTimeout.current);
  };
  const handleKeyDown = (event) => {
    if (_opened) {
      const elements = Array.from(dropdownElement.querySelectorAll(".mantine-Menu-item"));
      if (event.nativeEvent.code === "Tab" && trapFocus) {
        event.preventDefault();
      }
      if (event.nativeEvent.code === "ArrowDown") {
        event.preventDefault();
        const prevIndex = getNextItem(hovered, elements);
        setHovered(prevIndex);
        elements[prevIndex].focus();
      }
      if (event.nativeEvent.code === "ArrowUp") {
        event.preventDefault();
        const prevIndex = getPreviousItem(hovered, elements);
        setHovered(prevIndex);
        elements[prevIndex].focus();
      }
      if (event.nativeEvent.code === "Escape") {
        handleClose();
        focusReference();
      }
    }
  };
  const menuControl = cloneElement(control, __spreadProps$j(__spreadValues$G({}, controlEventHandlers), {
    onClick: (event) => {
      controlEventHandlers.onClick();
      typeof control.props.onClick === "function" && control.props.onClick(event);
    },
    role: "button",
    "aria-haspopup": "menu",
    "aria-expanded": _opened,
    "aria-controls": uuid,
    "aria-label": menuButtonLabel,
    title: menuButtonLabel,
    [controlRefProp]: useMergedRef(setReferenceElement, ref),
    onKeyDown: handleKeyDown
  }));
  const handleItemClick = () => {
    if (closeOnItemClick) {
      handleClose();
      trigger === "click" && focusReference();
    }
  };
  return /* @__PURE__ */ React__default.createElement(MenuProvider, {
    value: {
      hovered,
      radius,
      styles,
      classNames,
      onItemHover: setHovered,
      onItemKeyDown: handleKeyDown,
      onItemClick: handleItemClick
    }
  }, /* @__PURE__ */ React__default.createElement(Box, __spreadValues$G({
    ref: setWrapperElement,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    className: cx(classes.root, className),
    sx
  }, others), menuControl, /* @__PURE__ */ React__default.createElement(Popper, {
    referenceElement,
    transitionDuration,
    transitionTimingFunction,
    transition,
    mounted: _opened,
    position,
    placement,
    gutter,
    withArrow,
    arrowSize: 3,
    zIndex,
    arrowClassName: classes.arrow,
    withinPortal
  }, /* @__PURE__ */ React__default.createElement(Paper, __spreadValues$G({
    shadow,
    className: classes.body,
    role: "menu",
    "aria-orientation": "vertical",
    radius,
    onMouseLeave: () => setHovered(-1),
    ref: setDropdownElement,
    id: uuid
  }, others), children))));
});
Menu$2.Item = MenuItem;
Menu$2.Label = MenuLabel;
Menu$2.displayName = "@mantine/core/Menu";

const sizes$5 = {
  xs: 320,
  sm: 380,
  md: 440,
  lg: 620,
  xl: 780,
  full: "100%"
};
var useStyles$W = createStyles((theme, { overflow, size, centered, zIndex }) => ({
  close: {},
  overlay: {},
  root: {
    position: "fixed",
    zIndex,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  inner: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: "auto",
    padding: `${theme.spacing.xl * 2}px ${theme.spacing.md}px`,
    display: "flex",
    justifyContent: "center",
    alignItems: centered ? "center" : "flex-start"
  },
  title: {
    marginRight: theme.spacing.md,
    textOverflow: "ellipsis",
    display: "block",
    wordBreak: "break-word"
  },
  modal: {
    position: "relative",
    width: theme.fn.size({ sizes: sizes$5, size }),
    outline: 0,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    marginTop: centered ? "auto" : void 0,
    marginBottom: centered ? "auto" : void 0,
    zIndex: 1,
    marginLeft: "calc(var(--removed-scroll-width, 0px) * -1)"
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.md,
    marginRight: -9
  },
  body: {
    maxHeight: overflow === "inside" ? "calc(100vh - 185px)" : null,
    overflowY: overflow === "inside" ? "auto" : null,
    wordBreak: "break-word"
  }
}));

var useStyles$X = useStyles$W;

var __defProp$F = Object.defineProperty;
var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
var __hasOwnProp$F = Object.prototype.hasOwnProperty;
var __propIsEnum$F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$F = (obj, key, value) => key in obj ? __defProp$F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$F.call(b, prop))
      __defNormalProp$F(a, prop, b[prop]);
  if (__getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(b)) {
      if (__propIsEnum$F.call(b, prop))
        __defNormalProp$F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$g = {
  size: "md",
  transitionDuration: 250,
  overflow: "outside",
  transition: "pop",
  padding: "lg",
  shadow: "lg",
  closeOnClickOutside: true,
  closeOnEscape: true,
  trapFocus: true,
  withCloseButton: true,
  withinPortal: true,
  overlayBlur: 0,
  zIndex: getDefaultZIndex("modal")
};
function Modal$1(props) {
  const _a = useMantineDefaultProps("Modal", defaultProps$g, props), {
    className,
    opened,
    title,
    onClose,
    children,
    withCloseButton,
    overlayOpacity,
    size,
    transitionDuration,
    closeButtonLabel,
    overlayColor,
    overflow,
    transition,
    padding,
    shadow,
    radius,
    id,
    classNames,
    styles,
    closeOnClickOutside,
    trapFocus,
    closeOnEscape,
    centered,
    target,
    withinPortal,
    zIndex,
    overlayBlur,
    transitionTimingFunction
  } = _a, others = __objRest$t(_a, [
    "className",
    "opened",
    "title",
    "onClose",
    "children",
    "withCloseButton",
    "overlayOpacity",
    "size",
    "transitionDuration",
    "closeButtonLabel",
    "overlayColor",
    "overflow",
    "transition",
    "padding",
    "shadow",
    "radius",
    "id",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "trapFocus",
    "closeOnEscape",
    "centered",
    "target",
    "withinPortal",
    "zIndex",
    "overlayBlur",
    "transitionTimingFunction"
  ]);
  const baseId = useUuid(id);
  const titleId = `${baseId}-title`;
  const bodyId = `${baseId}-body`;
  const { classes, cx, theme } = useStyles$X({ size, overflow, centered, zIndex }, { classNames, styles, name: "Modal" });
  const focusTrapRef = useFocusTrap(trapFocus && opened);
  const _overlayOpacity = typeof overlayOpacity === "number" ? overlayOpacity : theme.colorScheme === "dark" ? 0.85 : 0.75;
  const [, lockScroll] = useScrollLock();
  const closeOnEscapePress = (event) => {
    if (!trapFocus && event.code === "Escape" && closeOnEscape) {
      onClose();
    }
  };
  useEffect(() => {
    if (!trapFocus) {
      window.addEventListener("keydown", closeOnEscapePress);
      return () => window.removeEventListener("keydown", closeOnEscapePress);
    }
    return void 0;
  }, [trapFocus]);
  useFocusReturn({ opened, transitionDuration: 0 });
  return /* @__PURE__ */ React__default.createElement(OptionalPortal, {
    withinPortal,
    zIndex,
    target
  }, /* @__PURE__ */ React__default.createElement(GroupedTransition, {
    onExited: () => lockScroll(false),
    onEntered: () => lockScroll(true),
    mounted: opened,
    duration: transitionDuration,
    exitDuration: transitionDuration,
    timingFunction: transitionTimingFunction,
    transitions: {
      modal: { duration: transitionDuration, transition },
      overlay: {
        duration: transitionDuration / 2,
        transition: "fade",
        timingFunction: "ease"
      }
    }
  }, (transitionStyles) => /* @__PURE__ */ React__default.createElement(Box, __spreadValues$F({
    id: baseId,
    className: cx(classes.root, className)
  }, others), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.inner,
    onKeyDownCapture: (event) => {
      var _a2;
      const shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
      shouldTrigger && event.nativeEvent.code === "Escape" && closeOnEscape && onClose();
    },
    ref: focusTrapRef
  }, /* @__PURE__ */ React__default.createElement(Paper, {
    className: classes.modal,
    shadow,
    p: padding,
    radius,
    role: "dialog",
    "aria-labelledby": titleId,
    "aria-describedby": bodyId,
    "aria-modal": true,
    tabIndex: -1,
    style: transitionStyles.modal
  }, (title || withCloseButton) && /* @__PURE__ */ React__default.createElement("div", {
    className: classes.header
  }, /* @__PURE__ */ React__default.createElement(Text$1, {
    id: titleId,
    className: classes.title
  }, title), withCloseButton && /* @__PURE__ */ React__default.createElement(CloseButton, {
    iconSize: 16,
    onClick: onClose,
    "aria-label": closeButtonLabel,
    className: classes.close
  })), /* @__PURE__ */ React__default.createElement("div", {
    id: bodyId,
    className: classes.body
  }, children)), /* @__PURE__ */ React__default.createElement("div", {
    style: transitionStyles.overlay
  }, /* @__PURE__ */ React__default.createElement(Overlay, {
    className: classes.overlay,
    sx: { position: "fixed" },
    zIndex: 0,
    onMouseDown: () => closeOnClickOutside && onClose(),
    blur: overlayBlur,
    color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.black),
    opacity: _overlayOpacity
  }))))));
}
Modal$1.displayName = "@mantine/core/Modal";

var __defProp$E = Object.defineProperty;
var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
var __hasOwnProp$E = Object.prototype.hasOwnProperty;
var __propIsEnum$E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$E = (obj, key, value) => key in obj ? __defProp$E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$E.call(b, prop))
      __defNormalProp$E(a, prop, b[prop]);
  if (__getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(b)) {
      if (__propIsEnum$E.call(b, prop))
        __defNormalProp$E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const iconSizes$2 = {
  xs: 14,
  sm: 18,
  md: 20,
  lg: 24,
  xl: 28
};
function ChevronIcon(_a) {
  var _b = _a, { size, error, style } = _b, others = __objRest$s(_b, ["size", "error", "style"]);
  const theme = useMantineTheme();
  const _size = theme.fn.size({ size, sizes: iconSizes$2 });
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$E({
    width: _size,
    height: _size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: __spreadValues$E({ color: error ? theme.colors.red[6] : theme.colors.gray[6] }, style),
    "data-chevron": true
  }, others), /* @__PURE__ */ React__default.createElement("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}

function SelectRightSection({
  shouldClear,
  clearButtonLabel,
  onClear,
  size,
  error,
  clearButtonTabIndex
}) {
  return shouldClear ? /* @__PURE__ */ React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: onClear,
    size,
    tabIndex: clearButtonTabIndex
  }) : /* @__PURE__ */ React__default.createElement(ChevronIcon, {
    error,
    size
  });
}
SelectRightSection.displayName = "@mantine/core/SelectRightSection";

var __defProp$D = Object.defineProperty;
var __defProps$i = Object.defineProperties;
var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
var __hasOwnProp$D = Object.prototype.hasOwnProperty;
var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$D = (obj, key, value) => key in obj ? __defProp$D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$D.call(b, prop))
      __defNormalProp$D(a, prop, b[prop]);
  if (__getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(b)) {
      if (__propIsEnum$D.call(b, prop))
        __defNormalProp$D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$i = (a, b) => __defProps$i(a, __getOwnPropDescs$i(b));
var __objRest$r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RIGHT_SECTION_WIDTH$3 = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 44,
  xl: 54
};
function getSelectRightSectionProps(_a) {
  var _b = _a, {
    styles,
    rightSection,
    rightSectionWidth,
    theme
  } = _b, props = __objRest$r(_b, [
    "styles",
    "rightSection",
    "rightSectionWidth",
    "theme"
  ]);
  if (rightSection) {
    return { rightSection, rightSectionWidth, styles };
  }
  const _styles = typeof styles === "function" ? styles(theme) : styles;
  return {
    rightSectionWidth: theme.fn.size({ size: props.size, sizes: RIGHT_SECTION_WIDTH$3 }),
    rightSection: !(props.disabled && props.shouldClear) && /* @__PURE__ */ React__default.createElement(SelectRightSection, __spreadValues$D({}, props)),
    styles: __spreadProps$i(__spreadValues$D({}, _styles), {
      rightSection: __spreadProps$i(__spreadValues$D({}, _styles == null ? void 0 : _styles.rightSection), {
        pointerEvents: props.shouldClear ? void 0 : "none"
      })
    })
  };
}

var __defProp$C = Object.defineProperty;
var __defProps$h = Object.defineProperties;
var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
var __hasOwnProp$C = Object.prototype.hasOwnProperty;
var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$C = (obj, key, value) => key in obj ? __defProp$C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$C.call(b, prop))
      __defNormalProp$C(a, prop, b[prop]);
  if (__getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(b)) {
      if (__propIsEnum$C.call(b, prop))
        __defNormalProp$C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$h = (a, b) => __defProps$h(a, __getOwnPropDescs$h(b));
var __objRest$q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$f = {
  type: "text",
  size: "sm",
  __staticSelector: "TextInput"
};
const TextInput = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("TextInput", defaultProps$f, props), {
    className,
    id,
    label,
    error,
    required,
    type,
    style,
    icon,
    description,
    wrapperProps,
    size,
    classNames,
    styles,
    errorProps,
    labelProps,
    descriptionProps,
    __staticSelector,
    sx
  } = _a, others = __objRest$q(_a, [
    "className",
    "id",
    "label",
    "error",
    "required",
    "type",
    "style",
    "icon",
    "description",
    "wrapperProps",
    "size",
    "classNames",
    "styles",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "__staticSelector",
    "sx"
  ]);
  const uuid = useUuid(id);
  const { systemStyles, rest } = extractSystemStyles(others);
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$C(__spreadValues$C({
    required,
    id: uuid,
    label,
    error,
    description,
    size,
    className,
    style,
    classNames,
    styles,
    __staticSelector,
    sx,
    errorProps,
    labelProps,
    descriptionProps
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement(Input$1, __spreadProps$h(__spreadValues$C({}, rest), {
    required,
    ref,
    id: uuid,
    type,
    invalid: !!error,
    icon,
    size,
    classNames,
    styles,
    __staticSelector
  })));
});
TextInput.displayName = "@mantine/core/TextInput";

var useStyles$U = createStyles((theme, { radius, shadow, spacing, width }) => ({
  title: {},
  wrapper: {
    outline: 0
  },
  popover: {
    background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    pointerEvents: "all",
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
    width
  },
  body: {
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]}`,
    boxShadow: shadow in theme.shadows ? theme.shadows[shadow] : shadow,
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius })
  },
  inner: {
    padding: theme.fn.size({ size: spacing, sizes: theme.spacing })
  },
  header: {
    borderBottom: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[2]}`,
    padding: `${theme.spacing.xs / 1.5}px ${theme.fn.size({
      size: spacing,
      sizes: theme.spacing
    })}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  close: {
    position: "absolute",
    top: 7,
    zIndex: 2,
    right: 10
  }
}));

var useStyles$V = useStyles$U;

var __defProp$B = Object.defineProperty;
var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
var __hasOwnProp$B = Object.prototype.hasOwnProperty;
var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$B = (obj, key, value) => key in obj ? __defProp$B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$B.call(b, prop))
      __defNormalProp$B(a, prop, b[prop]);
  if (__getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(b)) {
      if (__propIsEnum$B.call(b, prop))
        __defNormalProp$B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PopoverBody = forwardRef((_a, ref) => {
  var _b = _a, {
    classNames,
    styles,
    shadow,
    spacing,
    radius,
    withCloseButton,
    title,
    titleId,
    bodyId,
    onClose,
    closeButtonLabel,
    children,
    width
  } = _b, others = __objRest$p(_b, [
    "classNames",
    "styles",
    "shadow",
    "spacing",
    "radius",
    "withCloseButton",
    "title",
    "titleId",
    "bodyId",
    "onClose",
    "closeButtonLabel",
    "children",
    "width"
  ]);
  const { classes } = useStyles$V({ shadow, radius, spacing, width }, { classNames, styles, name: "Popover" });
  return /* @__PURE__ */ React__default.createElement("div", __spreadValues$B({
    role: "dialog",
    tabIndex: -1,
    "aria-labelledby": titleId,
    "aria-describedby": bodyId,
    className: classes.wrapper,
    ref
  }, others), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.popover
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classes.body
  }, !!title && /* @__PURE__ */ React__default.createElement("div", {
    className: classes.header
  }, /* @__PURE__ */ React__default.createElement(Text$1, {
    size: "sm",
    id: titleId,
    className: classes.title
  }, title)), withCloseButton && /* @__PURE__ */ React__default.createElement(CloseButton, {
    size: "sm",
    onClick: onClose,
    "aria-label": closeButtonLabel,
    className: classes.close
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.inner,
    id: bodyId
  }, children))));
});
PopoverBody.displayName = "@mantine/core/PopoverBody";

var useStyles$S = createStyles((theme) => ({
  root: {
    position: "relative",
    display: "inline-block"
  },
  arrow: {
    borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2],
    background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
  },
  target: {
    zIndex: 1
  }
}));

var useStyles$T = useStyles$S;

var __defProp$A = Object.defineProperty;
var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
var __hasOwnProp$A = Object.prototype.hasOwnProperty;
var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$A = (obj, key, value) => key in obj ? __defProp$A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$A.call(b, prop))
      __defNormalProp$A(a, prop, b[prop]);
  if (__getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(b)) {
      if (__propIsEnum$A.call(b, prop))
        __defNormalProp$A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$e = {
  zIndex: getDefaultZIndex("popover"),
  arrowSize: 4,
  withArrow: false,
  transition: "fade",
  transitionDuration: 200,
  gutter: 10,
  position: "left",
  placement: "center",
  disabled: false,
  closeOnClickOutside: true,
  trapFocus: true,
  closeOnEscape: true,
  withCloseButton: false,
  radius: "sm",
  spacing: "md",
  shadow: "sm",
  positionDependencies: [],
  withinPortal: true,
  clickOutsideEvents: ["mousedown", "touchstart"]
};
function Popover(props) {
  const _a = useMantineDefaultProps("Popover", defaultProps$e, props), {
    className,
    children,
    target,
    title,
    onClose,
    opened,
    zIndex,
    arrowSize,
    withArrow,
    transition,
    transitionDuration,
    transitionTimingFunction,
    gutter,
    position,
    placement,
    disabled,
    closeOnClickOutside,
    trapFocus,
    closeOnEscape,
    withCloseButton,
    radius,
    spacing,
    shadow,
    closeButtonLabel,
    positionDependencies,
    withinPortal,
    id,
    classNames,
    styles,
    width,
    clickOutsideEvents
  } = _a, others = __objRest$o(_a, [
    "className",
    "children",
    "target",
    "title",
    "onClose",
    "opened",
    "zIndex",
    "arrowSize",
    "withArrow",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "gutter",
    "position",
    "placement",
    "disabled",
    "closeOnClickOutside",
    "trapFocus",
    "closeOnEscape",
    "withCloseButton",
    "radius",
    "spacing",
    "shadow",
    "closeButtonLabel",
    "positionDependencies",
    "withinPortal",
    "id",
    "classNames",
    "styles",
    "width",
    "clickOutsideEvents"
  ]);
  const { classes, cx } = useStyles$T(null, { classNames, styles, name: "Popover" });
  const handleClose = () => typeof onClose === "function" && onClose();
  const [referenceElement, setReferenceElement] = useState(null);
  const [rootElement, setRootElement] = useState(null);
  const [dropdownElement, setDropdownElement] = useState(null);
  const focusTrapRef = useFocusTrap(trapFocus && opened);
  useClickOutside(() => closeOnClickOutside && handleClose(), clickOutsideEvents, [
    rootElement,
    dropdownElement
  ]);
  const returnFocus = useFocusReturn({
    opened: opened || trapFocus,
    transitionDuration: 0,
    shouldReturnFocus: false
  });
  const handleKeydown = (event) => {
    if (closeOnEscape && event.nativeEvent.code === "Escape") {
      handleClose();
      window.setTimeout(returnFocus, 0);
    }
  };
  const uuid = useUuid(id);
  const titleId = `${uuid}-title`;
  const bodyId = `${uuid}-body`;
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$A({
    className: cx(classes.root, className),
    id,
    ref: setRootElement
  }, others), /* @__PURE__ */ React__default.createElement(Popper, {
    referenceElement,
    transitionDuration,
    transition,
    mounted: opened && !disabled,
    position,
    placement,
    gutter,
    withArrow,
    arrowSize,
    zIndex,
    arrowClassName: classes.arrow,
    forceUpdateDependencies: [radius, shadow, spacing, ...positionDependencies],
    withinPortal
  }, /* @__PURE__ */ React__default.createElement(PopoverBody, {
    shadow,
    radius,
    spacing,
    withCloseButton,
    title,
    titleId,
    bodyId,
    closeButtonLabel,
    onClose: handleClose,
    ref: useMergedRef(focusTrapRef, setDropdownElement),
    onKeyDownCapture: handleKeydown,
    classNames,
    styles,
    width
  }, children)), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.target,
    ref: setReferenceElement
  }, target));
}
Popover.displayName = "@mantine/core/Popover";

const sizes$4 = {
  xs: 3,
  sm: 5,
  md: 8,
  lg: 12,
  xl: 16
};
const stripesAnimation = keyframes({
  from: { backgroundPosition: "0 0" },
  to: { backgroundPosition: "40px 0" }
});
var useStyles$Q = createStyles((theme, { color, radius, size, striped, animate }) => ({
  root: {
    position: "relative",
    height: theme.fn.size({ size, sizes: sizes$4 }),
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
    overflow: "hidden"
  },
  bar: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.fn.themeColor(color || theme.primaryColor, theme.fn.primaryShade(), false),
    transition: "width 100ms linear",
    animation: animate ? `${stripesAnimation} 1000ms linear infinite` : "none",
    backgroundSize: "20px 20px",
    backgroundImage: striped ? "linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)" : "none",
    "&:last-of-type": {
      borderTopRightRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
      borderBottomRightRadius: theme.fn.size({ size: radius, sizes: theme.radius })
    },
    "&:first-of-type": {
      borderTopLeftRadius: theme.fn.size({ size: radius, sizes: theme.radius }),
      borderBottomLeftRadius: theme.fn.size({ size: radius, sizes: theme.radius })
    },
    "@media (prefers-reduced-motion)": {
      transitionDuration: "0ms"
    }
  },
  label: {
    color: theme.white,
    fontSize: theme.fn.size({ size, sizes: sizes$4 }) * 0.65,
    fontWeight: 700,
    userSelect: "none",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
}));

var useStyles$R = useStyles$Q;

var __defProp$z = Object.defineProperty;
var __defProps$g = Object.defineProperties;
var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
var __hasOwnProp$z = Object.prototype.hasOwnProperty;
var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$z = (obj, key, value) => key in obj ? __defProp$z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$z.call(b, prop))
      __defNormalProp$z(a, prop, b[prop]);
  if (__getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(b)) {
      if (__propIsEnum$z.call(b, prop))
        __defNormalProp$z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$g = (a, b) => __defProps$g(a, __getOwnPropDescs$g(b));
var __objRest$n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function getCumulativeSections(sections) {
  return sections.reduce((acc, section) => {
    acc.sections.push(__spreadProps$g(__spreadValues$z({}, section), { accumulated: acc.accumulated }));
    acc.accumulated += section.value;
    return acc;
  }, { accumulated: 0, sections: [] }).sections;
}
const defaultProps$d = {
  size: "md",
  radius: "sm",
  striped: false,
  animate: false,
  label: ""
};
const Progress$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Progress", defaultProps$d, props), {
    className,
    value,
    color,
    size,
    radius,
    striped,
    animate,
    label,
    "aria-label": ariaLabel,
    classNames,
    styles,
    sections
  } = _a, others = __objRest$n(_a, [
    "className",
    "value",
    "color",
    "size",
    "radius",
    "striped",
    "animate",
    "label",
    "aria-label",
    "classNames",
    "styles",
    "sections"
  ]);
  const { classes, cx, theme } = useStyles$R({ color, size, radius, striped: striped || animate, animate }, { classNames, styles, name: "Progress" });
  const segments = Array.isArray(sections) ? getCumulativeSections(sections).map((section, index) => /* @__PURE__ */ React__default.createElement(Box, {
    key: index,
    className: classes.bar,
    sx: {
      width: `${section.value}%`,
      left: `${section.accumulated}%`,
      backgroundColor: theme.fn.themeColor(section.color, theme.fn.primaryShade(), false)
    }
  }, section.label && /* @__PURE__ */ React__default.createElement(Text$1, {
    className: classes.label
  }, section.label))) : null;
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$z({
    className: cx(classes.root, className),
    ref
  }, others), segments || /* @__PURE__ */ React__default.createElement("div", {
    role: "progressbar",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": value,
    "aria-label": ariaLabel,
    className: classes.bar,
    style: { width: `${value}%` }
  }, label ? /* @__PURE__ */ React__default.createElement(Text$1, {
    className: classes.label
  }, label) : ""));
});
Progress$1.displayName = "@mantine/core/Progress";

function filterData({
  data,
  searchable,
  limit,
  searchValue,
  filter,
  value,
  filterDataOnExactSearchMatch
}) {
  if (!searchable) {
    return data;
  }
  const selected = value != null ? data.find((item) => item.value === value) || null : null;
  if (selected && !filterDataOnExactSearchMatch && (selected == null ? void 0 : selected.label) === searchValue) {
    return data;
  }
  const result = [];
  for (let i = 0; i < data.length; i += 1) {
    if (filter(searchValue, data[i])) {
      result.push(data[i]);
    }
    if (result.length >= limit) {
      break;
    }
  }
  return result;
}

var useStyles$O = createStyles(() => ({
  input: {
    "&:not(:disabled)": {
      cursor: "pointer",
      "&::selection": {
        backgroundColor: "transparent"
      }
    }
  }
}));

var useStyles$P = useStyles$O;

var __defProp$y = Object.defineProperty;
var __defProps$f = Object.defineProperties;
var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
var __hasOwnProp$y = Object.prototype.hasOwnProperty;
var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$y = (obj, key, value) => key in obj ? __defProp$y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$y.call(b, prop))
      __defNormalProp$y(a, prop, b[prop]);
  if (__getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(b)) {
      if (__propIsEnum$y.call(b, prop))
        __defNormalProp$y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$f = (a, b) => __defProps$f(a, __getOwnPropDescs$f(b));
var __objRest$m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function defaultFilter(value, item) {
  return item.label.toLowerCase().trim().includes(value.toLowerCase().trim());
}
function defaultShouldCreate(query, data) {
  return !!query && !data.some((item) => item.label.toLowerCase() === query.toLowerCase());
}
const defaultProps$c = {
  required: false,
  size: "sm",
  shadow: "sm",
  itemComponent: DefaultItem,
  transition: "fade",
  transitionDuration: 0,
  initiallyOpened: false,
  filter: defaultFilter,
  maxDropdownHeight: 220,
  searchable: false,
  clearable: false,
  limit: Infinity,
  disabled: false,
  creatable: false,
  shouldCreate: defaultShouldCreate,
  selectOnBlur: false,
  switchDirectionOnFlip: false,
  filterDataOnExactSearchMatch: false,
  zIndex: getDefaultZIndex("popover"),
  clearButtonTabIndex: 0,
  positionDependencies: []
};
const Select = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Select", defaultProps$c, props), {
    className,
    style,
    required,
    label,
    id,
    error,
    description,
    size,
    shadow,
    data,
    value,
    defaultValue,
    onChange,
    itemComponent,
    onKeyDown,
    onBlur,
    onFocus,
    transition,
    transitionDuration,
    initiallyOpened,
    transitionTimingFunction,
    wrapperProps,
    classNames,
    styles,
    filter,
    maxDropdownHeight,
    searchable,
    clearable,
    nothingFound,
    clearButtonLabel,
    limit,
    disabled,
    onSearchChange,
    rightSection,
    rightSectionWidth,
    creatable,
    getCreateLabel,
    shouldCreate,
    selectOnBlur,
    onCreate,
    sx,
    dropdownComponent,
    onDropdownClose,
    onDropdownOpen,
    withinPortal,
    switchDirectionOnFlip,
    zIndex,
    name,
    dropdownPosition,
    allowDeselect,
    errorProps,
    descriptionProps,
    labelProps,
    placeholder,
    filterDataOnExactSearchMatch,
    clearButtonTabIndex,
    form,
    positionDependencies
  } = _a, others = __objRest$m(_a, [
    "className",
    "style",
    "required",
    "label",
    "id",
    "error",
    "description",
    "size",
    "shadow",
    "data",
    "value",
    "defaultValue",
    "onChange",
    "itemComponent",
    "onKeyDown",
    "onBlur",
    "onFocus",
    "transition",
    "transitionDuration",
    "initiallyOpened",
    "transitionTimingFunction",
    "wrapperProps",
    "classNames",
    "styles",
    "filter",
    "maxDropdownHeight",
    "searchable",
    "clearable",
    "nothingFound",
    "clearButtonLabel",
    "limit",
    "disabled",
    "onSearchChange",
    "rightSection",
    "rightSectionWidth",
    "creatable",
    "getCreateLabel",
    "shouldCreate",
    "selectOnBlur",
    "onCreate",
    "sx",
    "dropdownComponent",
    "onDropdownClose",
    "onDropdownOpen",
    "withinPortal",
    "switchDirectionOnFlip",
    "zIndex",
    "name",
    "dropdownPosition",
    "allowDeselect",
    "errorProps",
    "descriptionProps",
    "labelProps",
    "placeholder",
    "filterDataOnExactSearchMatch",
    "clearButtonTabIndex",
    "form",
    "positionDependencies"
  ]);
  const { classes, cx, theme } = useStyles$P();
  const { systemStyles, rest } = extractSystemStyles(others);
  const [dropdownOpened, _setDropdownOpened] = useState(initiallyOpened);
  const [hovered, setHovered] = useState(-1);
  const inputRef = useRef();
  const dropdownRef = useRef();
  const itemsRefs = useRef({});
  const [direction, setDirection] = useState("column");
  const isColumn = direction === "column";
  const uuid = useUuid(id);
  const { scrollIntoView, targetRef, scrollableRef } = useScrollIntoView({
    duration: 0,
    offset: 5,
    cancelable: false,
    isList: true
  });
  const isDeselectable = allowDeselect === void 0 ? clearable : allowDeselect;
  const setDropdownOpened = (opened) => {
    if (dropdownOpened !== opened) {
      _setDropdownOpened(opened);
      const handler = opened ? onDropdownOpen : onDropdownClose;
      typeof handler === "function" && handler();
    }
  };
  const isCreatable = creatable && typeof getCreateLabel === "function";
  let createLabel = null;
  const formattedData = data.map((item) => typeof item === "string" ? { label: item, value: item } : item);
  const sortedData = groupOptions({ data: formattedData });
  const [_value, handleChange, inputMode] = useUncontrolled({
    value,
    defaultValue,
    finalValue: null,
    onChange,
    rule: (val) => typeof val === "string" || val === null
  });
  const selectedValue = sortedData.find((item) => item.value === _value);
  const [inputValue, setInputValue] = useState((selectedValue == null ? void 0 : selectedValue.label) || "");
  const handleSearchChange = (val) => {
    setInputValue(val);
    if (searchable && typeof onSearchChange === "function") {
      onSearchChange(val);
    }
  };
  const handleClear = () => {
    var _a2;
    handleChange(null);
    if (inputMode === "uncontrolled") {
      handleSearchChange("");
    }
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  useEffect(() => {
    const newSelectedValue = sortedData.find((item) => item.value === _value);
    if (newSelectedValue) {
      handleSearchChange(newSelectedValue.label);
    } else if (!isCreatable || !_value) {
      handleSearchChange("");
    }
  }, [_value]);
  useEffect(() => {
    if (selectedValue && (!searchable || !dropdownOpened)) {
      handleSearchChange(selectedValue.label);
    }
  }, [selectedValue == null ? void 0 : selectedValue.label]);
  const handleItemSelect = (item) => {
    if (isDeselectable && (selectedValue == null ? void 0 : selectedValue.value) === item.value) {
      handleChange(null);
      setDropdownOpened(false);
    } else {
      handleChange(item.value);
      if (item.creatable) {
        typeof onCreate === "function" && onCreate(item.value);
      }
      if (inputMode === "uncontrolled") {
        handleSearchChange(item.label);
      }
      setHovered(-1);
      setDropdownOpened(false);
      inputRef.current.focus();
    }
  };
  const filteredData = filterData({
    data: sortedData,
    searchable,
    limit,
    searchValue: inputValue,
    filter,
    filterDataOnExactSearchMatch,
    value: _value
  });
  if (isCreatable && shouldCreate(inputValue, filteredData)) {
    createLabel = getCreateLabel(inputValue);
    filteredData.push({ label: inputValue, value: inputValue, creatable: true });
  }
  const getNextIndex = (index, nextItem, compareFn) => {
    let i = index;
    while (compareFn(i)) {
      i = nextItem(i);
      if (!filteredData[i].disabled)
        return i;
    }
    return index;
  };
  useDidUpdate(() => {
    setHovered(getNextIndex(-1, (index) => index + 1, (index) => index < filteredData.length - 1));
  }, [inputValue]);
  const selectedItemIndex = _value ? filteredData.findIndex((el) => el.value === _value) : 0;
  const handlePrevious = () => {
    setHovered((current) => {
      var _a2;
      const nextIndex = getNextIndex(current, (index) => index - 1, (index) => index > 0);
      targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({ alignment: isColumn ? "start" : "end" });
      return nextIndex;
    });
  };
  const handleNext = () => {
    setHovered((current) => {
      var _a2;
      const nextIndex = getNextIndex(current, (index) => index + 1, (index) => index < filteredData.length - 1);
      targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({ alignment: isColumn ? "end" : "start" });
      return nextIndex;
    });
  };
  const scrollSelectedItemIntoView = () => window.setTimeout(() => {
    var _a2;
    targetRef.current = itemsRefs.current[(_a2 = filteredData[selectedItemIndex]) == null ? void 0 : _a2.value];
    scrollIntoView({ alignment: isColumn ? "end" : "start" });
  }, 0);
  const handleInputKeydown = (event) => {
    typeof onKeyDown === "function" && onKeyDown(event);
    switch (event.nativeEvent.code) {
      case "ArrowUp": {
        event.preventDefault();
        if (!dropdownOpened) {
          setHovered(selectedItemIndex);
          setDropdownOpened(true);
          scrollSelectedItemIntoView();
        } else {
          isColumn ? handlePrevious() : handleNext();
        }
        break;
      }
      case "ArrowDown": {
        event.preventDefault();
        if (!dropdownOpened) {
          setHovered(selectedItemIndex);
          setDropdownOpened(true);
          scrollSelectedItemIntoView();
        } else {
          isColumn ? handleNext() : handlePrevious();
        }
        break;
      }
      case "Home": {
        if (!searchable) {
          event.preventDefault();
          if (!dropdownOpened) {
            setDropdownOpened(true);
          }
          const firstItemIndex = filteredData.findIndex((item) => !item.disabled);
          setHovered(firstItemIndex);
          scrollIntoView({ alignment: isColumn ? "end" : "start" });
        }
        break;
      }
      case "End": {
        if (!searchable) {
          event.preventDefault();
          if (!dropdownOpened) {
            setDropdownOpened(true);
          }
          const lastItemIndex = filteredData.map((item) => !!item.disabled).lastIndexOf(false);
          setHovered(lastItemIndex);
          scrollIntoView({ alignment: isColumn ? "end" : "start" });
        }
        break;
      }
      case "Escape": {
        event.preventDefault();
        setDropdownOpened(false);
        setHovered(-1);
        break;
      }
      case "Space": {
        if (!searchable) {
          if (filteredData[hovered] && dropdownOpened) {
            event.preventDefault();
            handleItemSelect(filteredData[hovered]);
          } else {
            setDropdownOpened(true);
            setHovered(selectedItemIndex);
            scrollSelectedItemIntoView();
          }
        }
        break;
      }
      case "Enter": {
        if (!searchable) {
          event.preventDefault();
        }
        if (filteredData[hovered] && dropdownOpened) {
          event.preventDefault();
          handleItemSelect(filteredData[hovered]);
        }
      }
    }
  };
  const handleInputBlur = (event) => {
    typeof onBlur === "function" && onBlur(event);
    const selected = sortedData.find((item) => item.value === _value);
    if (selectOnBlur && filteredData[hovered] && dropdownOpened) {
      handleItemSelect(filteredData[hovered]);
    }
    handleSearchChange((selected == null ? void 0 : selected.label) || "");
    setDropdownOpened(false);
  };
  const handleInputFocus = (event) => {
    typeof onFocus === "function" && onFocus(event);
    if (searchable) {
      setDropdownOpened(true);
      scrollSelectedItemIntoView();
    }
  };
  const handleInputChange = (event) => {
    handleSearchChange(event.currentTarget.value);
    if (clearable && event.currentTarget.value === "") {
      handleChange(null);
    }
    setHovered(0);
    setDropdownOpened(true);
  };
  const handleInputClick = () => {
    let dropdownOpen = true;
    if (!searchable) {
      dropdownOpen = !dropdownOpened;
    }
    setDropdownOpened(dropdownOpen);
    if (_value && dropdownOpen) {
      setHovered(selectedItemIndex);
      scrollSelectedItemIntoView();
    }
  };
  const shouldShowDropdown = filteredData.length > 0 ? dropdownOpened : dropdownOpened && !!nothingFound;
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$y(__spreadValues$y({
    required,
    id: uuid,
    label,
    error,
    description,
    size,
    className,
    style,
    classNames,
    styles,
    __staticSelector: "Select",
    sx,
    errorProps,
    descriptionProps,
    labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement("div", {
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": shouldShowDropdown ? `${uuid}-items` : null,
    "aria-controls": uuid,
    "aria-expanded": shouldShowDropdown,
    onMouseLeave: () => setHovered(-1),
    tabIndex: -1
  }, /* @__PURE__ */ React__default.createElement("input", {
    type: "hidden",
    name,
    value: _value || "",
    form
  }), /* @__PURE__ */ React__default.createElement(Input$1, __spreadValues$y(__spreadProps$f(__spreadValues$y({
    autoComplete: "nope"
  }, rest), {
    type: "text",
    required,
    ref: useMergedRef(ref, inputRef),
    id: uuid,
    invalid: !!error,
    size,
    onKeyDown: handleInputKeydown,
    __staticSelector: "Select",
    value: inputValue,
    placeholder,
    onChange: handleInputChange,
    "aria-autocomplete": "list",
    "aria-controls": shouldShowDropdown ? `${uuid}-items` : null,
    "aria-activedescendant": hovered !== -1 ? `${uuid}-${hovered}` : null,
    onClick: handleInputClick,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    readOnly: !searchable,
    disabled,
    "data-mantine-stop-propagation": shouldShowDropdown,
    name: null,
    classNames: __spreadProps$f(__spreadValues$y({}, classNames), {
      input: cx({ [classes.input]: !searchable }, classNames == null ? void 0 : classNames.input)
    })
  }), getSelectRightSectionProps({
    theme,
    rightSection,
    rightSectionWidth,
    styles,
    size,
    shouldClear: clearable && !!selectedValue,
    clearButtonLabel,
    onClear: handleClear,
    error,
    clearButtonTabIndex
  }))), /* @__PURE__ */ React__default.createElement(SelectDropdown, {
    referenceElement: inputRef.current,
    mounted: shouldShowDropdown,
    transition,
    transitionDuration,
    transitionTimingFunction,
    uuid,
    shadow,
    maxDropdownHeight,
    classNames,
    styles,
    ref: useMergedRef(dropdownRef, scrollableRef),
    __staticSelector: "Select",
    dropdownComponent: dropdownComponent || SelectScrollArea,
    direction,
    onDirectionChange: setDirection,
    switchDirectionOnFlip,
    withinPortal,
    zIndex,
    dropdownPosition,
    positionDependencies
  }, /* @__PURE__ */ React__default.createElement(SelectItems, {
    data: filteredData,
    hovered,
    classNames,
    styles,
    isItemSelected: (val) => val === _value,
    uuid,
    __staticSelector: "Select",
    onItemHover: setHovered,
    onItemSelect: handleItemSelect,
    itemsRefs,
    itemComponent,
    size,
    nothingFound,
    creatable: isCreatable && !!createLabel,
    createLabel,
    "aria-label": label
  }))));
});
Select.displayName = "@mantine/core/Select";

function getSortedBreakpoints(theme, breakpoints) {
  if (breakpoints.length === 0) {
    return breakpoints;
  }
  const property = "maxWidth" in breakpoints[0] ? "maxWidth" : "minWidth";
  const sorted = [...breakpoints].sort((a, b) => theme.fn.size({ size: b[property], sizes: theme.breakpoints }) - theme.fn.size({ size: a[property], sizes: theme.breakpoints }));
  return property === "minWidth" ? sorted.reverse() : sorted;
}

var __defProp$x = Object.defineProperty;
var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
var __hasOwnProp$x = Object.prototype.hasOwnProperty;
var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$x.call(b, prop))
      __defNormalProp$x(a, prop, b[prop]);
  if (__getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(b)) {
      if (__propIsEnum$x.call(b, prop))
        __defNormalProp$x(a, prop, b[prop]);
    }
  return a;
};
var useStyles$M = createStyles((theme, { spacing, breakpoints, cols }) => {
  const gridBreakpoints = getSortedBreakpoints(theme, breakpoints).reduce((acc, breakpoint) => {
    const property = "maxWidth" in breakpoint ? "max-width" : "min-width";
    const breakpointSize = theme.fn.size({
      size: property === "max-width" ? breakpoint.maxWidth : breakpoint.minWidth,
      sizes: theme.breakpoints
    });
    acc[`@media (${property}: ${breakpointSize + (property === "max-width" ? 0 : 1)}px)`] = {
      gridTemplateColumns: `repeat(${breakpoint.cols}, minmax(0, 1fr))`,
      gap: theme.fn.size({
        size: breakpoint.spacing || spacing,
        sizes: theme.spacing
      })
    };
    return acc;
  }, {});
  return {
    root: __spreadValues$x({
      boxSizing: "border-box",
      display: "grid",
      gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
      gap: theme.fn.size({ size: spacing, sizes: theme.spacing })
    }, gridBreakpoints)
  };
});

var useStyles$N = useStyles$M;

var __defProp$w = Object.defineProperty;
var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
var __hasOwnProp$w = Object.prototype.hasOwnProperty;
var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$w.call(b, prop))
      __defNormalProp$w(a, prop, b[prop]);
  if (__getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(b)) {
      if (__propIsEnum$w.call(b, prop))
        __defNormalProp$w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$b = {
  breakpoints: [],
  cols: 1,
  spacing: "md"
};
const SimpleGrid = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("SimpleGrid", defaultProps$b, props), { className, breakpoints, cols, spacing, children, classNames, styles } = _a, others = __objRest$l(_a, ["className", "breakpoints", "cols", "spacing", "children", "classNames", "styles"]);
  const { classes, cx } = useStyles$N({ breakpoints, cols, spacing }, { classNames, styles, name: "SimpleGrid" });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$w({
    className: cx(classes.root, className),
    ref
  }, others), children);
});
SimpleGrid.displayName = "@mantine/core/SimpleGrid";

var __defProp$v = Object.defineProperty;
var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
var __hasOwnProp$v = Object.prototype.hasOwnProperty;
var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$v.call(b, prop))
      __defNormalProp$v(a, prop, b[prop]);
  if (__getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(b)) {
      if (__propIsEnum$v.call(b, prop))
        __defNormalProp$v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$a = {
  w: 0,
  h: 0
};
const Space = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Space", defaultProps$a, props), { w, h, sx } = _a, others = __objRest$k(_a, ["w", "h", "sx"]);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$v({
    ref,
    sx: [
      (theme) => {
        const width = theme.fn.size({ size: w, sizes: theme.spacing });
        const height = theme.fn.size({ size: h, sizes: theme.spacing });
        return { width, height, minWidth: width, minHeight: height };
      },
      ...Array.isArray(sx) ? sx : [sx]
    ]
  }, others));
});
Space.displayName = "@mantine/core/Space";

var useStyles$K = createStyles((theme, { spacing, align, justify }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: align,
    justifyContent: justify,
    gap: theme.fn.size({ size: spacing, sizes: theme.spacing })
  }
}));

var useStyles$L = useStyles$K;

var __defProp$u = Object.defineProperty;
var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
var __hasOwnProp$u = Object.prototype.hasOwnProperty;
var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$u.call(b, prop))
      __defNormalProp$u(a, prop, b[prop]);
  if (__getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(b)) {
      if (__propIsEnum$u.call(b, prop))
        __defNormalProp$u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$9 = {
  spacing: "md",
  align: "stretch",
  justify: "top"
};
const Stack = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Stack", defaultProps$9, props), { spacing, className, classNames, styles, align, justify } = _a, others = __objRest$j(_a, ["spacing", "className", "classNames", "styles", "align", "justify"]);
  const { classes, cx } = useStyles$L({ spacing, align, justify }, { name: "Stack", classNames, styles });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$u({
    className: cx(classes.root, className),
    ref
  }, others));
});
Stack.displayName = "@mantine/core/Stack";

var __defProp$t = Object.defineProperty;
var __defProps$e = Object.defineProperties;
var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$t.call(b, prop))
      __defNormalProp$t(a, prop, b[prop]);
  if (__getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(b)) {
      if (__propIsEnum$t.call(b, prop))
        __defNormalProp$t(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
const switchHeight = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 30,
  xl: 36
};
const switchWidth = {
  xs: 30,
  sm: 38,
  md: 46,
  lg: 56,
  xl: 68
};
const handleSizes = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 22,
  xl: 28
};
const labelFontSizes = {
  xs: 5,
  sm: 6,
  md: 7,
  lg: 9,
  xl: 11
};
Object.keys(switchHeight).reduce((acc, size) => {
  acc[size] = { width: switchWidth[size], height: switchHeight[size] };
  return acc;
}, {});
var useStyles$I = createStyles((theme, { size, radius, color, offLabel, onLabel }) => {
  const handleSize = theme.fn.size({ size, sizes: handleSizes });
  const borderRadius = theme.fn.size({ size: radius, sizes: theme.radius });
  const colors = theme.fn.variant({ variant: "filled", color });
  return {
    root: {
      display: "flex",
      alignItems: "center"
    },
    input: __spreadProps$e(__spreadValues$t({}, theme.fn.focusStyles()), {
      overflow: "hidden",
      WebkitTapHighlightColor: "transparent",
      position: "relative",
      borderRadius,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`,
      height: theme.fn.size({ size, sizes: switchHeight }),
      width: theme.fn.size({ size, sizes: switchWidth }),
      minWidth: theme.fn.size({ size, sizes: switchWidth }),
      margin: 0,
      transitionProperty: "background-color, border-color",
      transitionTimingFunction: theme.transitionTimingFunction,
      transitionDuration: "150ms",
      boxSizing: "border-box",
      appearance: "none",
      display: "flex",
      alignItems: "center",
      fontSize: theme.fn.size({ size, sizes: labelFontSizes }),
      fontWeight: 600,
      "&::before": {
        zIndex: 1,
        borderRadius,
        boxSizing: "border-box",
        content: "''",
        display: "block",
        backgroundColor: theme.white,
        height: handleSize,
        width: handleSize,
        border: `1px solid ${theme.colorScheme === "dark" ? theme.white : theme.colors.gray[3]}`,
        transition: `transform 150ms ${theme.transitionTimingFunction}`,
        transform: `translateX(${size === "xs" ? 1 : 2}px)`,
        "@media (prefers-reduced-motion)": {
          transitionDuration: "0ms"
        }
      },
      "&::after": {
        position: "absolute",
        zIndex: 0,
        display: "flex",
        height: "100%",
        alignItems: "center",
        lineHeight: 0,
        right: "10%",
        transform: "translateX(0)",
        content: offLabel ? `'${offLabel}'` : "''",
        color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[6],
        transition: `color 150ms ${theme.transitionTimingFunction}`
      },
      "&:checked": {
        backgroundColor: colors.background,
        borderColor: colors.background,
        "&::before": {
          transform: `translateX(${theme.fn.size({ size, sizes: switchWidth }) - theme.fn.size({ size, sizes: handleSizes }) - (size === "xs" ? 3 : 4)}px)`,
          borderColor: theme.white
        },
        "&::after": {
          transform: "translateX(-200%)",
          content: onLabel ? `'${onLabel}'` : "''",
          color: theme.white
        }
      },
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        cursor: "not-allowed",
        "&::before": {
          borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
          backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[0]
        }
      }
    }),
    label: __spreadProps$e(__spreadValues$t({}, theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      fontFamily: theme.fontFamily,
      paddingLeft: theme.spacing.sm,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    })
  };
});

var useStyles$J = useStyles$I;

var __defProp$s = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$s.call(b, prop))
      __defNormalProp$s(a, prop, b[prop]);
  if (__getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(b)) {
      if (__propIsEnum$s.call(b, prop))
        __defNormalProp$s(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
var __objRest$i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$8 = {
  offLabel: "",
  onLabel: "",
  size: "sm",
  radius: "xl"
};
const Switch$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Switch", defaultProps$8, props), {
    className,
    color,
    label,
    offLabel,
    onLabel,
    id,
    style,
    size,
    radius,
    wrapperProps,
    children,
    classNames,
    styles,
    sx
  } = _a, others = __objRest$i(_a, [
    "className",
    "color",
    "label",
    "offLabel",
    "onLabel",
    "id",
    "style",
    "size",
    "radius",
    "wrapperProps",
    "children",
    "classNames",
    "styles",
    "sx"
  ]);
  const { classes, cx } = useStyles$J({ size, color, radius, offLabel, onLabel }, { classNames, styles, name: "Switch" });
  const { systemStyles, rest } = extractSystemStyles(others);
  const uuid = useUuid(id);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$s(__spreadValues$s({
    className: cx(classes.root, className),
    style,
    sx
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement("input", __spreadProps$d(__spreadValues$s({}, rest), {
    id: uuid,
    ref,
    type: "checkbox",
    className: classes.input
  })), label && /* @__PURE__ */ React__default.createElement("label", {
    className: classes.label,
    htmlFor: uuid
  }, label));
});
Switch$1.displayName = "@mantine/core/Switch";

var __defProp$r = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$r.call(b, prop))
      __defNormalProp$r(a, prop, b[prop]);
  if (__getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(b)) {
      if (__propIsEnum$r.call(b, prop))
        __defNormalProp$r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
var useStyles$G = createStyles((theme, { color, radius }) => ({
  root: {
    position: "relative",
    display: "inline-block"
  },
  body: __spreadProps$c(__spreadValues$r({}, theme.fn.fontStyles()), {
    backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 9),
    lineHeight: theme.lineHeight,
    fontSize: theme.fontSizes.sm,
    borderRadius: theme.fn.radius(radius),
    padding: `${theme.spacing.xs / 2}px ${theme.spacing.xs}px`,
    color: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white,
    position: "relative",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }),
  arrow: {
    border: 0,
    background: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 9),
    zIndex: 1
  }
}));

var useStyles$H = useStyles$G;

var __defProp$q = Object.defineProperty;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$q.call(b, prop))
      __defNormalProp$q(a, prop, b[prop]);
  if (__getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(b)) {
      if (__propIsEnum$q.call(b, prop))
        __defNormalProp$q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$7 = {
  openDelay: 0,
  closeDelay: 0,
  gutter: 5,
  color: "gray",
  disabled: false,
  withArrow: false,
  arrowSize: 2,
  position: "top",
  placement: "center",
  transition: "pop-top-left",
  transitionDuration: 100,
  zIndex: getDefaultZIndex("popover"),
  width: "auto",
  wrapLines: false,
  allowPointerEvents: false,
  positionDependencies: [],
  withinPortal: true
};
const Tooltip$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Tooltip", defaultProps$7, props), {
    className,
    label,
    children,
    opened,
    openDelay,
    closeDelay,
    gutter,
    color,
    radius,
    disabled,
    withArrow,
    arrowSize,
    position,
    placement,
    transition,
    transitionDuration,
    zIndex,
    transitionTimingFunction,
    width,
    wrapLines,
    allowPointerEvents,
    positionDependencies,
    withinPortal,
    tooltipRef,
    tooltipId,
    classNames,
    styles,
    onMouseLeave,
    onMouseEnter
  } = _a, others = __objRest$h(_a, [
    "className",
    "label",
    "children",
    "opened",
    "openDelay",
    "closeDelay",
    "gutter",
    "color",
    "radius",
    "disabled",
    "withArrow",
    "arrowSize",
    "position",
    "placement",
    "transition",
    "transitionDuration",
    "zIndex",
    "transitionTimingFunction",
    "width",
    "wrapLines",
    "allowPointerEvents",
    "positionDependencies",
    "withinPortal",
    "tooltipRef",
    "tooltipId",
    "classNames",
    "styles",
    "onMouseLeave",
    "onMouseEnter"
  ]);
  const { classes, cx, theme } = useStyles$H({ color, radius }, { classNames, styles, name: "Tooltip" });
  const openTimeoutRef = useRef();
  const closeTimeoutRef = useRef();
  const [_opened, setOpened] = useState(false);
  const visible = (typeof opened === "boolean" ? opened : _opened) && !disabled;
  const [referenceElement, setReferenceElement] = useState(null);
  const mergedRefs = useMergedRef(ref, setReferenceElement);
  const handleOpen = () => {
    window.clearTimeout(closeTimeoutRef.current);
    if (openDelay !== 0) {
      openTimeoutRef.current = window.setTimeout(() => {
        setOpened(true);
      }, openDelay);
    } else {
      setOpened(true);
    }
  };
  const handleClose = () => {
    window.clearTimeout(openTimeoutRef.current);
    if (closeDelay !== 0) {
      closeTimeoutRef.current = window.setTimeout(() => {
        setOpened(false);
      }, closeDelay);
    } else {
      setOpened(false);
    }
  };
  useEffect(() => () => {
    window.clearTimeout(openTimeoutRef.current);
    window.clearTimeout(closeTimeoutRef.current);
  }, []);
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$q({
    className: cx(classes.root, className),
    onPointerEnter: (event) => {
      handleOpen();
      typeof onMouseEnter === "function" && onMouseEnter(event);
    },
    onPointerLeave: (event) => {
      handleClose();
      typeof onMouseLeave === "function" && onMouseLeave(event);
    },
    onFocusCapture: handleOpen,
    onBlurCapture: handleClose,
    ref: mergedRefs
  }, others), /* @__PURE__ */ React__default.createElement(Popper, {
    referenceElement,
    transitionDuration,
    transition,
    mounted: visible,
    position,
    placement,
    gutter,
    withArrow,
    arrowSize,
    arrowDistance: theme.fn.radius(radius) > 10 ? 7 : 3,
    zIndex,
    arrowClassName: classes.arrow,
    forceUpdateDependencies: [color, radius, ...positionDependencies],
    withinPortal
  }, /* @__PURE__ */ React__default.createElement(Box, {
    className: classes.body,
    ref: tooltipRef,
    sx: {
      pointerEvents: allowPointerEvents ? "all" : "none",
      whiteSpace: wrapLines ? "normal" : "nowrap",
      width
    }
  }, label)), children);
});
Tooltip$1.displayName = "@mantine/core/Tooltip";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// automatically generated with generateIconMap
var ArrowDown$1 = lazy(function () { return Promise.resolve().then(function () { return ArrowDown; }); });
var ArrowLeft$1 = lazy(function () { return Promise.resolve().then(function () { return ArrowLeft; }); });
var ArrowRight$1 = lazy(function () { return Promise.resolve().then(function () { return ArrowRight; }); });
var ArrowUp$1 = lazy(function () { return Promise.resolve().then(function () { return ArrowUp; }); });
var Back$1 = lazy(function () { return Promise.resolve().then(function () { return Back; }); });
var LeftArrowCircle$1 = lazy(function () { return Promise.resolve().then(function () { return LeftArrowCircle; }); });
var Up$1 = lazy(function () { return Promise.resolve().then(function () { return Up; }); });
var Add$1 = lazy(function () { return Promise.resolve().then(function () { return Add; }); });
var Bullet$1 = lazy(function () { return Promise.resolve().then(function () { return Bullet; }); });
var Calendar$1 = lazy(function () { return Promise.resolve().then(function () { return Calendar$2; }); });
var Check$1 = lazy(function () { return Promise.resolve().then(function () { return Check; }); });
var Clip$1 = lazy(function () { return Promise.resolve().then(function () { return Clip; }); });
var Clock$1 = lazy(function () { return Promise.resolve().then(function () { return Clock; }); });
var Close$1 = lazy(function () { return Promise.resolve().then(function () { return Close; }); });
var Copy$1 = lazy(function () { return Promise.resolve().then(function () { return Copy; }); });
var Download$1 = lazy(function () { return Promise.resolve().then(function () { return Download; }); });
var Edit$1 = lazy(function () { return Promise.resolve().then(function () { return Edit; }); });
var Email$1 = lazy(function () { return Promise.resolve().then(function () { return Email; }); });
var Exit$1 = lazy(function () { return Promise.resolve().then(function () { return Exit; }); });
var EyeOff$1 = lazy(function () { return Promise.resolve().then(function () { return EyeOff; }); });
var EyeOn$1 = lazy(function () { return Promise.resolve().then(function () { return EyeOn; }); });
var Fail$1 = lazy(function () { return Promise.resolve().then(function () { return Fail; }); });
var Filter$1 = lazy(function () { return Promise.resolve().then(function () { return Filter; }); });
var Flag$1 = lazy(function () { return Promise.resolve().then(function () { return Flag; }); });
var Home$1 = lazy(function () { return Promise.resolve().then(function () { return Home; }); });
var Image$1 = lazy(function () { return Promise.resolve().then(function () { return Image; }); });
var Information$1 = lazy(function () { return Promise.resolve().then(function () { return Information; }); });
var Key$1 = lazy(function () { return Promise.resolve().then(function () { return Key; }); });
var Lock$1 = lazy(function () { return Promise.resolve().then(function () { return Lock; }); });
var Menu$1 = lazy(function () { return Promise.resolve().then(function () { return Menu; }); });
var Minus$1 = lazy(function () { return Promise.resolve().then(function () { return Minus; }); });
var More$1 = lazy(function () { return Promise.resolve().then(function () { return More; }); });
var Notification$1 = lazy(function () { return Promise.resolve().then(function () { return Notification; }); });
var Plus$1 = lazy(function () { return Promise.resolve().then(function () { return Plus; }); });
var Print$1 = lazy(function () { return Promise.resolve().then(function () { return Print; }); });
var Question$1 = lazy(function () { return Promise.resolve().then(function () { return Question; }); });
var Refresh$1 = lazy(function () { return Promise.resolve().then(function () { return Refresh; }); });
var Search$1 = lazy(function () { return Promise.resolve().then(function () { return Search; }); });
var Settings$1 = lazy(function () { return Promise.resolve().then(function () { return Settings; }); });
var Star$1 = lazy(function () { return Promise.resolve().then(function () { return Star; }); });
var Success$1 = lazy(function () { return Promise.resolve().then(function () { return Success; }); });
var Support$1 = lazy(function () { return Promise.resolve().then(function () { return Support; }); });
var TimeZone$1 = lazy(function () { return Promise.resolve().then(function () { return TimeZone; }); });
var Trash$1 = lazy(function () { return Promise.resolve().then(function () { return Trash; }); });
var Unlock$1 = lazy(function () { return Promise.resolve().then(function () { return Unlock; }); });
var Upload$1 = lazy(function () { return Promise.resolve().then(function () { return Upload; }); });
var User$1 = lazy(function () { return Promise.resolve().then(function () { return User; }); });
var Warning$1 = lazy(function () { return Promise.resolve().then(function () { return Warning; }); });
var Wifi$1 = lazy(function () { return Promise.resolve().then(function () { return Wifi; }); });
var Brain$1 = lazy(function () { return Promise.resolve().then(function () { return Brain; }); });
var CardEdit$1 = lazy(function () { return Promise.resolve().then(function () { return CardEdit; }); });
var DoctorTalk$1 = lazy(function () { return Promise.resolve().then(function () { return DoctorTalk; }); });
var Folder$1 = lazy(function () { return Promise.resolve().then(function () { return Folder; }); });
var Heartbeat$1 = lazy(function () { return Promise.resolve().then(function () { return Heartbeat; }); });
var Hospital$1 = lazy(function () { return Promise.resolve().then(function () { return Hospital; }); });
var Mask$1 = lazy(function () { return Promise.resolve().then(function () { return Mask; }); });
var MedicalCertificate$1 = lazy(function () { return Promise.resolve().then(function () { return MedicalCertificate; }); });
var MedicalCross$1 = lazy(function () { return Promise.resolve().then(function () { return MedicalCross; }); });
var Notes$1 = lazy(function () { return Promise.resolve().then(function () { return Notes; }); });
var Pill$1 = lazy(function () { return Promise.resolve().then(function () { return Pill; }); });
var ScaleWeight$1 = lazy(function () { return Promise.resolve().then(function () { return ScaleWeight; }); });
var ShieldHeart$1 = lazy(function () { return Promise.resolve().then(function () { return ShieldHeart; }); });
var Stethoscope$1 = lazy(function () { return Promise.resolve().then(function () { return Stethoscope; }); });
var Syringe$1 = lazy(function () { return Promise.resolve().then(function () { return Syringe; }); });
var Audio$1 = lazy(function () { return Promise.resolve().then(function () { return Audio; }); });
var CameraOff$1 = lazy(function () { return Promise.resolve().then(function () { return CameraOff; }); });
var CameraOn$1 = lazy(function () { return Promise.resolve().then(function () { return CameraOn; }); });
var Fullscreen$1 = lazy(function () { return Promise.resolve().then(function () { return Fullscreen; }); });
var MicrophoneOff$1 = lazy(function () { return Promise.resolve().then(function () { return MicrophoneOff; }); });
var MicrophoneOn$1 = lazy(function () { return Promise.resolve().then(function () { return MicrophoneOn; }); });
var Minimize$1 = lazy(function () { return Promise.resolve().then(function () { return Minimize; }); });
var Miniplayer$1 = lazy(function () { return Promise.resolve().then(function () { return Miniplayer; }); });
var PhoneOn$1 = lazy(function () { return Promise.resolve().then(function () { return PhoneOn; }); });
var Rotate$1 = lazy(function () { return Promise.resolve().then(function () { return Rotate; }); });
var ShareScreen$1 = lazy(function () { return Promise.resolve().then(function () { return ShareScreen; }); });
var Chart$1 = lazy(function () { return Promise.resolve().then(function () { return Chart; }); });
var Chat$1 = lazy(function () { return Promise.resolve().then(function () { return Chat; }); });
var ClipboardSaved$1 = lazy(function () { return Promise.resolve().then(function () { return ClipboardSaved; }); });
var Clipboard$1 = lazy(function () { return Promise.resolve().then(function () { return Clipboard; }); });
var CreditCard$1 = lazy(function () { return Promise.resolve().then(function () { return CreditCard; }); });
var Dashboard$1 = lazy(function () { return Promise.resolve().then(function () { return Dashboard; }); });
var DocumentAtestado$1 = lazy(function () { return Promise.resolve().then(function () { return DocumentAtestado; }); });
var FaceId$1 = lazy(function () { return Promise.resolve().then(function () { return FaceId; }); });
var FileCheck$1 = lazy(function () { return Promise.resolve().then(function () { return FileCheck; }); });
var FileError$1 = lazy(function () { return Promise.resolve().then(function () { return FileError; }); });
var File$1 = lazy(function () { return Promise.resolve().then(function () { return File; }); });
var FontBold$1 = lazy(function () { return Promise.resolve().then(function () { return FontBold; }); });
var FontItalic$1 = lazy(function () { return Promise.resolve().then(function () { return FontItalic; }); });
var FontUnderline$1 = lazy(function () { return Promise.resolve().then(function () { return FontUnderline; }); });
var Frame$1 = lazy(function () { return Promise.resolve().then(function () { return Frame; }); });
var IconShare$1 = lazy(function () { return Promise.resolve().then(function () { return IconShare; }); });
var Identity$1 = lazy(function () { return Promise.resolve().then(function () { return Identity; }); });
var JustifyCenter$1 = lazy(function () { return Promise.resolve().then(function () { return JustifyCenter; }); });
var JustifyLeft$1 = lazy(function () { return Promise.resolve().then(function () { return JustifyLeft; }); });
var Mobile$1 = lazy(function () { return Promise.resolve().then(function () { return Mobile; }); });
var ParagraphList$1 = lazy(function () { return Promise.resolve().then(function () { return ParagraphList; }); });
var ParagraphNumber$1 = lazy(function () { return Promise.resolve().then(function () { return ParagraphNumber; }); });
var Receipt$1 = lazy(function () { return Promise.resolve().then(function () { return Receipt; }); });
var SelectAll$1 = lazy(function () { return Promise.resolve().then(function () { return SelectAll; }); });
var Send$1 = lazy(function () { return Promise.resolve().then(function () { return Send; }); });
var SettingsHandles$1 = lazy(function () { return Promise.resolve().then(function () { return SettingsHandles; }); });
var SigninSendShare$1 = lazy(function () { return Promise.resolve().then(function () { return SigninSendShare; }); });
// iconMap
var iconMap = {
    'arrow-down': ArrowDown$1,
    'arrow-left': ArrowLeft$1,
    'arrow-right': ArrowRight$1,
    'arrow-up': ArrowUp$1,
    back: Back$1,
    'left-arrow-circle': LeftArrowCircle$1,
    up: Up$1,
    add: Add$1,
    bullet: Bullet$1,
    calendar: Calendar$1,
    check: Check$1,
    clip: Clip$1,
    clock: Clock$1,
    close: Close$1,
    copy: Copy$1,
    download: Download$1,
    edit: Edit$1,
    email: Email$1,
    exit: Exit$1,
    'eye-off': EyeOff$1,
    'eye-on': EyeOn$1,
    fail: Fail$1,
    filter: Filter$1,
    flag: Flag$1,
    home: Home$1,
    image: Image$1,
    information: Information$1,
    key: Key$1,
    lock: Lock$1,
    menu: Menu$1,
    minus: Minus$1,
    more: More$1,
    notification: Notification$1,
    plus: Plus$1,
    print: Print$1,
    question: Question$1,
    refresh: Refresh$1,
    search: Search$1,
    settings: Settings$1,
    star: Star$1,
    success: Success$1,
    support: Support$1,
    'time-zone': TimeZone$1,
    trash: Trash$1,
    unlock: Unlock$1,
    upload: Upload$1,
    user: User$1,
    warning: Warning$1,
    wifi: Wifi$1,
    brain: Brain$1,
    'card-edit': CardEdit$1,
    'doctor-talk': DoctorTalk$1,
    folder: Folder$1,
    heartbeat: Heartbeat$1,
    hospital: Hospital$1,
    mask: Mask$1,
    'medical-certificate': MedicalCertificate$1,
    'medical-cross': MedicalCross$1,
    notes: Notes$1,
    pill: Pill$1,
    'scale-weight': ScaleWeight$1,
    'shield-heart': ShieldHeart$1,
    stethoscope: Stethoscope$1,
    syringe: Syringe$1,
    audio: Audio$1,
    'camera-off': CameraOff$1,
    'camera-on': CameraOn$1,
    fullscreen: Fullscreen$1,
    'microphone-off': MicrophoneOff$1,
    'microphone-on': MicrophoneOn$1,
    minimize: Minimize$1,
    miniplayer: Miniplayer$1,
    'phone-on': PhoneOn$1,
    rotate: Rotate$1,
    'share-screen': ShareScreen$1,
    chart: Chart$1,
    chat: Chat$1,
    'clipboard-saved': ClipboardSaved$1,
    clipboard: Clipboard$1,
    'credit-card': CreditCard$1,
    dashboard: Dashboard$1,
    'document-atestado': DocumentAtestado$1,
    'face-id': FaceId$1,
    'file-check': FileCheck$1,
    'file-error': FileError$1,
    file: File$1,
    'font-bold': FontBold$1,
    'font-italic': FontItalic$1,
    'font-underline': FontUnderline$1,
    frame: Frame$1,
    'icon-share': IconShare$1,
    identity: Identity$1,
    'justify-center': JustifyCenter$1,
    'justify-left': JustifyLeft$1,
    mobile: Mobile$1,
    'paragraph-list': ParagraphList$1,
    'paragraph-number': ParagraphNumber$1,
    receipt: Receipt$1,
    'select-all': SelectAll$1,
    send: Send$1,
    'settings-handles': SettingsHandles$1,
    'signin-send-share': SigninSendShare$1
};

var Icon = function (_a) {
    var name = _a.name, size = _a.size, color = _a.color, onClick = _a.onClick;
    var iconName = useMemo(function () {
        if (!name) {
            throw new Error('Icon name was not provided');
        }
        return name;
    }, [name]);
    var MappedIcon = iconMap[iconName];
    return (jsx(Suspense, __assign({ fallback: jsx("span", { className: "icon-on-suspense" }) }, { children: jsx(MappedIcon, { color: color, onClick: onClick, size: size }) })));
};

var iconSizes$1 = {
    small: 16,
    medium: 24,
    large: 32,
};

var getIconSize = function (iconSize) {
    return iconSizes$1[iconSize || 'medium'];
};

var SvgArrowDown = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.231 9.24a.77.77 0 0 1 1.117 0L12 13.025l3.652-3.785a.77.77 0 0 1 1.117 0 .84.84 0 0 1 0 1.157l-4.21 4.363a.77.77 0 0 1-1.117 0l-4.21-4.363a.84.84 0 0 1 0-1.157Z", fill: props.color }) })));
};

var ArrowDown = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowDown
});

var SvgArrowLeft = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.76 7.231a.77.77 0 0 1 0 1.117L10.975 12l3.785 3.652a.77.77 0 0 1 0 1.117.84.84 0 0 1-1.157 0l-4.363-4.21a.77.77 0 0 1 0-1.117l4.363-4.21a.84.84 0 0 1 1.157 0Z", fill: "currentColor" }) })));
};

var ArrowLeft = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowLeft
});

var SvgArrowRight = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.24 7.231a.84.84 0 0 1 1.157 0l4.363 4.21a.77.77 0 0 1 0 1.117l-4.363 4.21a.84.84 0 0 1-1.157 0 .77.77 0 0 1 0-1.116L13.025 12 9.24 8.348a.77.77 0 0 1 0-1.117Z", fill: "currentColor" }) })));
};

var ArrowRight = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowRight
});

var SvgArrowUp = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.442 9.24a.77.77 0 0 1 1.116 0l4.21 4.363a.84.84 0 0 1 0 1.157.77.77 0 0 1-1.116 0L12 10.975 8.348 14.76a.77.77 0 0 1-1.117 0 .84.84 0 0 1 0-1.157l4.21-4.363Z", fill: "currentColor" }) })));
};

var ArrowUp = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowUp
});

var SvgBack = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.53 6.47a.75.75 0 0 1 0 1.06l-3.72 3.72H19a.75.75 0 0 1 0 1.5H6.81l3.72 3.72a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }) })));
};

var Back = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgBack
});

var SvgLeftArrowCircle = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.949A7.05 7.05 0 0 0 2.95 10 7.05 7.05 0 0 0 10 17.051 7.05 7.05 0 0 0 17.052 10 7.05 7.05 0 0 0 10 2.949Zm0 15.384A8.333 8.333 0 0 1 1.667 10 8.333 8.333 0 0 1 10 1.667 8.333 8.333 0 0 1 18.334 10 8.333 8.333 0 0 1 10 18.333Z", fill: "#0031B2" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.94 10c0-.354.287-.641.641-.641h6.838a.641.641 0 0 1 0 1.282H6.581a.641.641 0 0 1-.64-.641Z", fill: "#0031B2" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.599 6.983c.25.25.25.656 0 .906L7.488 10l2.11 2.112a.641.641 0 1 1-.906.906l-2.564-2.564a.641.641 0 0 1 0-.906l2.564-2.564c.25-.25.656-.25.907 0Z", fill: "#0031B2" })] })));
};

var LeftArrowCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgLeftArrowCircle
});

var SvgUp = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.48 10.48a.75.75 0 0 1-1.06 0L12.7 6.76v12.19a.75.75 0 0 1-1.5 0V6.76l-3.72 3.72a.75.75 0 1 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06Z", fill: "currentColor" }) })));
};

var Up = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUp
});

var SvgAdd = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 15.25a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5V.75a.75.75 0 0 0-1.5 0v6.5H.75a.75.75 0 0 0 0 1.5h6.5v6.5Z", fill: "currentColor" }) })));
};

var Add = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgAdd
});

var SvgBullet = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.243 7.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486Z", fill: "currentColor" }) })));
};

var Bullet = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgBullet
});

var SvgCalendar = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.999A3.749 3.749 0 0 1 5.999 2.25H18a3.749 3.749 0 0 1 3.749 3.749V18a3.749 3.749 0 0 1-3.749 3.749H6a3.749 3.749 0 0 1-3.749-3.749V6Zm3.749-2.25A2.25 2.25 0 0 0 3.749 6V18A2.25 2.25 0 0 0 6 20.251H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.749H6Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8A.75.75 0 0 1 3 7.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8ZM17.805 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 10.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 11.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 14.45ZM10.803 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM14.304 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM17.805 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM17.805 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 17.45Z", fill: "currentColor" })] })));
};

var Calendar$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCalendar
});

var SvgCheck = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.774 5.728a.786.786 0 0 1 0 1.104L9.46 18.272a.765.765 0 0 1-1.091 0l-5.143-5.2a.786.786 0 0 1 0-1.103.765.765 0 0 1 1.09 0l4.598 4.648 10.77-10.889a.765.765 0 0 1 1.09 0Z", fill: "currentColor" }) })));
};

var Check = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCheck
});

var SvgClip = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6 3.605a4.629 4.629 0 1 1 6.547 6.546l-7.232 7.232a2.866 2.866 0 0 1-4.052-4.052l5.486-5.486a.75.75 0 1 1 1.06 1.06l-5.486 5.486a1.366 1.366 0 0 0 1.932 1.932l7.232-7.232a3.13 3.13 0 1 0-4.426-4.426L6.43 11.897a4.892 4.892 0 1 0 6.92 6.92l4.389-4.39a.75.75 0 1 1 1.06 1.061l-4.389 4.39a6.392 6.392 0 0 1-9.04 0 6.392 6.392 0 0 1 0-9.041L12.6 3.605Z", fill: "currentColor" }) })));
};

var Clip = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgClip
});

var SvgClock = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.613 12.618c0-.425.345-.77.77-.77h4.769a.769.769 0 0 1 0 1.539h-4.77a.769.769 0 0 1-.769-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.382 6.103c.425 0 .77.344.77.769v5.746a.769.769 0 1 1-1.539 0V6.872c0-.425.345-.77.77-.77Z", fill: "currentColor" })] })));
};

var Clock = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgClock
});

var SvgClose = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.277 6.277c.37-.37.97-.37 1.34 0l10.105 10.106a.947.947 0 1 1-1.34 1.34L6.278 7.617a.947.947 0 0 1 0-1.34Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.723 6.277c.37.37.37.97 0 1.34L7.617 17.722a.947.947 0 1 1-1.34-1.34L16.383 6.278c.37-.37.97-.37 1.34 0Z", fill: "currentColor" })] })));
};

var Close = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgClose
});

var SvgCopy = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.103 8.922a2.82 2.82 0 0 1 2.82-2.82H19.18A2.82 2.82 0 0 1 22 8.923v10.259A2.82 2.82 0 0 1 19.18 22H8.923a2.82 2.82 0 0 1-2.82-2.82V8.923Zm2.82-1.281c-.709 0-1.282.573-1.282 1.281v10.259c0 .707.573 1.281 1.281 1.281h10.259c.707 0 1.281-.574 1.281-1.281V8.922c0-.708-.574-1.281-1.281-1.281H8.922Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.82 3.538c-.708 0-1.282.574-1.282 1.282v10.257c0 .708.574 1.282 1.282 1.282h2.052a.769.769 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 15.077V4.82A2.82 2.82 0 0 1 4.82 2h10.257a2.82 2.82 0 0 1 2.82 2.82v2.052a.769.769 0 0 1-1.538 0V4.82c0-.708-.574-1.282-1.282-1.282H4.82Z", fill: "currentColor" })] })));
};

var Copy = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCopy
});

var SvgDownload = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061L8.25 13.19V1A.75.75 0 0 1 9 .25ZM.25 19a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 19Z", fill: "currentColor" }) })));
};

var Download = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDownload
});

var SvgEdit = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.834 3.622c-.71 0-1.296.612-1.296 1.381v13.994c0 .768.586 1.381 1.296 1.381h14.332c.71 0 1.296-.613 1.296-1.381v-6.384c0-.448.344-.81.769-.81.425 0 .769.362.769.81v6.384C22 20.65 20.737 22 19.166 22H4.834C3.264 22 2 20.65 2 18.997V5.003C2 3.35 3.263 2 4.834 2H12c.425 0 .77.363.77.81 0 .449-.345.812-.77.812H4.834Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.009 2.871a2.719 2.719 0 0 1 3.988 0l.177.186c1.101 1.16 1.101 3.043 0 4.204l-8.605 9.07-.003.002a1.78 1.78 0 0 1-.832.496l-3.812 1.005a.751.751 0 0 1-.745-.21.835.835 0 0 1-.199-.785l.954-4.018c.079-.333.242-.637.472-.88l8.605-9.07Zm-8.23 13.065 2.582-.68a.26.26 0 0 0 .121-.073l8.604-9.069c.5-.527.5-1.383 0-1.91l-.176-.186a1.236 1.236 0 0 0-1.813 0l-8.605 9.07a.276.276 0 0 0-.068.126l-.646 2.722Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.384 4.583a.742.742 0 0 1 1.088 0l3.077 3.244c.3.316.3.83 0 1.146a.742.742 0 0 1-1.088 0L15.385 5.73a.842.842 0 0 1 0-1.147ZM8.616 12.22c.08-.011.24-.035.387-.035 1.841 0 3.333 1.573 3.333 3.513 0 .161-.022.325-.034.415a2.576 2.576 0 0 0-.005.039c-.056.444-.442.756-.863.697-.421-.058-.718-.466-.662-.91l.012-.094c.01-.08.014-.11.014-.147 0-1.045-.803-1.892-1.795-1.892a.633.633 0 0 0-.103.01l-.133.02c-.421.054-.805-.263-.857-.707-.051-.444.249-.849.67-.903l.036-.006Z", fill: "currentColor" })] })));
};

var Edit = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgEdit
});

var SvgEmail = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 6.8A2.543 2.543 0 0 1 4.8 4.25h14.4a2.543 2.543 0 0 1 2.547 2.68.75.75 0 0 1 .003.07v10A2.756 2.756 0 0 1 19 19.75H5A2.756 2.756 0 0 1 2.25 17V7c0-.024.001-.047.003-.07a2.55 2.55 0 0 1-.003-.13Zm1.5 2.374V17c0 .06.004.119.013.177l4.748-4.75L3.75 9.175Zm6.39 2.55a.77.77 0 0 0-.072-.05l-5.82-3.976c-.357-.293-.498-.589-.498-.898 0-.586.464-1.05 1.05-1.05h14.4c.586 0 1.05.464 1.05 1.05 0 .312-.14.62-.466 1.042l-5.827 3.885a.65.65 0 0 0-.025.017l-.043.028c-1.149.736-2.525.737-3.675.003l-.074-.051Zm-.344 1.54-4.973 4.973c.058.009.117.013.177.013h14c.06 0 .119-.004.177-.013l-4.94-4.939a4.81 4.81 0 0 1-4.44-.034Zm5.741-.787 4.7 4.7c.009-.058.013-.117.013-.177V9.335l-4.713 3.142Z", fill: "currentColor" }) })));
};

var Email = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgEmail
});

var SvgExit = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.825 12a.77.77 0 0 1 .77-.77h5.135a.77.77 0 1 1 0 1.538h-5.135a.77.77 0 0 1-.77-.768Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.131 9.405c.301-.3.789-.3 1.09 0l2.053 2.051c.301.3.301.787 0 1.087l-2.054 2.052c-.3.3-.788.3-1.089 0-.3-.3-.3-.788 0-1.088L19.641 12l-1.51-1.508c-.3-.3-.3-.787 0-1.087Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.324 3.538c-.71 0-1.284.574-1.284 1.282v14.36c0 .708.574 1.282 1.284 1.282H17.65c.71 0 1.284-.574 1.284-1.283v-2.051a.77.77 0 0 1 1.54 0v2.051A2.822 2.822 0 0 1 17.649 22H5.324A2.822 2.822 0 0 1 2.5 19.18V4.82A2.822 2.822 0 0 1 5.324 2H17.65a2.822 2.822 0 0 1 2.824 2.82v2.051a.77.77 0 0 1-1.54 0v-2.05c0-.71-.575-1.283-1.284-1.283H5.324Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.405 10.205a.77.77 0 0 1 .77.769v2.051a.77.77 0 0 1-1.54 0v-2.051a.77.77 0 0 1 .77-.769Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.486 2a.77.77 0 0 1 .77.769v14.355c0 1.069-.604 2.044-1.56 2.523l-4.11 2.052c-1.876.937-4.086-.427-4.086-2.523a.77.77 0 0 1 1.54 0 1.284 1.284 0 0 0 1.858 1.147l4.107-2.05c.437-.22.711-.663.711-1.15V2.77a.77.77 0 0 1 .77-.769Z", fill: "currentColor" })] })));
};

var Exit = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgExit
});

var SvgEyeOff = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.714 18.435a.768.768 0 0 1 .995-.442c.766.298 1.536.459 2.291.459.425 0 .77.346.77.774A.772.772 0 0 1 12 20c-.972 0-1.931-.207-2.846-.563a.776.776 0 0 1-.44-1.002Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.476 11.802a.777.777 0 0 1 .31 1.05c-1.016 1.892-2.465 3.664-4.144 4.97C15.967 19.123 14.014 20 12 20a.772.772 0 0 1-.77-.774c0-.428.345-.774.77-.774 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.767.767 0 0 1 1.043-.313Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.761 8.233a.766.766 0 0 1 1.085.086 16.398 16.398 0 0 1 1.94 2.83c.285.53.285 1.173 0 1.702a.766.766 0 0 1-1.041.313.777.777 0 0 1-.312-1.05.245.245 0 0 0 0-.228 14.858 14.858 0 0 0-1.757-2.562.778.778 0 0 1 .085-1.091ZM19.724 4.227c.3.302.3.792 0 1.095L5.364 19.773a.766.766 0 0 1-1.088 0 .778.778 0 0 1 0-1.095l14.36-14.451a.766.766 0 0 1 1.088 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.741 10.248a2.45 2.45 0 0 0-3.481 0 2.49 2.49 0 0 0 0 3.503c.3.303.3.793 0 1.095a.766.766 0 0 1-1.088 0 4.045 4.045 0 0 1 0-5.693 3.983 3.983 0 0 1 5.657 0c.3.302.3.792 0 1.095a.766.766 0 0 1-1.088 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.358 6.179C8.033 4.876 9.986 4 12 4c2.014 0 3.97.877 5.644 2.181a.778.778 0 0 1 .138 1.086.766.766 0 0 1-1.08.139C15.205 6.238 13.573 5.548 12 5.548c-1.57 0-3.202.69-4.701 1.856-1.495 1.163-2.809 2.763-3.732 4.482a.245.245 0 0 0 0 .23c.923 1.718 2.236 3.316 3.73 4.48a.778.778 0 0 1 .138 1.085.766.766 0 0 1-1.08.14c-1.676-1.307-3.125-3.077-4.142-4.97a1.805 1.805 0 0 1 0-1.7C3.23 9.256 4.679 7.483 6.358 6.178Z", fill: "currentColor" })] })));
};

var EyeOff = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgEyeOff
});

var SvgEyeOn = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.299 7.404c-1.495 1.162-2.809 2.762-3.732 4.481a.245.245 0 0 0 0 .23c.923 1.719 2.237 3.318 3.732 4.481 1.499 1.166 3.13 1.856 4.701 1.856 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.246.246 0 0 0 0-.23c-.923-1.719-2.237-3.318-3.732-4.481-1.5-1.166-3.13-1.856-4.701-1.856-1.571 0-3.202.69-4.701 1.856Zm-.941-1.225C8.033 4.876 9.986 4 12 4c2.014 0 3.967.876 5.642 2.179 1.679 1.305 3.128 3.077 4.145 4.97.284.53.284 1.172 0 1.702-1.017 1.893-2.466 3.665-4.145 4.97C15.967 19.125 14.014 20 12 20c-2.014 0-3.967-.876-5.642-2.179-1.679-1.306-3.128-3.077-4.145-4.97a1.804 1.804 0 0 1 0-1.702C3.23 9.256 4.679 7.484 6.358 6.18Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.658 10.332a2.334 2.334 0 0 0-3.316 0 2.37 2.37 0 0 0 0 3.336c.916.922 2.4.922 3.316 0a2.37 2.37 0 0 0 0-3.336Zm1.036-1.043a3.793 3.793 0 0 0-5.388 0 3.852 3.852 0 0 0 0 5.422 3.793 3.793 0 0 0 5.388 0 3.852 3.852 0 0 0 0-5.422Z", fill: "currentColor" })] })));
};

var EyeOn = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgEyeOn
});

var SvgFail = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.447 8.553c.3.3.3.788 0 1.088L9.64 15.447a.77.77 0 1 1-1.088-1.088l5.806-5.806c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.553 8.553c.3-.3.788-.3 1.088 0l5.806 5.806a.77.77 0 0 1-1.088 1.088L8.553 9.64a.77.77 0 0 1 0-1.088Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" })] })));
};

var Fail = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFail
});

var SvgFilter = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.797C3 3.805 3.806 3 4.8 3h14.4c.994 0 1.8.805 1.8 1.797v2.656c0 .477-.19.933-.527 1.27l-5.356 5.349c-.301.3-.79.3-1.091 0a.77.77 0 0 1 0-1.09l5.356-5.347a.255.255 0 0 0 .075-.182V4.797a.257.257 0 0 0-.257-.256H4.8a.257.257 0 0 0-.257.256v2.656c0 .07.027.134.074.18l.001.002 5.356 5.347a.77.77 0 0 1 0 1.09c-.301.3-.79.3-1.09 0L3.528 8.725h-.001A1.793 1.793 0 0 1 3 7.453V4.797Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.429 12.757a.77.77 0 0 1 .771.77v6.418c0 .334.315.58.64.498l2.57-.642a.514.514 0 0 0 .39-.498v-5.776a.77.77 0 0 1 1.543 0v5.776c0 .943-.643 1.764-1.559 1.993l-2.571.642a2.057 2.057 0 0 1-2.556-1.993v-6.418a.77.77 0 0 1 .772-.77Z", fill: "currentColor" })] })));
};

var Filter = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFilter
});

var SvgFlag = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.774 2.954c.428 0 .774.344.774.77V21.23c0 .425-.346.769-.774.769A.772.772 0 0 1 4 21.23V3.724c0-.425.347-.77.774-.77ZM19.226 3.026c.427 0 .774.344.774.769v10.277c0 .425-.347.769-.774.769a.772.772 0 0 1-.774-.77V3.796c0-.425.346-.77.774-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m4.774 14.051-.495-.591a.766.766 0 0 0-.1 1.083.778.778 0 0 0 1.074.113l.002-.002a.97.97 0 0 1 .078-.046c.084-.047.238-.121.476-.2.475-.157 1.295-.333 2.578-.333 1.187 0 2.186.384 3.329.832l.043.017c1.105.433 2.351.922 3.854.922 1.453 0 2.465-.27 3.138-.568.336-.149.582-.303.754-.43a2.532 2.532 0 0 0 .283-.244l.008-.008.003-.004.002-.002v-.001s.002 0-.575-.514l.576.513a.766.766 0 0 0-.06-1.086.778.778 0 0 0-1.08.045l-.004.005a.988.988 0 0 1-.078.062 2.434 2.434 0 0 1-.46.26c-.456.202-1.25.434-2.507.434-1.187 0-2.186-.384-3.329-.832l-.043-.017c-1.105-.434-2.351-.923-3.854-.923-1.426 0-2.413.197-3.067.412-.326.108-.568.22-.737.314a2.536 2.536 0 0 0-.287.184l-.009.008-.004.003-.002.001s-.002.002.493.593ZM5.325 4.266a.778.778 0 0 1-1.08.02.766.766 0 0 1-.035-1.087l.564.526c-.564-.526-.563-.527-.563-.527v-.001l.002-.002.004-.004.008-.008a1.23 1.23 0 0 1 .083-.077 2.51 2.51 0 0 1 .201-.157c.172-.121.418-.268.752-.41C5.931 2.256 6.94 2 8.387 2c1.503 0 2.75.489 3.854.922l.043.017c1.143.449 2.142.832 3.329.832 1.283 0 2.103-.176 2.578-.333.238-.079.392-.153.476-.2a.987.987 0 0 0 .077-.046l.003-.002a.778.778 0 0 1 1.074.113.766.766 0 0 1-.1 1.084l-.495-.592.494.592-.001.001-.002.001-.004.004-.009.007a1.536 1.536 0 0 1-.085.062 2.52 2.52 0 0 1-.202.122 4.38 4.38 0 0 1-.737.314c-.654.215-1.64.412-3.067.412-1.503 0-2.75-.49-3.854-.923-.014-.005-.029-.01-.043-.017-1.143-.448-2.142-.832-3.329-.832-1.261 0-2.06.223-2.519.417-.23.097-.38.19-.462.248a.975.975 0 0 0-.081.063Z", fill: "currentColor" })] })));
};

var Flag = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFlag
});

var SvgHome = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.757 3.27a3.653 3.653 0 0 1 4.487 0l5.845 4.547a3.653 3.653 0 0 1 1.411 2.884v7.145a3.654 3.654 0 0 1-3.654 3.654H6.154A3.654 3.654 0 0 1 2.5 17.846v-7.145c0-1.127.52-2.192 1.41-2.884L9.757 3.27Zm.897 1.154L4.808 8.97a2.191 2.191 0 0 0-.846 1.73v7.145c0 1.211.98 2.192 2.192 2.192h11.692c1.211 0 2.192-.98 2.192-2.192v-7.145a2.19 2.19 0 0 0-.846-1.73l-5.846-4.547a2.192 2.192 0 0 0-2.692 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.55 11.912a2.192 2.192 0 1 0-3.1 3.1 2.192 2.192 0 0 0 3.1-3.1Zm1.033-1.034a3.654 3.654 0 1 0-5.167 5.167 3.654 3.654 0 0 0 5.167-5.167Z", fill: "currentColor" })] })));
};

var Home = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgHome
});

var SvgImage = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.558 4.385c-.642 0-1.162.516-1.162 1.153v12.924c0 .637.52 1.153 1.162 1.153h14.88c.643 0 1.164-.516 1.164-1.153V5.538c0-.637-.52-1.153-1.163-1.153H4.559ZM2 5.538A2.548 2.548 0 0 1 4.558 3h14.88a2.548 2.548 0 0 1 2.56 2.538v12.924A2.549 2.549 0 0 1 19.437 21H4.559A2.548 2.548 0 0 1 2 18.462V5.538Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.1 8.415a1.17 1.17 0 0 0-1.645 0 1.147 1.147 0 0 0 0 1.632c.454.45 1.19.45 1.645 0a1.147 1.147 0 0 0 0-1.632Zm.986-.98c-1-.99-2.62-.99-3.618 0-1 .992-1 2.6 0 3.59 1 .992 2.62.992 3.618 0 1-.99 1-2.598 0-3.59ZM15.524 12.288a1.638 1.638 0 0 1 2.29-.252l3.924 3.116c.301.239.35.674.11.973a.702.702 0 0 1-.982.108l-3.925-3.116a.235.235 0 0 0-.327.036m0 0-3.104 3.85a1.638 1.638 0 0 1-2.288.252l-1.739-1.38a.234.234 0 0 0-.324.032l-4.067 4.844a.701.701 0 0 1-.983.088.689.689 0 0 1-.09-.974l4.068-4.844a1.637 1.637 0 0 1 2.268-.228l1.738 1.38c.1.08.248.064.328-.035l3.103-3.85", fill: "currentColor" })] })));
};

var Image = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgImage
});

var SvgInformation = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8.253a1 1 0 1 1 2-.005 1 1 0 0 1-2 .005Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75ZM2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 11.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] })));
};

var Information = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgInformation
});

var SvgKey = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.673 8.406c.186-.187.476-.357.83-.357s.644.17.83.357c.185.186.355.477.355.833s-.17.647-.355.833a1.183 1.183 0 0 1-.83.357c-.354 0-.644-.17-.83-.357a1.192 1.192 0 0 1-.355-.833c0-.356.17-.647.355-.833Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.01 4.166c-.59-.218-1.073-.12-1.433.241L9.589 7.408a1.48 1.48 0 0 0-.346 1.538l.916 2.044a.778.778 0 0 1-.163.872l-5.95 5.876v2.21H6.25l5.955-5.98a.77.77 0 0 1 .85-.165l2.147.923c.59.218 1.073.12 1.433-.242l2.961-2.973c.341-.426.456-.948.268-1.467l-1.538-3.603-.007-.018a1.27 1.27 0 0 0-.703-.706l-.017-.007-3.589-1.544Zm-2.526-.856c.872-.876 2.034-.987 3.084-.592a.832.832 0 0 1 .033.014L18.2 4.28a2.82 2.82 0 0 1 1.55 1.557l1.543 3.614.013.033c.419 1.121.128 2.238-.542 3.046a.8.8 0 0 1-.047.051l-2.988 3.001c-.873.876-2.034.987-3.084.592a.784.784 0 0 1-.033-.014l-1.683-.724-5.812 5.837a.771.771 0 0 1-.546.227H3.273a.774.774 0 0 1-.773-.776v-3.311c0-.208.083-.407.23-.553l5.799-5.726-.706-1.577a3.037 3.037 0 0 1 .673-3.247l2.988-3Z", fill: "currentColor" })] })));
};

var Key = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgKey
});

var SvgLock = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538c-1.853 0-3.355 1.493-3.355 3.334v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873C7.097 4.182 9.292 2 12 2c2.708 0 4.903 2.181 4.903 4.872v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-1.841-1.502-3.334-3.355-3.334Z", fill: "currentColor" })] })));
};

var Lock = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgLock
});

var SvgMenu = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.251 6a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001A.75.75 0 0 1 2.25 6ZM2.251 12a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75ZM2.251 18a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var Menu = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMenu
});

var SvgMinus = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 16 2", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1c0-.552.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89C.398 2 0 1.552 0 1Z", fill: "currentColor" }) })));
};

var Minus = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMinus
});

var SvgMore = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 18.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 12.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 6.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246ZM11.438 6h-.688v.004", fill: "currentColor" }) })));
};

var More = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMore
});

var SvgNotification = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.292 17.593a.75.75 0 0 1 .75.75v.365a3.042 3.042 0 0 1-6.084.001v-.365a.75.75 0 0 1 1.5 0v.365a1.542 1.542 0 0 0 3.084-.001v-.365a.75.75 0 0 1 .75-.75ZM9.417 4.833a2.583 2.583 0 1 1 5.166 0v.918a.75.75 0 0 1-1.5 0v-.918a1.083 1.083 0 1 0-2.166 0v.918a.75.75 0 0 1-1.5 0v-.918Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.094 6.407a3.78 3.78 0 0 0-3.781 3.781v2.797c0 .73-.29 1.429-.806 1.944l-.64.641a1.25 1.25 0 0 0-.367.884c0 .63.51 1.14 1.14 1.14h10.721c.63 0 1.14-.51 1.14-1.14 0-.33-.132-.65-.366-.884l-.641-.64a2.75 2.75 0 0 1-.806-1.945v-2.797a3.78 3.78 0 0 0-3.781-3.781h-1.813Zm-5.281 3.781a5.28 5.28 0 0 1 5.281-5.281h1.813a5.28 5.28 0 0 1 5.281 5.281v2.797c0 .33.132.65.366.884l.641.64a2.75 2.75 0 0 1 .806 1.945 2.64 2.64 0 0 1-2.64 2.64H6.64A2.64 2.64 0 0 1 4 16.454c0-.73.29-1.429.806-1.944l.64-.641a1.25 1.25 0 0 0 .367-.884v-2.797Z", fill: "currentColor" })] })));
};

var Notification = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgNotification
});

var SvgPlus = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .907c.523 0 .947.424.947.948v14.29a.947.947 0 0 1-1.894 0V1.855c0-.524.424-.948.947-.948Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.093 9a.947.947 0 0 1-.948.947H1.855a.947.947 0 1 1 0-1.894h14.29c.524 0 .948.424.948.947Z", fill: "currentColor" })] })));
};

var Plus = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPlus
});

var SvgPrint = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3.75a.25.25 0 0 0-.25.25v3.25h8.5V4a.25.25 0 0 0-.25-.25H8Zm9.75 3.5V4A1.75 1.75 0 0 0 16 2.25H8A1.75 1.75 0 0 0 6.25 4v3.25H5A2.75 2.75 0 0 0 2.25 10v5A2.75 2.75 0 0 0 5 17.75h1.25V20c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 17.75 20v-2.25H19A2.75 2.75 0 0 0 21.75 15v-5A2.75 2.75 0 0 0 19 7.25h-1.25ZM5 8.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h1.25V13.8a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75v2.45H19c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25H5Zm11.25 5.8h-8.5V20c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-5.45ZM6.25 11a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var Print = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPrint
});

var SvgQuestion = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.436 9.971a1.422 1.422 0 0 0-1.496-1.306.771.771 0 0 1-.074 0 1.467 1.467 0 0 0-1.49 1.135.769.769 0 0 1-1.499-.348 3.005 3.005 0 0 1 3.015-2.324 2.96 2.96 0 0 1 3.082 2.82c0 1.175-.856 1.899-1.386 2.33l-.196.157c-.209.168-.365.294-.492.426a.597.597 0 0 0-.131.173.769.769 0 0 1-1.538-.008c0-.552.301-.96.558-1.229.204-.213.466-.422.686-.598l.143-.115c.56-.455.808-.755.818-1.113ZM12.604 15.242A.767.767 0 0 0 12 14.95a.897.897 0 1 0 .897.897.768.768 0 0 0-.293-.604Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.231 15.718c0-.425.344-.769.769-.769.495 0 .897.402.897.897a.769.769 0 0 1-1.373.476.767.767 0 0 1-.293-.604Z", fill: "currentColor" })] })));
};

var Question = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgQuestion
});

var SvgRefresh = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 3.538a.77.77 0 0 1 .768.77v3.077h3.077a.77.77 0 1 1 0 1.538H2.77A.77.77 0 0 1 2 8.153V4.309a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.917 7.833C4.497 4.396 7.964 2 12 2c5.523 0 10 4.477 10 10a.77.77 0 0 1-1.538 0A8.46 8.46 0 0 0 12 3.538c-3.41 0-6.345 2.023-7.685 4.937a.77.77 0 0 1-1.398-.642ZM16.615 15.846a.77.77 0 0 1 .77-.77h3.846a.77.77 0 0 1 .769.77v3.846a.77.77 0 0 1-1.538 0v-3.077h-3.077a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 11.23a.77.77 0 0 1 .768.77A8.46 8.46 0 0 0 12 20.462c3.41 0 6.345-2.023 7.685-4.937a.77.77 0 1 1 1.398.642C19.502 19.604 16.035 22 12 22 6.477 22 2 17.523 2 12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" })] })));
};

var Refresh = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgRefresh
});

var SvgSearch = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.286 7.22a5.704 5.704 0 1 0-8.067 8.066 5.704 5.704 0 0 0 8.067-8.067Zm1.095-1.096A7.253 7.253 0 1 0 6.124 16.381 7.253 7.253 0 0 0 16.381 6.124Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.282 15.282a.774.774 0 0 1 1.095 0l3.396 3.396a.774.774 0 1 1-1.095 1.095l-3.396-3.396a.774.774 0 0 1 0-1.095Z", fill: "currentColor" })] })));
};

var Search = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSearch
});

var SvgSettings = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { clipRule: "evenodd", d: "M14.121 9.879A3 3 0 1 1 9.88 14.12 3 3 0 0 1 14.12 9.88Z", stroke: props.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), jsx("path", { clipRule: "evenodd", d: "M16.18 18.725a1.29 1.29 0 0 0 1.823 0l.722-.722a1.29 1.29 0 0 0 0-1.823 1.324 1.324 0 0 1-.284-1.453 7.63 7.63 0 0 0 .065-.16 1.217 1.217 0 0 1 1.137-.766h.067c.712 0 1.289-.577 1.289-1.289v-1.021c0-.712-.577-1.289-1.289-1.289h-.067c-.5 0-.954-.301-1.137-.766a7.63 7.63 0 0 0-.065-.16 1.324 1.324 0 0 1 .284-1.453 1.29 1.29 0 0 0 0-1.823l-.722-.722a1.29 1.29 0 0 0-1.823 0 1.324 1.324 0 0 1-1.453.284l-.16-.065a1.227 1.227 0 0 1-.767-1.141v-.067C13.8 3.577 13.223 3 12.511 3H11.49a1.29 1.29 0 0 0-1.29 1.289v.067c0 .5-.301.954-.766 1.137-.054.022-.107.043-.16.066a1.324 1.324 0 0 1-1.453-.284 1.29 1.29 0 0 0-1.823 0l-.723.722a1.29 1.29 0 0 0 0 1.823c.382.382.494.955.284 1.453a5.419 5.419 0 0 0-.065.161 1.22 1.22 0 0 1-1.138.766h-.067C3.577 10.2 3 10.777 3 11.489v1.021c0 .713.577 1.29 1.289 1.29h.067c.5 0 .954.301 1.137.766l.065.16c.21.498.098 1.071-.284 1.453a1.29 1.29 0 0 0 0 1.823l.722.722a1.29 1.29 0 0 0 1.823 0 1.324 1.324 0 0 1 1.453-.284l.16.065c.466.183.766.637.766 1.137v.067c0 .712.577 1.289 1.289 1.289h1.021c.712 0 1.289-.577 1.289-1.289v-.067c0-.5.301-.954.766-1.137l.16-.065a1.332 1.332 0 0 1 1.457.285Z", stroke: props.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] })));
};

var Settings = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSettings
});

var SvgStar = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2a.73.73 0 0 1 .657.426l2.694 5.722 6.024.923a.74.74 0 0 1 .589.518.783.783 0 0 1-.183.778L17.42 14.82l1.03 6.291a.775.775 0 0 1-.293.745.708.708 0 0 1-.772.055L12 18.943l-5.385 2.968a.708.708 0 0 1-.772-.055.775.775 0 0 1-.292-.745l1.03-6.291-4.362-4.453a.783.783 0 0 1-.183-.778.74.74 0 0 1 .59-.518l6.022-.923 2.695-5.722A.73.73 0 0 1 12 2Zm0 2.491L9.793 9.178a.735.735 0 0 1-.55.418l-4.948.758 3.583 3.658a.78.78 0 0 1 .21.671l-.845 5.16 4.414-2.434a.707.707 0 0 1 .686 0l4.414 2.434-.844-5.16a.78.78 0 0 1 .209-.67l3.583-3.659-4.948-.758a.734.734 0 0 1-.55-.418L12 4.49Z", fill: "currentColor" }) })));
};

var Star = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgStar
});

var SvgSuccess = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.12 8.998c.3.3.3.787 0 1.087l-4.89 4.89a.77.77 0 0 1-1.198.14L7.809 12.89a.769.769 0 1 1 1.087-1.087l1.665 1.665 4.47-4.471c.301-.3.788-.3 1.088 0Z", fill: "currentColor" })] })));
};

var Success = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSuccess
});

var SvgSupport = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10.62a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h1c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-1Zm-1.75.25c0-.966.784-1.75 1.75-1.75h1a2.75 2.75 0 0 1 2.75 2.75v3A2.75 2.75 0 0 1 19 17.62h-1a1.75 1.75 0 0 1-1.75-1.75v-5ZM5 10.62c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h1a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25H5Zm-2.75 1.25A2.75 2.75 0 0 1 5 9.12h1c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 6 17.62H5a2.75 2.75 0 0 1-2.75-2.75v-3Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 9.37a7.25 7.25 0 1 1 14.5 0v.5a.75.75 0 0 1-1.5 0v-.5a5.75 5.75 0 1 0-11.5 0v.5a.75.75 0 0 1-1.5 0v-.5ZM11.375 19.37a.5.5 0 0 0 0 1h1.25a.5.5 0 0 0 0-1h-1.25Zm-2 .5a2 2 0 0 1 2-2h1.25a2 2 0 0 1 0 4h-1.25a2 2 0 0 1-2-2Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 16.12a.75.75 0 0 1 .75.75v1A2.75 2.75 0 0 1 16 20.62h-2.125a.75.75 0 0 1 0-1.5H16c.69 0 1.25-.56 1.25-1.25v-1a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] })));
};

var Support = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSupport
});

var SvgTimeZone = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.754 3.5a8.254 8.254 0 0 0 0 16.508.75.75 0 1 1 0 1.5C6.367 21.508 2 17.14 2 11.754S6.367 2 11.754 2s9.754 4.367 9.754 9.754a.75.75 0 1 1-1.5 0A8.254 8.254 0 0 0 11.754 3.5Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.513 8.752a.75.75 0 0 1 .75-.75h16.981a.75.75 0 0 1 0 1.5H3.264a.75.75 0 0 1-.75-.75ZM2.514 14.755a.75.75 0 0 1 .75-.75h8.49a.75.75 0 1 1 0 1.5h-8.49a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.273 3.433a2.865 2.865 0 0 1 4.962-.001 16.234 16.234 0 0 1 2.27 8.324.75.75 0 1 1-1.5-.004 14.733 14.733 0 0 0-2.063-7.559l-.005-.008a1.366 1.366 0 0 0-2.366 0l-.004.007a14.885 14.885 0 0 0 0 15.125l.003.005c.245.424.697.685 1.187.687a.75.75 0 0 1-.004 1.5 2.876 2.876 0 0 1-2.48-1.432 16.385 16.385 0 0 1 0-16.644Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.756 14.505a3.252 3.252 0 1 0 0 6.503 3.252 3.252 0 0 0 0-6.503Zm0-1.5a4.752 4.752 0 1 0 0 9.503 4.752 4.752 0 0 0 0-9.503Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.294 15.799c.345 0 .624.279.624.623v1.488h1.129a.624.624 0 1 1 0 1.247h-1.753a.624.624 0 0 1-.623-.623v-2.111c0-.345.279-.624.623-.624Z", fill: "currentColor" })] })));
};

var TimeZone = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgTimeZone
});

var SvgTrash = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.818 5.077c.427 0 .773.344.773.77v13.076c0 .859.68 1.539 1.526 1.539h7.727c.862 0 1.565-.697 1.565-1.539V5.846c0-.425.346-.77.773-.77a.77.77 0 0 1 .773.77v13.077c0 1.708-1.413 3.077-3.11 3.077H8.116a3.067 3.067 0 0 1-3.072-3.077V5.846c0-.425.346-.77.773-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 5.846c0-.425.346-.77.773-.77h15.454c.427 0 .773.345.773.77 0 .425-.346.77-.773.77H4.273a.771.771 0 0 1-.773-.77ZM9.167 2.77c0-.426.346-.77.772-.77h4.122a.77.77 0 0 1 .772.77.77.77 0 0 1-.772.768H9.939a.771.771 0 0 1-.772-.769ZM14.06 9.18a.77.77 0 0 1 .773.769v7.18a.77.77 0 0 1-.772.768.77.77 0 0 1-.773-.769v-7.18a.77.77 0 0 1 .773-.769ZM9.94 9.18a.77.77 0 0 1 .772.769v7.18a.77.77 0 0 1-.773.768.771.771 0 0 1-.772-.769v-7.18c0-.424.346-.769.772-.769Z", fill: "currentColor" })] })));
};

var Trash = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgTrash
});

var SvgUnlock = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12ZM7.259 5.681A4.89 4.89 0 0 1 12 2c2.708 0 4.903 2.181 4.903 4.872 0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77c0-1.84-1.502-3.333-3.355-3.333a3.343 3.343 0 0 0-3.24 2.52.775.775 0 0 1-1.501-.377Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.129 6.103c.428 0 .774.344.774.769v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-.425.346-.77.774-.77Z", fill: "currentColor" })] })));
};

var Unlock = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUnlock
});

var SvgUpload = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061l3.721 3.721V3a.75.75 0 0 1 .75-.75ZM3.25 21a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var Upload = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUpload
});

var SvgUser = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.348 16.472c-2.082 0-3.806 1.625-3.806 3.765A.767.767 0 0 1 4.77 21 .767.767 0 0 1 4 20.237c0-3.005 2.437-5.29 5.348-5.29h5.304c3.038 0 5.348 2.41 5.348 5.29a.767.767 0 0 1-.771.763.767.767 0 0 1-.77-.763c0-2.06-1.643-3.765-3.807-3.765H9.348ZM14.63 5.56a3.774 3.774 0 0 0-5.164.009c-1.41 1.313-1.378 3.599.034 5.083 1.327 1.396 3.638 1.364 5.138-.033 1.429-1.33 1.456-3.6-.009-5.058Zm1.074-1.118a5.346 5.346 0 0 0-7.307.003c-2.126 1.98-1.95 5.25-.034 7.265 2.001 2.103 5.308 1.93 7.344.033 2.104-1.959 2.08-5.238.02-7.28a.778.778 0 0 0-.011-.01l-.012-.011Z", fill: "currentColor" }) })));
};

var User = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUser
});

var SvgWarning = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6.615a.77.77 0 0 1 .77.77v5.128a.77.77 0 1 1-1.54 0V7.385a.77.77 0 0 1 .77-.77ZM10.974 16.362a1.026 1.026 0 1 1 2.05-.005 1.026 1.026 0 0 1-2.05.005Z", fill: "currentColor" })] })));
};

var Warning = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgWarning
});

var SvgWifi = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.876 19.627a1.125 1.125 0 1 1 2.247-.003 1.125 1.125 0 0 1-2.247.003Zm.473-.003-.473-.003v.006M18.901 12.553c-3.805-3.49-9.998-3.49-13.803 0a.75.75 0 1 1-1.014-1.106c4.38-4.016 11.452-4.016 15.831 0a.75.75 0 1 1-1.014 1.106Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.91 8.366c-5.463-4.821-14.356-4.821-19.82 0a.75.75 0 0 1-.992-1.124c6.03-5.323 15.774-5.323 21.805 0a.75.75 0 1 1-.993 1.124ZM15.891 16.353a5.526 5.526 0 0 0-7.783 0 .75.75 0 1 1-1.058-1.064 7.026 7.026 0 0 1 9.9 0 .75.75 0 0 1-1.059 1.064Z", fill: "currentColor" })] })));
};

var Wifi = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgWifi
});

var SvgAudio = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: "currentColor" })] })));
};

var Audio = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgAudio
});

var SvgCameraOff = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.81 2.886a.75.75 0 0 1 1.044.184l11.9 17a.75.75 0 1 1-1.228.86l-11.9-17a.75.75 0 0 1 .184-1.044Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.75a.75.75 0 0 1 .75.75v7a1.5 1.5 0 0 0 1.5 1.5h7.962a.75.75 0 0 1 0 1.5H5.25a3 3 0 0 1-3-3v-7A.75.75 0 0 1 3 7.75ZM4.412 6.25a.75.75 0 0 1 .75-.75h7.963a3 3 0 0 1 3 3v7a.75.75 0 0 1-1.5 0v-7a1.5 1.5 0 0 0-1.5-1.5H5.162a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.7 7.265c1.227-.988 3.05-.114 3.05 1.46v6.55c0 1.575-1.823 2.449-3.05 1.46l-3.795-3.054a.75.75 0 1 1 .94-1.168l3.795 3.054c.245.197.61.024.61-.292v-6.55a.374.374 0 0 0-.61-.292l-3.795 3.054a.75.75 0 0 1-.94-1.168L18.7 7.265Z", fill: "currentColor" })] })));
};

var CameraOff = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCameraOff
});

var SvgCameraOn = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 22 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.633 1.625c-.898 0-1.625.727-1.625 1.625v7.583c0 .898.727 1.625 1.625 1.625h8.532c.897 0 1.625-.727 1.625-1.625V3.25c0-.898-.728-1.625-1.625-1.625H3.633ZM.383 3.25A3.25 3.25 0 0 1 3.633 0h8.532a3.25 3.25 0 0 1 3.25 3.25v7.583a3.25 3.25 0 0 1-3.25 3.25H3.633a3.25 3.25 0 0 1-3.25-3.25V3.25Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.204 1.912c1.33-1.07 3.304-.124 3.304 1.582v7.096c0 1.705-1.975 2.652-3.305 1.581l-4.11-3.308a.812.812 0 1 1 1.018-1.266l4.112 3.309c.265.213.66.025.66-.316V3.494a.406.406 0 0 0-.66-.317l-4.112 3.31a.812.812 0 1 1-1.018-1.267l4.11-3.308Z", fill: "currentColor" })] })));
};

var CameraOn = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCameraOn
});

var SvgFullscreen = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.073 1.375c0-.397.322-.719.719-.719h3.833c.397 0 .719.322.719.72v3.832a.719.719 0 0 1-1.438 0V2.094h-3.114a.719.719 0 0 1-.72-.719Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.133.867c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM1.375 14.073c.397 0 .719.322.719.719v3.114h3.114a.719.719 0 1 1 0 1.438H1.375a.719.719 0 0 1-.719-.719v-3.833c0-.397.322-.719.719-.719Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.633 12.367c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM4.25 3.052c-.662 0-1.198.536-1.198 1.198v4.792a.719.719 0 1 1-1.437 0V4.25A2.635 2.635 0 0 1 4.25 1.615h4.792a.719.719 0 1 1 0 1.437H4.25ZM17.667 10.24c.397 0 .718.321.718.718v4.792a2.635 2.635 0 0 1-2.635 2.636H10a.719.719 0 0 1 0-1.438h5.75c.662 0 1.198-.536 1.198-1.198v-4.792c0-.397.322-.718.719-.718Z", fill: "currentColor" })] })));
};

var Fullscreen = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFullscreen
});

var SvgMicrophoneOff = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 11.25a.75.75 0 0 1 .75.75A2.751 2.751 0 0 0 12 14.752a.75.75 0 0 1 0 1.5A4.251 4.251 0 0 1 7.75 12a.75.75 0 0 1 .75-.75ZM8.5 8.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 7.75a.75.75 0 0 1 .75.75V12a.75.75 0 1 1-1.5 0V8.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.498 10.75a.75.75 0 0 1 .749.75 6.744 6.744 0 0 0 11.29 4.99.75.75 0 0 1 1.012 1.107A8.244 8.244 0 0 1 3.747 11.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.253a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM3.466 3.466a.75.75 0 0 1 1.061 0l16.007 16.007a.75.75 0 0 1-1.061 1.06L3.466 4.528a.75.75 0 0 1 0-1.06ZM8.238 4.566A4.236 4.236 0 0 1 16.252 6.5V11a.75.75 0 0 1-1.5 0V6.495a2.736 2.736 0 0 0-5.176-1.25.75.75 0 1 1-1.338-.678ZM19.505 10.75a.75.75 0 0 1 .748.752 8.159 8.159 0 0 1-.835 3.572.75.75 0 1 1-1.346-.661 6.658 6.658 0 0 0 .681-2.915.75.75 0 0 1 .752-.748Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 13.945a.75.75 0 0 1 .001 1.061 4.238 4.238 0 0 1-3.006 1.245.75.75 0 0 1 0-1.5c.729.001 1.43-.288 1.944-.804a.75.75 0 0 1 1.061-.002Z", fill: "currentColor" })] })));
};

var MicrophoneOff = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMicrophoneOff
});

var SvgMicrophoneOn = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: props.color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: props.color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: props.color })] })));
};

var MicrophoneOn = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMicrophoneOn
});

var SvgMinimize = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 2.996a.75.75 0 0 1 .75-.75h4.002a.75.75 0 1 1 0 1.5H3.746v3.252a.75.75 0 0 1-1.5 0V2.996Zm8.004 2A2.75 2.75 0 0 1 13 2.246h6.004a2.75 2.75 0 0 1 2.75 2.75V11a2.75 2.75 0 0 1-2.75 2.75H13A2.75 2.75 0 0 1 10.25 11V4.996ZM13 3.746c-.69 0-1.25.56-1.25 1.25V11c0 .69.56 1.25 1.25 1.25h6.004c.69 0 1.25-.56 1.25-1.25V4.996c0-.69-.56-1.25-1.25-1.25H13ZM8.529 15.471a.75.75 0 0 1 0 1.06l-3.722 3.723h2.191a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75v-4.002a.75.75 0 0 1 1.5 0v2.19l3.722-3.72a.75.75 0 0 1 1.06 0Zm12.475.78a.75.75 0 0 1 .75.75v4.003a.75.75 0 0 1-.75.75h-4.002a.75.75 0 0 1 0-1.5h3.252v-3.252a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }) })));
};

var Minimize = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMinimize
});

var SvgMiniplayer = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.283 14c0-.966.783-1.75 1.75-1.75H20c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 0 1 20 21.75h-8.969A1.75 1.75 0 0 1 9.283 20v-6Zm1.75-.25a.25.25 0 0 0-.25.25v6c0 .139.111.25.25.25H20a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25h-8.969ZM5.47 6.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 6.538a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-.75.75H6.29a.75.75 0 1 1 0-1.5H8.25V7.288a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h2a.75.75 0 1 1 0 1.5H5A2.75 2.75 0 0 1 2.252 13V6a2.75 2.75 0 0 1 2.75-2.75h11A2.75 2.75 0 0 1 18.75 6v4a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H5Z", fill: "currentColor" })] })));
};

var Miniplayer = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMiniplayer
});

var SvgPhoneOn = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { clipRule: "evenodd", d: "M11.19 11.192a13.162 13.162 0 0 0 2.749-3.968.78.78 0 0 0-.173-.862l-.853-.852c-.7-.699-.7-1.687-.089-2.298l1.223-1.222a2.083 2.083 0 0 1 2.946 0l.68.679c.771.772 1.093 1.885.885 2.99-.515 2.721-2.096 5.701-4.647 8.253-2.551 2.55-5.532 4.132-8.253 4.646-1.105.209-2.218-.113-2.99-.885l-.678-.678a2.083 2.083 0 0 1 0-2.946l1.222-1.222c.61-.61 1.6-.61 2.209 0l.94.942a.78.78 0 0 0 .862.173c1.385-.612 2.75-1.532 3.968-2.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};

var PhoneOn = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPhoneOn
});

var SvgRotate = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.424 4.053a.75.75 0 0 1 .75.75v2.893a.75.75 0 0 1-.75.75h-2.893a.75.75 0 0 1 0-1.5h2.143V4.803a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12c0-5.384 4.365-9.75 9.75-9.75a9.747 9.747 0 0 1 8.563 5.087.75.75 0 0 1-1.316.718A8.25 8.25 0 1 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.384-4.365 9.75-9.75 9.75S2.25 17.384 2.25 12Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.945 10.055a2.75 2.75 0 1 0-3.89 3.89 2.75 2.75 0 0 0 3.89-3.89Zm1.06-1.06a4.25 4.25 0 1 0-6.01 6.01 4.25 4.25 0 0 0 6.01-6.01Z", fill: "currentColor" })] })));
};

var Rotate = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgRotate
});

var SvgShareScreen = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.12A2.75 2.75 0 0 1 5 2.37h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 1 1 1.5 0v6.125A2.75 2.75 0 0 1 19 21.87H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.372a3.751 3.751 0 0 1 3.752-3.75h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.25v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.34a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.502a.75.75 0 1 1-1.06-1.061l1.97-1.97-1.97-1.972a.75.75 0 0 1 0-1.06Z", fill: "currentColor" })] })));
};

var ShareScreen = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgShareScreen
});

var SvgChart = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.194 15.334a.194.194 0 0 0-.194.194v3.778c0 .107.087.194.194.194h4.723a.75.75 0 0 1 0 1.5H4.194c-.937 0-1.694-.76-1.694-1.694v-3.778c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H4.194ZM13.833 4.194c0-.935.759-1.694 1.694-1.694h3.778c.935 0 1.694.757 1.694 1.694v15.112c0 .935-.757 1.694-1.694 1.694h-4.722a.75.75 0 0 1-.75-.75V4.194Zm1.5 0V19.5h3.972a.194.194 0 0 0 .194-.194V4.194A.194.194 0 0 0 19.305 4h-3.778a.194.194 0 0 0-.194.194Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.86 9.667a.194.194 0 0 0-.194.194V19.5h4.917a.75.75 0 0 1 0 1.5H8.917a.75.75 0 0 1-.751-.75V9.861c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H9.86Z", fill: "currentColor" })] })));
};

var Chart = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgChart
});

var SvgChat = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h3c.219 0 .416.094.553.243l3.446 3.446 3.47-3.47A.75.75 0 0 1 16 16.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5Zm7.553 17.757a.75.75 0 0 1-1.083.024L7.688 17.75H5A2.75 2.75 0 0 1 2.25 15V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75h-2.69l-3.757 3.757Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Z", fill: "currentColor" })] })));
};

var Chat = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgChat
});

var SvgClipboardSaved = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.167 12.321c.29.293.29.768 0 1.06l-2.768 2.792a.74.74 0 0 1-1.051.001l-1.665-1.673a.755.755 0 0 1-.002-1.06.74.74 0 0 1 1.052-.002l1.139 1.144 2.243-2.262a.74.74 0 0 1 1.052 0ZM9.946 3.555 8.843 4.939v.72c0 .134.109.243.243.243h5.828c.134 0 .243-.11.243-.244V4.94l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.586A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.235-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.731a.728.728 0 0 1-.73-.728v.972c0 .943.762 1.708 1.7 1.708h5.83c.938 0 1.7-.765 1.7-1.708v-.975h-.73Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634A2.677 2.677 0 0 1 6.171 3.95h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.731H6.171c-.67 0-1.214.546-1.214 1.22v12.683c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.2 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" })] })));
};

var ClipboardSaved = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgClipboardSaved
});

var SvgClipboard = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.946 3.555 8.843 4.94v.719c0 .134.109.243.243.243h5.828c.134 0 .243-.109.243-.243v-.72l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.585V2.64A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.236-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.732a.728.728 0 0 1-.73-.729v.973c0 .942.762 1.707 1.7 1.707h5.83c.938 0 1.7-.765 1.7-1.707v-.976h-.73Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634a2.677 2.677 0 0 1 2.671-2.683h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.732H6.171c-.67 0-1.214.545-1.214 1.22v12.682c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.201 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.386 11.512a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732ZM7.386 16.39a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732Z", fill: "currentColor" })] })));
};

var Clipboard = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgClipboard
});

var SvgCreditCard = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { d: "M3 9h18M9.57 13H7m11 6H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};

var CreditCard = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCreditCard
});

var SvgDashboard = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.128 3.962a3.167 3.167 0 0 0-3.166 3.166v9.744a3.167 3.167 0 0 0 3.166 3.166h9.744a3.167 3.167 0 0 0 3.166-3.166V7.128a3.167 3.167 0 0 0-3.166-3.166H7.128ZM2.5 7.128A4.628 4.628 0 0 1 7.128 2.5h9.744A4.628 4.628 0 0 1 21.5 7.128v9.744a4.628 4.628 0 0 1-4.628 4.628H7.128A4.628 4.628 0 0 1 2.5 16.872V7.128Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.124 8.615 2.825 5.648 1.16-2.32a1.219 1.219 0 0 1 1.09-.674h4.57a.73.73 0 0 1 0 1.462h-4.42l-1.31 2.62c-.45.9-1.731.9-2.18.001l-2.833-5.664L8.73 12.09v.002a1.22 1.22 0 0 1-1.072.638H3.231a.73.73 0 0 1 0-1.462h4.282l1.45-2.688a1.218 1.218 0 0 1 2.16.034Zm-.875.66Zm-.432-.007ZM13.73 14.7Z", fill: "currentColor" })] })));
};

var Dashboard = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDashboard
});

var SvgDocumentAtestado = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.783 7.398a3.751 3.751 0 0 1 1.677-.396h1.293a.75.75 0 1 1 0 1.5H6.46c-.35 0-.694.081-1.006.238l-.586.292a2.25 2.25 0 0 0-.924.856l-1.55 2.585a.75.75 0 1 1-1.287-.772l1.551-2.585c.367-.612.901-1.106 1.54-1.425m0 0 .585-.293M17.257 5.001a.75.75 0 0 1 .75.75v3.001a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 7.252a.75.75 0 0 1 .75-.75h3.001a.75.75 0 0 1 0 1.5h-3.001a.75.75 0 0 1-.75-.75ZM16.006 12.754a.75.75 0 0 1 .75-.75h2.001a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.005 15.755a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5h-4.002a.75.75 0 0 1-.75-.75ZM10.414 10.033a2.396 2.396 0 0 1 3.688 3.025l-2.994 4.49A4.751 4.751 0 0 1 8.77 19.38l-5.765 2.083a.75.75 0 0 1-.51-1.41l5.765-2.084a3.252 3.252 0 0 0 1.6-1.254l2.994-4.49a.896.896 0 0 0-1.38-1.131l-2.19 2.19a.75.75 0 0 1-.531.22h-2a.75.75 0 0 1 0-1.5h1.69l1.971-1.97Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.003 4.25A2.25 2.25 0 0 1 9.253 2h11.005a2.25 2.25 0 0 1 2.25 2.25v15.007a2.25 2.25 0 0 1-2.25 2.25H9.253a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .414.336.75.75.75h11.005a.75.75 0 0 0 .75-.75V4.25a.75.75 0 0 0-.75-.751H9.253a.75.75 0 0 0-.75.75v8.504a.75.75 0 0 1-1.5 0V4.251Z", fill: "currentColor" })] })));
};

var DocumentAtestado = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDocumentAtestado
});

var SvgFaceId = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.385 8.236a.77.77 0 0 1 .769.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM16.615 8.236a.77.77 0 0 1 .77.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM12.513 8.253a.77.77 0 0 1 .77.77v3.59c0 .99-.805 1.794-1.796 1.794h-.513a.77.77 0 1 1 0-1.538h.513a.257.257 0 0 0 .257-.257v-3.59a.77.77 0 0 1 .769-.769ZM8.132 15.72c.3-.3.787-.3 1.088 0a3.933 3.933 0 0 0 5.561 0 .77.77 0 0 1 1.088 1.088 5.471 5.471 0 0 1-7.737 0 .77.77 0 0 1 0-1.088ZM2 4.82A2.82 2.82 0 0 1 4.82 2h2.655a.77.77 0 1 1 0 1.538H4.82c-.709 0-1.283.574-1.283 1.283v2.654a.77.77 0 1 1-1.538 0V4.82ZM21.23 15.756a.77.77 0 0 1 .77.77v2.654A2.82 2.82 0 0 1 19.18 22h-2.655a.77.77 0 0 1 0-1.538h2.655c.708 0 1.282-.574 1.282-1.282v-2.655a.77.77 0 0 1 .769-.77ZM2.77 15.756a.77.77 0 0 1 .768.77v2.654c0 .708.574 1.282 1.283 1.282h2.654a.77.77 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18v-2.655a.77.77 0 0 1 .77-.77ZM15.756 2.77a.77.77 0 0 1 .77-.77h2.654A2.82 2.82 0 0 1 22 4.82v2.655a.77.77 0 1 1-1.538 0V4.82c0-.709-.574-1.283-1.282-1.283h-2.655a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }) })));
};

var FaceId = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFaceId
});

var SvgFileCheck = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.246 2.25a.75.75 0 0 1 .749.75v3.998c0 .139.112.25.25.25h3.999a.75.75 0 1 1 0 1.5h-3.999a1.75 1.75 0 0 1-1.749-1.75V3a.75.75 0 0 1 .75-.749ZM10.64 11.429a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 0 1 1.06-1.06l.97.97 1.97-1.97a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 10.996a3.747 3.747 0 0 1 3.747-3.748h4.001a3.747 3.747 0 0 1 3.748 3.748v4.001a3.747 3.747 0 0 1-3.748 3.747h-4A3.747 3.747 0 0 1 2.5 14.997v-4.001Zm3.747-2.249A2.248 2.248 0 0 0 4 10.996v4.001a2.248 2.248 0 0 0 2.248 2.248h4.001a2.248 2.248 0 0 0 2.249-2.248v-4.001a2.248 2.248 0 0 0-2.249-2.249h-4Z", fill: "currentColor" }), jsx("path", { d: "M7 5.002c0-.69.56-1.25 1.25-1.25h7.171c.331 0 .649.132.883.366l2.83 2.827c.235.234.367.552.367.884v11.173c0 .69-.56 1.25-1.249 1.25H8.249c-.69 0-1.249-.56-1.249-1.25v-.763H5.501v.763A2.748 2.748 0 0 0 8.25 21.75h10.003A2.748 2.748 0 0 0 21 19.002V7.829c0-.73-.29-1.429-.806-1.944l-2.83-2.828a2.748 2.748 0 0 0-1.943-.803H8.25a2.748 2.748 0 0 0-2.748 2.748v3.244h1.5V5.002Z", fill: "currentColor" })] })));
};

var FileCheck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFileCheck
});

var SvgFileError = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.748 2.003h6.922a.758.758 0 0 1 .15 0h.1c.729 0 1.427.289 1.942.804l2.83 2.827c.517.515.807 1.215.807 1.944v11.173A2.748 2.748 0 0 1 17.75 21.5H7.748A2.748 2.748 0 0 1 5 18.751v-.332A3.749 3.749 0 0 1 2 14.746v-4.001A3.749 3.749 0 0 1 5 7.072V4.75a2.748 2.748 0 0 1 2.748-2.748ZM6.5 18.75v-.257h3.248a3.747 3.747 0 0 0 3.748-3.748v-4.001a3.747 3.747 0 0 0-3.748-3.747H6.5V4.75c0-.69.56-1.25 1.25-1.25h6.246v3.247c0 .966.783 1.749 1.75 1.749H19V18.75c0 .69-.56 1.25-1.249 1.25H7.748c-.69 0-1.249-.56-1.249-1.25Zm9.245-11.753h3.113a1.248 1.248 0 0 0-.223-.304l-2.83-2.827a1.25 1.25 0 0 0-.31-.226v3.107c0 .138.112.25.25.25ZM3.498 10.745a2.248 2.248 0 0 1 2.248-2.248h4.001a2.248 2.248 0 0 1 2.249 2.248v4.001a2.248 2.248 0 0 1-2.249 2.249h-4a2.248 2.248 0 0 1-2.25-2.249v-4.001Zm3.574.268a.75.75 0 1 0-1.152.96l.85 1.019-.85 1.019a.75.75 0 0 0 1.152.96l.673-.809.673.808a.75.75 0 0 0 1.152-.96l-.85-1.018.85-1.02a.75.75 0 0 0-1.152-.96l-.673.809-.673-.808Z", fill: "currentColor" }) })));
};

var FileError = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFileError
});

var SvgFile = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] })));
};

var File = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFile
});

var SvgFontBold = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 6A.75.75 0 0 1 7 5.25h5.875a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75V6Zm1.5.75v4.5h5.125a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h7a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75v-6Zm1.5.75v4.5H14a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" })] })));
};

var FontBold = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFontBold
});

var SvgFontItalic = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.682 5.273a.75.75 0 0 1 .546.91l-3 12a.75.75 0 0 1-1.456-.365l3-12a.75.75 0 0 1 .91-.545Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 18a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM9.25 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 9.25 6Z", fill: "currentColor" })] })));
};

var FontItalic = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFontItalic
});

var SvgFontUnderline = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 5a.75.75 0 0 1 .75.75v6a3.25 3.25 0 0 0 6.5 0v-6a.75.75 0 0 1 1.5 0v6a4.75 4.75 0 1 1-9.5 0v-6A.75.75 0 0 1 8 5ZM6.25 18.75A.75.75 0 0 1 7 18h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var FontUnderline = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFontUnderline
});

var SvgFrame = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 14A2.75 2.75 0 0 1 16 11.25h3A2.75 2.75 0 0 1 21.75 14v5A2.75 2.75 0 0 1 19 21.75h-3A2.75 2.75 0 0 1 13.25 19v-5ZM16 3.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 5A2.75 2.75 0 0 1 16 2.25h3A2.75 2.75 0 0 1 21.75 5v2A2.75 2.75 0 0 1 19 9.75h-3A2.75 2.75 0 0 1 13.25 7V5ZM5 3.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5ZM2.25 5A2.75 2.75 0 0 1 5 2.25h3A2.75 2.75 0 0 1 10.75 5v5A2.75 2.75 0 0 1 8 12.75H5A2.75 2.75 0 0 1 2.25 10V5ZM5 15.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H5ZM2.25 17A2.75 2.75 0 0 1 5 14.25h3A2.75 2.75 0 0 1 10.75 17v2A2.75 2.75 0 0 1 8 21.75H5A2.75 2.75 0 0 1 2.25 19v-2Z", fill: "currentColor" }) })));
};

var Frame = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFrame
});

var SvgIconShare = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.5A2.75 2.75 0 0 1 5 2.75h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 0 1 1.5 0V19.5A2.75 2.75 0 0 1 19 22.25H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.752a3.751 3.751 0 0 1 3.752-3.751h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.251v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.72a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.501a.75.75 0 1 1-1.06-1.06l1.97-1.971-1.97-1.97a.75.75 0 0 1 0-1.061Z", fill: "currentColor" })] })));
};

var IconShare = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgIconShare
});

var SvgIdentity = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.998a.75.75 0 0 1 .75-.75h18.008a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75ZM6.248 11a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75ZM6.25 14.5a.75.75 0 0 1 .75-.75h5a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: props.color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.997 4.747a2.251 2.251 0 0 0-2.25 2.251V15a2.251 2.251 0 0 0 2.25 2.252H10a.75.75 0 0 1 0 1.5H5.997A3.751 3.751 0 0 1 2.247 15V6.998a3.752 3.752 0 0 1 3.75-3.751h12.005a3.752 3.752 0 0 1 3.752 3.751V11a.75.75 0 0 1-1.5 0V6.998a2.251 2.251 0 0 0-2.252-2.251H5.997Z", fill: props.color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.093 16.253H18.41a2.85 2.85 0 0 1 2.843 2.843V19.504c0 .69-.56 1.25-1.25 1.25H13.5c-.69 0-1.25-.56-1.25-1.25v-.409a2.85 2.85 0 0 1 2.843-2.842Zm.003 1.5a1.35 1.35 0 0 0-1.346 1.346v.155h6.003v-.155a1.35 1.35 0 0 0-1.346-1.346h-3.311ZM14 12.49a2.75 2.75 0 1 1 5.502.022 2.75 2.75 0 0 1-5.501-.022Zm2.751 1.262a1.25 1.25 0 1 0-1.25-1.256m1.25 1.256a1.25 1.25 0 0 1-1.25-1.256", fill: props.color })] })));
};

var Identity = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgIdentity
});

var SvgJustifyCenter = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM7.253 20.008a.75.75 0 0 1 .75-.75h8.003a.75.75 0 0 1 0 1.5H8.003a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var JustifyCenter = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgJustifyCenter
});

var SvgJustifyLeft = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 20.008a.75.75 0 0 1 .75-.75h8.004a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var JustifyLeft = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgJustifyLeft
});

var SvgMobile = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.998 3.746c-.69 0-1.25.56-1.25 1.251v14.006c0 .69.56 1.25 1.25 1.25h8.004c.69 0 1.25-.56 1.25-1.25V4.997c0-.69-.56-1.25-1.25-1.25h-.75v1.026A1.307 1.307 0 0 1 14 6.147H9.999a1.307 1.307 0 0 1-1.25-1.375V3.747h-.75Zm0-1.5a2.75 2.75 0 0 0-2.75 2.751v14.006a2.75 2.75 0 0 0 2.75 2.75h8.004a2.75 2.75 0 0 0 2.75-2.75V4.997a2.75 2.75 0 0 0-2.75-2.75H7.998Zm2.251 1.5v.901h3.502v-.9H10.25Zm-1 14.257a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5H9.999a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) })));
};

var Mobile = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMobile
});

var SvgParagraphList = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.25 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM11.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM11.25 19a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM6 17.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 19a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z", fill: "currentColor" }) })));
};

var ParagraphList = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgParagraphList
});

var SvgParagraphNumber = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.25 4a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 9a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85A.75.75 0 0 1 10.4 9ZM5.537 3.307A.75.75 0 0 1 6 4v5a.75.75 0 1 1-1.5 0V5.81a.75.75 0 0 1-1.03-1.09l1.25-1.25a.75.75 0 0 1 .817-.163ZM10.25 14a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 19a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85a.75.75 0 0 1-.75-.75ZM5 14.75a.25.25 0 0 0-.25.25.75.75 0 0 1-1.5 0c0-.966.784-1.75 1.75-1.75h.614a1.979 1.979 0 0 1 1.503 3.266L5.63 18.25H7a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.57-1.238l2.548-2.972a.479.479 0 0 0-.364-.79H5Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 9A.75.75 0 0 1 4 8.25h2.5a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 9Z", fill: "currentColor" })] })));
};

var ParagraphNumber = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgParagraphNumber
});

var SvgReceipt = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 7.394c0-.427.346-.773.772-.773h8.228a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773ZM7.114 11.515c0-.427.346-.773.772-.773h8.362a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.8 4.045a.258.258 0 0 0-.257.258v15.235l1.626-.815a.77.77 0 0 1 .69 0l2.398 1.201 2.398-1.2a.77.77 0 0 1 .69-.001l2.398 1.2 2.397-1.2a.77.77 0 0 1 .69 0l1.627.814V4.303a.258.258 0 0 0-.257-.258H4.8ZM3 4.303C3 3.308 3.806 2.5 4.8 2.5h14.4c.994 0 1.8.808 1.8 1.803v15.651c0 .96-1.007 1.578-1.86 1.152h-.001l-1.654-.829-2.167 1.086-.002.001c-.362.18-.785.18-1.146 0h-.002L12 20.277l-2.168 1.086-.002.001c-.36.18-.784.18-1.146 0h-.002l-2.167-1.087-1.654.829-.002.001A1.287 1.287 0 0 1 3 19.954V4.303Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 15.636c0-.427.346-.773.772-.773h5.142a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" })] })));
};

var Receipt = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgReceipt
});

var SvgSelectAll = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5A2.75 2.75 0 0 1 5 2.25a.75.75 0 0 1 0 1.5c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0ZM3 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 3 7.58ZM7.58 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 7.58 3ZM21 18.25a.75.75 0 0 1 .75.75A2.75 2.75 0 0 1 19 21.75a.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25a.75.75 0 0 1 .75-.75ZM18.25 3a.75.75 0 0 1 .75-.75A2.75 2.75 0 0 1 21.75 5a.75.75 0 0 1-1.5 0c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1-.75-.75ZM21 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM21 12.92a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM12.92 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM12.92 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM9.308 15.58a.75.75 0 0 1 0 1.061l-2.222 2.222a.75.75 0 0 1-1.06 0l-1.334-1.332a.75.75 0 1 1 1.06-1.061l.804.803 1.692-1.692a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13.75c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25H5ZM2.25 15A2.75 2.75 0 0 1 5 12.25h4A2.75 2.75 0 0 1 11.75 15v4A2.75 2.75 0 0 1 9 21.75H5A2.75 2.75 0 0 1 2.25 19v-4Z", fill: "currentColor" })] })));
};

var SelectAll = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSelectAll
});

var SvgSend = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.874 5.995C2.27 4.308 3.979 2.672 5.639 3.442l14.429 6.697c1.577.731 1.577 2.989 0 3.72l-14.43 6.7c-1.659.769-3.367-.867-2.764-2.554l2.143-6.008-2.143-6.002Zm2.133-1.193a.54.54 0 0 0-.72.689l2.232 6.254a.75.75 0 0 1 0 .504l-2.232 6.26c-.171.478.31.879.72.689l14.43-6.7a.555.555 0 0 0 0-.999L5.006 4.802Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.06 12a.75.75 0 0 1 .75-.75H20.5a.75.75 0 0 1 0 1.5H5.81a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] })));
};

var Send = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSend
});

var SvgSettingsHandles = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.385 4.82a.77.77 0 0 1 .769-.769h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 4.82a.77.77 0 0 1 .77-.769H14.05a.77.77 0 0 1 0 1.539H2.77A.77.77 0 0 1 2 4.82ZM9.18 12a.77.77 0 0 1 .769-.77H21.23a.77.77 0 0 1 0 1.54H9.949a.77.77 0 0 1-.77-.77ZM2 12a.77.77 0 0 1 .77-.77h3.076a.77.77 0 1 1 0 1.54H2.77A.77.77 0 0 1 2 12ZM17.385 19.18a.77.77 0 0 1 .769-.77h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 19.18a.77.77 0 0 1 .77-.77H14.05a.77.77 0 0 1 0 1.539H2.77a.77.77 0 0 1-.769-.77Z", fill: props.color }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.01 3.914a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002ZM8.804 11.093a1.282 1.282 0 1 0-1.813 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.087-1.088a2.82 2.82 0 1 0-3.989 3.989 2.82 2.82 0 0 0 3.99-3.988v-.001ZM17.01 18.273a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002Z", fill: props.color })] })));
};

var SettingsHandles = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSettingsHandles
});

var SvgSigninSendShare = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 8.5A.5.5 0 0 1 2 8h8.253a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Z", fill: "#4E535C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.646 5.896a.5.5 0 0 1 .708 0l2.25 2.25a.5.5 0 0 1 0 .708l-2.25 2.249a.5.5 0 1 1-.707-.707L9.543 8.5 7.646 6.604a.5.5 0 0 1 0-.708Z", fill: "#4E535C" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-1.5a.5.5 0 0 1 1 0V13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v1.5a.5.5 0 0 1-1 0V4Z", fill: "#4E535C" })] })));
};

var SigninSendShare = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSigninSendShare
});

var SvgBrain = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.165 2.84a3.849 3.849 0 0 1 6.14 2.1l.004.016a.27.27 0 0 0 .204.206 4.355 4.355 0 0 1 2.757 6.681l-.004.007a.256.256 0 0 0 0 .29l.005.006a4.355 4.355 0 0 1-2.758 6.682.27.27 0 0 0-.204.205l-.003.015a3.845 3.845 0 0 1-6.14 2.112l-.004-.004a.257.257 0 0 0-.323 0l-.004.003a3.849 3.849 0 0 1-6.14-2.099l-.004-.016a.27.27 0 0 0-.204-.206 4.355 4.355 0 0 1-2.758-6.68l.005-.008a.256.256 0 0 0 0-.29l-.006-.008a4.355 4.355 0 0 1 2.759-6.68.27.27 0 0 0 .204-.205l.004-.016a3.845 3.845 0 0 1 6.14-2.105l.004.003c.084.068.2.075.291.022a.715.715 0 0 1 .035-.03Zm1.012 1.162a1.796 1.796 0 0 1-2.304.044 2.31 2.31 0 0 0-3.68 1.258 1.808 1.808 0 0 1-1.386 1.372l-.008.002a2.821 2.821 0 0 0-1.791 4.32 1.793 1.793 0 0 1 0 2.014 2.818 2.818 0 0 0 1.79 4.32l.01.002c.689.148 1.23.684 1.384 1.371a2.308 2.308 0 0 0 3.681 1.255 1.796 1.796 0 0 1 2.254 0 2.31 2.31 0 0 0 3.681-1.264 1.808 1.808 0 0 1 1.385-1.372l.009-.002a2.821 2.821 0 0 0 1.79-4.321 1.793 1.793 0 0 1 0-2.012 2.818 2.818 0 0 0-1.79-4.322l-.009-.001a1.808 1.808 0 0 1-1.385-1.371 2.308 2.308 0 0 0-3.63-1.293Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.904c.425 0 .77.344.77.769v16.653a.769.769 0 0 1-1.539 0V3.673c0-.425.344-.769.77-.769ZM17.13 14.82c-.709 0-1.283.573-1.283 1.281a.769.769 0 0 1-1.538 0 2.82 2.82 0 0 1 2.82-2.82.769.769 0 1 1 0 1.538ZM8.922 7.13c.425 0 .77.345.77.769a2.82 2.82 0 0 1-2.821 2.82.769.769 0 1 1 0-1.538c.708 0 1.282-.574 1.282-1.282 0-.424.345-.769.77-.769ZM6.101 14.05c0-.424.345-.768.77-.768A2.82 2.82 0 0 1 9.69 16.1a.769.769 0 0 1-1.538 0c0-.708-.574-1.282-1.282-1.282a.769.769 0 0 1-.77-.769ZM15.078 7.13c.425 0 .769.345.769.769 0 .708.574 1.282 1.283 1.282a.769.769 0 1 1 0 1.537A2.82 2.82 0 0 1 14.309 7.9c0-.424.344-.769.769-.769Z", fill: "currentColor" })] })));
};

var Brain = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgBrain
});

var SvgCardEdit = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.82A2.82 2.82 0 0 1 4.82 2h12.308a2.82 2.82 0 0 1 2.82 2.82V9.95a.77.77 0 0 1-1.538 0V4.82c0-.709-.573-1.283-1.282-1.283H4.821c-.709 0-1.283.574-1.283 1.283V19.18c0 .707.574 1.282 1.283 1.282h5.128a.77.77 0 1 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18V4.82Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.31 13.658c.7-.7 1.837-.7 2.538 0l1.626 1.627c.701.7.701 1.837 0 2.538l-3.65 3.651a1.795 1.795 0 0 1-1.27.526h-2.652a.77.77 0 0 1-.77-.77v-2.652c0-.476.19-.932.526-1.269l3.652-3.65Zm1.087 1.088-3.65 3.651a.257.257 0 0 0-.076.181v1.884h1.883a.256.256 0 0 0 .181-.076l3.652-3.65c.1-.101.1-.263 0-.363m-1.627-1.627Zm-.363 0c.1-.1.263-.1.363 0h-.363ZM10.975 11.23a.77.77 0 0 1 .769.77v3.077a.77.77 0 0 1-1.539 0V12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.667 13.539a.77.77 0 0 1 .769-.77h3.077a.77.77 0 0 1 0 1.539H9.436a.77.77 0 0 1-.77-.77ZM7.128 6.872a.77.77 0 0 1 .77-.77h6.153a.77.77 0 1 1 0 1.54H7.898a.77.77 0 0 1-.77-.77Z", fill: "currentColor" })] })));
};

var CardEdit = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCardEdit
});

var SvgDoctorTalk = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.262 2.75a1.04 1.04 0 0 0-1.04 1.04v1.039h5.659v-1.04a1.04 1.04 0 0 0-1.04-1.039H8.262Zm6.119 1.04a2.54 2.54 0 0 0-2.54-2.54H8.262a2.54 2.54 0 0 0-2.54 2.54v3.578a4.32 4.32 0 0 0 1.6 3.36l-.335 1.342a1.56 1.56 0 0 0-.43.025l-.216.043a.82.82 0 0 0-.032.007l-2.299.46a3.434 3.434 0 0 0-2.761 3.367v.344a.75.75 0 0 0 1.5 0v-.344c0-.922.65-1.716 1.555-1.897l1.419-.283v1.902a2.252 2.252 0 1 0 1.5 0v-1.912c1.133.67 2.386.908 3.724.643a.75.75 0 0 0-.291-1.472 3.628 3.628 0 0 1-2.28-.257l.305-1.22c.431.144.892.221 1.37.221.482 0 .946-.078 1.379-.224l.092.359a.75.75 0 1 0 1.453-.375l-.19-.732a4.32 4.32 0 0 0 1.596-3.357V3.79Zm-1.5 2.539H7.223v1.04a2.827 2.827 0 0 0 2.829 2.828 2.829 2.829 0 0 0 2.829-2.829v-1.04ZM6.473 17.066a.75.75 0 1 0 0 1.501.75.75 0 0 0 0-1.501ZM11.443 16.904a5.654 5.654 0 1 1 5.654 5.654.75.75 0 0 1 0-1.5 4.155 4.155 0 1 0-4.154-4.154.75.75 0 0 1-1.5 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.193 16.154a.75.75 0 0 1 .75.75c0 .628.139 1.222.387 1.756a.75.75 0 0 1 .054.47l-.396 1.898 1.893-.403a.75.75 0 0 1 .471.054 4.148 4.148 0 0 0 1.75.384.75.75 0 1 1 0 1.5c-.758 0-1.482-.15-2.144-.42l-2.783.59a.75.75 0 0 1-.89-.886l.582-2.79a5.651 5.651 0 0 1-.424-2.153.75.75 0 0 1 .75-.75ZM14.814 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.213 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM17.064 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.463 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM19.314 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.713 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132Z", fill: "currentColor" })] })));
};

var DoctorTalk = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDoctorTalk
});

var SvgFolder = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.846 5.509a3.004 3.004 0 0 1 3-3.009h5.657c.918 0 1.799.366 2.448 1.017l2.189 2.195a3.477 3.477 0 0 1 1.014 2.455v3.381a.693.693 0 1 1-1.385 0v-3.38c0-.553-.219-1.083-.608-1.474L14.97 4.5c-.389-.39-.917-.61-1.468-.61H7.846c-.892 0-1.615.725-1.615 1.62V8.77a.693.693 0 1 1-1.385 0V5.509Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.846 2.522c.383 0 .693.31.693.694v3.218c0 .384.31.695.692.695h3.209a.693.693 0 0 1 0 1.388h-3.21a2.08 2.08 0 0 1-2.076-2.083V3.216c0-.383.31-.694.692-.694ZM3 10.622a2.542 2.542 0 0 1 2.538-2.546h3.875a2.075 2.075 0 0 1 1.728.928l1.024 1.54c.128.194.344.31.576.31h5.72A2.542 2.542 0 0 1 21 13.4v5.554a2.542 2.542 0 0 1-2.538 2.546H5.538A2.542 2.542 0 0 1 3 18.954v-8.332Zm2.538-1.157c-.637 0-1.153.518-1.153 1.157v8.332c0 .64.516 1.157 1.153 1.157h12.924c.637 0 1.153-.518 1.153-1.157V13.4c0-.64-.516-1.158-1.153-1.158H12.74a2.075 2.075 0 0 1-1.728-.927l-1.024-1.54a.692.692 0 0 0-.576-.31H5.538Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.462 15.02c0-.384.31-.695.692-.695h2.77a.693.693 0 0 1 0 1.389h-2.77a.693.693 0 0 1-.692-.694Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.538 12.937c.383 0 .693.31.693.694v2.777a.693.693 0 1 1-1.385 0v-2.777c0-.383.31-.694.692-.694Z", fill: "currentColor" })] })));
};

var Folder = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFolder
});

var SvgHeartbeat = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsx("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.086 21.23a.77.77 0 0 1 .771-.768h10.286a.77.77 0 1 1 0 1.538H6.857a.77.77 0 0 1-.771-.77ZM5.829 3.538c-.71 0-1.286.574-1.286 1.283v1.025a.77.77 0 0 1-1.543 0V4.821A2.824 2.824 0 0 1 5.829 2H18.17A2.824 2.824 0 0 1 21 4.82V9.95a.77.77 0 0 1-.771.769h-4.115a.772.772 0 0 1-.622-.315l-1.714-2.335-2.73 5.582a.771.771 0 0 1-1.316.117l-2.238-3.05H4.543v4.36c0 .709.575 1.282 1.285 1.282h12.345c.709 0 1.284-.573 1.284-1.282V14.05a.77.77 0 0 1 .772-.769.77.77 0 0 1 .771.77v1.025a2.824 2.824 0 0 1-2.828 2.82H5.829A2.824 2.824 0 0 1 3 15.077V9.949a.77.77 0 0 1 .771-.77h4.115c.246 0 .477.117.622.315l1.714 2.335 2.73-5.582a.771.771 0 0 1 1.316-.117l2.238 3.05h2.951V4.82c0-.708-.575-1.282-1.286-1.282H5.83Z", fill: "currentColor" }) })));
};

var Heartbeat = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgHeartbeat
});

var SvgHospital = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.326 9.432c0-.425.343-.77.767-.77h4.093c.99 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.766.77a.769.769 0 0 1-.768-.77V10.46a.257.257 0 0 0-.256-.258h-4.093a.769.769 0 0 1-.767-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.814 4.04a.257.257 0 0 0-.256.257V20.73a.769.769 0 1 1-1.534 0V4.297c0-.992.8-1.797 1.79-1.797H15.07c.989 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.767.77a.769.769 0 0 1-.767-.77V4.297a.257.257 0 0 0-.256-.257H3.814Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.023 20.73c0 .425-.343.77-.767.77H6.628a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77h5.628c.424 0 .767.345.767.77v4.108Zm-1.534-.77v-2.568H7.395v2.568h4.094Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.442 15.852c.423 0 .767.345.767.77v4.108c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 20.73c0-.425.343-.77.767-.77h20.466c.424 0 .767.345.767.77 0 .425-.343.77-.767.77H1.767A.769.769 0 0 1 1 20.73ZM9.442 7.635c.423 0 .767.345.767.77v3.082c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77V8.404c0-.425.343-.77.767-.77Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.14 9.946c0-.425.343-.77.767-.77h3.07c.423 0 .767.345.767.77 0 .425-.344.77-.767.77h-3.07a.769.769 0 0 1-.767-.77Z", fill: "currentColor" })] })));
};

var Hospital = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgHospital
});

var SvgMask = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.998 5.2 6.5 6.641a1.287 1.287 0 0 0-.896 1.227v8.264c0 .562.363 1.058.896 1.227h.002l4.492 1.438a3.29 3.29 0 0 0 2.011 0l4.498-1.437c.532-.17.893-.667.893-1.228V7.87a1.287 1.287 0 0 0-.893-1.224l-4.499-1.442a3.29 3.29 0 0 0-2.006-.005Zm2.474-1.468a4.812 4.812 0 0 0-2.936-.006l-.002.001L6.04 5.168h-.001a2.83 2.83 0 0 0-1.968 2.7v8.265a2.832 2.832 0 0 0 1.968 2.7h.001l4.49 1.437a4.816 4.816 0 0 0 2.942 0l4.497-1.437a2.83 2.83 0 0 0 1.962-2.7V7.867a2.83 2.83 0 0 0-1.962-2.693l-4.496-1.442Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.396 9.139a.77.77 0 0 1 .767-.772h.227C21.384 8.367 23 9.994 23 12c0 2.007-1.616 3.634-3.61 3.634h-.227a.77.77 0 0 1-.767-.772.77.77 0 0 1 .767-.772h.227A2.083 2.083 0 0 0 21.466 12c0-1.154-.93-2.09-2.076-2.09h-.227a.77.77 0 0 1-.767-.772ZM4.61 9.911a2.083 2.083 0 0 0-2.076 2.09c0 1.154.93 2.09 2.076 2.09h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61c-1.994 0-3.61-1.627-3.61-3.634 0-2.007 1.616-3.634 3.61-3.634h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61ZM8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" })] })));
};

var Mask = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMask
});

var SvgMedicalCertificate = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.031 7.646a3.75 3.75 0 0 1 1.677-.396H8a.75.75 0 1 1 0 1.5H6.708c-.35 0-.694.08-1.006.237l-.585.293a2.25 2.25 0 0 0-.924.855l-1.55 2.584a.75.75 0 1 1-1.286-.771l1.55-2.585A3.75 3.75 0 0 1 4.447 7.94m0 0 .585-.293M17.5 5.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.25 7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM16.25 13a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.25 16a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM10.66 10.28a2.396 2.396 0 0 1 3.687 3.023l-2.993 4.488a4.75 4.75 0 0 1-2.337 1.832l-5.762 2.082a.75.75 0 1 1-.51-1.41l5.762-2.082a3.25 3.25 0 0 0 1.6-1.254l2.993-4.488a.896.896 0 0 0-1.38-1.13l-2.19 2.19a.75.75 0 0 1-.53.219H7a.75.75 0 1 1 0-1.5h1.69l1.97-1.97Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 4.5A2.25 2.25 0 0 1 9.5 2.25h11a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .415.336.75.75.75h11a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75V13a.75.75 0 1 1-1.5 0V4.5Z", fill: "currentColor" })] })));
};

var MedicalCertificate = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMedicalCertificate
});

var SvgMedicalCross = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.539a8.461 8.461 0 0 0-8.461 8.46v.002A8.462 8.462 0 1 0 12 3.539h-.002Zm10 8.46C22 6.477 17.523 2 12 2S2 6.477 2 12s4.478 10 10 10c5.523 0 10.001-4.478 10-10Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.367 7.911c0-.991.803-1.795 1.794-1.795h1.678c.992 0 1.795.804 1.795 1.795V9.38h1.47c.99 0 1.794.804 1.794 1.795v1.678c0 .99-.804 1.795-1.795 1.795h-1.469v1.469c0 .99-.803 1.794-1.795 1.794h-1.678a1.795 1.795 0 0 1-1.794-1.794v-1.47h-1.47a1.795 1.795 0 0 1-1.794-1.794v-1.678c0-.991.804-1.795 1.795-1.795h1.469V7.91Zm1.794-.256a.257.257 0 0 0-.256.256v2.238a.77.77 0 0 1-.77.77H7.899a.257.257 0 0 0-.257.256v1.678c0 .141.115.256.257.256h2.238a.77.77 0 0 1 .77.77v2.238c0 .14.114.256.255.256h1.678a.257.257 0 0 0 .257-.256v-2.239a.77.77 0 0 1 .77-.769h2.237a.257.257 0 0 0 .257-.256v-1.678a.257.257 0 0 0-.257-.257h-2.238a.77.77 0 0 1-.769-.769V7.911a.257.257 0 0 0-.257-.256h-1.678Z", fill: "currentColor" })] })));
};

var MedicalCross = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMedicalCross
});

var SvgNotes = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 16.502a.75.75 0 0 1 .75-.75h4.001a.75.75 0 0 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM18.032 15.033a.75.75 0 0 1 0 1.061l-1.876 1.876a.75.75 0 0 1-1.06 0l-1.126-1.126a.75.75 0 1 1 1.061-1.06l.595.595 1.346-1.346a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.996a4.75 4.75 0 0 1 4.75-4.75h10.008a4.75 4.75 0 0 1 4.75 4.75v10.008a4.75 4.75 0 0 1-4.75 4.75H6.996a4.75 4.75 0 0 1-4.75-4.75V6.996Zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v10.008a3.25 3.25 0 0 0 3.25 3.25h10.008a3.25 3.25 0 0 0 3.25-3.25V6.996a3.25 3.25 0 0 0-3.25-3.25H6.996Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 13a.75.75 0 0 1 .75-.75H15a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM8.498 5.748a.75.75 0 0 1 .75.75v3.001a.75.75 0 1 1-1.5 0V6.498a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 7.998a.75.75 0 0 1 .75-.75h3.001a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] })));
};

var Notes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgNotes
});

var SvgPill = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.824 3.562c-.699-.7-1.833-.7-2.532 0-.7.7-.7 1.835 0 2.535.7.7 1.833.7 2.532 0 .7-.7.7-1.835 0-2.535Zm1.085-1.087a3.323 3.323 0 0 0-4.702 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.708ZM8.212 8.11a3.323 3.323 0 0 0-4.703 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.709Zm1.085-1.088a4.857 4.857 0 0 0-6.873 0 4.87 4.87 0 0 0 0 6.882 4.857 4.857 0 0 0 6.873 0 4.87 4.87 0 0 0 0-6.882Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 10.463c0-.424.344-.768.767-.768h8.186a.768.768 0 0 1 0 1.537H1.767A.768.768 0 0 1 1 10.463ZM20.784 11.911a2.321 2.321 0 0 0-3.286 0l-5.075 5.081a2.327 2.327 0 0 0 0 3.29 2.321 2.321 0 0 0 3.286 0l5.075-5.081a2.328 2.328 0 0 0 0-3.29Zm-4.371-1.086a3.855 3.855 0 0 1 5.457 0 3.865 3.865 0 0 1 0 5.463l-5.076 5.08a3.855 3.855 0 0 1-5.456 0 3.865 3.865 0 0 1 0-5.462l5.075-5.081Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.893 13.383c.3-.3.785-.3 1.085 0l4.339 4.343a.769.769 0 0 1-1.086 1.087l-4.338-4.344c-.3-.3-.3-.786 0-1.086Z", fill: "currentColor" })] })));
};

var Pill = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPill
});

var SvgScaleWeight = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.897A5.898 5.898 0 0 1 7.897 2h8.206A5.898 5.898 0 0 1 22 7.897v8.206A5.898 5.898 0 0 1 16.103 22H7.897A5.898 5.898 0 0 1 2 16.103V7.897Zm5.897-4.359a4.36 4.36 0 0 0-4.359 4.36v8.205a4.36 4.36 0 0 0 4.36 4.358h8.205a4.36 4.36 0 0 0 4.358-4.358V7.897a4.36 4.36 0 0 0-4.358-4.359H7.897Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7.06a3.334 3.334 0 0 0-3.333 3.334c0 .141.115.256.256.256h6.154a.256.256 0 0 0 .256-.256A3.333 3.333 0 0 0 12 7.06Zm-4.872 3.334a4.872 4.872 0 0 1 9.744 0c0 .992-.805 1.795-1.795 1.795H8.923a1.795 1.795 0 0 1-1.795-1.795Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.37 8.676a.77.77 0 0 1 .344 1.032l-1.026 2.051a.77.77 0 1 1-1.376-.688l1.026-2.05a.77.77 0 0 1 1.032-.345Z", fill: "currentColor" })] })));
};

var ScaleWeight = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgScaleWeight
});

var SvgShieldHeart = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.515 3.836a4.009 4.009 0 0 0-3.03 0L5.342 5.934c-.483.197-.8.666-.8 1.187v4.04c0 4.233 3.169 8.234 7.458 9.28 4.29-1.046 7.457-5.047 7.457-9.28V7.12c0-.52-.315-.989-.8-1.187l-5.142-2.098Zm.584-1.424a5.556 5.556 0 0 0-4.198 0L4.758 4.51A2.82 2.82 0 0 0 3 7.12v4.04c0 5.027 3.77 9.687 8.83 10.821a.776.776 0 0 0 .34 0c5.06-1.134 8.83-5.794 8.83-10.82V7.12a2.82 2.82 0 0 0-1.758-2.61L14.1 2.41Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.522 9.692c-.757 0-1.35.708-1.35 1.444 0 .786.522 1.577 1.268 2.228.36.313.738.563 1.057.73.16.084.295.143.398.179.052.018.086.027.105.031.019-.004.053-.013.105-.031.103-.036.238-.095.398-.178a5.703 5.703 0 0 0 1.056-.731c.747-.65 1.27-1.442 1.27-2.228 0-.735-.595-1.444-1.35-1.444-.449 0-.73.206-.902.4a.772.772 0 0 1-1.154 0 1.158 1.158 0 0 0-.901-.4Zm-2.893 1.444c0-1.4 1.109-2.982 2.893-2.982.614 0 1.104.183 1.478.423.374-.24.864-.423 1.478-.423 1.783 0 2.893 1.582 2.893 2.982 0 1.445-.921 2.624-1.797 3.387-.45.393-.928.71-1.351.932a4.525 4.525 0 0 1-.61.27c-.177.062-.396.121-.613.121-.217 0-.436-.06-.613-.12a4.525 4.525 0 0 1-.61-.27c-.423-.223-.9-.54-1.351-.933-.876-.763-1.797-1.942-1.797-3.387Z", fill: "currentColor" })] })));
};

var ShieldHeart = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgShieldHeart
});

var SvgStethoscope = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.94 12.269a1.79 1.79 0 1 0-2.532 2.532 1.79 1.79 0 0 0 2.533-2.532Zm1.085-1.086a3.326 3.326 0 1 0-4.702 4.704 3.326 3.326 0 0 0 4.703-4.704ZM1 4.837a2.813 2.813 0 0 1 2.814-2.814H5.86a.767.767 0 0 1 0 1.535H3.814c-.707 0-1.28.572-1.28 1.28V8.93a5.372 5.372 0 1 0 10.745 0V4.837c0-.707-.572-1.279-1.279-1.279H9.953a.767.767 0 0 1 0-1.535H12a2.813 2.813 0 0 1 2.814 2.814V8.93A6.907 6.907 0 1 1 1 8.93V4.837Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.907 14.302c.424 0 .767.344.767.768v1.279a5.116 5.116 0 1 0 10.233 0v-.256a.767.767 0 1 1 1.535 0v.256a6.65 6.65 0 1 1-13.302 0v-1.28c0-.423.343-.767.767-.767ZM5.86 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767ZM9.953 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767Z", fill: "currentColor" })] })));
};

var Stethoscope = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgStethoscope
});

var SvgSyringe = function (props) {
    var sizeInPixels = getIconSize(props.size);
    return (jsxs("svg", __assign({}, props, { width: sizeInPixels, height: sizeInPixels, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.175 3.288c.3.3.3.785 0 1.085l-4.267 4.253c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l4.267-4.254c.3-.3.787-.3 1.088 0ZM20.759 5.864c.3.3.301.785.001 1.085l-4.256 4.253c-.3.3-.788.3-1.088.002a.765.765 0 0 1-.002-1.085l4.257-4.254c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.379 5.108c.3-.3.787-.3 1.088 0l7.487 7.454c.3.299.3.784 0 1.084-.3.3-.787.3-1.087 0l-7.488-7.453c-.3-.3-.3-.785 0-1.085ZM7.057 16.959c.3.3.3.785 0 1.084l-3.744 3.732c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l3.744-3.732c.3-.3.787-.3 1.088 0ZM6.718 11.744c.3-.3.787-.3 1.087 0l1.498 1.493c.3.3.3.785 0 1.085-.3.299-.788.299-1.088 0l-1.497-1.493c-.3-.3-.3-.785 0-1.085ZM8.964 9.505c.3-.3.787-.3 1.088 0l1.497 1.493c.3.3.3.785 0 1.084-.3.3-.787.3-1.088 0L8.964 10.59c-.3-.3-.3-.785 0-1.084ZM16.02 2.225c.3-.3.788-.3 1.088 0l4.667 4.652c.3.3.3.785 0 1.084-.3.3-.788.3-1.088 0L16.02 3.31c-.3-.3-.3-.785 0-1.084Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.964 6.596c.3.3.3.785 0 1.084L6.26 14.364a1.275 1.275 0 0 0 0 1.807l1.648 1.641c.5.5 1.312.5 1.813 0l6.704-6.684c.3-.299.788-.299 1.088 0 .3.3.3.786 0 1.085l-6.705 6.684a2.826 2.826 0 0 1-3.987 0l-1.649-1.64a2.806 2.806 0 0 1 0-3.977l6.705-6.684c.3-.3.787-.3 1.087 0Z", fill: "currentColor" })] })));
};

var Syringe = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSyringe
});

var AVATAR_SIZES = {
    'x-large': 80,
    large: 56,
    medium: 40,
    small: 32,
    'x-small': 24,
};

var Avatar = function (_a) {
    var src = _a.src, size = _a.size, onClick = _a.onClick, styles = _a.styles, props = __rest(_a, ["src", "size", "onClick", "styles"]);
    var defaultStyles = useStyles$1W();
    return (jsx(Avatar$1, __assign$2({ src: src }, props, { size: AVATAR_SIZES[size], styles: __assign$2(__assign$2({}, defaultStyles), styles), onClick: onClick }, { children: jsx(SvgUser, { color: theme.colors.neutral[300] }) })));
};

var useStyles$F = makeStyles({
    root: function () { return css(templateObject_1$A || (templateObject_1$A = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n  "]))); },
    label: function () { return css(templateObject_2$j || (templateObject_2$j = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: 8px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: 8px;\n  "]))); },
    icon: function () { return css(templateObject_3$g || (templateObject_3$g = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: 8px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: 8px;\n  "]))); },
});
var templateObject_1$A, templateObject_2$j, templateObject_3$g;

var AVATAR_OPTIONS_STATUS_SIZES = {
    'x-large': 24,
    large: 16,
    medium: 12,
    small: 10,
    'x-small': 8,
};
var AVATAR_OPTIONS_STATUS_OFFSET = {
    'x-large': AVATAR_OPTIONS_STATUS_SIZES['x-large'] / 2,
    large: AVATAR_OPTIONS_STATUS_SIZES.large / 2,
    medium: AVATAR_OPTIONS_STATUS_SIZES.medium / 2,
    small: AVATAR_OPTIONS_STATUS_SIZES.small / 2,
    'x-small': AVATAR_OPTIONS_STATUS_SIZES['x-small'] / 2,
};
var STATUS_COLOR = {
    ONLINE: theme.colors.success[500],
    OFFLINE: theme.colors.danger[500],
};
var LABEL_TEXT_SIZE = {
    'x-large': 'large',
    large: 'large',
    medium: 'small',
    small: 'small',
    'x-small': 'small',
};

var AvatarOptions = function (_a) {
    var src = _a.src, _b = _a.size, size = _b === void 0 ? 'medium' : _b, onClick = _a.onClick, status = _a.status, label = _a.label, hasMenu = _a.hasMenu, menuOptions = _a.menuOptions, props = __rest(_a, ["src", "size", "onClick", "status", "label", "hasMenu", "menuOptions"]);
    var _c = useState(false), opened = _c[0], setOpened = _c[1];
    var _d = useStyles$F(), rootStyle = _d.root, labelStyle = _d.label, iconStyle = _d.icon;
    var AvatarOptionLabel = function () { return (jsx("div", __assign$2({ css: labelStyle }, { children: jsx(Text, __assign$2({ variant: LABEL_TEXT_SIZE[size] }, { children: label })) }))); };
    var AvatarOptionIndicator = function () { return (jsxs("div", __assign$2({ css: rootStyle }, { children: [jsx(Indicator, __assign$2({ size: AVATAR_OPTIONS_STATUS_SIZES[size], offset: AVATAR_OPTIONS_STATUS_OFFSET[size], color: STATUS_COLOR[status], disabled: !status, inline: true, withBorder: true }, { children: jsx(Avatar, __assign$2({ src: src }, props, { size: size, onClick: onClick }, { children: !src && jsx(SvgUser, { color: theme.colors.neutral[300] }) })) })), label && jsx(AvatarOptionLabel, {}), hasMenu && (jsx("div", __assign$2({ css: iconStyle }, { children: jsx(Icon, { name: opened ? 'arrow-up' : 'arrow-down', color: theme.colors.extra.gray_icon }) })))] }))); };
    return (jsx(Fragment, { children: hasMenu ? (jsx(Menu$2, __assign$2({ opened: opened, onOpen: function () { return setOpened(true); }, onClose: function () { return setOpened(false); }, transition: "slide-down", control: jsx(UnstyledButton, { children: jsx(AvatarOptionIndicator, {}) }) }, { children: menuOptions }))) : (jsx(AvatarOptionIndicator, {})) }));
};

var typographyToStyle = function (specification) { return css(templateObject_1$z || (templateObject_1$z = __makeTemplateObject$1(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"])), specification.fontFamily, specification.fontWeight, specification.fontSize, specification.lineHeight, specification.letterSpacing); };
var templateObject_1$z;

var TAG_TYPE_COLORS = {
    filled: {
        primary: {
            background: theme.colors.primary[600],
            color: theme.colors.common.white,
        },
        secondary: {
            background: theme.colors.secondary[600],
            color: theme.colors.common.white,
        },
        information: {
            background: theme.colors.info[600],
            color: theme.colors.common.white,
        },
        success: {
            background: theme.colors.success[600],
            color: theme.colors.common.white,
        },
        warning: {
            background: theme.colors.warning[600],
            color: theme.colors.common.white,
        },
        error: {
            background: theme.colors.danger[600],
            color: theme.colors.common.white,
        },
        neutral: {
            background: theme.colors.neutral[600],
            color: theme.colors.common.white,
        },
    },
    light: {
        primary: {
            background: theme.colors.primary[100],
            color: theme.colors.primary[700],
        },
        secondary: {
            background: theme.colors.secondary[100],
            color: theme.colors.secondary[700],
        },
        information: {
            background: theme.colors.info[100],
            color: theme.colors.info[700],
        },
        success: {
            background: theme.colors.success[100],
            color: theme.colors.success[700],
        },
        warning: {
            background: theme.colors.warning[100],
            color: theme.colors.warning[700],
        },
        error: {
            background: theme.colors.danger[100],
            color: theme.colors.danger[700],
        },
        neutral: {
            background: theme.colors.neutral[100],
            color: theme.colors.neutral[700],
        },
    },
};

var useStyles$E = makeStyles({
    root: function (_a, _b) {
        var typography = _a.typography;
        var variant = _b.variant, type = _b.type;
        return css(templateObject_1$y || (templateObject_1$y = __makeTemplateObject$1(["\n    ", "\n    text-transform: capitalize;\n    padding: 0 16px;\n    height: fit-content;\n    width: fit-content;\n\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    ", "\n    text-transform: capitalize;\n    padding: 0 16px;\n    height: fit-content;\n    width: fit-content;\n\n    background-color: ", ";\n    color: ", ";\n  "])), typographyToStyle(typography.label), TAG_TYPE_COLORS[variant][type].background, TAG_TYPE_COLORS[variant][type].color);
    },
    inner: function () { return css(templateObject_2$i || (templateObject_2$i = __makeTemplateObject$1([""], [""]))); },
});
var templateObject_1$y, templateObject_2$i;

var Tag = function (_a) {
    var onClick = _a.onClick, children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'filled' : _b, style = _a.style, _c = _a.type, type = _c === void 0 ? 'primary' : _c, props = __rest(_a, ["onClick", "children", "variant", "style", "type"]);
    var styles = useStyles$E({ type: type, variant: variant });
    return (jsx(Badge, __assign$2({}, props, { variant: variant, styles: styles, style: style, onClick: onClick }, { children: children })));
};

function getEndOfWeek(date, firstDayOfWeek = "monday") {
  const value = new Date(date);
  const day = value.getDay();
  const isSunday = firstDayOfWeek === "sunday";
  const clampToLastDay = 7 - (isSunday ? day + 1 : day);
  if (isSunday && day !== 6 || day !== 0) {
    value.setDate(value.getDate() + clampToLastDay);
  }
  return value;
}

function getStartOfWeek(date, firstDayOfWeek = "monday") {
  const value = new Date(date);
  const day = value.getDay() || 7;
  const isSunday = firstDayOfWeek === "sunday";
  const clampToFirstDay = isSunday ? day : day - 1;
  if (isSunday && day !== 0 || day !== 1) {
    value.setHours(-24 * clampToFirstDay);
  }
  return value;
}

function getMonthDays(month, firstDayOfWeek = "monday") {
  const currentMonth = month.getMonth();
  const startOfMonth = new Date(month.getFullYear(), currentMonth, 1);
  const endOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
  const endDate = getEndOfWeek(endOfMonth, firstDayOfWeek);
  const date = getStartOfWeek(startOfMonth, firstDayOfWeek);
  const weeks = [];
  while (date <= endDate) {
    const days = [];
    for (let i = 0; i < 7; i += 1) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    weeks.push(days);
  }
  return weeks;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var dayjs_min = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
});

function getMonthsNames(locale, format = "MMM") {
  const names = [];
  const date = new Date(2021, 0, 1);
  for (let i = 0; i < 12; i += 1) {
    names.push(dayjs_min(date).locale(locale).format(format));
    date.setMonth(date.getMonth() + 1);
  }
  return names;
}

function getWeekdaysNames(locale, firstDayOfWeek = "monday", format = "dd") {
  const names = [];
  const date = getStartOfWeek(new Date(), firstDayOfWeek);
  for (let i = 0; i < 7; i += 1) {
    names.push(dayjs_min(date).locale(locale).format(format));
    date.setDate(date.getDate() + 1);
  }
  return names;
}

function isSameMonth(date, comparison) {
  return date.getFullYear() === comparison.getFullYear() && date.getMonth() === comparison.getMonth();
}

function isSameDate(date, comparison) {
  return isSameMonth(date, comparison) && date.getDate() === comparison.getDate();
}

function getDecadeRange(year) {
  const rounded = year - year % 10 - 1;
  const range = [];
  for (let i = 0; i < 12; i += 1) {
    const rangeYear = rounded + i;
    range.push(rangeYear);
  }
  return range;
}

var __defProp$p = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$p.call(b, prop))
      __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(b)) {
      if (__propIsEnum$p.call(b, prop))
        __defNormalProp$p(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
var __objRest$g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function ArrowIcon(_a) {
  var _b = _a, { direction, style } = _b, others = __objRest$g(_b, ["direction", "style"]);
  const theme = useMantineTheme();
  return /* @__PURE__ */ React__default.createElement("svg", __spreadValues$p({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: __spreadProps$b(__spreadValues$p({}, style), {
      transform: direction === "right" && theme.dir === "ltr" || direction === "left" && theme.dir === "rtl" ? "rotate(180deg)" : "none"
    })
  }, others), /* @__PURE__ */ React__default.createElement("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
ArrowIcon.displayName = "@mantine/dates/ArrowIcon";

var __defProp$o = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$o.call(b, prop))
      __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(b)) {
      if (__propIsEnum$o.call(b, prop))
        __defNormalProp$o(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
const sizes$3 = {
  xs: 32,
  sm: 40,
  md: 44,
  lg: 50,
  xl: 54
};
var useStyles$D = createStyles((theme, { size }) => ({
  calendarHeader: {
    display: "flex",
    justifyContent: "space-between",
    align: "center",
    marginBottom: theme.fn.size({ size, sizes: theme.spacing })
  },
  calendarHeaderControl: {
    width: theme.fn.size({ size, sizes: sizes$3 }),
    height: theme.fn.size({ size, sizes: sizes$3 }),
    "&:disabled": {
      opacity: 0,
      cursor: "default"
    }
  },
  calendarHeaderLevel: __spreadProps$a(__spreadValues$o({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: theme.fn.size({ size, sizes: sizes$3 }),
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    padding: `0 ${theme.fn.size({ size, sizes: theme.spacing })}px`,
    borderRadius: theme.radius.sm,
    fontWeight: 500,
    flex: 1,
    textAlign: "center",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
  }, theme.fn.hover({
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
  })), {
    "&:disabled": theme.fn.hover({
      backgroundColor: "transparent",
      cursor: "default"
    })
  }),
  calendarHeaderLevelIcon: {
    marginLeft: 4
  }
}));

var __defProp$n = Object.defineProperty;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$n.call(b, prop))
      __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(b)) {
      if (__propIsEnum$n.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const iconSizes = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 22,
  xl: 28
};
function CalendarHeader(_a) {
  var _b = _a, {
    hasNext,
    hasPrevious,
    onNext,
    onPrevious,
    onNextLevel,
    className,
    label,
    nextLevelDisabled,
    size,
    classNames,
    styles,
    __staticSelector = "CalendarHeader",
    nextLabel,
    previousLabel,
    preventLevelFocus = false,
    preventFocus
  } = _b, others = __objRest$f(_b, [
    "hasNext",
    "hasPrevious",
    "onNext",
    "onPrevious",
    "onNextLevel",
    "className",
    "label",
    "nextLevelDisabled",
    "size",
    "classNames",
    "styles",
    "__staticSelector",
    "nextLabel",
    "previousLabel",
    "preventLevelFocus",
    "preventFocus"
  ]);
  const { classes, cx, theme } = useStyles$D({ size }, { classNames, styles, name: __staticSelector });
  const iconSize = theme.fn.size({ size, sizes: iconSizes });
  return /* @__PURE__ */ React__default.createElement("div", __spreadValues$n({
    className: cx(classes.calendarHeader, className)
  }, others), /* @__PURE__ */ React__default.createElement(ActionIcon, {
    className: classes.calendarHeaderControl,
    disabled: !hasPrevious,
    onClick: onPrevious,
    "aria-label": previousLabel,
    onMouseDown: (event) => preventFocus && event.preventDefault()
  }, /* @__PURE__ */ React__default.createElement(ArrowIcon, {
    direction: "left",
    width: iconSize,
    height: iconSize
  })), /* @__PURE__ */ React__default.createElement(UnstyledButton, {
    className: classes.calendarHeaderLevel,
    disabled: nextLevelDisabled,
    onClick: onNextLevel,
    tabIndex: preventLevelFocus ? -1 : 0,
    onMouseDown: (event) => preventFocus && event.preventDefault()
  }, label, !nextLevelDisabled && /* @__PURE__ */ React__default.createElement(ChevronIcon, {
    error: false,
    size,
    className: classes.calendarHeaderLevelIcon
  })), /* @__PURE__ */ React__default.createElement(ActionIcon, {
    className: classes.calendarHeaderControl,
    disabled: !hasNext,
    onClick: onNext,
    "aria-label": nextLabel,
    onMouseDown: (event) => preventFocus && event.preventDefault()
  }, /* @__PURE__ */ React__default.createElement(ArrowIcon, {
    direction: "right",
    width: iconSize,
    height: iconSize
  })));
}
CalendarHeader.displayName = "@mantine/dates/CalendarHeader";

var __defProp$m = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$m.call(b, prop))
      __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(b)) {
      if (__propIsEnum$m.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
const sizes$2 = {
  xs: 32,
  sm: 40,
  md: 46,
  lg: 52,
  xl: 56
};
var useStyles$C = createStyles((theme, { size }) => {
  const colors = theme.fn.variant({ color: theme.primaryColor, variant: "filled" });
  return {
    yearPicker: {
      width: "100%"
    },
    yearPickerControls: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center"
    },
    yearPickerControl: __spreadProps$9(__spreadValues$m({
      flex: "0 0 25%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      height: theme.fn.size({ size, sizes: sizes$2 }),
      textAlign: "center",
      borderRadius: theme.radius.sm,
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes })
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    })), {
      "&:disabled": __spreadValues$m({
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4],
        cursor: "not-allowed"
      }, theme.fn.hover({
        backgroundColor: "transparent"
      }))
    }),
    yearPickerControlActive: __spreadValues$m({
      backgroundColor: colors.background,
      color: colors.color
    }, theme.fn.hover({
      backgroundColor: colors.hover
    }))
  };
});

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$l.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(b)) {
      if (__propIsEnum$l.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function YearPicker(_a) {
  var _b = _a, {
    className,
    styles,
    classNames,
    value,
    onChange,
    size,
    minYear,
    maxYear,
    __staticSelector = "YearPicker",
    nextDecadeLabel,
    previousDecadeLabel,
    preventFocus
  } = _b, others = __objRest$e(_b, [
    "className",
    "styles",
    "classNames",
    "value",
    "onChange",
    "size",
    "minYear",
    "maxYear",
    "__staticSelector",
    "nextDecadeLabel",
    "previousDecadeLabel",
    "preventFocus"
  ]);
  const { classes, cx } = useStyles$C({ size }, { classNames, styles, name: __staticSelector });
  const [decade, setDecade] = useState(value);
  const range = getDecadeRange(decade);
  const years = range.map((year) => /* @__PURE__ */ React__default.createElement(UnstyledButton, {
    key: year,
    onClick: () => onChange(year),
    disabled: year < minYear || year > maxYear,
    onMouseDown: (event) => preventFocus && event.preventDefault(),
    className: cx(classes.yearPickerControl, {
      [classes.yearPickerControlActive]: year === value
    })
  }, year));
  return /* @__PURE__ */ React__default.createElement("div", __spreadValues$l({
    className: cx(classes.yearPicker, className)
  }, others), /* @__PURE__ */ React__default.createElement(CalendarHeader, {
    label: `${range[0]} \u2013 ${range[range.length - 1]}`,
    hasPrevious: typeof minYear === "number" ? minYear < range[0] : true,
    hasNext: typeof maxYear === "number" ? maxYear > range[range.length - 1] : true,
    onNext: () => setDecade((current) => current + 10),
    onPrevious: () => setDecade((current) => current - 10),
    nextLevelDisabled: true,
    size,
    nextLabel: nextDecadeLabel,
    previousLabel: previousDecadeLabel,
    styles,
    classNames,
    __staticSelector,
    preventFocus
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.yearPickerControls
  }, years));
}
YearPicker.displayName = "@mantine/dates/YearPicker";

function isMonthInRange({ date, minDate, maxDate }) {
  const hasMinDate = minDate instanceof Date;
  const hasMaxDate = maxDate instanceof Date;
  if (!hasMaxDate && !hasMinDate) {
    return true;
  }
  const endOfMonth = dayjs_min(date).endOf("month");
  const startOfMonth = dayjs_min(date).startOf("month");
  const maxInRange = hasMaxDate ? startOfMonth.isBefore(maxDate) : true;
  const minInRange = hasMinDate ? endOfMonth.isAfter(minDate) : true;
  return maxInRange && minInRange;
}

var __defProp$k = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
const sizes$1 = {
  xs: 32,
  sm: 40,
  md: 46,
  lg: 52,
  xl: 56
};
var useStyles$B = createStyles((theme, { size }) => {
  const colors = theme.fn.variant({ color: theme.primaryColor, variant: "filled" });
  return {
    monthPicker: {
      width: "100%"
    },
    monthPickerControls: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center"
    },
    monthPickerControl: __spreadProps$8(__spreadValues$k({
      flex: "0 0 33.3333%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      height: theme.fn.size({ size, sizes: sizes$1 }),
      textAlign: "center",
      borderRadius: theme.radius.sm,
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes })
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    })), {
      "&:disabled": __spreadValues$k({
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4],
        cursor: "not-allowed"
      }, theme.fn.hover({
        backgroundColor: "transparent"
      }))
    }),
    monthPickerControlActive: __spreadValues$k({
      backgroundColor: colors.background,
      color: colors.color
    }, theme.fn.hover({
      backgroundColor: colors.hover
    }))
  };
});

var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function MonthPicker(_a) {
  var _b = _a, {
    className,
    styles,
    classNames,
    value,
    onChange,
    locale,
    year,
    onYearChange,
    onNextLevel,
    size,
    minDate,
    maxDate,
    __staticSelector = "MonthPicker",
    nextYearLabel,
    previousYearLabel,
    preventFocus
  } = _b, others = __objRest$d(_b, [
    "className",
    "styles",
    "classNames",
    "value",
    "onChange",
    "locale",
    "year",
    "onYearChange",
    "onNextLevel",
    "size",
    "minDate",
    "maxDate",
    "__staticSelector",
    "nextYearLabel",
    "previousYearLabel",
    "preventFocus"
  ]);
  const { classes, cx } = useStyles$B({ size }, { classNames, styles, name: __staticSelector });
  const range = getMonthsNames(locale);
  const minYear = minDate instanceof Date ? minDate.getFullYear() : void 0;
  const maxYear = maxDate instanceof Date ? maxDate.getFullYear() : void 0;
  const months = range.map((month, index) => /* @__PURE__ */ React__default.createElement(UnstyledButton, {
    key: month,
    onClick: () => onChange(index),
    className: cx(classes.monthPickerControl, {
      [classes.monthPickerControlActive]: index === value.month && year === value.year
    }),
    disabled: !isMonthInRange({ date: new Date(year, index), minDate, maxDate }),
    onMouseDown: (event) => preventFocus && event.preventDefault()
  }, month));
  return /* @__PURE__ */ React__default.createElement("div", __spreadValues$j({
    className: cx(classes.monthPicker, className)
  }, others), /* @__PURE__ */ React__default.createElement(CalendarHeader, {
    label: year.toString(),
    hasNext: typeof maxYear === "number" ? year < maxYear : true,
    hasPrevious: typeof minYear === "number" ? year > minYear : true,
    onNext: () => onYearChange(year + 1),
    onPrevious: () => onYearChange(year - 1),
    onNextLevel,
    size,
    classNames,
    styles,
    __staticSelector,
    nextLabel: nextYearLabel,
    previousLabel: previousYearLabel,
    preventFocus
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.monthPickerControls
  }, months));
}
MonthPicker.displayName = "@mantine/dates/MonthPicker";

function formatMonthLabel({ month, locale, format }) {
  return upperFirst(dayjs_min(month).locale(locale).format(format));
}

function getDayTabIndex({ focusable, hasValue, selected, firstInMonth }) {
  if (!focusable) {
    return -1;
  }
  if (hasValue) {
    return selected ? 0 : -1;
  }
  return firstInMonth ? 0 : -1;
}

function getDayAutofocus({ hasValue, selected, firstInMonth }) {
  if (hasValue) {
    return selected ? true : void 0;
  }
  return firstInMonth ? true : void 0;
}

var __defProp$i = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const sizes = {
  xs: 34,
  sm: 38,
  md: 46,
  lg: 58,
  xl: 66
};
var useStyles$A = createStyles((theme, { size, fullWidth, hideOutsideDates }, getRef) => {
  const weekend = { ref: getRef("weekend") };
  const outside = { ref: getRef("outside") };
  const selected = { ref: getRef("selected") };
  const inRange = { ref: getRef("inRange") };
  const firstInRange = { ref: getRef("firstInRange") };
  const lastInRange = { ref: getRef("lastInRange") };
  return {
    weekend,
    outside,
    selected,
    inRange,
    firstInRange,
    lastInRange,
    day: __spreadProps$7(__spreadValues$i(__spreadProps$7(__spreadValues$i(__spreadValues$i({}, theme.fn.fontStyles()), theme.fn.focusStyles()), {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      width: fullWidth ? "100%" : theme.fn.size({ size, sizes }),
      height: theme.fn.size({ size, sizes }),
      lineHeight: `${theme.fn.size({ size, sizes })}px`,
      fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
      padding: 0,
      borderRadius: theme.radius.sm,
      border: "none",
      cursor: "pointer",
      userSelect: "none",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      "&:disabled": {
        pointerEvents: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]
      }
    }), theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
    })), {
      [`&.${weekend.ref}:not(:disabled)`]: {
        color: theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7]
      },
      [`&.${outside.ref}`]: {
        display: hideOutsideDates ? "none" : void 0,
        color: `${theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]} !important`
      },
      [`&.${inRange.ref}:not(:disabled)`]: {
        backgroundColor: theme.fn.variant({ variant: "light" }).background,
        borderRadius: 0
      },
      [`&.${selected.ref}:not(:disabled)`]: {
        backgroundColor: theme.fn.variant({ variant: "filled" }).background,
        color: theme.white
      },
      [`&.${firstInRange.ref}:not(:disabled)`]: {
        borderTopLeftRadius: theme.radius.sm,
        borderBottomLeftRadius: theme.radius.sm
      },
      [`&.${lastInRange.ref}:not(:disabled)`]: {
        borderTopRightRadius: theme.radius.sm,
        borderBottomRightRadius: theme.radius.sm
      }
    })
  };
});

var __defProp$h = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
var __objRest$c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Day = forwardRef((_a, ref) => {
  var _b = _a, {
    className,
    value,
    selected,
    weekend,
    outside,
    onMouseEnter,
    classNames,
    styles,
    hasValue,
    firstInRange,
    lastInRange,
    __staticSelector = "Month",
    inRange,
    size,
    fullWidth,
    firstInMonth,
    focusable,
    hideOutsideDates,
    renderDay
  } = _b, others = __objRest$c(_b, [
    "className",
    "value",
    "selected",
    "weekend",
    "outside",
    "onMouseEnter",
    "classNames",
    "styles",
    "hasValue",
    "firstInRange",
    "lastInRange",
    "__staticSelector",
    "inRange",
    "size",
    "fullWidth",
    "firstInMonth",
    "focusable",
    "hideOutsideDates",
    "renderDay"
  ]);
  const { classes, cx } = useStyles$A({ size, fullWidth, hideOutsideDates }, { classNames, styles, name: __staticSelector });
  return /* @__PURE__ */ React__default.createElement("button", __spreadProps$6(__spreadValues$h({}, others), {
    type: "button",
    ref,
    onMouseEnter: (event) => onMouseEnter(value, event),
    tabIndex: getDayTabIndex({ focusable, hasValue, selected, firstInMonth }),
    "data-autofocus": getDayAutofocus({ hasValue, selected, firstInMonth }),
    "data-mantine-stop-propagation": true,
    className: cx(classes.day, {
      [classes.outside]: outside,
      [classes.weekend]: weekend,
      [classes.selected]: selected,
      [classes.inRange]: inRange,
      [classes.firstInRange]: firstInRange,
      [classes.lastInRange]: lastInRange
    }, className)
  }), typeof renderDay === "function" ? renderDay(value) : value.getDate());
});
Day.displayName = "@mantine/core/Day";

function isWeekend(date) {
  const weekday = date.getDay();
  return weekday === 6 || weekday === 0;
}

function isOutside(date, month) {
  return !isSameMonth(date, month);
}

function isDisabled({
  minDate,
  maxDate,
  excludeDate,
  disableOutsideEvents,
  date,
  outside
}) {
  const isAfterMax = maxDate instanceof Date && dayjs_min(maxDate).isBefore(date, "day");
  const isBeforeMin = minDate instanceof Date && dayjs_min(minDate).isAfter(date, "day");
  const shouldExclude = typeof excludeDate === "function" && excludeDate(date);
  const disabledOutside = !!disableOutsideEvents && !!outside;
  return isAfterMax || isBeforeMin || shouldExclude || disabledOutside;
}

function getRangeProps(date, range) {
  const hasRange = Array.isArray(range) && range.every((val) => val instanceof Date);
  const inclusiveRange = hasRange && [
    dayjs_min(range[0]).subtract(1, "day"),
    dayjs_min(range[1]).add(1, "day")
  ];
  const firstInRange = hasRange && isSameDate(date, range[0]);
  const lastInRange = hasRange && isSameDate(date, range[1]);
  const inRange = hasRange && dayjs_min(date).isAfter(inclusiveRange[0], "day") && dayjs_min(date).isBefore(inclusiveRange[1], "day");
  return { firstInRange, lastInRange, inRange, selectedInRange: firstInRange || lastInRange };
}

function getDayProps({
  date,
  month,
  hasValue,
  minDate,
  maxDate,
  value,
  excludeDate,
  disableOutsideEvents,
  range
}) {
  const outside = isOutside(date, month);
  const selected = hasValue && (Array.isArray(value) ? value.some((val) => isSameDate(val, date)) : isSameDate(date, value));
  const { inRange, lastInRange, firstInRange, selectedInRange } = getRangeProps(date, range);
  return {
    disabled: isDisabled({ minDate, maxDate, excludeDate, disableOutsideEvents, date, outside }),
    weekend: isWeekend(date),
    selectedInRange,
    selected,
    inRange,
    firstInRange,
    lastInRange,
    outside
  };
}

var __defProp$g = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
var useStyles$z = createStyles((theme, { fullWidth }) => ({
  weekday: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[5]
  },
  month: __spreadProps$5(__spreadValues$g({}, theme.fn.fontStyles()), {
    borderCollapse: "collapse",
    width: fullWidth ? "100%" : "auto",
    tableLayout: "fixed"
  }),
  cell: {
    boxSizing: "border-box",
    padding: 0,
    borderTop: "1px solid transparent"
  },
  weekdayCell: {
    boxSizing: "border-box",
    padding: 0,
    fontWeight: "normal",
    paddingBottom: theme.spacing.xs / 2,
    textAlign: "center",
    cursor: "default",
    userSelect: "none"
  }
}));

var __defProp$f = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const no = () => false;
const defaultProps$6 = {
  disableOutsideEvents: false,
  hideWeekdays: false,
  __staticSelector: "Month",
  size: "sm",
  fullWidth: false,
  preventFocus: false,
  focusable: true,
  firstDayOfWeek: "monday",
  hideOutsideDates: false
};
const Month = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("Month", defaultProps$6, props), {
    className,
    month,
    value,
    onChange,
    disableOutsideEvents,
    locale,
    dayClassName,
    dayStyle,
    classNames,
    styles,
    minDate,
    maxDate,
    excludeDate,
    onDayMouseEnter,
    range,
    hideWeekdays,
    __staticSelector,
    size,
    fullWidth,
    preventFocus,
    focusable,
    firstDayOfWeek,
    onDayKeyDown,
    daysRefs,
    hideOutsideDates,
    isDateInRange = no,
    isDateFirstInRange = no,
    isDateLastInRange = no,
    renderDay,
    weekdayLabelFormat
  } = _a, others = __objRest$b(_a, [
    "className",
    "month",
    "value",
    "onChange",
    "disableOutsideEvents",
    "locale",
    "dayClassName",
    "dayStyle",
    "classNames",
    "styles",
    "minDate",
    "maxDate",
    "excludeDate",
    "onDayMouseEnter",
    "range",
    "hideWeekdays",
    "__staticSelector",
    "size",
    "fullWidth",
    "preventFocus",
    "focusable",
    "firstDayOfWeek",
    "onDayKeyDown",
    "daysRefs",
    "hideOutsideDates",
    "isDateInRange",
    "isDateFirstInRange",
    "isDateLastInRange",
    "renderDay",
    "weekdayLabelFormat"
  ]);
  const { classes, cx, theme } = useStyles$z({ fullWidth }, { classNames, styles, name: __staticSelector });
  const finalLocale = locale || theme.datesLocale;
  const days = getMonthDays(month, firstDayOfWeek);
  const weekdays = getWeekdaysNames(finalLocale, firstDayOfWeek, weekdayLabelFormat).map((weekday) => /* @__PURE__ */ React__default.createElement("th", {
    className: classes.weekdayCell,
    key: weekday
  }, /* @__PURE__ */ React__default.createElement(Text$1, {
    size,
    className: classes.weekday
  }, weekday.length >= 2 ? upperFirst(weekday) : weekday)));
  const hasValue = Array.isArray(value) ? value.every((item) => item instanceof Date) : value instanceof Date;
  const hasValueInMonthRange = value instanceof Date && dayjs_min(value).isAfter(dayjs_min(month).startOf("month")) && dayjs_min(value).isBefore(dayjs_min(month).endOf("month"));
  const rows = days.map((row, rowIndex) => {
    const cells = row.map((date, cellIndex) => {
      const dayProps = getDayProps({
        date,
        month,
        hasValue,
        minDate,
        maxDate,
        value,
        excludeDate,
        disableOutsideEvents,
        range
      });
      const onKeyDownPayload = { rowIndex, cellIndex, date };
      return /* @__PURE__ */ React__default.createElement("td", {
        className: classes.cell,
        key: cellIndex
      }, /* @__PURE__ */ React__default.createElement(Day, {
        ref: (button) => {
          if (daysRefs) {
            if (!Array.isArray(daysRefs[rowIndex])) {
              daysRefs[rowIndex] = [];
            }
            daysRefs[rowIndex][cellIndex] = button;
          }
        },
        onClick: () => typeof onChange === "function" && onChange(date),
        onMouseDown: (event) => preventFocus && event.preventDefault(),
        value: date,
        outside: dayProps.outside,
        weekend: dayProps.weekend,
        inRange: dayProps.inRange || isDateInRange(date, dayProps),
        firstInRange: dayProps.firstInRange || isDateFirstInRange(date, dayProps),
        lastInRange: dayProps.lastInRange || isDateLastInRange(date, dayProps),
        firstInMonth: hideOutsideDates ? isSameDate(date, dayjs_min(month).startOf("month").toDate()) : cellIndex === 0 && rowIndex === 0,
        selected: dayProps.selected || dayProps.selectedInRange,
        hasValue: hasValueInMonthRange,
        onKeyDown: (event) => typeof onDayKeyDown === "function" && onDayKeyDown(onKeyDownPayload, event),
        className: typeof dayClassName === "function" ? dayClassName(date, dayProps) : null,
        style: typeof dayStyle === "function" ? dayStyle(date, dayProps) : null,
        disabled: dayProps.disabled,
        onMouseEnter: typeof onDayMouseEnter === "function" ? onDayMouseEnter : no,
        size,
        fullWidth,
        focusable,
        hideOutsideDates,
        __staticSelector,
        styles,
        classNames,
        renderDay
      }));
    });
    return /* @__PURE__ */ React__default.createElement("tr", {
      key: rowIndex
    }, cells);
  });
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$f({
    component: "table",
    className: cx(classes.month, className),
    ref
  }, others), !hideWeekdays && /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, weekdays)), /* @__PURE__ */ React__default.createElement("tbody", null, rows));
});
Month.displayName = "@mantine/dates/Month";

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function MonthsList(_a) {
  var _b = _a, {
    amountOfMonths,
    month,
    locale,
    minDate,
    maxDate,
    allowLevelChange,
    size,
    daysRefs,
    onMonthChange,
    onNextLevel,
    onDayKeyDown,
    classNames,
    styles,
    __staticSelector = "MonthsList",
    nextMonthLabel,
    previousMonthLabel,
    labelFormat,
    weekdayLabelFormat,
    preventFocus,
    renderDay
  } = _b, others = __objRest$a(_b, [
    "amountOfMonths",
    "month",
    "locale",
    "minDate",
    "maxDate",
    "allowLevelChange",
    "size",
    "daysRefs",
    "onMonthChange",
    "onNextLevel",
    "onDayKeyDown",
    "classNames",
    "styles",
    "__staticSelector",
    "nextMonthLabel",
    "previousMonthLabel",
    "labelFormat",
    "weekdayLabelFormat",
    "preventFocus",
    "renderDay"
  ]);
  const nextMonth = dayjs_min(month).add(amountOfMonths, "months").toDate();
  const previousMonth = dayjs_min(month).subtract(1, "months").toDate();
  const months = Array(amountOfMonths).fill(0).map((_, index) => {
    const monthDate = dayjs_min(month).add(index, "months").toDate();
    return /* @__PURE__ */ React__default.createElement("div", {
      key: index
    }, /* @__PURE__ */ React__default.createElement(CalendarHeader, {
      hasNext: index + 1 === amountOfMonths && isMonthInRange({ date: nextMonth, minDate, maxDate }),
      hasPrevious: index === 0 && isMonthInRange({ date: previousMonth, minDate, maxDate }),
      label: formatMonthLabel({ month: monthDate, locale, format: labelFormat }),
      onNext: () => onMonthChange(dayjs_min(month).add(amountOfMonths, "months").toDate()),
      onPrevious: () => onMonthChange(dayjs_min(month).subtract(amountOfMonths, "months").toDate()),
      onNextLevel,
      nextLevelDisabled: !allowLevelChange,
      size,
      classNames,
      styles,
      __staticSelector,
      nextLabel: nextMonthLabel,
      previousLabel: previousMonthLabel,
      preventLevelFocus: index > 0,
      preventFocus
    }), /* @__PURE__ */ React__default.createElement(Month, __spreadValues$e({
      month: monthDate,
      daysRefs: daysRefs.current[index],
      onDayKeyDown: (...args) => onDayKeyDown(index, ...args),
      size,
      minDate,
      maxDate,
      classNames,
      styles,
      __staticSelector,
      locale,
      focusable: index === 0,
      preventFocus,
      renderDay,
      weekdayLabelFormat
    }, others)));
  });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, months);
}
MonthsList.displayName = "@mantine/dates/MonthsList";

var useStyles$y = createStyles((theme, { size, amountOfMonths, fullWidth }) => {
  const _maxWidth = theme.fn.size({ size, sizes: sizes }) * 7;
  const maxWidth = amountOfMonths > 1 ? _maxWidth * amountOfMonths + (amountOfMonths - 1) * theme.spacing.md : _maxWidth;
  return {
    calendarBase: {
      boxSizing: "border-box",
      display: "flex",
      gap: theme.spacing.md,
      maxWidth: fullWidth ? "100%" : maxWidth
    }
  };
});

var __defProp$d = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$9 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CalendarBase = forwardRef((_a, ref) => {
  var _b = _a, {
    className,
    classNames,
    styles,
    month,
    initialMonth,
    onMonthChange,
    locale,
    amountOfMonths = 1,
    size = "sm",
    allowLevelChange = true,
    initialLevel = "date",
    minDate,
    maxDate,
    __staticSelector = "CalendarBase",
    dayClassName,
    dayStyle,
    disableOutsideEvents,
    excludeDate,
    hideWeekdays,
    fullWidth,
    preventFocus,
    firstDayOfWeek = "monday",
    value,
    onChange,
    onDayMouseEnter,
    range,
    nextDecadeLabel,
    nextMonthLabel,
    nextYearLabel,
    previousDecadeLabel,
    previousMonthLabel,
    previousYearLabel,
    labelFormat = "MMMM YYYY",
    weekdayLabelFormat,
    hideOutsideDates,
    isDateInRange,
    isDateFirstInRange,
    isDateLastInRange,
    renderDay
  } = _b, others = __objRest$9(_b, [
    "className",
    "classNames",
    "styles",
    "month",
    "initialMonth",
    "onMonthChange",
    "locale",
    "amountOfMonths",
    "size",
    "allowLevelChange",
    "initialLevel",
    "minDate",
    "maxDate",
    "__staticSelector",
    "dayClassName",
    "dayStyle",
    "disableOutsideEvents",
    "excludeDate",
    "hideWeekdays",
    "fullWidth",
    "preventFocus",
    "firstDayOfWeek",
    "value",
    "onChange",
    "onDayMouseEnter",
    "range",
    "nextDecadeLabel",
    "nextMonthLabel",
    "nextYearLabel",
    "previousDecadeLabel",
    "previousMonthLabel",
    "previousYearLabel",
    "labelFormat",
    "weekdayLabelFormat",
    "hideOutsideDates",
    "isDateInRange",
    "isDateFirstInRange",
    "isDateLastInRange",
    "renderDay"
  ]);
  const [selectionState, setSelectionState] = useState(initialLevel);
  const { classes, cx, theme } = useStyles$y({ size, fullWidth, amountOfMonths: selectionState === "date" ? amountOfMonths : 1 }, { name: __staticSelector, styles, classNames });
  const finalLocale = locale || theme.datesLocale;
  const daysRefs = useRef(Array(amountOfMonths).fill(0).map(() => []));
  const [_month, setMonth] = useUncontrolled({
    value: month,
    defaultValue: initialMonth,
    finalValue: new Date(),
    onChange: onMonthChange,
    rule: (val) => val instanceof Date
  });
  const [yearSelection, setYearSelection] = useState(_month.getFullYear());
  const minYear = minDate instanceof Date ? minDate.getFullYear() : 0;
  const maxYear = maxDate instanceof Date ? maxDate.getFullYear() : 1e4;
  const handleDayKeyDown = (monthIndex, payload, event) => {
    var _a2;
    switch (event.code) {
      case "ArrowDown": {
        event.preventDefault();
        if (payload.rowIndex + 1 < daysRefs.current[monthIndex].length) {
          daysRefs.current[monthIndex][payload.rowIndex + 1][payload.cellIndex].focus();
        }
        break;
      }
      case "ArrowUp": {
        event.preventDefault();
        if (payload.rowIndex > 0) {
          daysRefs.current[monthIndex][payload.rowIndex - 1][payload.cellIndex].focus();
        }
        break;
      }
      case "ArrowRight": {
        event.preventDefault();
        if (payload.cellIndex !== 6) {
          daysRefs.current[monthIndex][payload.rowIndex][payload.cellIndex + 1].focus();
        } else if (monthIndex + 1 < amountOfMonths) {
          if (daysRefs.current[monthIndex + 1][payload.rowIndex]) {
            (_a2 = daysRefs.current[monthIndex + 1][payload.rowIndex][0]) == null ? void 0 : _a2.focus();
          }
        }
        break;
      }
      case "ArrowLeft": {
        event.preventDefault();
        if (payload.cellIndex !== 0) {
          daysRefs.current[monthIndex][payload.rowIndex][payload.cellIndex - 1].focus();
        } else if (monthIndex > 0) {
          if (daysRefs.current[monthIndex - 1][payload.rowIndex]) {
            daysRefs.current[monthIndex - 1][payload.rowIndex][6].focus();
          }
        }
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, __spreadValues$d({
    className: cx(classes.calendarBase, className),
    ref
  }, others), selectionState === "year" && /* @__PURE__ */ React__default.createElement(YearPicker, {
    size,
    value: yearSelection,
    minYear,
    maxYear,
    onChange: (year) => {
      setYearSelection(year);
      setSelectionState("month");
    },
    classNames,
    styles,
    __staticSelector,
    nextDecadeLabel,
    previousDecadeLabel,
    preventFocus
  }), selectionState === "month" && /* @__PURE__ */ React__default.createElement(MonthPicker, {
    size,
    value: { month: _month.getMonth(), year: _month.getFullYear() },
    year: yearSelection,
    onYearChange: setYearSelection,
    onNextLevel: () => setSelectionState("year"),
    locale: finalLocale,
    minDate,
    maxDate,
    onChange: (monthValue) => {
      setMonth(new Date(yearSelection, monthValue, 1));
      setSelectionState("date");
    },
    classNames,
    styles,
    __staticSelector,
    nextYearLabel,
    previousYearLabel,
    preventFocus
  }), selectionState === "date" && /* @__PURE__ */ React__default.createElement(MonthsList, {
    amountOfMonths,
    month: _month,
    locale: finalLocale,
    minDate,
    maxDate,
    allowLevelChange,
    size,
    daysRefs,
    onMonthChange: setMonth,
    onNextLevel: () => setSelectionState("month"),
    onDayKeyDown: handleDayKeyDown,
    classNames,
    styles,
    __staticSelector,
    dayClassName,
    dayStyle,
    disableOutsideEvents,
    excludeDate,
    hideWeekdays,
    fullWidth,
    preventFocus,
    firstDayOfWeek,
    value,
    range,
    onChange,
    nextMonthLabel,
    previousMonthLabel,
    labelFormat,
    weekdayLabelFormat,
    onDayMouseEnter,
    renderDay,
    hideOutsideDates,
    isDateInRange,
    isDateFirstInRange,
    isDateLastInRange
  }));
});
CalendarBase.displayName = "@mantine/dates/CalendarBase";

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$8 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$5 = {
  __staticSelector: "Calendar"
};
function Calendar(props) {
  const _a = useMantineDefaultProps("Calendar", defaultProps$5, props), {
    __staticSelector = "Calendar",
    multiple,
    value,
    onChange
  } = _a, others = __objRest$8(_a, [
    "__staticSelector",
    "multiple",
    "value",
    "onChange"
  ]);
  const handleChange = (date) => {
    if (!multiple) {
      return onChange(date);
    }
    const isSelected = value.some((val) => isSameDate(val, date));
    return onChange(isSelected ? value.filter((val) => !isSameDate(val, date)) : [...value, date]);
  };
  return /* @__PURE__ */ React__default.createElement(CalendarBase, __spreadValues$c({
    __staticSelector,
    onChange: handleChange,
    value
  }, others));
}
Calendar.displayName = "@mantine/dates/Calendar";

var __defProp$b = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var useStyles$x = createStyles((theme, { size, invalid }, getRef) => ({
  wrapper: __spreadProps$4(__spreadValues$b({}, theme.fn.fontStyles()), {
    position: "relative",
    cursor: "pointer"
  }),
  placeholder: {
    lineHeight: `${theme.fn.size({ size, sizes: sizes$b }) - 2}px`,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
  },
  value: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  dropdownWrapper: {
    position: "relative",
    pointerEvents: "all"
  },
  input: {
    cursor: "pointer",
    whiteSpace: "nowrap",
    [`&:not(.${getRef("freeInput")})::selection`]: {
      backgroundColor: "transparent"
    }
  },
  freeInput: {
    ref: getRef("freeInput"),
    cursor: "text"
  },
  dropdown: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]}`,
    padding: `${theme.spacing.md}px ${theme.spacing.xs}px`
  },
  arrow: {
    borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2],
    background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
  }
}));

var __defProp$a = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __objRest$7 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RIGHT_SECTION_WIDTH$2 = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
const DatePickerBase = forwardRef((_a, ref) => {
  var _b = _a, {
    classNames,
    className,
    style,
    styles,
    wrapperProps,
    required,
    allowFreeInput = false,
    label,
    error,
    id,
    description,
    placeholder,
    shadow = "sm",
    transition = "pop-top-left",
    transitionDuration = 200,
    transitionTimingFunction,
    closeDropdownOnScroll = false,
    size = "sm",
    children,
    inputLabel,
    __staticSelector = "DatePickerBase",
    dropdownOpened,
    setDropdownOpened,
    dropdownType = "popover",
    clearable = true,
    clearButtonLabel,
    onClear,
    positionDependencies = [],
    zIndex = getDefaultZIndex("popover"),
    withinPortal = true,
    onBlur,
    onFocus,
    onChange,
    onKeyDown,
    name = "date",
    sx,
    amountOfMonths = 1,
    onDropdownClose,
    onDropdownOpen,
    clickOutsideEvents = ["mousedown", "touchstart"],
    modalZIndex,
    errorProps,
    labelProps,
    descriptionProps,
    clearButtonTabIndex = 0
  } = _b, others = __objRest$7(_b, [
    "classNames",
    "className",
    "style",
    "styles",
    "wrapperProps",
    "required",
    "allowFreeInput",
    "label",
    "error",
    "id",
    "description",
    "placeholder",
    "shadow",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "closeDropdownOnScroll",
    "size",
    "children",
    "inputLabel",
    "__staticSelector",
    "dropdownOpened",
    "setDropdownOpened",
    "dropdownType",
    "clearable",
    "clearButtonLabel",
    "onClear",
    "positionDependencies",
    "zIndex",
    "withinPortal",
    "onBlur",
    "onFocus",
    "onChange",
    "onKeyDown",
    "name",
    "sx",
    "amountOfMonths",
    "onDropdownClose",
    "onDropdownOpen",
    "clickOutsideEvents",
    "modalZIndex",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "clearButtonTabIndex"
  ]);
  const { classes, cx, theme } = useStyles$x({ size, invalid: !!error }, { classNames, styles, name: __staticSelector });
  const { systemStyles, rest } = extractSystemStyles(others);
  const [dropdownElement, setDropdownElement] = useState(null);
  const [rootElement, setRootElement] = useState(null);
  const [referenceElement, setReferenceElement] = useState(null);
  const uuid = useUuid(id);
  const focusTrapRef = useFocusTrap(!allowFreeInput && dropdownOpened);
  const inputRef = useRef();
  const closeDropdown = () => {
    setDropdownOpened(false);
    onDropdownClose == null ? void 0 : onDropdownClose();
  };
  const openDropdown = () => {
    setDropdownOpened(true);
    onDropdownOpen == null ? void 0 : onDropdownOpen();
  };
  const toggleDropdown = () => {
    setDropdownOpened(!dropdownOpened);
    !dropdownOpened ? onDropdownOpen == null ? void 0 : onDropdownOpen() : onDropdownClose == null ? void 0 : onDropdownClose();
  };
  const closeOnEscape = (event) => {
    if (event.nativeEvent.code === "Escape") {
      closeDropdown();
      window.setTimeout(() => {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
      }, 0);
    }
  };
  useClickOutside(() => dropdownType === "popover" && !allowFreeInput && closeDropdown(), clickOutsideEvents, [dropdownElement, rootElement]);
  useWindowEvent("scroll", () => closeDropdownOnScroll && closeDropdown());
  const rightSection = clearable ? /* @__PURE__ */ React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: onClear,
    size,
    tabIndex: clearButtonTabIndex
  }) : null;
  const handleInputBlur = (event) => {
    typeof onBlur === "function" && onBlur(event);
    if (allowFreeInput) {
      closeDropdown();
    }
  };
  const handleInputFocus = (event) => {
    typeof onFocus === "function" && onFocus(event);
    if (allowFreeInput) {
      openDropdown();
    }
  };
  const handleKeyDown = (event) => {
    typeof onKeyDown === "function" && onKeyDown(event);
    if ((event.code === "Space" || event.code === "Enter") && !allowFreeInput) {
      event.preventDefault();
      openDropdown();
    }
  };
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$a(__spreadValues$a({
    required,
    id: uuid,
    label,
    error,
    description,
    className,
    style,
    classNames,
    styles,
    size,
    __staticSelector,
    sx,
    ref: setReferenceElement,
    errorProps,
    descriptionProps,
    labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement("div", {
    ref: setRootElement
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classes.wrapper
  }, /* @__PURE__ */ React__default.createElement(Input$1, __spreadValues$a({
    classNames: __spreadProps$3(__spreadValues$a({}, classNames), {
      input: cx(classes.input, { [classes.freeInput]: allowFreeInput }, classNames == null ? void 0 : classNames.input)
    }),
    styles,
    onClick: () => !allowFreeInput ? toggleDropdown() : openDropdown(),
    onKeyDown: handleKeyDown,
    id: uuid,
    ref: useMergedRef(ref, inputRef),
    __staticSelector,
    size,
    name,
    placeholder,
    value: inputLabel,
    required,
    invalid: !!error,
    readOnly: !allowFreeInput,
    rightSection,
    rightSectionWidth: theme.fn.size({ size, sizes: RIGHT_SECTION_WIDTH$2 }),
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    onChange,
    autoComplete: "off"
  }, rest))), dropdownType === "popover" ? /* @__PURE__ */ React__default.createElement(Popper, {
    referenceElement,
    transitionDuration,
    transitionTimingFunction,
    forceUpdateDependencies: positionDependencies,
    transition,
    mounted: dropdownOpened,
    position: "bottom",
    placement: "start",
    gutter: 10,
    withinPortal,
    withArrow: true,
    arrowSize: 3,
    zIndex,
    arrowClassName: classes.arrow
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classes.dropdownWrapper,
    ref: setDropdownElement,
    "data-mantine-stop-propagation": dropdownOpened,
    onKeyDownCapture: closeOnEscape,
    "aria-hidden": allowFreeInput || void 0
  }, /* @__PURE__ */ React__default.createElement(Paper, {
    className: classes.dropdown,
    shadow,
    ref: focusTrapRef
  }, children))) : /* @__PURE__ */ React__default.createElement(Modal$1, {
    opened: dropdownOpened,
    onClose: closeDropdown,
    withCloseButton: false,
    size: amountOfMonths * 400,
    zIndex: modalZIndex
  }, children)));
});
DatePickerBase.displayName = "@mantine/dates/DatePickerBase";

var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$4 = {
  shadow: "sm",
  transitionDuration: 200,
  closeCalendarOnChange: true,
  labelFormat: "MMMM YYYY",
  initiallyOpened: false,
  name: "date",
  size: "sm",
  dropdownType: "popover",
  clearable: true,
  disabled: false,
  fixOnBlur: true,
  withinPortal: true,
  firstDayOfWeek: "monday",
  openDropdownOnClear: true
};
const DatePicker$1 = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("DatePicker", defaultProps$4, props), {
    value,
    onChange,
    defaultValue,
    classNames,
    styles,
    shadow,
    locale,
    inputFormat,
    transitionDuration,
    transitionTimingFunction,
    nextMonthLabel,
    previousMonthLabel,
    closeCalendarOnChange,
    labelFormat,
    dayClassName,
    dayStyle,
    disableOutsideEvents,
    minDate,
    maxDate,
    excludeDate,
    initialMonth,
    initiallyOpened,
    name,
    size,
    dropdownType,
    clearable,
    disabled,
    clearButtonLabel,
    fixOnBlur,
    allowFreeInput,
    withinPortal,
    dateParser,
    firstDayOfWeek,
    onFocus,
    onBlur,
    amountOfMonths,
    allowLevelChange,
    initialLevel,
    onDropdownClose,
    onDropdownOpen,
    hideOutsideDates,
    hideWeekdays,
    renderDay,
    type,
    openDropdownOnClear
  } = _a, others = __objRest$6(_a, [
    "value",
    "onChange",
    "defaultValue",
    "classNames",
    "styles",
    "shadow",
    "locale",
    "inputFormat",
    "transitionDuration",
    "transitionTimingFunction",
    "nextMonthLabel",
    "previousMonthLabel",
    "closeCalendarOnChange",
    "labelFormat",
    "dayClassName",
    "dayStyle",
    "disableOutsideEvents",
    "minDate",
    "maxDate",
    "excludeDate",
    "initialMonth",
    "initiallyOpened",
    "name",
    "size",
    "dropdownType",
    "clearable",
    "disabled",
    "clearButtonLabel",
    "fixOnBlur",
    "allowFreeInput",
    "withinPortal",
    "dateParser",
    "firstDayOfWeek",
    "onFocus",
    "onBlur",
    "amountOfMonths",
    "allowLevelChange",
    "initialLevel",
    "onDropdownClose",
    "onDropdownOpen",
    "hideOutsideDates",
    "hideWeekdays",
    "renderDay",
    "type",
    "openDropdownOnClear"
  ]);
  const theme = useMantineTheme();
  const finalLocale = locale || theme.datesLocale;
  const dateFormat = type === "date" ? "YYYY-MM-DD" : inputFormat || theme.dateFormat;
  const [dropdownOpened, setDropdownOpened] = useState(initiallyOpened);
  const calendarSize = size === "lg" || size === "xl" ? "md" : "sm";
  const inputRef = useRef();
  const [lastValidValue, setLastValidValue] = useState(defaultValue != null ? defaultValue : null);
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: null,
    onChange,
    rule: (val) => val === null || val instanceof Date
  });
  const [calendarMonth, setCalendarMonth] = useState(_value || initialMonth || new Date());
  const [focused, setFocused] = useState(false);
  const [inputState, setInputState] = useState(_value instanceof Date ? upperFirst(dayjs_min(_value).locale(finalLocale).format(dateFormat)) : "");
  const closeDropdown = () => {
    setDropdownOpened(false);
    onDropdownClose == null ? void 0 : onDropdownClose();
  };
  const openDropdown = () => {
    setDropdownOpened(true);
    onDropdownOpen == null ? void 0 : onDropdownOpen();
  };
  useEffect(() => {
    if (value === null && !focused) {
      setInputState("");
    }
    if (value instanceof Date && !focused) {
      setInputState(dayjs_min(value).locale(finalLocale).format(dateFormat));
    }
  }, [value, focused]);
  const handleValueChange = (date) => {
    setValue(date);
    setInputState(upperFirst(dayjs_min(date).locale(finalLocale).format(dateFormat)));
    closeCalendarOnChange && closeDropdown();
    window.setTimeout(() => {
      var _a2;
      return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    }, 0);
  };
  const handleClear = () => {
    var _a2;
    setValue(null);
    setLastValidValue(null);
    setInputState("");
    openDropdownOnClear && openDropdown();
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  const parseDate = (date) => dateParser ? dateParser(date) : dayjs_min(date, dateFormat, finalLocale).toDate();
  const setDateFromInput = () => {
    let date = typeof _value === "string" ? parseDate(_value) : _value;
    if (maxDate && dayjs_min(date).isAfter(maxDate)) {
      date = maxDate;
    }
    if (minDate && dayjs_min(date).isBefore(minDate)) {
      date = minDate;
    }
    if (dayjs_min(date).isValid()) {
      setValue(date);
      setLastValidValue(date);
      setInputState(upperFirst(dayjs_min(date).locale(finalLocale).format(dateFormat)));
      setCalendarMonth(date);
    } else if (fixOnBlur) {
      setValue(lastValidValue);
    }
  };
  const handleInputBlur = (event) => {
    typeof onBlur === "function" && onBlur(event);
    setFocused(false);
    if (allowFreeInput) {
      setDateFromInput();
    }
  };
  const handleKeyDown = (event) => {
    if (event.code === "Enter" && allowFreeInput) {
      closeDropdown();
      setDateFromInput();
    }
  };
  const handleInputFocus = (event) => {
    typeof onFocus === "function" && onFocus(event);
    setFocused(true);
  };
  const handleChange = (event) => {
    openDropdown();
    const date = parseDate(event.target.value);
    if (dayjs_min(date).isValid()) {
      setValue(date);
      setLastValidValue(date);
      setInputState(event.target.value);
      setCalendarMonth(date);
    } else {
      setInputState(event.target.value);
    }
  };
  return /* @__PURE__ */ React__default.createElement(DatePickerBase, __spreadValues$9({
    allowFreeInput,
    dropdownOpened,
    setDropdownOpened,
    shadow,
    transitionDuration,
    ref: useMergedRef(ref, inputRef),
    size,
    styles,
    classNames,
    onChange: handleChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    onKeyDown: handleKeyDown,
    name,
    inputLabel: inputState,
    __staticSelector: "DatePicker",
    dropdownType,
    clearable: type === "date" ? false : clearable && !!_value && !disabled,
    clearButtonLabel,
    onClear: handleClear,
    disabled,
    withinPortal,
    amountOfMonths,
    onDropdownClose,
    onDropdownOpen,
    type
  }, others), /* @__PURE__ */ React__default.createElement(Calendar, {
    classNames,
    styles,
    locale: finalLocale,
    nextMonthLabel,
    previousMonthLabel,
    month: allowFreeInput ? calendarMonth : void 0,
    initialMonth: initialMonth || (_value instanceof Date ? _value : new Date()),
    onMonthChange: setCalendarMonth,
    value: _value instanceof Date ? _value : dayjs_min(_value).toDate(),
    onChange: handleValueChange,
    labelFormat,
    dayClassName,
    dayStyle,
    disableOutsideEvents,
    minDate,
    maxDate,
    excludeDate,
    __staticSelector: "DatePicker",
    fullWidth: dropdownType === "modal",
    size: dropdownType === "modal" ? "lg" : calendarSize,
    firstDayOfWeek,
    preventFocus: allowFreeInput,
    amountOfMonths,
    allowLevelChange,
    initialLevel,
    hideOutsideDates,
    hideWeekdays,
    renderDay
  }));
});
DatePicker$1.displayName = "@mantine/dates/DatePicker";

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps$3 = {
  __staticSelector: "RangeCalendar",
  allowSingleDateInRange: false,
  amountOfMonths: 1
};
const RangeCalendar = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("RangeCalendar", defaultProps$3, props), {
    value,
    onChange,
    dayStyle,
    onMouseLeave,
    __staticSelector,
    allowSingleDateInRange,
    amountOfMonths
  } = _a, others = __objRest$5(_a, [
    "value",
    "onChange",
    "dayStyle",
    "onMouseLeave",
    "__staticSelector",
    "allowSingleDateInRange",
    "amountOfMonths"
  ]);
  const [hoveredDay, setHoveredDay] = useState(null);
  const [pickedDate, setPickedDate] = useState(null);
  const setRangeDate = (date) => {
    if (pickedDate instanceof Date) {
      if (isSameDate(date, pickedDate) && !allowSingleDateInRange) {
        setPickedDate(null);
        setHoveredDay(null);
        return null;
      }
      const result = [date, pickedDate];
      result.sort((a, b) => a.getTime() - b.getTime());
      onChange(result);
      setPickedDate(null);
      return null;
    }
    if (value[0] && isSameDate(date, value[0]) && !allowSingleDateInRange) {
      setPickedDate(null);
      setHoveredDay(null);
      onChange([null, null]);
      return null;
    }
    onChange([date, null]);
    setPickedDate(date);
    return null;
  };
  const handleMouseLeave = (event) => {
    typeof onMouseLeave === "function" && onMouseLeave(event);
    setHoveredDay(null);
  };
  const shouldHighlightDate = (date, modifiers) => {
    if (pickedDate instanceof Date && hoveredDay instanceof Date) {
      const result = [hoveredDay, pickedDate];
      result.sort((a, b) => a.getTime() - b.getTime());
      return !modifiers.selected && dayjs_min(date).subtract(1, "day").isBefore(result[1]) && dayjs_min(date).add(1, "day").isAfter(result[0]);
    }
    return false;
  };
  const isPickedDateFirstInRange = (date, modifiers) => {
    if (pickedDate instanceof Date && hoveredDay instanceof Date) {
      const result = [hoveredDay, pickedDate];
      result.sort((a, b) => a.getTime() - b.getTime());
      return modifiers.selected && dayjs_min(date).isBefore(result[1]);
    }
    return false;
  };
  const isPickedDateLastInRange = (date, modifiers) => {
    if (pickedDate instanceof Date && hoveredDay instanceof Date) {
      const result = [hoveredDay, pickedDate];
      result.sort((a, b) => a.getTime() - b.getTime());
      return modifiers.selected && dayjs_min(date).isAfter(result[0]);
    }
    return false;
  };
  return /* @__PURE__ */ React__default.createElement(CalendarBase, __spreadValues$8({
    dayStyle,
    onMouseLeave: handleMouseLeave,
    onDayMouseEnter: (date) => setHoveredDay(date),
    onChange: setRangeDate,
    value: pickedDate,
    range: value,
    ref,
    __staticSelector,
    amountOfMonths,
    hideOutsideDates: amountOfMonths > 1,
    isDateInRange: shouldHighlightDate,
    isDateFirstInRange: isPickedDateFirstInRange,
    isDateLastInRange: isPickedDateLastInRange
  }, others));
});
RangeCalendar.displayName = "@mantine/dates/RangeCalendar";

var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const validationRule = (val) => Array.isArray(val) && val.length === 2 && val.every((v) => v instanceof Date);
const isFirstDateSet = (val) => Array.isArray(val) && val.length === 2 && val[0] instanceof Date;
const defaultProps$2 = {
  shadow: "sm",
  transitionDuration: 200,
  closeCalendarOnChange: true,
  labelFormat: "MMMM YYYY",
  initiallyOpened: false,
  size: "sm",
  dropdownType: "popover",
  labelSeparator: "\u2013",
  clearable: true,
  firstDayOfWeek: "monday",
  allowSingleDateInRange: false,
  amountOfMonths: 1,
  withinPortal: true,
  openDropdownOnClear: true
};
const DateRangePicker = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("DateRangePicker", defaultProps$2, props), {
    value,
    onChange,
    defaultValue,
    classNames,
    styles,
    shadow,
    locale,
    inputFormat,
    transitionDuration,
    transitionTimingFunction,
    nextMonthLabel,
    previousMonthLabel,
    closeCalendarOnChange,
    labelFormat,
    dayClassName,
    dayStyle,
    disableOutsideEvents,
    minDate,
    maxDate,
    excludeDate,
    initialMonth,
    initiallyOpened,
    size,
    dropdownType,
    labelSeparator,
    clearable,
    clearButtonLabel,
    firstDayOfWeek,
    allowLevelChange,
    allowSingleDateInRange,
    amountOfMonths,
    withinPortal,
    initialLevel,
    onDropdownClose,
    onDropdownOpen,
    hideOutsideDates,
    hideWeekdays,
    renderDay,
    openDropdownOnClear
  } = _a, others = __objRest$4(_a, [
    "value",
    "onChange",
    "defaultValue",
    "classNames",
    "styles",
    "shadow",
    "locale",
    "inputFormat",
    "transitionDuration",
    "transitionTimingFunction",
    "nextMonthLabel",
    "previousMonthLabel",
    "closeCalendarOnChange",
    "labelFormat",
    "dayClassName",
    "dayStyle",
    "disableOutsideEvents",
    "minDate",
    "maxDate",
    "excludeDate",
    "initialMonth",
    "initiallyOpened",
    "size",
    "dropdownType",
    "labelSeparator",
    "clearable",
    "clearButtonLabel",
    "firstDayOfWeek",
    "allowLevelChange",
    "allowSingleDateInRange",
    "amountOfMonths",
    "withinPortal",
    "initialLevel",
    "onDropdownClose",
    "onDropdownOpen",
    "hideOutsideDates",
    "hideWeekdays",
    "renderDay",
    "openDropdownOnClear"
  ]);
  const theme = useMantineTheme();
  const finalLocale = locale || theme.datesLocale;
  const dateFormat = inputFormat || theme.dateFormat;
  const [dropdownOpened, setDropdownOpened] = useState(initiallyOpened);
  const calendarSize = size === "lg" || size === "xl" ? "md" : "sm";
  const inputRef = useRef();
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: [null, null],
    onChange,
    rule: isFirstDateSet
  });
  const handleValueChange = (range) => {
    setValue(range);
    if (closeCalendarOnChange && validationRule(range)) {
      setDropdownOpened(false);
      onDropdownClose == null ? void 0 : onDropdownClose();
      window.setTimeout(() => {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
      }, 0);
    }
  };
  const valueValid = validationRule(_value);
  const firstValueValid = isFirstDateSet(_value);
  const firstDateLabel = _value[0] ? upperFirst(dayjs_min(_value[0]).locale(finalLocale).format(dateFormat)) : "";
  const secondDateLabel = _value[1] ? upperFirst(dayjs_min(_value[1]).locale(finalLocale).format(dateFormat)) : "";
  const handleClear = () => {
    var _a2;
    setValue([null, null]);
    setDropdownOpened(true);
    openDropdownOnClear && (onDropdownOpen == null ? void 0 : onDropdownOpen());
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  const handleDropdownToggle = (isOpened) => {
    if (!isOpened && firstValueValid && _value[1] === null) {
      handleClear();
    }
    setDropdownOpened(isOpened);
  };
  return /* @__PURE__ */ React__default.createElement(DatePickerBase, __spreadValues$7({
    dropdownOpened,
    setDropdownOpened: handleDropdownToggle,
    shadow,
    transitionDuration,
    ref: useMergedRef(ref, inputRef),
    size,
    styles,
    classNames,
    inputLabel: firstValueValid ? `${firstDateLabel} ${labelSeparator} ${secondDateLabel}` : "",
    __staticSelector: "DateRangePicker",
    dropdownType,
    clearable: clearable && firstValueValid,
    clearButtonLabel,
    onClear: handleClear,
    withinPortal,
    amountOfMonths,
    onDropdownClose,
    onDropdownOpen
  }, others), /* @__PURE__ */ React__default.createElement(RangeCalendar, {
    classNames,
    styles,
    locale: finalLocale,
    nextMonthLabel,
    previousMonthLabel,
    initialMonth: valueValid ? _value[0] : initialMonth,
    value: _value,
    onChange: handleValueChange,
    labelFormat,
    dayClassName,
    dayStyle,
    disableOutsideEvents,
    minDate,
    maxDate,
    excludeDate,
    __staticSelector: "DateRangePicker",
    fullWidth: dropdownType === "modal",
    firstDayOfWeek,
    size: dropdownType === "modal" ? "lg" : calendarSize,
    allowLevelChange,
    allowSingleDateInRange,
    amountOfMonths,
    initialLevel,
    hideOutsideDates,
    hideWeekdays,
    renderDay
  }));
});
DateRangePicker.displayName = "@mantine/dates/DateRangePicker";

function padTime(value) {
  const _val = parseInt(value, 10);
  return _val >= 10 ? _val.toString() : `0${_val}`;
}

var __defProp$6 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const inputSizes = {
  xs: 20,
  sm: 23,
  md: 25,
  lg: 27,
  xl: 29
};
var useStyles$w = createStyles((theme, { size, hasValue }) => ({
  timeInput: __spreadProps$2(__spreadValues$6({}, theme.fn.fontStyles()), {
    width: theme.fn.size({ size, sizes: inputSizes }),
    appearance: "none",
    backgroundColor: "transparent",
    color: "inherit",
    padding: 0,
    textAlign: "center",
    border: "1px solid transparent",
    fontSize: theme.fn.size({ size, sizes: theme.fontSizes }),
    lineHeight: 1,
    outline: 0,
    "&:focus": {
      textAlign: hasValue ? void 0 : "start"
    },
    "&::placeholder": {
      textAlign: "center"
    },
    "&[disabled]": {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
      cursor: "not-allowed"
    }
  })
}));

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TimeField = forwardRef((_a, ref) => {
  var _b = _a, {
    className,
    onFocus,
    onBlur,
    onChange,
    setValue,
    withSeparator = false,
    size = "sm",
    max,
    min = 0,
    value
  } = _b, others = __objRest$3(_b, [
    "className",
    "onFocus",
    "onBlur",
    "onChange",
    "setValue",
    "withSeparator",
    "size",
    "max",
    "min",
    "value"
  ]);
  const [digitsEntered, setDigitsEntered] = useState(0);
  const { classes, cx, theme } = useStyles$w({ size, hasValue: !!value });
  const inputRef = useRef();
  const handleFocus = (event) => {
    typeof onFocus === "function" && onFocus(event);
    inputRef.current.select();
    setDigitsEntered(0);
  };
  const handleBlur = (event) => {
    typeof onBlur === "function" && onBlur(event);
    if (digitsEntered === 1) {
      typeof onChange === "function" && onChange(event.currentTarget.value, false);
    }
  };
  const handleClick = (event) => {
    event.stopPropagation();
    inputRef.current.select();
  };
  const handleKeyDown = (event) => {
    if (event.nativeEvent.code === "ArrowUp") {
      event.preventDefault();
      const padded = padTime(clamp$1({ value: parseInt(event.currentTarget.value, 10) + 1, max, min }).toString());
      if (value !== padded) {
        onChange(padded, false);
      }
    }
    if (event.nativeEvent.code === "ArrowDown") {
      event.preventDefault();
      const padded = padTime(clamp$1({ value: parseInt(event.currentTarget.value, 10) - 1, max, min }).toString());
      if (value !== padded) {
        onChange(padded, false);
      }
    }
  };
  const handleChange = (event) => {
    setDigitsEntered(digitsEntered + 1);
    const _val = parseInt(event.currentTarget.value, 10).toString();
    if (_val === "0" && digitsEntered === 0) {
      setValue("00");
      return;
    }
    onChange(_val, true, digitsEntered > 0);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("input", __spreadValues$5({
    type: "text",
    inputMode: "numeric",
    ref: useMergedRef(inputRef, ref),
    onChange: handleChange,
    onClick: handleClick,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    value,
    className: cx(classes.timeInput, className)
  }, others)), withSeparator && /* @__PURE__ */ React__default.createElement(Text$1, {
    size,
    style: {
      lineHeight: 1,
      color: value ? "inherit" : theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
    }
  }, ":"));
});
TimeField.displayName = "@mantine/dates/TimeField";

function allButLastDigit(value) {
  return Math.floor(value / 10);
}

function createTimeHandler({ onChange, nextRef, min, max, nextMax }) {
  return (value, triggerShift, forceTriggerShift = false) => {
    var _a, _b;
    const parsed = parseInt(value, 10);
    if (Number.isNaN(parsed)) {
      return;
    }
    if (parsed > allButLastDigit(max) || forceTriggerShift) {
      const lastDigit = parsed % 10;
      let updatedValue;
      let carryOver;
      if (parsed > max && nextMax && lastDigit <= allButLastDigit(nextMax)) {
        updatedValue = padTime(allButLastDigit(parsed).toString());
        carryOver = padTime(lastDigit.toString());
      } else {
        updatedValue = padTime(clamp$1({ value: parsed, min, max }).toString());
      }
      onChange(updatedValue, carryOver);
      triggerShift && ((_a = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _a.focus());
      triggerShift && ((_b = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _b.select());
      return;
    }
    onChange(parsed.toString());
  };
}

var useStyles$v = createStyles((theme, { size }) => ({
  timeInput: {},
  disabled: {
    opacity: 0.6,
    cursor: "not-allowed"
  },
  controls: {
    display: "flex",
    alignItems: "center",
    height: theme.fn.size({ size, sizes: sizes$b }) - 2
  }
}));

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AmPmInput = forwardRef((_a, ref) => {
  var _b = _a, { className, onChange, onFocus, size = "sm", value } = _b, others = __objRest$2(_b, ["className", "onChange", "onFocus", "size", "value"]);
  const { classes, cx } = useStyles$w({ size, hasValue: !!value });
  const inputRef = useRef();
  const handleFocus = (event) => {
    typeof onFocus === "function" && onFocus(event);
    inputRef.current.select();
  };
  const handleClick = (event) => {
    event.stopPropagation();
    inputRef.current.select();
  };
  const handleKeyDown = (event) => {
    if (event.nativeEvent.code === "ArrowUp" || event.nativeEvent.code === "ArrowDown") {
      event.preventDefault();
      onChange(value === "am" ? "pm" : "am", true);
    }
  };
  const handleChange = (event) => {
    const lastInputVal = event.target.value.slice(-1).toLowerCase();
    if (lastInputVal === "p") {
      event.preventDefault();
      onChange("pm", true);
      return;
    }
    if (lastInputVal === "a") {
      event.preventDefault();
      onChange("am", true);
      return;
    }
    onChange(value.toString(), true);
  };
  return /* @__PURE__ */ React__default.createElement("input", __spreadValues$4({
    type: "text",
    ref: useMergedRef(inputRef, ref),
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    value,
    className: cx(classes.timeInput, className)
  }, others));
});
AmPmInput.displayName = "@mantine/dates/AmPmInput";

const testRegex = /(^(a|p)m?$)|(^$)/;
function createAmPmHandler({ onChange, nextRef }) {
  return (value, triggerShift) => {
    var _a, _b;
    const valLower = value.toLowerCase();
    if (valLower === "am" || valLower === "pm") {
      onChange(valLower);
      triggerShift && ((_a = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _a.focus());
      triggerShift && ((_b = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _b.select());
      return;
    }
    if (!testRegex.test(valLower)) {
      return;
    }
    onChange(valLower);
  };
}

function getDate(hours, minutes, seconds, format, amPm) {
  const date = dayjs_min();
  let _hours = parseInt(hours, 10);
  const _minutes = parseInt(minutes, 10);
  const _seconds = parseInt(seconds, 10);
  if (Number.isNaN(_hours)) {
    _hours = 0;
  }
  if (format === "12") {
    _hours %= 12;
    if (amPm === "pm") {
      _hours += 12;
    }
  }
  return date.hour(_hours).minute(Number.isNaN(_minutes) ? 0 : _minutes).second(Number.isNaN(_seconds) ? 0 : _seconds).millisecond(0).toDate();
}

function getTimeValues(value, format) {
  if (!(value instanceof Date)) {
    return { hours: "", minutes: "", seconds: "", amPm: "" };
  }
  let _hours = value.getHours();
  const isPm = _hours >= 12;
  if (format === "12") {
    _hours %= 12;
    if (_hours === 0) {
      _hours += 12;
    }
  }
  return {
    hours: padTime(_hours.toString()),
    minutes: padTime(value.getMinutes().toString()),
    seconds: padTime(value.getSeconds().toString()),
    amPm: isPm ? "pm" : "am"
  };
}

var __defProp$3 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RIGHT_SECTION_WIDTH$1 = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
const defaultProps$1 = {
  size: "sm",
  withSeconds: false,
  clearable: false,
  format: "24",
  timePlaceholder: "--",
  amPmPlaceholder: "am",
  disabled: false
};
const TimeInput = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("TimeInput", defaultProps$1, props), {
    required,
    label,
    error,
    description,
    className,
    style,
    size,
    wrapperProps,
    classNames,
    styles,
    id,
    value,
    defaultValue,
    onChange,
    withSeconds,
    clearable,
    clearButtonLabel,
    format,
    name,
    hoursLabel,
    minutesLabel,
    secondsLabel,
    amPmLabel,
    timePlaceholder,
    amPmPlaceholder,
    disabled,
    sx,
    nextRef,
    labelProps,
    descriptionProps,
    errorProps
  } = _a, others = __objRest$1(_a, [
    "required",
    "label",
    "error",
    "description",
    "className",
    "style",
    "size",
    "wrapperProps",
    "classNames",
    "styles",
    "id",
    "value",
    "defaultValue",
    "onChange",
    "withSeconds",
    "clearable",
    "clearButtonLabel",
    "format",
    "name",
    "hoursLabel",
    "minutesLabel",
    "secondsLabel",
    "amPmLabel",
    "timePlaceholder",
    "amPmPlaceholder",
    "disabled",
    "sx",
    "nextRef",
    "labelProps",
    "descriptionProps",
    "errorProps"
  ]);
  const { classes, cx, theme } = useStyles$v({ size }, { classNames, styles, name: "TimeInput" });
  const { systemStyles, rest } = extractSystemStyles(others);
  const uuid = useUuid(id);
  const hoursRef = useRef();
  const minutesRef = useRef();
  const secondsRef = useRef();
  const amPmRef = useRef();
  const [time, setTime] = useState(getTimeValues(value || defaultValue, format));
  const [_value, setValue] = useState(value || defaultValue);
  useDidUpdate(() => {
    setTime(getTimeValues(_value, format));
  }, [_value, format]);
  useDidUpdate(() => {
    if ((value == null ? void 0 : value.getTime()) !== (_value == null ? void 0 : _value.getTime())) {
      setValue(value);
    }
  }, [value]);
  const setDate = (change) => {
    const timeWithChange = __spreadValues$3(__spreadValues$3({}, time), change);
    const newDate = getDate(timeWithChange.hours, timeWithChange.minutes, timeWithChange.seconds, format, timeWithChange.amPm);
    setValue(newDate);
    typeof onChange === "function" && onChange(newDate);
  };
  const handleHoursChange = createTimeHandler({
    onChange: (val, carryOver) => {
      setDate({
        hours: val,
        minutes: carryOver != null ? carryOver : time.minutes
      });
    },
    min: format === "12" ? 1 : 0,
    max: format === "12" ? 12 : 23,
    nextRef: minutesRef,
    nextMax: 59
  });
  const handleMinutesChange = createTimeHandler({
    onChange: (val, carryOver) => {
      setDate({
        minutes: val,
        seconds: carryOver != null ? carryOver : time.seconds
      });
    },
    min: 0,
    max: 59,
    nextRef: withSeconds ? secondsRef : format === "12" ? amPmRef : nextRef,
    nextMax: withSeconds ? 59 : void 0
  });
  const handleSecondsChange = createTimeHandler({
    onChange: (val) => {
      setDate({ seconds: val });
    },
    min: 0,
    max: 59,
    nextRef: format === "12" ? amPmRef : nextRef
  });
  const handleAmPmChange = createAmPmHandler({
    onChange: (val) => {
      setDate({ amPm: val });
    },
    nextRef
  });
  const handleClear = () => {
    setTime({ hours: "", minutes: "", seconds: "", amPm: "" });
    setValue(null);
    onChange == null ? void 0 : onChange(null);
    hoursRef.current.focus();
  };
  const rightSection = clearable && _value ? /* @__PURE__ */ React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: handleClear,
    size
  }) : null;
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$3(__spreadValues$3({
    required,
    label,
    error,
    description,
    className,
    style,
    classNames,
    styles,
    size,
    __staticSelector: "TimeInput",
    id: uuid,
    sx,
    errorProps,
    descriptionProps,
    labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement(Input$1, __spreadValues$3({
    component: "div",
    __staticSelector: "TimeInput",
    required,
    invalid: !!error,
    onClick: () => hoursRef.current.focus(),
    size,
    className: cx({ [classes.disabled]: disabled }),
    classNames,
    styles,
    disabled,
    rightSection,
    rightSectionWidth: theme.fn.size({ size, sizes: RIGHT_SECTION_WIDTH$1 })
  }, rest), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.controls
  }, /* @__PURE__ */ React__default.createElement(TimeField, {
    ref: useMergedRef(hoursRef, ref),
    value: time.hours,
    onChange: handleHoursChange,
    setValue: (val) => setTime((current) => __spreadProps$1(__spreadValues$3({}, current), { hours: val })),
    id: uuid,
    className: classes.timeInput,
    withSeparator: true,
    size,
    max: format === "12" ? 12 : 23,
    placeholder: timePlaceholder,
    "aria-label": hoursLabel,
    disabled,
    name
  }), /* @__PURE__ */ React__default.createElement(TimeField, {
    ref: minutesRef,
    value: time.minutes,
    onChange: handleMinutesChange,
    setValue: (val) => setTime((current) => __spreadProps$1(__spreadValues$3({}, current), { minutes: val })),
    className: classes.timeInput,
    withSeparator: withSeconds,
    size,
    max: 59,
    placeholder: timePlaceholder,
    "aria-label": minutesLabel,
    disabled
  }), withSeconds && /* @__PURE__ */ React__default.createElement(TimeField, {
    ref: secondsRef,
    value: time.seconds,
    onChange: handleSecondsChange,
    setValue: (val) => setTime((current) => __spreadProps$1(__spreadValues$3({}, current), { seconds: val })),
    className: classes.timeInput,
    size,
    max: 59,
    placeholder: timePlaceholder,
    "aria-label": secondsLabel,
    disabled
  }), format === "12" && /* @__PURE__ */ React__default.createElement(AmPmInput, {
    ref: amPmRef,
    value: time.amPm,
    onChange: handleAmPmChange,
    placeholder: amPmPlaceholder,
    size,
    "aria-label": amPmLabel,
    disabled
  }))));
});
TimeInput.displayName = "@mantine/dates/TimeInput";

var useStyles$u = createStyles((theme, { size }) => ({
  timeField: {},
  disabled: {
    opacity: 0.6,
    cursor: "not-allowed"
  },
  inputWrapper: {
    display: "inline-flex",
    alignItems: "center",
    height: theme.fn.size({ size, sizes: sizes$b }) - 2
  },
  separator: {
    paddingLeft: theme.fn.size({ size, sizes: theme.spacing }) / 2,
    paddingRight: theme.fn.size({ size, sizes: theme.spacing }) / 2,
    lineHeight: 1
  }
}));

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RIGHT_SECTION_WIDTH = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
const defaultProps = {
  size: "sm",
  defaultValue: [null, null],
  withSeconds: false,
  clearable: false,
  format: "24",
  timePlaceholder: "--",
  amPmPlaceholder: "am",
  labelSeparator: "\u2013",
  disabled: false
};
const TimeRangeInput = forwardRef((props, ref) => {
  const _a = useMantineDefaultProps("TimeRangeInput", defaultProps, props), {
    required,
    label,
    error,
    description,
    className,
    style,
    size,
    wrapperProps,
    classNames,
    styles,
    id,
    value,
    defaultValue,
    onChange,
    withSeconds,
    clearable,
    clearButtonLabel,
    format,
    name,
    hoursLabel,
    minutesLabel,
    secondsLabel,
    amPmLabel,
    timePlaceholder,
    amPmPlaceholder,
    labelSeparator,
    disabled,
    sx,
    labelProps,
    descriptionProps,
    errorProps
  } = _a, others = __objRest(_a, [
    "required",
    "label",
    "error",
    "description",
    "className",
    "style",
    "size",
    "wrapperProps",
    "classNames",
    "styles",
    "id",
    "value",
    "defaultValue",
    "onChange",
    "withSeconds",
    "clearable",
    "clearButtonLabel",
    "format",
    "name",
    "hoursLabel",
    "minutesLabel",
    "secondsLabel",
    "amPmLabel",
    "timePlaceholder",
    "amPmPlaceholder",
    "labelSeparator",
    "disabled",
    "sx",
    "labelProps",
    "descriptionProps",
    "errorProps"
  ]);
  const { classes, cx, theme } = useStyles$u({ size }, { classNames, styles, name: "TimeRangeInput" });
  const { systemStyles, rest } = extractSystemStyles(others);
  const uuid = useUuid(id);
  const fromTimeRef = useRef();
  const toTimeRef = useRef();
  const [_value, setValue] = useState(value != null ? value : defaultValue);
  useDidUpdate(() => {
    typeof onChange === "function" && onChange(_value);
  }, [_value]);
  useDidUpdate(() => {
    var _a2, _b, _c, _d;
    if (((_a2 = value[0]) == null ? void 0 : _a2.getTime()) !== ((_b = _value[0]) == null ? void 0 : _b.getTime()) || ((_c = value[1]) == null ? void 0 : _c.getTime()) !== ((_d = _value[1]) == null ? void 0 : _d.getTime())) {
      setValue(value);
    }
  }, [value]);
  const handleClear = () => {
    var _a2;
    setValue([null, null]);
    (_a2 = fromTimeRef.current) == null ? void 0 : _a2.focus();
  };
  const rightSection = clearable && _value.filter((item) => Boolean(item)).length > 0 ? /* @__PURE__ */ React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: handleClear,
    size
  }) : null;
  const forwardProps = {
    amPmLabel,
    amPmPlaceholder,
    disabled,
    format,
    hoursLabel,
    minutesLabel,
    secondsLabel,
    size,
    timePlaceholder,
    withSeconds
  };
  return /* @__PURE__ */ React__default.createElement(InputWrapper, __spreadValues$2(__spreadValues$2({
    required,
    label,
    error,
    description,
    className,
    style,
    classNames,
    styles,
    size,
    __staticSelector: "TimeRangeInput",
    id: uuid,
    sx,
    errorProps,
    descriptionProps,
    labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */ React__default.createElement(Input$1, __spreadValues$2({
    component: "div",
    __staticSelector: "TimeRangeInput",
    required,
    invalid: !!error,
    onClick: () => {
      var _a2;
      (_a2 = fromTimeRef.current) == null ? void 0 : _a2.focus();
    },
    size,
    className: cx({ [classes.disabled]: disabled }),
    classNames,
    styles,
    disabled,
    rightSection,
    rightSectionWidth: theme.fn.size({ size, sizes: RIGHT_SECTION_WIDTH })
  }, rest), /* @__PURE__ */ React__default.createElement("div", {
    className: classes.inputWrapper
  }, /* @__PURE__ */ React__default.createElement(TimeInput, __spreadValues$2({
    ref: useMergedRef(fromTimeRef, ref),
    variant: "unstyled",
    value: _value[0],
    onChange: (date) => setValue([date, _value[1]]),
    name,
    nextRef: toTimeRef,
    id: uuid
  }, forwardProps)), /* @__PURE__ */ React__default.createElement("span", {
    className: classes.separator,
    style: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
    }
  }, labelSeparator), /* @__PURE__ */ React__default.createElement(TimeInput, __spreadValues$2({
    ref: toTimeRef,
    variant: "unstyled",
    value: _value[1],
    onChange: (date) => setValue([_value[0], date])
  }, forwardProps)))));
});
TimeRangeInput.displayName = "@mantine/dates/TimeRangeInput";

var inputBorderColor$2 = function (colors, dataEntered, validated) {
    if (dataEntered && !validated) {
        return colors.neutral[800];
    }
    if (validated) {
        return colors.success[500];
    }
    else {
        return colors.neutral[500];
    }
};

var useStyles$t = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$x || (templateObject_1$x = __makeTemplateObject$1(["\n    width: ", " !important;\n    position: relative;\n    ", "\n  "], ["\n    width: ", " !important;\n    position: relative;\n    ", "\n  "])), fullWidth ? '100%' : '232px', typographyToStyle(theme.typography.body2));
    },
    label: function (theme) { return css(templateObject_2$h || (templateObject_2$h = __makeTemplateObject$1(["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "], ["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "])), typographyToStyle(theme.typography.label), theme.typography.fontFamily, theme.colors.neutral[500], theme.colors.common.white); },
    input: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius, typography = _a.typography;
        var dataEntered = _b.dataEntered, validated = _b.validated;
        return css(templateObject_3$f || (templateObject_3$f = __makeTemplateObject$1(["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    background: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    background: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "])), borderRadius.sm, inputBorderColor$2(colors, dataEntered, validated), typographyToStyle(typography.body2), colors.common.white, colors.neutral[800], colors.neutral[600], colors.neutral[600], colors.common.white, colors.neutral[600], colors.primary[500]);
    },
    item: function () { return css(templateObject_4$b || (templateObject_4$b = __makeTemplateObject$1(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))); },
    hovered: function (_a) {
        var colors = _a.colors;
        return css(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    disabled: function (_a) {
        var colors = _a.colors;
        return css(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject$1(["\n    border-color: ", ";\n    color: ", ";\n  "], ["\n    border-color: ", ";\n    color: ", ";\n  "])), colors.neutral[200], colors.neutral[500]);
    },
    rightSection: function (_a, _b) {
        var colors = _a.colors;
        var disabled = _b.disabled;
        return css(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject$1(["\n    color: ", ";\n    margin-right: 8px;\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n    path {\n      fill: ", ";\n    }\n  "], ["\n    color: ", ";\n    margin-right: 8px;\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n    path {\n      fill: ", ";\n    }\n  "])), colors.neutral[500], disabled ? colors.neutral[200] : colors.neutral[400]);
    },
    required: function () { return css(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject$1(["\n    display: none;\n  "], ["\n    display: none;\n  "]))); },
    // Calendar
    dropdown: function (_a) {
        var borderRadius = _a.borderRadius, shadows = _a.shadows, colors = _a.colors;
        return css(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject$1(["\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n    width: 104%;\n    padding: 16px 24px;\n  "], ["\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n    width: 104%;\n    padding: 16px 24px;\n  "])), borderRadius.sm, shadows[1], colors.neutral[100]);
    },
    calendarBase: function () { return css(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject$1(["\n    width: 280px !important;\n  "], ["\n    width: 280px !important;\n  "]))); },
    arrow: function () { return css(templateObject_11 || (templateObject_11 = __makeTemplateObject$1(["\n    display: none;\n  "], ["\n    display: none;\n  "]))); },
    weekday: function (_a) {
        var colors = _a.colors;
        return css(templateObject_12 || (templateObject_12 = __makeTemplateObject$1(["\n    font-weight: 700;\n    text-transform: lowercase;\n    color: ", ";\n  "], ["\n    font-weight: 700;\n    text-transform: lowercase;\n    color: ", ";\n  "])), colors.neutral[400]);
    },
    weekend: function (_a) {
        var colors = _a.colors;
        return css(templateObject_13 || (templateObject_13 = __makeTemplateObject$1(["\n    color: ", " !important;\n    &:hover {\n      color: ", " !important;\n    }\n  "], ["\n    color: ", " !important;\n    &:hover {\n      color: ", " !important;\n    }\n  "])), colors.neutral[900], colors.primary[500]);
    },
    selected: function (_a) {
        var colors = _a.colors;
        return css(templateObject_14 || (templateObject_14 = __makeTemplateObject$1(["\n    color: ", " !important;\n    background-color: ", " !important;\n  "], ["\n    color: ", " !important;\n    background-color: ", " !important;\n  "])), colors.common.white, colors.primary[500]);
    },
    outside: function (_a) {
        var colors = _a.colors;
        return css(templateObject_15 || (templateObject_15 = __makeTemplateObject$1(["\n    color: ", " !important;\n  "], ["\n    color: ", " !important;\n  "])), colors.neutral[600]);
    },
    day: function (_a) {
        var colors = _a.colors, typography = _a.typography;
        return css(templateObject_16 || (templateObject_16 = __makeTemplateObject$1(["\n    color: ", ";\n    ", ";\n    width: 40px;\n    height: 40px;\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    ", ";\n    width: 40px;\n    height: 40px;\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  "])), colors.neutral[900], typographyToStyle(typography.link), colors.primary[100], colors.primary[500]);
    },
});
var templateObject_1$x, templateObject_2$h, templateObject_3$f, templateObject_4$b, templateObject_5$7, templateObject_6$7, templateObject_7$6, templateObject_8$3, templateObject_9$3, templateObject_10$1, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;

createCommonjsModule(function (module, exports) {
!function(e,o){module.exports=o(dayjs_min);}(commonjsGlobal,(function(e){function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=o(e),s={name:"pt-br",weekdays:"domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),ordinal:function(e){return e+"º"},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},relativeTime:{future:"em %s",past:"há %s",s:"poucos segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"}};return a.default.locale(s,null,!0),s}));
});

var updateLocale = createCommonjsModule(function (module, exports) {
!function(e,n){module.exports=n();}(commonjsGlobal,(function(){return function(e,n,t){t.updateLocale=function(e,n){var o=t.Ls[e];if(o)return (n?Object.keys(n):[]).forEach((function(e){o[e]=n[e];})),o};}}));
});

var DatePicker = function (_a) {
    var label = _a.label, fullWidth = _a.fullWidth, validated = _a.validated, disabled = _a.disabled, required = _a.required, optional = _a.optional, onChange = _a.onChange, error = _a.error, props = __rest(_a, ["label", "fullWidth", "validated", "disabled", "required", "optional", "onChange", "error"]);
    var _b = useState(), dataEntered = _b[0], setDataEntered = _b[1];
    var styles = useStyles$t({ fullWidth: fullWidth, validated: validated, dataEntered: dataEntered, disabled: disabled });
    var Label = function () { return (jsxs(Fragment, { children: [label, required && label && jsx("span", { children: " (obrigat\u00F3rio)" }), optional && label && jsx("span", { children: " (opcional)" })] })); };
    dayjs_min.extend(updateLocale);
    dayjs_min.updateLocale('pt-br', {
        weekdaysMin: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
    });
    var handleChange = function (value) {
        if (value.length)
            setDataEntered(true);
        else
            setDataEntered(false);
        onChange && onChange(value);
    };
    var fixDate = function (dateString) {
        var cleanedDateString = dateString.replace(/ˆ[0-9]/g, '');
        var day = cleanedDateString.substring(0, 2);
        var month = cleanedDateString.substring(2, 4);
        var year = cleanedDateString.substring(4, 8);
        return new Date("".concat(year, "/").concat(month, "/").concat(day));
    };
    return (jsx(DatePicker$1, __assign$2({ locale: "pt-br", firstDayOfWeek: "sunday", rightSection: jsx(SvgCalendar, { size: "medium" }), onChange: handleChange, disabled: disabled, error: error && jsx(FieldErrorMessage, { error: error }), label: jsx(Label, {}), inputFormat: "DD/MM/YYYY", labelFormat: "DD/MM/YYYY", styles: styles, allowLevelChange: false, dateParser: fixDate }, props)));
};

var useStyles$s = makeStyles({
    footer: function (_a) {
        var colors = _a.colors, typography = _a.typography;
        return css(templateObject_1$w || (templateObject_1$w = __makeTemplateObject$1(["\n    color: ", ";\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    width: 100%;\n    z-index: 9;\n    ", "\n\n    @media (max-width: 639px) {\n      text-align: center;\n    }\n  "], ["\n    color: ", ";\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    width: 100%;\n    z-index: 9;\n    ", "\n\n    @media (max-width: 639px) {\n      text-align: center;\n    }\n  "])), colors.neutral[700], typographyToStyle(typography.microCopy));
    },
});
var templateObject_1$w;

function formatBytes(bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0)
        return '0 Bytes';
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return (parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[Math.abs(i)]);
}
function capitalize(str) {
    var _a, _b;
    var strSplited = str.split(' ');
    for (var i = 0, x = strSplited.length; i < x; i++) {
        strSplited[i] = ((_a = strSplited[i][0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + ((_b = strSplited[i]) === null || _b === void 0 ? void 0 : _b.substr(1));
    }
    return strSplited.join(' ');
}

var utc = createCommonjsModule(function (module, exports) {
!function(t,i){module.exports=i();}(commonjsGlobal,(function(){var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t);};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds();}else r.call(this);};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r;}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return !!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return "s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)};}}));
});

var timezone = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10));}var d=r[3],l=24===d?0:d,v=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",h=+e;return (o.utc(v).valueOf()-(h-=h%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute");}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return "timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return [i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t;};}}));
});

dayjs_min.locale('pt-br');
dayjs_min.extend(utc);
dayjs_min.extend(timezone);
var TimeZoneGMT = function () {
    var footer = useStyles$s().footer;
    var _a = useState(), parsedDate = _a[0], setParsedData = _a[1];
    var parseDate = useCallback(function (date) {
        var parsedDate = date.format('DD/MM/YYYY, dddd - HH:mm:ss');
        var timeZoneText = 'Brasil (UTC-3) - Horário de Brasília';
        return "".concat(capitalize(parsedDate), " - ").concat(timeZoneText);
    }, []);
    useEffect(function () {
        var interval = setInterval(function () {
            var dt = dayjs_min();
            dt.tz('America/Sao_Paulo');
            var parsedDt = parseDate(dt);
            setParsedData(parsedDt);
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [parseDate]);
    return (jsx("div", __assign$2({ css: footer }, { children: jsx("div", { children: parsedDate }) })));
};

var DEFAULT_TOAST_DURATION = 3000;
var TOAST_CONTAINER_POSITION_STYLE = {
    'top-right': 'position: fixed; top: 0; right: 0; padding: 16px; z-index: 9999;',
    'top-center': 'position: fixed; top: 0; left: 50%; transform: translateX(-50%); padding: 16px; z-index: 9999;',
    'top-left': 'position: fixed; top: 0; left: 0; padding: 16px; z-index: 9999;',
    'bottom-left': 'position: fixed; bottom: 0; left: 0; padding: 16px; z-index: 9999;',
    'bottom-center': 'position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); padding: 16px; z-index: 9999;',
    'bottom-right': 'position: fixed; bottom: 0; right: 0; padding: 16px; z-index: 9999;',
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

var toastStore = create(function (set) { return ({
    toasts: [],
    containerPosition: 'top-right',
    setContainerPosition: function (position) {
        return set(function () { return ({
            containerPosition: position,
        }); });
    },
    removeToast: function (id) {
        return set(function (state) { return ({ toasts: state.toasts.filter(function (t) { return t.id !== id; }) }); });
    },
    addToast: function (toast) {
        var newMessage = __assign$2({ id: v4() }, toast);
        return set(function (state) { return ({ toasts: __spreadArray(__spreadArray([], state.toasts, true), [newMessage], false) }); });
    },
    cleanAll: function () { return set(function () { return ({ toasts: [] }); }); },
}); });

var useToastContainer = function () {
    var uuid = useId();
    var _a = useState(false), loaded = _a[0], setLoaded = _a[1];
    var toastContainerId = useState("toast-container-".concat(uuid))[0];
    var containerPosition = toastStore.getState().containerPosition;
    useEffect(function () {
        var div = document.createElement('div');
        div.setAttribute('id', toastContainerId);
        div.setAttribute('style', TOAST_CONTAINER_POSITION_STYLE[containerPosition]);
        document.getElementsByTagName('body')[0].prepend(div);
        setLoaded(true);
        return function () {
            document.getElementsByTagName('body')[0].removeChild(div);
        };
    }, [toastContainerId, containerPosition]);
    return { toastContainerId: toastContainerId, loaded: loaded };
};

var ICON_VARIANTS = {
    success: jsx(SvgSuccess, { size: "large", color: theme.colors.success[400] }),
    error: jsx(SvgFail, { size: "large", color: theme.colors.danger[400] }),
    warning: jsx(SvgWarning, { size: "large", color: theme.colors.warning[500] }),
};
var ANIMATION_POSITION_IN$1 = {
    'top-right': 'animate__fadeInRight',
    'top-center': 'animate__fadeInDown',
    'top-left': 'animate__fadeInLeft',
    'bottom-right': 'animate__fadeInRight',
    'bottom-center': 'animate__fadeInUp',
    'bottom-left': 'animate__fadeInLeft',
};
var ANIMATION_POSITION_OUT = {
    'top-right': 'animate__fadeOutRight',
    'top-center': 'animate__fadeOutUp',
    'top-left': 'animate__fadeOutLeft',
    'bottom-right': 'animate__fadeOutRight',
    'bottom-center': 'animate__fadeOutDown',
    'bottom-left': 'animate__fadeOutLeft',
};
var ANIMATION_DURATION$1 = 300;

var themesToStyle$1 = {
    dark: {
        background: theme.colors.neutral[700],
        color: theme.colors.common.white,
    },
    light: {
        background: theme.colors.common.white,
        color: theme.colors.neutral[800],
    },
};
var useStyles$r = makeStyles({
    body: function (theme, _a) {
        var toastTheme = _a.theme;
        return css(templateObject_1$v || (templateObject_1$v = __makeTemplateObject$1(["\n    max-width: 578px;\n    min-width: 266px;\n    width: fit-content;\n    box-shadow: ", ";\n    background: ", ";\n    padding: 16px;\n    border-radius: ", "px;\n    display: flex;\n    flex-direction: row;\n    animation-duration: ", "ms;\n  "], ["\n    max-width: 578px;\n    min-width: 266px;\n    width: fit-content;\n    box-shadow: ", ";\n    background: ", ";\n    padding: 16px;\n    border-radius: ", "px;\n    display: flex;\n    flex-direction: row;\n    animation-duration: ", "ms;\n  "])), theme.shadows[2], themesToStyle$1[toastTheme].background, theme.spacing(1), ANIMATION_DURATION$1);
    },
    text: function (theme, _a) {
        var toastTheme = _a.theme;
        return css(templateObject_2$g || (templateObject_2$g = __makeTemplateObject$1(["\n    ", "\n    color: ", ";\n    margin: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    flex-grow: 1;\n  "], ["\n    ", "\n    color: ", ";\n    margin: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    flex-grow: 1;\n  "])), typographyToStyle(theme.typography.body2), themesToStyle$1[toastTheme].color);
    },
    icon: function () { return css(templateObject_3$e || (templateObject_3$e = __makeTemplateObject$1(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "]))); },
    close: function (theme, _a) {
        var toastTheme = _a.theme;
        return css(templateObject_4$a || (templateObject_4$a = __makeTemplateObject$1(["\n    svg {\n      color: ", ";\n    }\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "], ["\n    svg {\n      color: ", ";\n    }\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "])), themesToStyle$1[toastTheme].color);
    },
});
var templateObject_1$v, templateObject_2$g, templateObject_3$e, templateObject_4$a;

var ToastComponent = function (_a) {
    var _b = _a.theme, theme$1 = _b === void 0 ? 'dark' : _b, message = _a.message, variant = _a.variant, id = _a.id, onClose = _a.onClose, styles = _a.styles;
    var _c = useStyles$r({ theme: theme$1 }), body = _c.body, text = _c.text, icon = _c.icon, close = _c.close;
    var useStore = create$1(toastStore);
    var containerPosition = useStore().containerPosition;
    return (jsxs("div", __assign$2({ style: styles === null || styles === void 0 ? void 0 : styles.body, css: body, id: id, className: "".concat(ANIMATION_POSITION_IN$1[containerPosition]) }, { children: [jsx("span", __assign$2({ css: icon }, { children: ICON_VARIANTS[variant] })), jsx("span", __assign$2({ style: styles === null || styles === void 0 ? void 0 : styles.message, css: text }, { children: message })), jsx("span", { className: "action" }), jsx("span", __assign$2({ css: close }, { children: jsx(ActionIcon, __assign$2({ variant: "transparent", onClick: function () { return onClose(id); } }, { children: jsx(SvgClose, { color: theme$1 === 'dark'
                            ? theme.colors.common.white
                            : theme.colors.neutral[800] }) })) }))] })));
};
function areEqual$1(prevProps, nextProps) {
    return (prevProps.message === nextProps.message ||
        prevProps.id === nextProps.id ||
        prevProps.variant === nextProps.variant);
}
var Toast = memo(ToastComponent, areEqual$1);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var useToastRemoval = function () {
    var _a = toastStore.getState(), removeToast = _a.removeToast, containerPosition = _a.containerPosition;
    function toastPurge(id) {
        removeToast(id);
    }
    function toastRemoval(id) {
        var toast = document.getElementById(id);
        if (toast) {
            toast.classList.add(ANIMATION_POSITION_OUT[containerPosition]);
            setTimeout(function () {
                toastPurge(id);
            }, ANIMATION_DURATION$1);
        }
    }
    return { toastRemoval: toastRemoval };
};

var useToastAutoClose = function (props) {
    var toasts = props.toasts;
    var toastRemoval = useToastRemoval().toastRemoval;
    var _a = useState(), removingToast = _a[0], setRemovingToast = _a[1];
    useEffect(function () {
        if (removingToast === null || removingToast === void 0 ? void 0 : removingToast.id) {
            toastRemoval(removingToast.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removingToast]);
    useEffect(function () {
        if (!toasts.length)
            return;
        var currentToastToClose = toasts[toasts.length - 1];
        if (currentToastToClose.autoClose) {
            setTimeout(function () { return setRemovingToast(currentToastToClose); }, currentToastToClose.autoCloseDuration || DEFAULT_TOAST_DURATION);
        }
    }, [toasts]);
};

var ToastContainer = function (_a) {
    var position = _a.position, toastStyles = _a.toastStyles;
    var useStore = create$1(toastStore);
    var toastRemoval = useToastRemoval().toastRemoval;
    var _b = useStore(), toasts = _b.toasts, setContainerPosition = _b.setContainerPosition;
    var _c = useToastContainer(), toastContainerId = _c.toastContainerId, loaded = _c.loaded;
    useEffect(function () {
        position && setContainerPosition(position);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [position]);
    useToastAutoClose({ toasts: toasts });
    return loaded ? (ReactDOM.createPortal(jsx("div", __assign$2({ style: {
            display: 'flex',
            gap: '8px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        } }, { children: toasts.map(function (t) { return (jsx(Toast, { styles: toastStyles, id: t.id, message: t.message, theme: t.theme, variant: t.variant, onClose: toastRemoval }, t.id)); }) })), document.getElementById(toastContainerId))) : (jsx(Fragment, {}));
};

// eslint-disable-next-line @typescript-eslint/ban-types
var useStyles$q = makeStyles({
    root: function (_a) {
        var colors = _a.colors;
        return css(templateObject_1$u || (templateObject_1$u = __makeTemplateObject$1(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), colors.extra.disabled_bg);
    },
});
var templateObject_1$u;

var Progress = function (_a) {
    var size = _a.size, style = _a.style, props = __rest(_a, ["size", "style"]);
    var defaultStyles = useStyles$q({ size: size });
    return (jsx(Progress$1, __assign$2({ styles: defaultStyles, style: style, color: theme.colors.primary[500] }, props)));
};

var spinAnimation = keyframes(templateObject_1$t || (templateObject_1$t = __makeTemplateObject$1(["\n  from {\n    transform:  rotate(0deg);\n  }\n  to {\n    transform:  rotate(360deg);\n  }\n"], ["\n  from {\n    transform:  rotate(0deg);\n  }\n  to {\n    transform:  rotate(360deg);\n  }\n"
    // eslint-disable-next-line @typescript-eslint/ban-types
])));
// eslint-disable-next-line @typescript-eslint/ban-types
var useStyles$p = makeStyles({
    root: function () { return css(templateObject_2$f || (templateObject_2$f = __makeTemplateObject$1(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n  "]))); },
    spin: function () { return css(templateObject_3$d || (templateObject_3$d = __makeTemplateObject$1(["\n    svg {\n      animation: ", " 1.1s infinite linear;\n    }\n  "], ["\n    svg {\n      animation: ", " 1.1s infinite linear;\n    }\n  "])), spinAnimation); },
    text: function (theme, _a) {
        var textColor = _a.textColor;
        return css(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject$1(["\n    color: ", ";\n    margin-left: 8px;\n    ", ";\n    user-select: none;\n    cursor: default;\n  "], ["\n    color: ", ";\n    margin-left: 8px;\n    ", ";\n    user-select: none;\n    cursor: default;\n  "])), textColor, typographyToStyle(theme.typography.body1));
    },
});
var templateObject_1$t, templateObject_2$f, templateObject_3$d, templateObject_4$9;

var LOADER_SIZES = {
    large: 32,
    medium: 24,
};

var Loader = function (_a) {
    var text = _a.text, styles = _a.styles, _b = _a.size, size = _b === void 0 ? 'medium' : _b, ref = _a.ref, _c = _a.ringColor, ringColor = _c === void 0 ? theme.colors.primary[300] : _c, _d = _a.spinColor, spinColor = _d === void 0 ? theme.colors.primary[500] : _d;
    var defaultStyles = useStyles$p({
        size: size,
        textColor: spinColor,
    });
    return (jsxs("div", __assign$2({ css: [defaultStyles.root, styles === null || styles === void 0 ? void 0 : styles.root], ref: ref }, { children: [jsx("div", __assign$2({ css: [defaultStyles.spin, styles === null || styles === void 0 ? void 0 : styles.spinner] }, { children: jsxs("svg", __assign$2({ width: LOADER_SIZES[size], height: LOADER_SIZES[size], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { opacity: "0.2", fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z", fill: ringColor }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 1C11 0.447715 11.4477 0 12 0C18.6274 0 24 5.37258 24 12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12C22 6.47715 17.5228 2 12 2C11.4477 2 11 1.55228 11 1Z", fill: spinColor })] })) })), jsx("div", __assign$2({ css: [defaultStyles.text, styles === null || styles === void 0 ? void 0 : styles.text] }, { children: text }))] })));
};

var BUTTON_HEIGHT = {
    sm: '42px',
    md: '48px',
};

var useStyles$o = makeStyles({
    root: function (_a, _b) {
        var borderRadius = _a.borderRadius, borderWidths = _a.borderWidths, spacing = _a.spacing;
        var fullWidth = _b.fullWidth, size = _b.size;
        return css(templateObject_1$s || (templateObject_1$s = __makeTemplateObject$1(["\n    outline: none;\n    cursor: pointer;\n    padding: ", "px ", "px;\n    border-radius: ", ";\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.2s ease-in-out;\n    border: ", " solid;\n    width: ", ";\n    height: ", ";\n  "], ["\n    outline: none;\n    cursor: pointer;\n    padding: ", "px ", "px;\n    border-radius: ", ";\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.2s ease-in-out;\n    border: ", " solid;\n    width: ", ";\n    height: ", ";\n  "])), spacing(1), spacing(2), borderRadius.sm, borderWidths.thin, fullWidth ? '100%' : 'auto', BUTTON_HEIGHT[size]);
    },
    label: function (_a) {
        var typography = _a.typography;
        return css(templateObject_2$e || (templateObject_2$e = __makeTemplateObject$1(["\n    ", "\n  "], ["\n    ", "\n  "])), typographyToStyle(typography.button1));
    },
    filled: function (_a, _b) {
        var colors = _a.colors;
        var active = _b.active, variant = _b.variant;
        return css(templateObject_3$c || (templateObject_3$c = __makeTemplateObject$1(["\n    height: 42px;\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n      border-color: none;\n    }\n\n    &:active {\n      background-color: ", ";\n      border-color: none;\n    }\n\n    &::disabled {\n      color: ", ";\n      border-color: none;\n      background-color: ", ";\n    }\n  "], ["\n    height: 42px;\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n      border-color: none;\n    }\n\n    &:active {\n      background-color: ", ";\n      border-color: none;\n    }\n\n    &::disabled {\n      color: ", ";\n      border-color: none;\n      background-color: ", ";\n    }\n  "])), colors.primary[active ? 800 : 500], colors.primary[400], colors.primary[600], colors.extra.disabled_bg, variant === 'flat'
            ? " ".concat(colors.extra.disabled_bg)
            : 'transparent');
    },
    outline: function (_a, _b) {
        var colors = _a.colors;
        var active = _b.active, disabled = _b.disabled;
        return css(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject$1(["\n    background-color: transparent !important;\n    color: ", ";\n    border-color: ", " !important;\n    color: ", " !important;\n\n    &:hover {\n      background-color: transparent;\n\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &:active {\n      background-color: transparent;\n      color: ", ";\n      border-color: ", ";\n    }\n  "], ["\n    background-color: transparent !important;\n    color: ", ";\n    border-color: ", " !important;\n    color: ", " !important;\n\n    &:hover {\n      background-color: transparent;\n\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &:active {\n      background-color: transparent;\n      color: ", ";\n      border-color: ", ";\n    }\n  "])), colors.primary[active ? 800 : 500], disabled
            ? colors.extra.disabled_bg
            : colors.primary[active ? 800 : 500], disabled
            ? colors.extra.disabled_bg
            : colors.primary[active ? 800 : 500], colors.primary[400], colors.primary[400], colors.primary[600], colors.primary[600]);
    },
    subtle: function (_a) {
        var colors = _a.colors;
        return css(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject$1(["\n    height: 42px;\n    background-color: transparent;\n    border-color: transparent !important;\n    color: ", ";\n\n    &:hover {\n      background-color: transparent;\n      color: ", ";\n    }\n\n    &:active {\n      background-color: transparent;\n      color: ", ";\n    }\n\n    &::disabled {\n      color: ", ";\n    }\n  "], ["\n    height: 42px;\n    background-color: transparent;\n    border-color: transparent !important;\n    color: ", ";\n\n    &:hover {\n      background-color: transparent;\n      color: ", ";\n    }\n\n    &:active {\n      background-color: transparent;\n      color: ", ";\n    }\n\n    &::disabled {\n      color: ", ";\n    }\n  "])), colors.primary[500], colors.primary[400], colors.primary[600], colors.extra.disabled_bg);
    },
    loading: function () { return css(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject$1(["\n    &::before {\n      content: none;\n    }\n  "], ["\n    &::before {\n      content: none;\n    }\n  "]))); },
});
var templateObject_1$s, templateObject_2$e, templateObject_3$c, templateObject_4$8, templateObject_5$6, templateObject_6$6;

var Button = function (_a) {
    var onClick = _a.onClick, children = _a.children, fullWidth = _a.fullWidth, active = _a.active, _b = _a.variant, variant = _b === void 0 ? 'flat' : _b, disabled = _a.disabled, busy = _a.busy, _c = _a.size, size = _c === void 0 ? 'md' : _c, props = __rest(_a, ["onClick", "children", "fullWidth", "active", "variant", "disabled", "busy", "size"]);
    var styles = useStyles$o({ fullWidth: fullWidth, active: active, disabled: disabled, variant: variant, busy: busy, size: size });
    var variantStyle = useCallback(function () {
        if (variant === 'flat')
            return 'filled';
        if (variant === 'outlined')
            return 'outline';
        if (variant === 'link')
            return 'subtle';
    }, [variant]);
    return (jsx(Button$1, __assign$2({ onClick: onClick, styles: styles, variant: variantStyle(), disabled: disabled, loading: busy, loaderProps: {
            color: variant === 'flat'
                ? theme.colors.common.white
                : theme.colors.primary[500],
            size: 'sm',
        } }, props, { children: children })));
};

var useStyles$n = makeStyles({
    input: function (theme) { return css(templateObject_1$r || (templateObject_1$r = __makeTemplateObject$1(["\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    background-color: ", ";\n    border: 1px solid ", ";\n    &:checked {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n      border: 1px solid ", ";\n      cursor: not-allowed;\n    }\n  "], ["\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    background-color: ", ";\n    border: 1px solid ", ";\n    &:checked {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n      border: 1px solid ", ";\n      cursor: not-allowed;\n    }\n  "])), theme.colors.common.white, theme.colors.primary[500], theme.colors.primary[500], theme.colors.primary[500], theme.colors.common.white, theme.colors.neutral[200]); },
    inner: function () { return css(templateObject_2$d || (templateObject_2$d = __makeTemplateObject$1(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "]))); },
    icon: function () { return css(templateObject_3$b || (templateObject_3$b = __makeTemplateObject$1(["\n    width: 8px;\n    height: 8px;\n  "], ["\n    width: 8px;\n    height: 8px;\n  "]))); },
    label: function (theme, _a) {
        var disabled = _a.disabled;
        return css(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject$1(["\n    ", ";\n    color: ", ";\n    cursor: ", ";\n    padding-left: 8px;\n  "], ["\n    ", ";\n    color: ", ";\n    cursor: ", ";\n    padding-left: 8px;\n  "])), typographyToStyle(theme.typography.body2), disabled ? theme.colors.neutral[300] : theme.colors.common.black, disabled ? 'not-allowed' : 'pointer');
    },
});
var templateObject_1$r, templateObject_2$d, templateObject_3$b, templateObject_4$7;

var Checkbox = function (_a) {
    var disabled = _a.disabled, checked = _a.checked, rest = __rest(_a, ["disabled", "checked"]);
    var styles = useStyles$n({ disabled: disabled, checked: checked });
    return (jsx(Checkbox$1, __assign$2({ styles: styles, disabled: disabled, checked: checked }, rest)));
};

var useStyles$m = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$q || (templateObject_1$q = __makeTemplateObject$1(["\n    ", "\n    position: relative;\n    width: ", ";\n  "], ["\n    ", "\n    position: relative;\n    width: ", ";\n  "])), typographyToStyle(theme.typography.body2), fullWidth ? '100%' : '232px');
    },
    label: function (theme) { return css(templateObject_2$c || (templateObject_2$c = __makeTemplateObject$1(["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "], ["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "])), typographyToStyle(theme.typography.label), theme.typography.fontFamily, theme.colors.neutral[500], theme.colors.common.white); },
    input: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius, typography = _a.typography;
        var dataEntered = _b.dataEntered;
        return css(templateObject_3$a || (templateObject_3$a = __makeTemplateObject$1(["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    color: ", ";\n    background: ", ";\n\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    color: ", ";\n    background: ", ";\n\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "])), borderRadius.sm, dataEntered ? colors.neutral[800] : colors.neutral[500], typographyToStyle(typography.body2), colors.neutral[800], colors.common.white, colors.neutral[600], colors.neutral[600], colors.common.white, colors.neutral[600], colors.primary[500]);
    },
    dropdown: function (_a) {
        var borderRadius = _a.borderRadius, shadows = _a.shadows;
        return css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject$1(["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n  "], ["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n  "])), borderRadius.sm, shadows[4]);
    },
    item: function () { return css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject$1(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))); },
    rightSection: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius;
        var disabled = _b.disabled;
        return css(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject$1(["\n    border-radius: 0 ", " ", " 0;\n    width: 42px;\n    pointer-events: none;\n    color: ", ";\n    margin-right: 8px;\n    path {\n      fill: ", ";\n    }\n  "], ["\n    border-radius: 0 ", " ", " 0;\n    width: 42px;\n    pointer-events: none;\n    color: ", ";\n    margin-right: 8px;\n    path {\n      fill: ", ";\n    }\n  "])), borderRadius.sm, borderRadius.sm, colors.neutral[500], disabled ? colors.neutral[200] : colors.neutral[500]);
    },
    hovered: function (_a) {
        var colors = _a.colors;
        return css(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    selected: function (_a) {
        var colors = _a.colors;
        return css(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    disabled: function (_a) {
        var colors = _a.colors;
        return css(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject$1(["\n    border-color: ", ";\n  "], ["\n    border-color: ", ";\n  "])), colors.primary[200]);
    },
    required: function () { return css(templateObject_10 || (templateObject_10 = __makeTemplateObject$1(["\n    display: none;\n  "], ["\n    display: none;\n  "]))); },
});
var templateObject_1$q, templateObject_2$c, templateObject_3$a, templateObject_4$6, templateObject_5$5, templateObject_6$5, templateObject_7$5, templateObject_8$2, templateObject_9$2, templateObject_10;

var Dropdown = function (_a) {
    var label = _a.label, fullWidth = _a.fullWidth; _a.validated; var disabled = _a.disabled, required = _a.required, optional = _a.optional, onChange = _a.onChange, error = _a.error, props = __rest(_a, ["label", "fullWidth", "validated", "disabled", "required", "optional", "onChange", "error"]);
    var _b = useState(), dataEntered = _b[0], setDataEntered = _b[1];
    var styles = useStyles$m({ fullWidth: fullWidth, dataEntered: dataEntered, disabled: disabled });
    var Label = function () { return (jsxs(Fragment, { children: [label, required && label && jsx("span", { children: " (obrigat\u00F3rio)" }), optional && label && jsx("span", { children: " (opcional)" })] })); };
    var handleChange = function (value) {
        if (onChange)
            onChange(value);
        if (value.length)
            setDataEntered(true);
        else
            setDataEntered(false);
    };
    return (jsx(Select, __assign$2({ label: jsx(Label, {}), styles: styles, required: required, disabled: disabled, error: error && jsx(FieldErrorMessage, { error: error }), rightSection: jsx(SvgArrowDown, { size: "medium" }), onChange: handleChange, "data-testid": "hero-input-dropdown", variant: "unstyled", size: "md" }, props)));
};

var HEADING_TAGS = {
    display: 'h1',
    'x-large': 'h2',
    large: 'h3',
    medium: 'h4',
    small: 'h5',
    'x-small': 'h6',
};

var typoMixin$1 = function (_a, typo) {
    var typography = _a.typography;
    var fixedTypo = "h".concat(parseInt(typo.replace('h', '')) - 1);
    return css(templateObject_1$p || (templateObject_1$p = __makeTemplateObject$1(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  "])), typography[fixedTypo].fontFamily, typography[fixedTypo].fontSize, typography[fixedTypo].fontWeight, typography[fixedTypo].lineHeight, typography[fixedTypo].letterSpacing);
};
var templateObject_1$p;

var useStyles$l = makeStyles({
    root: function (_a, _b) {
        var typography = _a.typography;
        var tag = _b.tag;
        return css(templateObject_1$o || (templateObject_1$o = __makeTemplateObject$1(["\n    ", "\n  "], ["\n    ", "\n  "])), typoMixin$1({ typography: typography }, tag));
    },
});
var templateObject_1$o;

var Heading = function (_a) {
    var variant = _a.variant, children = _a.children, args = __rest(_a, ["variant", "children"]);
    var HeadingTag = HEADING_TAGS[variant];
    var root = useStyles$l({ tag: HeadingTag }).root;
    return (jsx(HeadingTag, __assign$2({}, args, { css: root }, { children: children })));
};

var themesToStyle = {
    dark: {
        background: theme.colors.neutral[800],
        color: theme.colors.common.white,
    },
    light: {
        background: theme.colors.common.white,
        color: theme.colors.neutral[800],
    },
};
var useStyles$k = makeStyles({
    root: function () { return css(templateObject_1$n || (templateObject_1$n = __makeTemplateObject$1(["\n    padding: none;\n    width: min-content;\n    height: min-content;\n  "], ["\n    padding: none;\n    width: min-content;\n    height: min-content;\n  "]))); },
    body: function (theme, _a) {
        var tooltipTheme = _a.theme;
        return css(templateObject_2$b || (templateObject_2$b = __makeTemplateObject$1(["\n    box-shadow: ", ";\n    background: ", ";\n    padding: 16px;\n    ", "\n    color: ", ";\n    border-radius: ", "px;\n  "], ["\n    box-shadow: ", ";\n    background: ", ";\n    padding: 16px;\n    ", "\n    color: ", ";\n    border-radius: ", "px;\n  "])), theme.shadows[0], themesToStyle[tooltipTheme].background, typographyToStyle(theme.typography.body2), themesToStyle[tooltipTheme].color, theme.spacing(1));
    },
    arrow: function (theme, _a) {
        var tooltipTheme = _a.theme;
        return css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject$1(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), themesToStyle[tooltipTheme].background);
    },
});
var templateObject_1$n, templateObject_2$b, templateObject_3$9;

var Tooltip = function (_a) {
    var placement = _a.placement, position = _a.position, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b, children = _a.children, label = _a.label, variant = _a.variant, sx = _a.sx;
    var styles = useStyles$k({ theme: theme });
    return (jsx(Tooltip$1, __assign$2({ placement: placement, position: position, label: label, styles: styles, "data-testid": "hero-tooltip", withArrow: true, arrowSize: 6, gutter: 8, transition: "fade", transitionDuration: 200, width: variant === 'auto' ? 'auto' : 232, wrapLines: variant === 'fixed', sx: sx }, { children: children })));
};

var useStyles$j = makeStyles({
    root: function () { return css(templateObject_1$m || (templateObject_1$m = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    h4 {\n      margin-right: 8px;\n    }\n    svg {\n      padding-top: 3px;\n      padding-bottom: 2px;\n    }\n\n    hr {\n      flex-grow: 1;\n      border: none;\n      border-bottom: 1px solid #ccc;\n      margin-left: 16px;\n    }\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    h4 {\n      margin-right: 8px;\n    }\n    svg {\n      padding-top: 3px;\n      padding-bottom: 2px;\n    }\n\n    hr {\n      flex-grow: 1;\n      border: none;\n      border-bottom: 1px solid #ccc;\n      margin-left: 16px;\n    }\n  "]))); },
});
var templateObject_1$m;

var FormGroupTitle = function (_a) {
    var _b = _a.hasDivider, hasDivider = _b === void 0 ? true : _b, tooltip = _a.tooltip, label = _a.label;
    var root = useStyles$j().root;
    return (jsx(Fragment, { children: jsxs("div", __assign$2({ css: root }, { children: [jsx(Heading, __assign$2({ variant: "medium" }, { children: label })), tooltip && (jsx(Tooltip, __assign$2({ label: tooltip }, { children: jsx(SvgWarning, { color: theme.colors.warning[500] }) }))), hasDivider && jsx("hr", {})] })) }));
};

var validadeStates$1 = function (props) {
    if (props.optional && props.required) {
        throw new Error("Conflicting params. You can't use 'optional' and 'required' in the same field");
    }
    // if (props.mask && !isValidInputMask(props.mask)) {
    //   throw new Error(
    //     "Wrong pattern form mask, you are able to insert only special characters and '0' for numbers and 'a' for letters",
    //   )
    // }
};
var inputBorderColor$1 = function (colors, dataEntered, validated) {
    if (dataEntered && !validated) {
        return colors.neutral[800];
    }
    if (validated) {
        return colors.success[500];
    }
    else {
        return colors.neutral[500];
    }
};

var useStyles$i = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$l || (templateObject_1$l = __makeTemplateObject$1(["\n    ", "\n    position: relative;\n    width: ", ";\n  "], ["\n    ", "\n    position: relative;\n    width: ", ";\n  "])), typographyToStyle(theme.typography.body2), fullWidth ? '100%' : '232px');
    },
    label: function (theme) { return css(templateObject_2$a || (templateObject_2$a = __makeTemplateObject$1(["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "], ["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "])), typographyToStyle(theme.typography.label), theme.typography.fontFamily, theme.colors.neutral[500], theme.colors.common.white); },
    input: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius, typography = _a.typography;
        var dataEntered = _b.dataEntered, validated = _b.validated;
        return css(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject$1(["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    background: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    background: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "])), borderRadius.sm, inputBorderColor$1(colors, dataEntered, validated), typographyToStyle(typography.body2), colors.common.white, colors.neutral[800], colors.neutral[600], colors.neutral[600], colors.common.white, colors.neutral[600], colors.primary[500]);
    },
    dropdown: function (_a) {
        var borderRadius = _a.borderRadius, shadows = _a.shadows, colors = _a.colors;
        return css(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject$1(["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n  "], ["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n  "])), borderRadius.sm, shadows[1], colors.neutral[100]);
    },
    item: function () { return css(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject$1(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))); },
    hovered: function (_a) {
        var colors = _a.colors;
        return css(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    disabled: function (_a) {
        var colors = _a.colors;
        return css(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject$1(["\n    border-color: ", ";\n    color: ", ";\n  "], ["\n    border-color: ", ";\n    color: ", ";\n  "])), colors.neutral[200], colors.neutral[500]);
    },
    rightSection: function (_a, _b) {
        var colors = _a.colors;
        var disabled = _b.disabled;
        return css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject$1(["\n    color: ", ";\n    margin-right: 8px;\n    path {\n      fill: ", ";\n    }\n  "], ["\n    color: ", ";\n    margin-right: 8px;\n    path {\n      fill: ", ";\n    }\n  "])), colors.neutral[500], disabled ? colors.neutral[200] : colors.neutral[500]);
    },
    required: function () { return css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject$1(["\n    display: none;\n  "], ["\n    display: none;\n  "]))); },
});
var templateObject_1$l, templateObject_2$a, templateObject_3$8, templateObject_4$5, templateObject_5$4, templateObject_6$4, templateObject_7$4, templateObject_8$1, templateObject_9$1;

function e(e,r,t){return e.length+1===r.length&&r.endsWith(t)}function r(r,t){if(!t)return t;var n=String(t).replace(/[^\da-zA-Z\n|]/g,""),l=r.split(/[^\da-zA-Z\n|]/g).filter(Boolean).map((function(e){return e.length})),a=r.split(/[\da-zA-Z\n|]/g).filter(Boolean),u=a[0],c=a[a.length-1];if(r.startsWith(u)){var i=a.reduce((function(e,r,t){var n=l[t],a=e.value.slice(0,n),u=e.value.slice(n);return {result:a?e.result.concat(r,a):e.result,value:u}}),{result:"",value:n}).result.slice(0,r.length);return e(i,r,c)?i.concat(c):i}var v=l.reduce((function(e,r,t){var n=a[t]||"",l="$1"+n+"$2",u=r+e.prevSlice+e.prevSeparator.length,c=new RegExp("(.{"+u+"})(.)");return {prevSeparator:n,prevSlice:u,value:e.value.replace(c,l)}}),{prevSeparator:"",prevSlice:0,value:n}).value.slice(0,r.length);return e(v,r,c)?v.concat(c):v}function formatByPattern(e,t){return void 0===t?function(t){return r(e,t)}:r(e,t)}

var Input = function (props) {
    var label = props.label, value = props.value, required = props.required, optional = props.optional, error = props.error, disabled = props.disabled, onChange = props.onChange, _a = props.fullWidth, fullWidth = _a === void 0 ? false : _a, _b = props.type, type = _b === void 0 ? 'text' : _b, icon = props.icon, validated = props.validated, mask = props.mask; props.id; var maxLength = props.maxLength, rest = __rest(props, ["label", "value", "required", "optional", "error", "disabled", "onChange", "fullWidth", "type", "icon", "validated", "mask", "id", "maxLength"]);
    var _c = useState(), dataEntered = _c[0], setDataEntered = _c[1];
    var _d = useState(''), internalValue = _d[0], setInternalValue = _d[1];
    useEffect(function () {
        validadeStates$1(props);
    }, [props]);
    useEffect(function () {
        if (mask) {
            var fixedValue = value ? value.replace(/[ˆa-zA-Z]/g, '') : value; // temporary workaround
            setInternalValue(formatByPattern(mask, fixedValue));
        }
        else {
            setInternalValue(value);
        }
    }, [mask, value]);
    var styles = useStyles$i({ fullWidth: fullWidth, validated: validated, dataEntered: dataEntered, disabled: disabled });
    var Label = function () { return (jsxs(Fragment, { children: [label, required && label && jsx("span", { children: " (obrigat\u00F3rio)" }), optional && label && jsx("span", { children: " (opcional)" })] })); };
    var handleChange = function (e) {
        var changedValue = e.currentTarget.value;
        if (!error &&
            (changedValue ||
                (typeof changedValue === 'string' && (changedValue === null || changedValue === void 0 ? void 0 : changedValue.length))))
            setDataEntered(true);
        else
            setDataEntered(false);
        if (onChange)
            onChange(e);
    };
    return (jsx(TextInput, __assign$2({ disabled: disabled, label: jsx(Label, {}), error: error && jsx(FieldErrorMessage, { error: error }), styles: styles, rightSection: validated ? jsx(SvgCheck, {}) : icon, onChange: handleChange, value: internalValue, required: required, type: type, maxLength: maxLength || (mask === null || mask === void 0 ? void 0 : mask.length) || null, "data-testid": "hero-text-input" }, rest)));
};

var validadeStates = function (props) {
    if (props.optional && props.required) {
        throw new Error("Conflicting params. You can't use 'optional' and 'required' in the same field");
    }
};
var inputBorderColor = function (colors, dataEntered, validated) {
    if (dataEntered && !validated) {
        return colors.neutral[800];
    }
    if (validated) {
        return colors.success[500];
    }
    else {
        return colors.neutral[500];
    }
};

var useStyles$h = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$k || (templateObject_1$k = __makeTemplateObject$1(["\n    ", "\n    position: relative;\n    width: ", ";\n  "], ["\n    ", "\n    position: relative;\n    width: ", ";\n  "])), typographyToStyle(theme.typography.body2), fullWidth ? '100%' : '232px');
    },
    label: function (theme) { return css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject$1(["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "], ["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "])), typographyToStyle(theme.typography.label), theme.typography.fontFamily, theme.colors.neutral[500], theme.colors.common.white); },
    input: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius, typography = _a.typography;
        var dataEntered = _b.dataEntered, validated = _b.validated;
        return css(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject$1(["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    background: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    ", ";\n    background: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "])), borderRadius.sm, inputBorderColor(colors, dataEntered, validated), typographyToStyle(typography.body2), colors.common.white, colors.neutral[800], colors.neutral[600], colors.neutral[600], colors.common.white, colors.neutral[600], colors.primary[500]);
    },
    dropdown: function (_a) {
        var borderRadius = _a.borderRadius, shadows = _a.shadows, colors = _a.colors;
        return css(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject$1(["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n  "], ["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n  "])), borderRadius.sm, shadows[1], colors.neutral[100]);
    },
    item: function () { return css(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject$1(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))); },
    hovered: function (_a) {
        var colors = _a.colors;
        return css(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    disabled: function (_a) {
        var colors = _a.colors;
        return css(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject$1(["\n    border-color: ", ";\n    color: ", ";\n  "], ["\n    border-color: ", ";\n    color: ", ";\n  "])), colors.neutral[200], colors.neutral[500]);
    },
    rightSection: function (_a, _b) {
        var colors = _a.colors;
        var disabled = _b.disabled;
        return css(templateObject_8 || (templateObject_8 = __makeTemplateObject$1(["\n    color: ", ";\n    cursor: pointer;\n    margin-right: 8px;\n    path {\n      fill: ", ";\n    }\n  "], ["\n    color: ", ";\n    cursor: pointer;\n    margin-right: 8px;\n    path {\n      fill: ", ";\n    }\n  "])), colors.neutral[500], disabled ? colors.neutral[200] : colors.neutral[500]);
    },
    required: function () { return css(templateObject_9 || (templateObject_9 = __makeTemplateObject$1(["\n    display: none;\n  "], ["\n    display: none;\n  "]))); },
});
var templateObject_1$k, templateObject_2$9, templateObject_3$7, templateObject_4$4, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8, templateObject_9;

var InputPassword = function (props) {
    var label = props.label, value = props.value, required = props.required, optional = props.optional, error = props.error, disabled = props.disabled, onChange = props.onChange, _a = props.fullWidth, fullWidth = _a === void 0 ? false : _a; props.icon; var validated = props.validated; props.id; var rest = __rest(props, ["label", "value", "required", "optional", "error", "disabled", "onChange", "fullWidth", "icon", "validated", "id"]);
    var _b = useState(), dataEntered = _b[0], setDataEntered = _b[1];
    var _c = useState(false), isVisible = _c[0], setIsVisible = _c[1];
    useEffect(function () {
        validadeStates(props);
    }, [props]);
    function handleVisibilityIcon() {
        setIsVisible(function (prevState) { return !prevState; });
    }
    var styles = useStyles$h({ fullWidth: fullWidth, validated: validated, dataEntered: dataEntered, disabled: disabled });
    var Label = function () { return (jsxs(Fragment, { children: [label, required && label && jsx("span", { children: " (obrigat\u00F3rio)" }), optional && label && jsx("span", { children: " (opcional)" })] })); };
    var handleChange = function (e) {
        var changedValue = e.currentTarget.value;
        if (!error &&
            (changedValue ||
                (typeof changedValue === 'string' && changedValue.length)))
            setDataEntered(true);
        else
            setDataEntered(false);
        if (onChange)
            onChange(e);
    };
    return (jsx(TextInput, __assign$2({ disabled: disabled, label: jsx(Label, {}), onChange: handleChange, error: error && jsx(FieldErrorMessage, { error: error }), styles: styles, rightSection: jsx(Icon, { name: isVisible ? 'eye-on' : 'eye-off', onClick: handleVisibilityIcon }), value: value, required: required, type: isVisible ? 'text' : 'password', "data-testid": "hero-text-input" }, rest)));
};

// eslint-disable-next-line @typescript-eslint/ban-types
var useStyles$g = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$j || (templateObject_1$j = __makeTemplateObject$1(["\n    padding: 0;\n    width: ", ";\n  "], ["\n    padding: 0;\n    width: ", ";\n  "])), fullWidth ? '100%' : 'unset');
    },
    body: function (theme, _a) {
        var dropdownMaxHeight = _a.dropdownMaxHeight;
        return css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject$1(["\n    border-radius: ", ";\n    box-shadow: ", ";\n    max-height: ", "px;\n    overflow-y: auto;\n  "], ["\n    border-radius: ", ";\n    box-shadow: ", ";\n    max-height: ", "px;\n    overflow-y: auto;\n  "])), theme.borderRadius.sm, theme.shadows[4], dropdownMaxHeight);
    },
    inner: function (theme) { return css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject$1(["\n    padding: 8px 0px;\n    ", "\n\n    .multiselect__select-all {\n      padding: 16px;\n      padding-top: 8px;\n      border-bottom: 1px solid ", ";\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n    .multiselect__badge {\n      background-color: ", ";\n      color: ", ";\n      height: 24px;\n      min-width: 41px;\n      border-radius: 12px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .multiselect__item {\n      padding: 8px 16px;\n      :hover {\n        background-color: ", ";\n      }\n    }\n  "], ["\n    padding: 8px 0px;\n    ", "\n\n    .multiselect__select-all {\n      padding: 16px;\n      padding-top: 8px;\n      border-bottom: 1px solid ", ";\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n    .multiselect__badge {\n      background-color: ", ";\n      color: ", ";\n      height: 24px;\n      min-width: 41px;\n      border-radius: 12px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .multiselect__item {\n      padding: 8px 16px;\n      :hover {\n        background-color: ", ";\n      }\n    }\n  "])), typographyToStyle(theme.typography.label), theme.colors.extra.disabled_bg, theme.colors.primary[100], theme.colors.primary[500], theme.colors.primary[100]); },
});
var templateObject_1$j, templateObject_2$8, templateObject_3$6;

var MultiSelect = function (_a) {
    var _b, _c;
    var onChange = _a.onChange, fullWidth = _a.fullWidth, _d = _a.selectAllOptionsLabel, selectAllOptionsLabel = _d === void 0 ? 'Selecionar todos' : _d, data = _a.data, _e = _a.dropdownMaxHeight, dropdownMaxHeight = _e === void 0 ? 300 : _e, value = _a.value, props = __rest(_a, ["onChange", "fullWidth", "selectAllOptionsLabel", "data", "dropdownMaxHeight", "value"]);
    var _f = useState([]), selectedData = _f[0], setSelectedData = _f[1];
    var _g = useState(), inputWidth = _g[0], setInputWidth = _g[1];
    var inputIdentifier = useUuid();
    var _h = useState(false), popoverOpened = _h[0], setPopoverOpened = _h[1];
    var _j = useState(false), isSelectAllOptionsChecked = _j[0], setIsSelectAllOptionsChecked = _j[1];
    var styles = useStyles$g({ fullWidth: fullWidth, dropdownMaxHeight: dropdownMaxHeight });
    useEffect(function () {
        if (!(value === null || value === void 0 ? void 0 : value.length)) {
            setSelectedData([]);
            setIsSelectAllOptionsChecked(false);
        }
    }, [value]);
    var handleSelectAllOptions = function (event) {
        var checked = event.target.checked;
        setIsSelectAllOptionsChecked(checked);
        if (checked) {
            var newState = __spreadArray([], data, true);
            setSelectedData(newState);
            if (onChange)
                onChange(newState);
            return;
        }
        setSelectedData([]);
        if (onChange)
            onChange([]);
    };
    var handleOptionChange = function (event, item) {
        var checked = event.target.checked;
        if (checked) {
            var selectedOption_1 = data.find(function (data) { return (data === null || data === void 0 ? void 0 : data.value) === item.value; });
            setSelectedData(function (prevState) {
                if (prevState.length + 1 === data.length) {
                    setIsSelectAllOptionsChecked(true);
                }
                var newState = __spreadArray(__spreadArray([], prevState, true), [selectedOption_1], false);
                if (onChange)
                    onChange(newState);
                return newState;
            });
            return;
        }
        if (isSelectAllOptionsChecked) {
            setIsSelectAllOptionsChecked(false);
        }
        setSelectedData(function (prevState) {
            var newState = prevState.filter(function (data) { return data.value !== item.value; });
            if (onChange)
                onChange(newState);
            return newState;
        });
    };
    var resizePopover = function () {
        var inputfield = document.getElementsByClassName(inputIdentifier)[0];
        setInputWidth(inputfield === null || inputfield === void 0 ? void 0 : inputfield.clientWidth);
    };
    useEffect(function () {
        resizePopover();
        window.addEventListener('resize', function () { return resizePopover(); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fullWidth, inputIdentifier]);
    return (jsxs(Popover, __assign$2({ target: jsx(Input, __assign$2({}, props, { sx: (_b = props === null || props === void 0 ? void 0 : props.sx) === null || _b === void 0 ? void 0 : _b.input, fullWidth: fullWidth, icon: jsx(SvgSearch, {}), value: selectedData.map(function (i) { return i.label; }).join('; '), className: inputIdentifier })), opened: popoverOpened, trapFocus: false, position: "bottom", placement: "center", width: inputWidth, onBlurCapture: function () { return setPopoverOpened(false); }, onFocusCapture: function () { return setPopoverOpened(true); }, styles: styles, sx: (_c = props === null || props === void 0 ? void 0 : props.sx) === null || _c === void 0 ? void 0 : _c.dropdown }, { children: [jsxs("div", __assign$2({ className: "multiselect__select-all" }, { children: [jsx(Checkbox, { label: selectAllOptionsLabel, checked: isSelectAllOptionsChecked, onChange: handleSelectAllOptions }), jsx("span", __assign$2({ className: "multiselect__badge" }, { children: selectedData.length }))] })), data.map(function (item) {
                var selectedItem = selectedData.find(function (data) { return (data === null || data === void 0 ? void 0 : data.value) === item.value; });
                return (jsx(Checkbox, { label: item.label, value: item.value, checked: !!selectedItem, onChange: function (event) { return handleOptionChange(event, item); }, className: "multiselect__item" }, item.label));
            })] })));
};

var useStyles$f = makeStyles({
    root: function () { return css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject$1(["\n    position: relative;\n    width: fit-content;\n  "], ["\n    position: relative;\n    width: fit-content;\n  "]))); },
    body: function () { return css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n  "]))); },
    bullet: function (theme) { return css(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject$1(["\n    width: 6px;\n    height: 6px;\n    top: calc(50% - 3px);\n    left: calc(50% - 3px);\n    border-radius: 3px;\n    position: absolute;\n    background-color: ", ";\n    opacity: 0;\n  "], ["\n    width: 6px;\n    height: 6px;\n    top: calc(50% - 3px);\n    left: calc(50% - 3px);\n    border-radius: 3px;\n    position: absolute;\n    background-color: ", ";\n    opacity: 0;\n  "])), theme.colors.primary[500]); },
    button: function () { return css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject$1(["\n    width: 6px;\n    height: 6px;\n    top: calc(50% - 3px);\n    left: calc(50% - 3px);\n    border-radius: 3px;\n    position: absolute;\n  "], ["\n    width: 6px;\n    height: 6px;\n    top: calc(50% - 3px);\n    left: calc(50% - 3px);\n    border-radius: 3px;\n    position: absolute;\n  "]))); },
    radio: function (theme) { return css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject$1(["\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    position: relative;\n  "], ["\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    position: relative;\n  "])), theme.colors.common.white, theme.colors.primary[500]); },
    input: function (theme) { return css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject$1(["\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    right: 0;\n    &:checked {\n      & + .radio-body__button {\n        border-color: ", ";\n        .radio-body__bullet {\n          opacity: 1;\n        }\n      }\n    }\n    &:disabled {\n      & + .radio-body__button {\n        border-color: ", ";\n        cursor: not-allowed;\n      }\n    }\n  "], ["\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    right: 0;\n    &:checked {\n      & + .radio-body__button {\n        border-color: ", ";\n        .radio-body__bullet {\n          opacity: 1;\n        }\n      }\n    }\n    &:disabled {\n      & + .radio-body__button {\n        border-color: ", ";\n        cursor: not-allowed;\n      }\n    }\n  "])), theme.colors.primary[500], theme.colors.neutral[200]); },
    label: function (theme, _a) {
        var disabled = _a.disabled;
        return css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject$1(["\n    margin-left: 8px;\n    ", ";\n    cursor: ", ";\n    user-select: none;\n  "], ["\n    margin-left: 8px;\n    ", ";\n    cursor: ", ";\n    user-select: none;\n  "])), typographyToStyle(theme.typography.body2), disabled ? 'not-allowed' : 'pointer');
    },
});
var templateObject_1$i, templateObject_2$7, templateObject_3$5, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$2;

var Radio = forwardRef(function (props, ref) {
    var disabled = props.disabled, id = props.id, name = props.name, label = props.label, otherProps = __rest(props, ["disabled", "id", "name", "label"]);
    var uuid = useUuid(id);
    var styles = useStyles$f({ disabled: disabled });
    return (jsx("div", __assign$2({ css: styles.root, role: "radio" }, { children: jsxs("label", __assign$2({ css: styles.body, htmlFor: uuid }, { children: [jsx("input", __assign$2({}, otherProps, { disabled: disabled, id: uuid, ref: ref, type: "radio", css: styles.input, "data-testid": "hero-radio", name: name })), jsx("span", __assign$2({ css: styles.radio, className: "radio-body__button" }, { children: jsx("div", { css: styles.bullet, className: "radio-body__bullet" }) })), jsx("span", __assign$2({ css: styles.label }, { children: label }))] })) })));
});
Radio.displayName = 'Radio';

var RadioGroup = forwardRef(function (props, ref) {
    var spacing = props.spacing, direction = props.direction, children = props.children, id = props.id, name = props.name, onChange = props.onChange, value = props.value, errorProps = props.errorProps, labelProps = props.labelProps, otherProps = __rest(props, ["spacing", "direction", "children", "id", "name", "onChange", "value", "errorProps", "labelProps"]);
    var rootId = useUuid(id);
    var uuid = useUuid(name);
    var childrenWithProps = React__default.Children.map(children, function (child, index) {
        if (isValidElement(child)) {
            var childValue = child.props.value;
            return cloneElement(child, __assign$2({ key: index, name: uuid, tabIndex: index === 0 ? '0' : '-1', checked: childValue === value, onChange: function (evt) {
                    onChange(evt.target.value);
                } }, otherProps));
        }
    });
    return (jsx(InputWrapper, __assign$2({ id: rootId, labelElement: "div", __staticSelector: "RadioGroup", ref: ref, errorProps: errorProps, labelProps: labelProps }, { children: jsx(Group, __assign$2({ role: "radiogroup", "aria-labelledby": "".concat(rootId, "-label"), spacing: spacing, direction: direction }, { children: childrenWithProps })) })));
});
RadioGroup.displayName = 'RadioGroup';

var useStyles$e = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject$1(["\n    ", "\n    position: relative;\n    width: ", ";\n  "], ["\n    ", "\n    position: relative;\n    width: ", ";\n  "])), typographyToStyle(theme.typography.body2), fullWidth ? '100%' : '232px');
    },
    label: function (theme) { return css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject$1(["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "], ["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "])), typographyToStyle(theme.typography.label), theme.typography.fontFamily, theme.colors.neutral[500], theme.colors.common.white); },
    input: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius, typography = _a.typography;
        var dataEntered = _b.dataEntered;
        return css(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject$1(["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    background: ", ";\n    ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 42px;\n    padding-left: 14px;\n    height: 48px;\n    background: ", ";\n    ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "])), borderRadius.sm, dataEntered ? colors.neutral[800] : colors.neutral[500], colors.common.white, typographyToStyle(typography.body2), colors.neutral[800], colors.neutral[600], colors.primary[500]);
    },
    dropdown: function (_a) {
        var borderRadius = _a.borderRadius, shadows = _a.shadows, colors = _a.colors;
        return css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject$1(["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n  "], ["\n    padding: 0;\n    border-radius: ", ";\n    box-shadow: ", ";\n    border-color: ", ";\n  "])), borderRadius.sm, shadows[4], colors.neutral[100]);
    },
    item: function () { return css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject$1(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))); },
    hovered: function (_a) {
        var colors = _a.colors;
        return css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    rightSection: function (_a) {
        var colors = _a.colors, borderRadius = _a.borderRadius;
        return css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject$1(["\n    cursor: pointer;\n    background: ", ";\n    border-radius: 0 ", " ", " 0;\n    width: 42px;\n    path {\n      fill: ", ";\n    }\n  "], ["\n    cursor: pointer;\n    background: ", ";\n    border-radius: 0 ", " ", " 0;\n    width: 42px;\n    path {\n      fill: ", ";\n    }\n  "])), colors.primary[500], borderRadius.sm, borderRadius.sm, colors.neutral[100]);
    },
});
var templateObject_1$h, templateObject_2$6, templateObject_3$4, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7$1;

var SearchBox = function (_a) {
    var fullWidth = _a.fullWidth, onChange = _a.onChange, onSearch = _a.onSearch, rest = __rest(_a, ["fullWidth", "onChange", "onSearch"]);
    var _b = useState(), dataEntered = _b[0], setDataEntered = _b[1];
    var styles = useStyles$e({ fullWidth: fullWidth, dataEntered: dataEntered });
    var handleChange = function (value) {
        if (value.length)
            setDataEntered(true);
        else
            setDataEntered(false);
        onChange && onChange(value);
    };
    var handleSearch = function () {
        onSearch && onSearch(rest.value);
    };
    var SearchButton = function () { return (jsx(ActionIcon, __assign$2({ onClick: handleSearch, size: "xl", variant: "transparent" }, { children: jsx(SvgSearch, {}) }))); };
    return (jsx(Autocomplete, __assign$2({ styles: styles, "data-testid": "hero-SearchBox", type: "search", variant: "unstyled", size: "md", rightSection: jsx(SearchButton, {}), onChange: handleChange }, rest)));
};

var useStyles$d = makeStyles({
    root: function (theme) { return css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject$1(["\n    ", "\n  "], ["\n    ", "\n  "])), typographyToStyle(theme.typography.body2)); },
    input: function (theme) { return css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject$1(["\n    cursor: pointer;\n    border: none;\n    background-color: ", ";\n    height: 22px;\n    width: 40px;\n    &::before {\n      border: none;\n      height: 16px;\n      width: 16px;\n      margin: 1px;\n    }\n    &:checked {\n      background-color: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n    }\n  "], ["\n    cursor: pointer;\n    border: none;\n    background-color: ", ";\n    height: 22px;\n    width: 40px;\n    &::before {\n      border: none;\n      height: 16px;\n      width: 16px;\n      margin: 1px;\n    }\n    &:checked {\n      background-color: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n    }\n  "])), theme.colors.neutral[400], theme.colors.primary[500], theme.colors.neutral[200]); },
    label: function () { return css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject$1(["\n    cursor: pointer;\n    user-select: none;\n  "], ["\n    cursor: pointer;\n    user-select: none;\n  "]))); },
});
var templateObject_1$g, templateObject_2$5, templateObject_3$3;

var Switch = function (_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onChange = _a.onChange, label = _a.label;
    var styles = useStyles$d({ disabled: disabled, checked: checked });
    return (jsx(Switch$1, { label: label, checked: checked, disabled: disabled, onChange: onChange, styles: styles }));
};

var textareaBorderColor = function (colors, dataEntered) {
    return dataEntered ? colors.neutral[800] : colors.neutral[500];
};
var useStyles$c = makeStyles({
    root: function (theme, _a) {
        var fullWidth = _a.fullWidth;
        return css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject$1(["\n    ", "\n    position: relative;\n    width: ", ";\n\n    .textarea-char-counter {\n      position: absolute;\n      color: red;\n      bottom: -20px;\n    }\n  "], ["\n    ", "\n    position: relative;\n    width: ", ";\n\n    .textarea-char-counter {\n      position: absolute;\n      color: red;\n      bottom: -20px;\n    }\n  "])), typographyToStyle(theme.typography.body2), fullWidth ? '100%' : '232px');
    },
    label: function (theme) { return css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject$1(["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "], ["\n    position: absolute;\n    top: -10px;\n    left: 12px;\n    padding: 0 4px;\n    z-index: 1;\n\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n  "])), typographyToStyle(theme.typography.label), theme.typography.fontFamily, theme.colors.neutral[500], theme.colors.common.white); },
    input: function (_a, _b) {
        var colors = _a.colors, borderRadius = _a.borderRadius, typography = _a.typography;
        var dataEntered = _b.dataEntered, hasCounter = _b.hasCounter;
        return css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject$1(["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 14px !important;\n    padding-left: 14px;\n    color: ", ";\n    ", ";\n    padding-bottom: ", " !important;\n\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-radius: ", ";\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1.5px;\n    padding-right: 14px !important;\n    padding-left: 14px;\n    color: ", ";\n    ", ";\n    padding-bottom: ", " !important;\n\n    &::placeholder {\n      color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    &:focus {\n      border-color: ", ";\n    }\n  "])), borderRadius.sm, textareaBorderColor(colors, dataEntered), colors.neutral[800], typographyToStyle(typography.body2), hasCounter ? '32px' : '14px', colors.neutral[600], colors.neutral[600], colors.common.white, colors.neutral[600], colors.primary[500]);
    },
    hovered: function (_a) {
        var colors = _a.colors;
        return css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject$1(["\n    background: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    color: ", ";\n  "])), colors.primary[100], colors.primary[500]);
    },
    disabled: function (_a) {
        var colors = _a.colors;
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject$1(["\n    border-color: ", ";\n    color: ", ";\n  "], ["\n    border-color: ", ";\n    color: ", ";\n  "])), colors.neutral[200], colors.neutral[500]);
    },
    rightSection: function (_a) {
        var colors = _a.colors, typography = _a.typography;
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject$1(["\n    color: ", ";\n    position: absolute;\n    width: 100%;\n    height: 28px;\n    top: unset;\n    bottom: 0px;\n    justify-content: end;\n    padding-right: 6px;\n    padding-bottom: 6px;\n    ", ";\n  "], ["\n    color: ", ";\n    position: absolute;\n    width: 100%;\n    height: 28px;\n    top: unset;\n    bottom: 0px;\n    justify-content: end;\n    padding-right: 6px;\n    padding-bottom: 6px;\n    ", ";\n  "])), colors.neutral[500], typographyToStyle(typography.microCopy));
    },
    required: function () { return css(templateObject_7 || (templateObject_7 = __makeTemplateObject$1(["\n    display: none;\n  "], ["\n    display: none;\n  "]))); },
});
var templateObject_1$f, templateObject_2$4, templateObject_3$2, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7;

var TextArea = function (props) {
    var optional = props.optional, onChange = props.onChange, _a = props.fullWidth, fullWidth = _a === void 0 ? false : _a, maxLength = props.maxLength, label = props.label, error = props.error, required = props.required, value = props.value, rest = __rest(props, ["optional", "onChange", "fullWidth", "maxLength", "label", "error", "required", "value"]);
    var _b = useState(), dataEntered = _b[0], setDataEntered = _b[1];
    var _c = useState(0), counter = _c[0], setCounter = _c[1];
    var styles = useStyles$c({ fullWidth: fullWidth, dataEntered: dataEntered, hasCounter: !!maxLength });
    var Label = function () { return (jsxs(Fragment, { children: [label, required && label && jsx("span", { children: " (obrigat\u00F3rio)" }), optional && label && jsx("span", { children: " (opcional)" })] })); };
    var Counter = function () { return (jsx(Fragment, { children: jsx("div", { children: "".concat(counter, "/").concat(maxLength) }) })); };
    var handleChange = function (e) {
        var _a;
        var changedValue = (_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.value;
        if (!error &&
            (changedValue ||
                (typeof changedValue === 'string' && (changedValue === null || changedValue === void 0 ? void 0 : changedValue.length))))
            setDataEntered(true);
        else
            setDataEntered(false);
        if (maxLength)
            setCounter(changedValue.length);
        onChange(e);
    };
    return (jsx(Textarea, __assign$2({ onChange: handleChange, "data-testid": "hero-text-area", label: jsx(Label, {}), autosize: true, error: error && jsx(FieldErrorMessage, { error: error }), styles: styles, rightSection: maxLength && jsx(Counter, {}), value: value, required: required }, rest)));
};

var APP_MAIN_MENU_HEIGHT = 64;
var APP_OPTION_MENU_HEIGHT = 64;
var APP_MENU_MARGIN_HEIGHT = 16;
var APP_MENU_HEIGHT = APP_MAIN_MENU_HEIGHT + APP_OPTION_MENU_HEIGHT + APP_MENU_MARGIN_HEIGHT;

var useStyles$b = makeStyles({
    root: function (theme, _a) {
        var canShowActionBar = _a.canShowActionBar, quantityOfButtonsInActionBar = _a.quantityOfButtonsInActionBar, isMobile = _a.isMobile, fullHeight = _a.fullHeight;
        var paddingBottomValue = function () {
            if (canShowActionBar && isMobile) {
                return "".concat(78 * quantityOfButtonsInActionBar, "px");
            }
            else if (canShowActionBar && !isMobile) {
                return '74px';
            }
            return '0';
        };
        return css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject$1(["\n      min-height: ", ";\n      padding-top: 16px;\n      height: max-content;\n      padding-bottom: ", ";\n      border-radius: 20px;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n    "], ["\n      min-height: ", ";\n      padding-top: 16px;\n      height: max-content;\n      padding-bottom: ", ";\n      border-radius: 20px;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n    "])), fullHeight
            ? 'calc(100vh - 32px)'
            : 'calc(100vh - ' + APP_MENU_HEIGHT + 'px)', paddingBottomValue());
    },
    content: function () {
        return css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject$1(["\n      flex: 1;\n      width: 100%;\n    "], ["\n      flex: 1;\n      width: 100%;\n    "])));
    },
    footer: function () {
        return css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject$1(["\n      flex: 0;\n      width: 100%;\n    "], ["\n      flex: 0;\n      width: 100%;\n    "])));
    },
    layoutMenuContainer: function () {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject$1(["\n      margin-bottom: 16px;\n      hr {\n        flex-grow: 1;\n        border: none;\n        border-bottom: 1px solid #ccc;\n        margin-top: 16px;\n      }\n    "], ["\n      margin-bottom: 16px;\n      hr {\n        flex-grow: 1;\n        border: none;\n        border-bottom: 1px solid #ccc;\n        margin-top: 16px;\n      }\n    "])));
    },
});
var templateObject_1$e, templateObject_2$3, templateObject_3$1, templateObject_4;

var captionColors = {
    medium: theme.colors.neutral[500],
    large: theme.colors.neutral[800],
};
var useStyles$a = makeStyles({
    container: function (theme, _a) {
        var size = _a.size;
        return css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    title {\n      margin-bottom: 8px;\n    }\n    .caption {\n      color: ", ";\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    title {\n      margin-bottom: 8px;\n    }\n    .caption {\n      color: ", ";\n    }\n  "])), captionColors[size]);
    },
});
var templateObject_1$d;

var typoMixin = function (_a, variant) {
    var typography = _a.typography;
    var typo = variant === 'large' ? 'body1' : 'body2';
    return css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject$1(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  "])), typography[typo].fontFamily, typography[typo].fontSize, typography[typo].fontWeight, typography[typo].lineHeight, typography[typo].letterSpacing);
};
var templateObject_1$c;

var useStyles$9 = makeStyles({
    root: function (_a, _b) {
        var typography = _a.typography;
        var variant = _b.variant;
        return css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$1(["\n    ", "\n  "], ["\n    ", "\n  "])), typoMixin({ typography: typography }, variant));
    },
});
var templateObject_1$b;

var Text = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'small' : _b, renderAs = _a.renderAs, children = _a.children, args = __rest(_a, ["variant", "renderAs", "children"]);
    var root = useStyles$9({ variant: variant }).root;
    var Tag = renderAs || 'p';
    return (jsx(Tag, __assign$2({}, args, { css: root }, { children: children })));
};

var LayoutHeader = function (_a) {
    var title = _a.title, caption = _a.caption, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var styles = useStyles$a({ size: size });
    return (jsxs("div", __assign$2({ css: styles.container }, { children: [typeof title === 'string' ? (jsx(Heading, __assign$2({ variant: size }, { children: title }))) : (title), typeof caption === 'string' ? (jsx(Text, __assign$2({ variant: "large", className: "caption" }, { children: caption }))) : (caption)] })));
};

var useStyles$8 = makeStyles({
    root: function (_a, _b) {
        var colors = _a.colors;
        var footerSize = _b.footerSize;
        var extraBottomSpacing = 40;
        var footerHeight = "".concat(footerSize + extraBottomSpacing, "px");
        return css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$1(["\n      padding-bottom: ", ";\n      position: fixed;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      z-index: 9;\n\n      padding-top: 16px;\n      padding-bottom: 16px;\n      background-color: ", ";\n    "], ["\n      padding-bottom: ", ";\n      position: fixed;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      z-index: 9;\n\n      padding-top: 16px;\n      padding-bottom: 16px;\n      background-color: ", ";\n    "])), footerHeight, colors.common.white);
    },
});
var templateObject_1$a;

var devices = {
    phone: {
        max: 639,
    },
    tablet: {
        min: 640,
        max: 1023,
    },
    smallDesktop: {
        min: 1024,
        max: 1087,
    },
    desktop: {
        min: 1088,
    },
};

function useBreakpoints() {
    var isPhone = useMediaQuery("(max-width: ".concat(devices.phone.max, "px)"));
    var isTablet = useMediaQuery("(min-width: ".concat(devices.tablet.min, "px) and (max-width: ").concat(devices.tablet.max, "px)"));
    var isSmallDesktop = useMediaQuery("(min-width: ".concat(devices.smallDesktop.min, "px) and (max-width: ").concat(devices.smallDesktop.max, "px)"));
    var isDesktop = useMediaQuery("(min-width: ".concat(devices.desktop.min, "px)"), true);
    return { isPhone: isPhone, isTablet: isTablet, isSmallDesktop: isSmallDesktop, isDesktop: isDesktop };
}

var LayoutActionBar = function (_a) {
    var primaryActionLabel = _a.primaryActionLabel, secondaryActionLabel = _a.secondaryActionLabel, negativeActionLabel = _a.negativeActionLabel, primaryActionProps = _a.primaryActionProps, secondaryActionProps = _a.secondaryActionProps, negativeActionProps = _a.negativeActionProps, primaryAction = _a.primaryAction, secondaryAction = _a.secondaryAction, negativeAction = _a.negativeAction, hasPrimaryAction = _a.hasPrimaryAction, hasSecondaryAction = _a.hasSecondaryAction, hasNegativeAction = _a.hasNegativeAction, customContent = _a.customContent, styles = _a.styles;
    var isPhone = useBreakpoints().isPhone;
    var _b = useState(undefined), footerSize = _b[0], setFooterSize = _b[1];
    var defaultStyles = useStyles$8({ footerSize: footerSize });
    var layoutActionBarRef = useRef(null);
    var updateFooterSize = function () {
        if (layoutActionBarRef.current) {
            setFooterSize(layoutActionBarRef.current.clientHeight);
        }
    };
    useEffect(function () {
        updateFooterSize();
    }, [isPhone]);
    return (jsx("div", __assign$2({ css: defaultStyles.root, style: styles === null || styles === void 0 ? void 0 : styles.root, ref: layoutActionBarRef }, { children: jsxs(Container, __assign$2({ style: styles === null || styles === void 0 ? void 0 : styles.body }, { children: [!isPhone ? (jsxs(Grid, __assign$2({ gutter: 0, align: "center", justify: "space-between" }, { children: [jsx(Grid.Col, __assign$2({ span: 4 }, { children: hasSecondaryAction && (jsx(Button, __assign$2({ onClick: secondaryAction, variant: "link" }, secondaryActionProps, { children: secondaryActionLabel }))) })), jsx(Grid.Col, __assign$2({ span: 8 }, { children: jsxs(Grid, __assign$2({ justify: "end", gutter: 0 }, { children: [hasNegativeAction && (jsx(Button, __assign$2({ variant: "link", onClick: negativeAction }, negativeActionProps, { children: negativeActionLabel }))), hasNegativeAction && hasPrimaryAction && jsx(Space, { w: "md" }), hasPrimaryAction && (jsx(Button, __assign$2({ onClick: primaryAction }, primaryActionProps, { children: primaryActionLabel })))] })) }))] }))) : (jsxs(Stack, { children: [hasPrimaryAction && (jsx(Button, __assign$2({ onClick: primaryAction, fullWidth: true }, primaryActionProps, { children: primaryActionLabel }))), hasSecondaryAction && (jsx(Button, __assign$2({ variant: "link", onClick: secondaryAction, fullWidth: true }, secondaryActionProps, { children: secondaryActionLabel }))), hasNegativeAction && (jsx(Button, __assign$2({ variant: "link", onClick: negativeAction, fullWidth: true }, negativeActionProps, { children: negativeActionLabel })))] })), customContent] })) })));
};

var ContentLayout = function (_a) {
    var children = _a.children, hasHeader = _a.hasHeader, title = _a.title, caption = _a.caption, headerSize = _a.headerSize, hideFooter = _a.hideFooter, 
    // actionBar
    primaryActionLabel = _a.primaryActionLabel, secondaryActionLabel = _a.secondaryActionLabel, negativeActionLabel = _a.negativeActionLabel, primaryActionProps = _a.primaryActionProps, secondaryActionProps = _a.secondaryActionProps, negativeActionProps = _a.negativeActionProps, primaryAction = _a.primaryAction, secondaryAction = _a.secondaryAction, negativeAction = _a.negativeAction, hasPrimaryAction = _a.hasPrimaryAction, hasSecondaryAction = _a.hasSecondaryAction, hasNegativeAction = _a.hasNegativeAction, 
    // custonContent from layoutActionBar
    customActionBarContent = _a.customActionBarContent, customFooter = _a.customFooter, _b = _a.fullHeight, fullHeight = _b === void 0 ? true : _b, fluid = _a.fluid, styles = _a.styles, hasLayoutMenu = _a.hasLayoutMenu, layoutMenu = _a.layoutMenu;
    var canShowActionBar = function () {
        return (hasPrimaryAction ||
            hasSecondaryAction ||
            hasNegativeAction ||
            !!customActionBarContent);
    };
    var quantityOfButtonsInActionBar = function () {
        var actions = [hasPrimaryAction, hasSecondaryAction, hasNegativeAction];
        var trueActions = actions.filter(function (i) { return !!i; });
        return trueActions.length;
    };
    var isPhone = useBreakpoints().isPhone;
    var defaultStyles = useStyles$b({
        canShowActionBar: canShowActionBar(),
        isMobile: isPhone,
        fullHeight: fullHeight,
        quantityOfButtonsInActionBar: quantityOfButtonsInActionBar(),
    });
    return (jsxs("div", __assign$2({ css: defaultStyles === null || defaultStyles === void 0 ? void 0 : defaultStyles.root, style: styles === null || styles === void 0 ? void 0 : styles.root }, { children: [jsx("div", __assign$2({ css: defaultStyles.content, style: styles === null || styles === void 0 ? void 0 : styles.body }, { children: jsxs(Container, __assign$2({ fluid: fluid }, { children: [hasLayoutMenu && (jsxs("div", __assign$2({ css: defaultStyles.layoutMenuContainer }, { children: [layoutMenu, !isPhone && jsx("hr", {})] }))), !hasHeader || (jsx(LayoutHeader, { title: title, caption: caption, size: headerSize || 'medium' })), children] })) })), !hideFooter && (jsx("footer", __assign$2({ css: defaultStyles.footer, style: styles === null || styles === void 0 ? void 0 : styles.footer }, { children: jsx(LayoutFooter, __assign$2({ fluid: fluid }, { children: customFooter })) }))), canShowActionBar() && (jsx(LayoutActionBar, { styles: styles === null || styles === void 0 ? void 0 : styles.actionBar, primaryActionLabel: primaryActionLabel, secondaryActionLabel: secondaryActionLabel, negativeActionLabel: negativeActionLabel, primaryActionProps: primaryActionProps, secondaryActionProps: secondaryActionProps, negativeActionProps: negativeActionProps, primaryAction: primaryAction, secondaryAction: secondaryAction, negativeAction: negativeAction, hasPrimaryAction: hasPrimaryAction, hasSecondaryAction: hasSecondaryAction, hasNegativeAction: hasNegativeAction, customContent: customActionBarContent }))] })));
};

var useStyles$7 = makeStyles({
    body: function () {
        return css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$1(["\n      min-height: 61px;\n      height: max-content;\n      display: flex;\n      flex-direction: row;\n      justify-items: flex-start;\n      align-items: center;\n      padding: 8px 0;\n\n      span {\n        display: flex;\n        flex-direction: row;\n        justify-items: flex-start;\n        align-items: center;\n        margin-right: 8px;\n        padding-bottom: 8px;\n      }\n\n      @media (max-width: 639px) {\n        flex-direction: column;\n        justify-items: flex-start;\n        align-items: center;\n        span {\n          display: flex;\n          flex-direction: row;\n          justify-items: flex-start;\n          align-items: center;\n        }\n      }\n    "], ["\n      min-height: 61px;\n      height: max-content;\n      display: flex;\n      flex-direction: row;\n      justify-items: flex-start;\n      align-items: center;\n      padding: 8px 0;\n\n      span {\n        display: flex;\n        flex-direction: row;\n        justify-items: flex-start;\n        align-items: center;\n        margin-right: 8px;\n        padding-bottom: 8px;\n      }\n\n      @media (max-width: 639px) {\n        flex-direction: column;\n        justify-items: flex-start;\n        align-items: center;\n        span {\n          display: flex;\n          flex-direction: row;\n          justify-items: flex-start;\n          align-items: center;\n        }\n      }\n    "])));
    },
});
var templateObject_1$9;

var LayoutFooter = function (_a) {
    var children = _a.children, hideDate = _a.hideDate, fluid = _a.fluid, styles = _a.styles;
    var defaultStyles = useStyles$7();
    return (jsx(Container, __assign$2({ fluid: fluid, style: styles === null || styles === void 0 ? void 0 : styles.root }, { children: jsxs("div", __assign$2({ css: defaultStyles.body, style: styles === null || styles === void 0 ? void 0 : styles.body }, { children: [jsx("span", { children: children }), !hideDate && (jsx("span", { children: jsx(TimeZoneGMT, {}) }))] })) })));
};

var useStyles$6 = makeStyles({
    root: function (theme) { return css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$1(["\n    ", "\n    color: ", ";\n    text-align: center;\n    align-content: center;\n    margin: auto 8px;\n    width: fit-content;\n    &:hover {\n      text-decoration: underline;\n      text-underline-position: under;\n    }\n    &:first-of-type {\n      padding-left: unset;\n    }\n    &:last-of-type {\n      color: ", ";\n      pointer-events: none;\n      &:hover {\n        text-decoration: none;\n        cursor: default;\n      }\n    }\n  "], ["\n    ", "\n    color: ", ";\n    text-align: center;\n    align-content: center;\n    margin: auto 8px;\n    width: fit-content;\n    &:hover {\n      text-decoration: underline;\n      text-underline-position: under;\n    }\n    &:first-of-type {\n      padding-left: unset;\n    }\n    &:last-of-type {\n      color: ", ";\n      pointer-events: none;\n      &:hover {\n        text-decoration: none;\n        cursor: default;\n      }\n    }\n  "])), typographyToStyle(theme.typography.link), theme.colors.neutral[600], theme.colors.neutral[900]); },
    mobilePreviousButtonWrapper: function (theme) { return css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$1(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    cursor: pointer;\n\n    h5 {\n      color: ", ";\n      user-select: none;\n    }\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    cursor: pointer;\n\n    h5 {\n      color: ", ";\n      user-select: none;\n    }\n  "])), theme.colors.extra.disabled_font); },
});
var templateObject_1$8, templateObject_2$2;

var Breadcrumbs = function (_a) {
    _a.onClick; var currentStep = _a.currentStep, items = _a.items, mobilePreviousLabel = _a.mobilePreviousLabel, onPreviousClick = _a.onPreviousClick, props = __rest(_a, ["onClick", "currentStep", "items", "mobilePreviousLabel", "onPreviousClick"]);
    var styles = useStyles$6();
    var lastItem = useCallback(function () {
        var lastItem = currentStep || items.length;
        return lastItem - 1;
    }, [items, currentStep]);
    var isPhone = useBreakpoints().isPhone;
    var handlePreviousClick = function () {
        var previousRoute = items[lastItem() - 1].route;
        onPreviousClick(previousRoute);
    };
    if (isPhone) {
        return (jsxs("div", __assign$2({ css: styles.mobilePreviousButtonWrapper, onClick: handlePreviousClick }, { children: [jsx(SvgArrowLeft, { color: theme.colors.extra.disabled_font }), jsx(Heading, __assign$2({ variant: "small" }, { children: mobilePreviousLabel }))] })));
    }
    return (jsx(Breadcrumbs$1, __assign$2({ styles: function () { return ({
            separator: {
                margin: '0',
                color: theme.colors.neutral[400],
            },
        }); }, separator: jsx(SvgArrowRight, {}) }, props, { children: items
            .map(function (item, index) { return (jsx(Anchor, __assign$2({ href: item.route, styles: styles, onClick: function (e) { return lastItem() === index && e.preventDefault(); } }, { children: item.title }), index)); })
            .filter(function (item, index) { return index < (currentStep || items.length); }) })));
};

// eslint-disable-next-line @typescript-eslint/ban-types
var useStyles$5 = makeStyles({
    root: function (_a) {
        var colors = _a.colors;
        return css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$1(["\n    border-right: none;\n    border-bottom: 1px solid ", ";\n    .navbar-logo {\n      height: 18px;\n    }\n  "], ["\n    border-right: none;\n    border-bottom: 1px solid ", ";\n    .navbar-logo {\n      height: 18px;\n    }\n  "])), colors.neutral[100]);
    },
});
var templateObject_1$7;

var logoConexa = "data:image/svg+xml,%3Csvg%20width%3D%22205%22%20height%3D%2232%22%20viewBox%3D%220%200%20205%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_6079_8780%29%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M185.459%2021.4625C182.675%2018.6433%20178.931%2017.0606%20175.043%2017.0606V12.6588H185.651V1.77777H194.196V12.7082H204.756V21.5119H194.148V32.4424H189.875C189.875%2028.4362%20188.339%2024.5784%20185.603%2021.7098L185.459%2021.4625ZM175.043%2027.9416V32.3929C177.443%2032.3929%20179.363%2032.3929%20179.363%2032.3929C179.363%2029.92%20177.443%2027.9416%20175.043%2027.9416ZM186.323%2032.4424C186.323%2026.0622%20181.283%2020.869%20175.043%2020.869V24.3311C179.411%2024.3311%20182.963%2027.9416%20182.963%2032.4424H186.323Z%22%20fill%3D%22%23F28080%22%2F%3E%3Cpath%20d%3D%22M0%2015.9999C0%206.73678%206.88734%200%2016.1183%200C20.9968%200%2025.2057%201.8328%2028.0276%205.20119L24.3926%208.71819C22.1925%206.29097%2019.5141%205.05259%2016.3574%205.05259C10.1397%205.05259%205.59596%209.60983%205.59596%2015.9999C5.59596%2022.3899%2010.0919%2026.9471%2016.3574%2026.9471C19.5141%2026.9471%2022.1925%2025.7583%2024.3926%2023.232L27.9798%2026.7985C25.2057%2030.1669%2020.9968%2031.9997%2016.0226%2031.9997C6.88734%2032.0493%200%2025.3125%200%2015.9999Z%22%20fill%3D%22%230031B2%22%2F%3E%3Cpath%20d%3D%22M30.5626%2019.7151C30.5626%2012.582%2035.7281%207.57898%2042.7589%207.57898C49.8854%207.57898%2055.003%2012.6316%2055.003%2019.7151C55.003%2026.7986%2049.8854%2031.9008%2042.7589%2031.9008C35.7281%2031.9008%2030.5626%2026.8482%2030.5626%2019.7151ZM49.5984%2019.7151C49.5984%2015.1579%2046.6808%2012.2848%2042.7589%2012.2848C38.8848%2012.2848%2035.9672%2015.1579%2035.9672%2019.7151C35.9672%2024.2723%2038.8848%2027.1454%2042.7589%2027.1454C46.6808%2027.1454%2049.5984%2024.2723%2049.5984%2019.7151Z%22%20fill%3D%22%230031B2%22%2F%3E%3Cpath%20d%3D%22M83.222%2017.9814V31.6035H77.8651V18.6749C77.8651%2014.4644%2075.8563%2012.3839%2072.4127%2012.3839C68.5864%2012.3839%2066.0036%2014.8111%2066.0036%2019.5665V31.6035H60.6468V7.82666H65.7645V10.8978C67.5341%208.71829%2070.3082%207.57898%2073.6562%207.57898C79.1087%207.57898%2083.222%2010.7988%2083.222%2017.9814Z%22%20fill%3D%22%230031B2%22%2F%3E%3Cpath%20d%3D%22M112.158%2021.4984H94.127C94.7488%2024.9658%2097.5707%2027.1949%20101.54%2027.1949C104.123%2027.1949%20106.132%2026.3528%20107.758%2024.6191L110.628%2028.037C108.571%2030.5633%20105.319%2031.9008%20101.397%2031.9008C93.6965%2031.9008%2088.7224%2026.7986%2088.7224%2019.7151C88.7224%2012.6316%2093.7444%207.57898%20100.584%207.57898C107.28%207.57898%20112.206%2012.4334%20112.206%2019.8637C112.254%2020.3095%20112.206%2020.9535%20112.158%2021.4984ZM94.127%2017.7832H107.136C106.706%2014.3653%20104.171%2011.9876%20100.632%2011.9876C97.188%2012.0371%2094.6531%2014.3158%2094.127%2017.7832Z%22%20fill%3D%22%230031B2%22%2F%3E%3Cpath%20d%3D%22M131.816%2031.6033L125.933%2023.3805L120.002%2031.6033H114.071L123.015%2019.5167L114.454%207.82642H120.433L126.076%2015.6034L131.72%207.82642H137.508L128.898%2019.4672L137.89%2031.6033H131.816Z%22%20fill%3D%22%230031B2%22%2F%3E%3Cpath%20d%3D%22M161.039%2017.6842V31.6036H155.969V28.7305C154.678%2030.7615%20152.191%2031.9503%20148.747%2031.9503C143.486%2031.9503%20140.186%2028.9782%20140.186%2024.8172C140.186%2020.8544%20142.769%2017.7337%20149.704%2017.7337H155.635V17.3374C155.635%2014.0681%20153.722%2012.1858%20149.895%2012.1858C147.312%2012.1858%20144.634%2013.0774%20142.912%2014.5634L140.808%2010.5016C143.247%208.52015%20146.834%207.57898%20150.517%207.57898C157.213%207.57898%20161.039%2010.7988%20161.039%2017.6842ZM155.682%2024.1733V21.3993H150.134C146.499%2021.3993%20145.495%2022.8358%20145.495%2024.5696C145.495%2026.551%20147.121%2027.8389%20149.895%2027.8389C152.478%2027.8884%20154.774%2026.6005%20155.682%2024.1733Z%22%20fill%3D%22%230031B2%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_6079_8780%22%3E%3Crect%20width%3D%22204.8%22%20height%3D%2232%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var INTERNAL_LOGOS = {
    conexa: jsx("img", { className: "navbar-logo", src: logoConexa, alt: "" }),
};

var Navbar = function (_a) {
    var children = _a.children, logo = _a.logo, rest = __rest(_a, ["children", "logo"]);
    var styles = useStyles$5();
    var Logo = function () {
        if (typeof logo === 'string')
            return INTERNAL_LOGOS[logo];
        return '';
    };
    return (jsx(Header, __assign$2({ styles: styles, height: 72, px: 24, py: 24 }, rest, { children: jsx(Container, { children: jsxs(Group, __assign$2({ position: "apart" }, { children: [jsx(Center, { children: jsx(Group, { children: jsx(Logo, {}) }) }), jsx(Group, { children: children || '' })] })) }) })));
};

var ANIMATION_POSITION_IN = {
    center: 'animate__zoomIn',
};
var ANIMATION_DURATION = 300;

// eslint-disable-next-line @typescript-eslint/ban-types
var useStyles$4 = makeStyles({
    body: function (theme) { return css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$1(["\n    max-width: 480px;\n    width: 100%;\n    box-shadow: ", ";\n    background: ", ";\n    border: none;\n    padding: 24px;\n    border-radius: ", "px;\n    display: flex;\n    flex-direction: column;\n    animation-duration: ", "ms;\n  "], ["\n    max-width: 480px;\n    width: 100%;\n    box-shadow: ", ";\n    background: ", ";\n    border: none;\n    padding: 24px;\n    border-radius: ", "px;\n    display: flex;\n    flex-direction: column;\n    animation-duration: ", "ms;\n  "])), theme.shadows[2], theme.colors.common.white, theme.spacing(2), ANIMATION_DURATION); },
});
var templateObject_1$6;

var ModalComponent = function (props) {
    var id = props.id, styles = props.styles, title = props.title, children = props.children, hasClose = props.hasClose, titleIcon = props.titleIcon;
    var defaultStyles = useStyles$4();
    var titleId = useUuid();
    return (jsxs("dialog", __assign$2({ css: __assign$2(__assign$2({}, defaultStyles.body), styles === null || styles === void 0 ? void 0 : styles.body), id: id, className: "".concat(ANIMATION_POSITION_IN.center), role: "dialog", "aria-labelledby": titleId }, { children: [jsx(ModalTitle, { title: title, id: titleId, hasClose: hasClose, icon: titleIcon }), jsx(Space, { h: "xl" }), children] })));
};
function areEqual(prevProps, nextProps) {
    return (prevProps.message === nextProps.message ||
        prevProps.id === nextProps.id ||
        prevProps.variant === nextProps.variant);
}
var Modal = memo(ModalComponent, areEqual);

var ModalTitle = function (props) {
    var icon = props.icon, title = props.title, hasClose = props.hasClose, id = props.id, onClose = props.onClose;
    return (jsxs(Stack, __assign$2({ spacing: "xl" }, { children: [jsxs(Group, __assign$2({ "data-testid": "hero-modal-title", position: "apart" }, { children: [jsxs(Group, __assign$2({ spacing: icon ? 'xs' : 0 }, { children: [jsx("div", __assign$2({ "data-testid": "hero-modal-title-icon" }, { children: icon })), jsx(Heading, __assign$2({ variant: "small" }, { children: jsx("div", __assign$2({ id: id, "data-testid": "hero-modal-title-heading" }, { children: title })) }))] })), hasClose && (jsx("div", __assign$2({ "data-testid": "hero-modal-title-close" }, { children: jsx(ActionIcon, __assign$2({ onClick: onClose }, { children: jsx(Icon, { name: "close", color: theme.colors.neutral[400] }) })) })))] })), jsx(Divider, {})] })));
};

var useStyles$3 = makeStyles({
    root: function () {
        return css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$1(["\n      margin: none;\n      padding-top: 16px;\n    "], ["\n      margin: none;\n      padding-top: 16px;\n    "])));
    },
    body: function () {
        return css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$1(["\n      padding: none;\n    "], ["\n      padding: none;\n    "])));
    },
});
var templateObject_1$5, templateObject_2$1;

var ActionBar = function (_a) {
    var primaryActionLabel = _a.primaryActionLabel, secondaryActionLabel = _a.secondaryActionLabel, negativeActionLabel = _a.negativeActionLabel, primaryActionProps = _a.primaryActionProps, secondaryActionProps = _a.secondaryActionProps, negativeActionProps = _a.negativeActionProps, primaryAction = _a.primaryAction, secondaryAction = _a.secondaryAction, negativeAction = _a.negativeAction, hasPrimaryAction = _a.hasPrimaryAction, hasSecondaryAction = _a.hasSecondaryAction, hasNegativeAction = _a.hasNegativeAction, customContent = _a.customContent, styles = _a.styles;
    var isPhone = useBreakpoints().isPhone;
    var _b = useState(undefined), footerSize = _b[0], setFooterSize = _b[1];
    var defaultStyles = useStyles$3({ footerSize: footerSize });
    var layoutActionBarRef = useRef(null);
    var updateFooterSize = function () {
        if (layoutActionBarRef.current) {
            setFooterSize(layoutActionBarRef.current.clientHeight);
        }
    };
    useEffect(function () {
        updateFooterSize();
    }, [isPhone]);
    var PrimaryButton = (jsx(Button, __assign$2({ variant: "flat", onClick: primaryAction, fullWidth: isPhone, "data-testid": "action-bar-button-primary" }, primaryActionProps, { children: primaryActionLabel })));
    var SecondaryButton = (jsx(Button, __assign$2({ variant: "outlined", onClick: secondaryAction, fullWidth: isPhone, "data-testid": "action-bar-button-secondary" }, secondaryActionProps, { children: secondaryActionLabel })));
    var NegativeButton = (jsx(Button, __assign$2({ variant: "link", onClick: negativeAction, fullWidth: isPhone, "data-testid": "action-bar-button-negative" }, negativeActionProps, { children: negativeActionLabel })));
    return (jsx("div", __assign$2({ css: defaultStyles.root, style: styles === null || styles === void 0 ? void 0 : styles.root, ref: layoutActionBarRef }, { children: jsxs("div", __assign$2({ css: defaultStyles.body, style: styles === null || styles === void 0 ? void 0 : styles.body }, { children: [!isPhone ? (jsxs(Grid, __assign$2({ gutter: 0, align: "center", justify: "space-between", "data-testid": "action-bar-button-desktop-options" }, { children: [jsx(Grid.Col, __assign$2({ span: 4 }, { children: hasSecondaryAction && SecondaryButton })), jsx(Grid.Col, __assign$2({ span: 8 }, { children: jsxs(Grid, __assign$2({ justify: "end", gutter: 0 }, { children: [hasNegativeAction && NegativeButton, hasNegativeAction && hasPrimaryAction && jsx(Space, { w: "md" }), hasPrimaryAction && PrimaryButton] })) }))] }))) : (jsxs(Stack, __assign$2({ "data-testid": "action-bar-button-mobile-options" }, { children: [hasPrimaryAction && PrimaryButton, hasNegativeAction && NegativeButton, hasSecondaryAction && SecondaryButton] }))), customContent] })) })));
};

var useStyles$2 = makeStyles({
    root: function (theme) { return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$1(["\n    display: flex;\n    align-items: center;\n    span {\n      margin-left: 5px;\n      color: ", ";\n      ", ";\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    span {\n      margin-left: 5px;\n      color: ", ";\n      ", ";\n    }\n  "])), theme.colors.danger[500], typographyToStyle(theme.typography.microCopy)); },
});
var templateObject_1$4;

var FieldErrorMessage = function (_a) {
    var error = _a.error;
    var root = useStyles$2().root;
    return (jsxs("div", __assign$2({ css: root, role: "field-error-message" }, { children: [jsx(SvgWarning, { "data-testid": "field-error-message-icon", size: "small", color: theme.colors.danger[500] }), jsx("span", __assign$2({ "data-testid": "field-error-message-child" }, { children: error }))] })));
};

var useStyles$1 = makeStyles({
    root: function (_a) {
        var typography = _a.typography, colors = _a.colors;
        return css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$1(["\n    color: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    ", "\n  "])), colors.neutral[600], typographyToStyle(typography.label));
    },
});
var templateObject_1$3;

var Caption = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'small' : _b, renderAs = _a.renderAs, children = _a.children, args = __rest(_a, ["variant", "renderAs", "children"]);
    var styles = useStyles$1({ variant: variant });
    var Tag = renderAs || 'p';
    return (jsx(Tag, __assign$2({}, args, { css: styles.root }, { children: children })));
};

function useWindowSize() {
    var _a = useState({
        width: undefined,
        height: undefined,
    }), windowSize = _a[0], setWindowSize = _a[1];
    var _b = useState(), isMobile = _b[0], setIsMobile = _b[1];
    useEffect(function () {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
            setIsMobile(window.innerWidth <= 639);
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return { windowSize: windowSize, isMobile: isMobile };
}

var AttachmentDeleteButton = function (_a) {
    var isDeleting = _a.isDeleting, uploadStatus = _a.uploadStatus, progress = _a.progress, onClick = _a.onClick, isWrapped = _a.isWrapped, cancelLabel = _a.cancelLabel, deleteLabel = _a.deleteLabel;
    var _b = useState('loading'), deleteIcon = _b[0], setDeleteIcon = _b[1];
    var isMobile = useWindowSize().isMobile;
    useEffect(function () {
        if ((progress === 100 && uploadStatus !== 'UPLOADED') || isDeleting) {
            setDeleteIcon('loading');
        }
        else if (progress < 100 && uploadStatus === 'UPLOADING' && !isDeleting) {
            setDeleteIcon('close');
        }
        else if (progress === 100 && uploadStatus === 'UPLOADED' && !isDeleting) {
            setDeleteIcon('trash');
        }
        else {
            setDeleteIcon('close');
        }
    }, [progress, isDeleting, uploadStatus]);
    var desktopLinkText = useCallback(function () {
        if (deleteIcon === 'close') {
            return cancelLabel;
        }
        else if (deleteIcon === 'trash') {
            return deleteLabel;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteIcon]);
    return (jsx(Fragment, { children: isWrapped || isMobile ? (jsx("button", { disabled: isDeleting, onClick: function () { return onClick(); } })) : deleteIcon === 'loading' ? (jsx(Icon, { name: "file" })) : (jsx(Button, __assign$2({ variant: "link", onClick: function () { return onClick(); } }, { children: desktopLinkText() }))) }));
};

var AttachAreaStyle = makeStyles({
    dropzoneWrapper: function () {
        return css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$1(["\n      width: 100%;\n      height: 100%;\n    "], ["\n      width: 100%;\n      height: 100%;\n    "])));
    },
    dropzoneContainer: function (_a) {
        var colors = _a.colors;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject$1(["\n      position: relative;\n      border: 2px dashed ", ";\n      border-radius: 8px;\n      background: ", ";\n      padding: 24px;\n      margin-bottom: 8px;\n    "], ["\n      position: relative;\n      border: 2px dashed ", ";\n      border-radius: 8px;\n      background: ", ";\n      padding: 24px;\n      margin-bottom: 8px;\n    "])), colors.primary[200], colors.common.white);
    },
    input: function () {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject$1(["\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      cursor: pointer;\n    "], ["\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      cursor: pointer;\n    "])));
    },
});
var templateObject_1$2, templateObject_2, templateObject_3;

var ALLOWED_FILE_EXTENSIONS = [
    'pdf',
    'docx',
    'doc',
    'xls',
    'xlsx',
    'jpg',
    'jpeg',
    'png',
];

var AttachmentDropZone = function (_a) {
    var onInput = _a.onInput, ref = _a.ref, _b = _a.accept, accept = _b === void 0 ? ALLOWED_FILE_EXTENSIONS : _b, id = _a.id, children = _a.children, caption = _a.caption, sx = _a.sx;
    var styles = AttachAreaStyle();
    return (jsxs("div", __assign$2({ css: styles.dropzoneWrapper, style: sx }, { children: [jsxs("div", __assign$2({ css: styles.dropzoneContainer }, { children: [jsx("input", { type: "file", id: id, css: styles.input, accept: accept.join(', '), ref: ref, onChange: function (e) {
                            var file = e.target.files[0];
                            onInput(file);
                            e.preventDefault();
                            e.stopPropagation();
                        } }), jsx("div", { children: children })] })), caption && jsx(Caption, { children: caption })] })));
};

var loadedFileStyles = makeStyles({
    container: function (_a) {
        var colors = _a.colors;
        return css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n      display: flex;\n      align-items: center;\n      padding: 16px;\n\n      .icon {\n        justify-content: center;\n        align-items: center;\n        padding-top: 4px;\n        height: 100%;\n        flex-grow: 0;\n        margin-right: 16px;\n      }\n\n      .info {\n        flex-grow: 1;\n        align-items: center;\n        justify-content: start;\n        display: flex;\n        flex-direction: column;\n        &__head {\n          padding: 0 12px;\n          flex-grow: 1;\n          width: 100%;\n          margin-bottom: 8px;\n          &__headline {\n            display: flex;\n            width: 100%;\n            flex-direction: row;\n            justify-content: space-between;\n          }\n          &__head__texts {\n            display: flex;\n            width: 100%;\n          }\n          &__file-name {\n            width: 160px;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n            ", "\n          }\n          &__status {\n            width: 100%;\n            text-align: left;\n            span {\n              ", "\n            }\n            &__error {\n              color: ", ";\n            }\n          }\n        }\n        &__fill {\n          flex-direction: row;\n          .info__head {\n            width: 120px;\n          }\n        }\n        &__file-type {\n          width: 100px;\n          text-align: right;\n        }\n        &__progress-bar {\n          padding: 0 12px;\n          width: 100%;\n          &__small {\n            width: 140px;\n          }\n        }\n      }\n\n      .caption {\n        ", "\n        color: ", ";\n      }\n      .action {\n        flex-grow: 0;\n        align-items: center;\n        justify-content: start;\n        margin-left: 16px;\n        a {\n          color: ", ";\n        }\n        button {\n          background: none;\n          border: none;\n          cursor: pointer;\n          width: 32px;\n          height: 32px;\n        }\n      }\n    "], ["\n      display: flex;\n      align-items: center;\n      padding: 16px;\n\n      .icon {\n        justify-content: center;\n        align-items: center;\n        padding-top: 4px;\n        height: 100%;\n        flex-grow: 0;\n        margin-right: 16px;\n      }\n\n      .info {\n        flex-grow: 1;\n        align-items: center;\n        justify-content: start;\n        display: flex;\n        flex-direction: column;\n        &__head {\n          padding: 0 12px;\n          flex-grow: 1;\n          width: 100%;\n          margin-bottom: 8px;\n          &__headline {\n            display: flex;\n            width: 100%;\n            flex-direction: row;\n            justify-content: space-between;\n          }\n          &__head__texts {\n            display: flex;\n            width: 100%;\n          }\n          &__file-name {\n            width: 160px;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n            ", "\n          }\n          &__status {\n            width: 100%;\n            text-align: left;\n            span {\n              ", "\n            }\n            &__error {\n              color: ", ";\n            }\n          }\n        }\n        &__fill {\n          flex-direction: row;\n          .info__head {\n            width: 120px;\n          }\n        }\n        &__file-type {\n          width: 100px;\n          text-align: right;\n        }\n        &__progress-bar {\n          padding: 0 12px;\n          width: 100%;\n          &__small {\n            width: 140px;\n          }\n        }\n      }\n\n      .caption {\n        ", "\n        color: ", ";\n      }\n      .action {\n        flex-grow: 0;\n        align-items: center;\n        justify-content: start;\n        margin-left: 16px;\n        a {\n          color: ", ";\n        }\n        button {\n          background: none;\n          border: none;\n          cursor: pointer;\n          width: 32px;\n          height: 32px;\n        }\n      }\n    "])), typographyToStyle(theme.typography.body1), typographyToStyle(theme.typography.label), colors.danger[600], typographyToStyle(theme.typography.label), colors.neutral[300], colors.danger[600]);
    },
});
var templateObject_1$1;

var AttachmentUploadProgress = function (props) {
    var id = props.id, AttachmentName = props.AttachmentName, size = props.size, onDelete = props.onDelete, attachmentTypeLabel = props.attachmentTypeLabel, uploadStatus = props.uploadStatus, errorMessage = props.errorMessage, isWrapped = props.isWrapped, _a = props.progress, progress = _a === void 0 ? 0 : _a, isDeleting = props.isDeleting;
    var container = loadedFileStyles().container;
    var theme = useThemeContext();
    var isMobile = useWindowSize().isMobile;
    var sizeFormated = useMemo(function () {
        return formatBytes(size);
    }, [size]);
    var handleDelete = function () {
        onDelete && onDelete(id, size, uploadStatus);
    };
    var progressColor = useCallback(function () {
        if (uploadStatus === 'ERROR')
            return theme.colors.danger[600];
        if (uploadStatus === 'UPLOADED')
            return theme.colors.success[600];
        return theme.colors.primary[600];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadStatus]);
    var iconColor = useCallback(function () {
        if (uploadStatus === 'ERROR')
            return theme.colors.danger[600];
        if (uploadStatus === 'UPLOADED')
            return theme.colors.success[600];
        return theme.colors.neutral[600];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadStatus]);
    var iconName = useCallback(function () {
        if (uploadStatus === 'ERROR')
            return 'file-error';
        if (uploadStatus === 'UPLOADED')
            return 'file-check';
        return 'file';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadStatus]);
    return (jsxs("div", __assign$2({ css: container }, { children: [jsx("div", __assign$2({ className: "icon" }, { children: jsx(Icon, { name: iconName(), color: iconColor(), size: "medium" }) })), jsxs("div", __assign$2({ className: "w-100" }, { children: [jsx("div", __assign$2({ className: "info__head" }, { children: jsxs("div", __assign$2({ className: "info__head__headline" }, { children: [jsxs("div", __assign$2({ className: "info__head__texts" }, { children: [jsx(Text, { children: AttachmentName }), uploadStatus === 'UPLOADED' ? (jsx("span", __assign$2({ className: "caption info__file-type" }, { children: attachmentTypeLabel }))) : null] })), jsx("div", __assign$2({ className: "caption" }, { children: jsx("div", __assign$2({ className: "info__head__status" }, { children: uploadStatus === 'ERROR' ? (jsx("span", __assign$2({ className: "info__head__status__error" }, { children: errorMessage }))) : (jsx("span", __assign$2({ className: "caption" }, { children: size ? sizeFormated : '' }))) })) }))] })) })), !isMobile && !isWrapped ? (jsx("div", __assign$2({ className: "caption info__file-type" }, { children: errorMessage || sizeFormated }))) : (''), jsx("div", __assign$2({ className: "info__progress-bar ".concat(!isMobile && !isWrapped ? 'info__progress-bar__small' : '') }, { children: !progress || (jsx(Progress, { value: progress, color: progressColor(), size: 'sm' })) }))] })), jsx("div", __assign$2({ className: "action" }, { children: !onDelete ? ('') : (jsx(AttachmentDeleteButton, { isDeleting: isDeleting, uploadStatus: uploadStatus, progress: progress, onClick: handleDelete, isWrapped: isWrapped })) }))] })));
};

var useStyles = makeStyles({
    root: function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject$1(["\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n\n    input {\n      display: none;\n    }\n  "], ["\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n\n    input {\n      display: none;\n    }\n  "]))); },
});
var templateObject_1;

var FileInputButton = function (_a) {
    _a.src; var onClick = _a.onClick, onChange = _a.onChange, label = _a.label, name = _a.name, id = _a.id, children = _a.children, props = __rest(_a, ["src", "onClick", "onChange", "label", "name", "id", "children"]);
    var root = useStyles().root;
    var inputRef = useRef(null);
    var handlePreview = useCallback(function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file) {
            return;
        }
        if (!file.type.includes('image')) {
            toast({
                message: 'Tipo de arquivo inválido.',
                variant: 'error',
                theme: 'dark',
            });
        }
        onChange(e);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function handleClick(event) {
        inputRef.current.click();
        onClick && onClick(event);
    }
    return (jsxs("div", __assign$2({ css: root }, { children: [jsx("div", __assign$2({ onClick: handleClick }, { children: children })), jsx(Button, __assign$2({ onClick: handleClick, variant: "link" }, { children: label })), jsx("input", __assign$2({ type: "file", accept: "image/*", name: name, id: id, onChange: handlePreview, ref: inputRef }, props))] })));
};

const LIST_IDENTIFIER = Symbol("@mantine/form/list");
function formList(list) {
  Object.defineProperty(list, LIST_IDENTIFIER, {
    value: true,
    writable: false,
    enumerable: false,
    configurable: false
  });
  return list;
}
function isFormList(list) {
  return Array.isArray(list) && !!list[LIST_IDENTIFIER];
}

function filterErrors(errors) {
  if (errors === null || typeof errors !== "object") {
    return {};
  }
  return Object.keys(errors).reduce((acc, key) => {
    const errorValue = errors[key];
    if (errorValue !== void 0 && errorValue !== null) {
      acc[key] = errorValue;
    }
    return acc;
  }, {});
}

function validateListValues(values, key, rules) {
  const list = values[key];
  const results = {};
  list.forEach((item, itemIndex) => {
    if (typeof item === "object" && item !== null) {
      Object.keys(item).forEach((listItemKey) => {
        if (typeof rules[key][listItemKey] === "function") {
          const error = rules[key][listItemKey](item[listItemKey], values);
          if (error) {
            results[`${key}.${itemIndex}.${listItemKey}`] = error;
          }
        }
      });
    }
  });
  return results;
}

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
function validateRecordRules(rules, values) {
  return Object.keys(rules).reduce((acc, key) => {
    const rule = rules[key];
    if (isFormList(values[key])) {
      return __spreadValues$1(__spreadValues$1({}, acc), validateListValues(values, key, rules));
    }
    if (typeof rule === "function") {
      acc[key] = rule(values[key], values);
    }
    return acc;
  }, {});
}
function getValidationResults(errors) {
  const filteredErrors = filterErrors(errors);
  return { hasErrors: Object.keys(filteredErrors).length > 0, errors: filteredErrors };
}
function validateValues(rules, values) {
  if (rules === void 0 || rules === null) {
    return { hasErrors: false, errors: {} };
  }
  if (typeof rules === "function") {
    return getValidationResults(rules(values));
  }
  return getValidationResults(validateRecordRules(rules, values));
}
function validateFieldValue(field, rules, values) {
  const results = validateValues(rules, values);
  const hasError = field in results.errors;
  return { hasError, error: hasError ? results.errors[field] : null };
}

function getInputOnChange(setValue) {
  return (val) => {
    if (!val) {
      setValue(val);
    } else if (typeof val === "function") {
      setValue(val);
    } else if (typeof val === "object" && "nativeEvent" in val) {
      const { currentTarget } = val;
      if (currentTarget.type === "checkbox") {
        setValue(currentTarget.checked);
      } else {
        setValue(currentTarget.value);
      }
    } else {
      setValue(val);
    }
  };
}

function getErrorPath(path) {
  return path.join(".");
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function useForm({
  initialValues,
  initialErrors,
  validate: rules,
  schema
}) {
  const [errors, setErrors] = useState(filterErrors(initialErrors));
  const [values, setValues] = useState(initialValues);
  const clearErrors = () => setErrors({});
  const setFieldError = (field, error) => setErrors((current) => __spreadProps(__spreadValues({}, current), { [field]: error }));
  const clearFieldError = (field) => setErrors((current) => {
    const clone = __spreadValues({}, current);
    delete clone[field];
    return clone;
  });
  const setFieldValue = (field, value, errorPath) => {
    setValues((currentValues) => __spreadProps(__spreadValues({}, currentValues), { [field]: value }));
    clearFieldError(errorPath);
  };
  const setListItem = (field, index, value, errorPath) => {
    const list = values[field];
    if (isFormList(list) && list[index] !== void 0) {
      const cloned = [...list];
      cloned[index] = value;
      setFieldValue(field, formList(cloned), errorPath);
    }
  };
  const removeListItem = (field, indices) => {
    const list = values[field];
    if (isFormList(list)) {
      setFieldValue(field, formList(list.filter((_, index) => Array.isArray(indices) ? !indices.includes(index) : indices !== index)));
    }
  };
  const addListItem = (field, payload) => {
    const list = values[field];
    if (isFormList(list)) {
      setFieldValue(field, formList([...list, payload]));
    }
  };
  const reorderListItem = (field, { from, to }) => {
    const list = values[field];
    if (isFormList(list) && list[from] !== void 0 && list[to] !== void 0) {
      const cloned = [...list];
      const item = list[from];
      cloned.splice(from, 1);
      cloned.splice(to, 0, item);
      setFieldValue(field, formList(cloned));
    }
  };
  const validate = () => {
    const results = validateValues(schema || rules, values);
    setErrors(results.errors);
    return results;
  };
  const validateField = (field) => {
    const results = validateFieldValue(field, schema || rules, values);
    results.hasError ? setFieldError(field, results.error) : clearFieldError(field);
    return results;
  };
  const onSubmit = (handleSubmit) => (event) => {
    event.preventDefault();
    const results = validate();
    !results.hasErrors && handleSubmit(values, event);
  };
  const reset = () => {
    setValues(initialValues);
    clearErrors();
  };
  const getInputProps = (field, { type, withError = true } = {}) => {
    const value = values[field];
    const onChange = getInputOnChange((val) => setFieldValue(field, val));
    const payload = type === "checkbox" ? { checked: value, onChange } : { value, onChange };
    if (withError && errors[field]) {
      payload.error = errors[field];
    }
    return payload;
  };
  const getListInputProps = (field, index, listField, { type, withError = true } = {}) => {
    const list = values[field];
    if (isFormList(list) && list[index] && listField in list[index]) {
      const listValue = list[index];
      const value = listValue[listField];
      const listItemErrorPath = getErrorPath([field, index, listField]);
      const onChange = getInputOnChange((val) => setListItem(field, index, __spreadProps(__spreadValues({}, listValue), { [listField]: val }), listItemErrorPath));
      const payload = type === "checkbox" ? { checked: value, onChange } : { value, onChange };
      const error = errors[getErrorPath([field, index, listField])];
      if (withError && error) {
        payload.error = error;
      }
      return payload;
    }
    return {};
  };
  return {
    values,
    setValues,
    setFieldValue,
    errors,
    setErrors,
    clearErrors,
    clearFieldError,
    setFieldError,
    setListItem,
    removeListItem,
    addListItem,
    reorderListItem,
    validate,
    validateField,
    onSubmit,
    reset,
    getInputProps,
    getListInputProps
  };
}

function yupResolver(schema) {
  const _schema = schema;
  return (values) => {
    try {
      _schema.validateSync(values, { abortEarly: false });
      return {};
    } catch (_yupError) {
      const yupError = _yupError;
      const results = {};
      yupError.inner.forEach((error) => {
        results[error.path.replace("[", ".").replace("]", "")] = error.message;
      });
      return results;
    }
  };
}

var toast = function (props) {
    var addToast = toastStore.getState().addToast;
    if (typeof props === 'string') {
        addToast({
            message: props,
            autoClose: true,
            variant: 'success',
        });
        return;
    }
    var options = props;
    if (props.autoClose === undefined)
        options.autoClose = true;
    if (props.variant === undefined)
        options.variant = 'success';
    addToast(options);
};

var convertToB64 = function (file) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () {
            var base64 = {
                file: null,
                ext: '',
            };
            base64.file = reader.result;
            var splitedFileName = file.name.split('.');
            base64.ext = "".concat(splitedFileName[splitedFileName.length - 1]);
            resolve(base64);
        };
        reader.readAsDataURL(file);
    });
};

export { ActionBar, AppShell, AspectRatio, AttachmentDeleteButton, AttachmentDropZone, AttachmentUploadProgress, Avatar, AvatarOptions, Breadcrumbs, Button, Caption, Center, Checkbox, Container, ContentLayout, DatePicker, Dropdown, FieldErrorMessage, FileInputButton, FormGroupTitle, Grid, Group, Heading, Input, InputPassword, LayoutActionBar, LayoutFooter, LayoutHeader, Loader, MediaQuery, Modal, ModalTitle, MultiSelect, Navbar, Progress, Radio, RadioGroup, ResetStyles, SearchBox, SimpleGrid, Space, Stack, Switch, Tag, Text, TextArea, ThemeProvider, TimeZoneGMT, Toast, ToastContainer, Tooltip, clampUseMovePosition, convertToB64, formList, getHotkeyHandler, isFormList, makeStyles, mergeRefs, theme, toast, useBooleanToggle, useClickOutside, useClipboard, useColorScheme, useDebouncedValue, useDidUpdate, useDisclosure, useDocumentTitle, useElementSize, useEventListener, useFocusReturn, useFocusTrap, useFocusWithin, useForceUpdate, useForm, useFullscreen, useHash, useHotkeys, useHover, useId, useIdle, useInputState, useIntersection, useInterval, useIsomorphicEffect, useListState, useLocalStorage, useLocalStorageValue, useLogger, useMediaQuery, useMergedRef, useMouse, useMove, useNetwork, useOs, usePageLeave, usePagination, useQueue, useReducedMotion, useResizeObserver, useScrollIntoView, useScrollLock, useSetState, useShallowEffect, useThemeContext, useToggle, useUncontrolled, useUuid, useValidatedState, useViewportSize, useWindowEvent, useWindowScroll, yupResolver };
//# sourceMappingURL=index.es.js.map
